import { Component, OnInit, OnDestroy, ViewChild,  HostListener, ChangeDetectorRef, Renderer2, ElementRef, ChangeDetectionStrategy,Inject } from '@angular/core';
import { ParticipationDataService } from '../_services/participation-data.service';
import { SurveyData } from '../common-class/survey-data';
import { SaveOnNextData } from '../common-class/save-on-next-data';
import { Questions, SelectedOptionList, DestinationQuestion, Rules, AnswerPipingType, AcceptCookiesCountryData, PrePopDetails, ContactRules } from '../common-class/questions';
import { Router, ActivatedRoute, ResolveData } from '@angular/router';
import { NgForm } from '@angular/forms';
//import { saveAs } from 'file-saver';
import { LanguageData } from '../common-class/language-data';
//import { ResponseData } from '../common-class/response-data';
import { Observable, Subscription, timer, interval, queueScheduler } from 'rxjs';
import { Group, Matrix, GroupPiping, MatrixPiping } from '../common-class/pages';
import { Title } from '@angular/platform-browser';
import { PreviewData, CommonSetting ,OfflineSurvey,SignUp } from '../common-class/survey';
import { Participation_Messages } from '../common-class/survey-messages';
import { SurveyQuestionAnswerDisplayLogic } from '../COMMON-LOGIC/question-display-logic';
import { ignoreElements, map, take, timeout} from 'rxjs/operators';
import { CustomErrorsHandlerService } from '../_services/custom-errors-handler.service';
import { SurveySpecificData } from '../common-class/survey-specific-data';
import { ParticipationResponseData, ResponseCommanData, ResponseData } from '../common-class/response-data';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ConnectionService } from 'ng-connection-service'
import { formatDate } from '@angular/common';
import { assertNotNull, ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { CommonLogic } from '../common-logic/common-logic';
import { EncryptionAndDecryption } from '../COMMON-LOGIC/EncryptionAndDecryption';
import {PostMessgesData} from '../common-class/Post-message-data';
declare const gaTracker: any;
declare var $: any;

@Component({
  selector: 'app-participation',
  templateUrl: './participation.component.html',
  styleUrls: ['./participation.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ParticipationComponent implements OnInit, OnDestroy {

  customCount:number=0;
  surveyData: SurveyData;
  surveySpecificData: SurveySpecificData;
  saveOnNextData: SaveOnNextData;
  participation_Messages: Participation_Messages;
  //responseDatas: ResponseData[] = [];
  participationResponseData: ParticipationResponseData;
  postMessgesData:PostMessgesData;
  responseData: ResolveData;

  responseQuestions: Questions[] = [];

  pageNumber: number;
  maxPageNumber: number;
  selectedLang: number;
  nextButtonClickNo: number = 0;

  isMandatory: boolean = false;
  isThankYouPage: boolean = false;
  multiLanguage: boolean = false;
  selectedLanguage: boolean = true;
  surveyTitle:string;
  isLoading: boolean;
  isSubmittedForm: boolean = false;
  isSaveAndContinue: boolean = false;
  showAnonymous: boolean = false;
  showGDPR:boolean = false;
  isPrintDownload: boolean;
  isEditedResponse: boolean = false;
  isAllQuestionHideOnPrevPages: boolean = false;
  isAllQuestionHideOnNextPages: boolean = false;
  isShowModalDialog: boolean = true;
  isAllQuestionHideMessage: boolean;
  isRemoveBackGround: boolean = false;
  isAssesmentSubmit: boolean = false;
  isResetPage: boolean = false;
  isDivScroll: boolean = false;
  isPreview: boolean = false;
  selectedLanguageName: string;
  urlParam: string;
  jsonData: string;
  isControlLoading: boolean;
  isSaveAndContinueDisabled: boolean = false;

  isHideHambugforEmbedMob:boolean=false;
  isHideEmbedWebHeader:boolean= false;
  isHideHamburgerMenu:boolean=false;

  surveyPageList: Array<number> = [];
  assesmentAutoSavePageList: Array<number> = [];
  ReopenPageList: Array<number> = [];
  surveyDisplayPageList1: Array<number>=[];
  surveyDisplayPageList2: Array<number>=[];
  skippedPageList: Array<number> = [];
  surveyBackground: string;
  SurveyURL:string;
  productName: string = '';
  cookieCorpNO:string=''
  isRTL: boolean = false;
  //Animation
  startAnimation: number = 0;
  transition: any = null;
  formValisandSubmited:boolean = false;
  questionLength: number = 0;
  //Screen_Resoution:string='';
  isConnected: boolean;
  isOfflinePage: Boolean;
  isOfflineSurvey: boolean = false;
  isOfflineTimeout: boolean = false;
  pageIndexnum: number = 0;
  timeouttext: string = 'Quiz time limit is over, your answers have been submitted.';
  isactivateQuestionInt: boolean = false;
  isactivateQuestionOnHoverInt: boolean = false;
  currHeight:number=0;
  isLangSetonLoading = false;

  @ViewChild('f', {static: false}) form: NgForm;

  public isTimeOutMsg: boolean = false;
  public isEndSurveyOnPage: boolean =false;
  public isTimeOutMsg_2: boolean = false;
  private subscription: Subscription;
  private subscription_2: Subscription;
  private subscription_3: Subscription;
  private autoSaveSubscription: Subscription;
  private timer: Observable<any>;
  private timer_2: Observable<any>;
  private autoSaveTimer: Observable<any>;
  public countDown: Observable<any>;
  private countDown_2: Observable<any>;
  private subscription_CountDown: Subscription;
  public currentValue: string = "00:00:00";
  public OfflineResponseData: any = [];


  //Preview Page Handling
  isManditorySkip: boolean;
  isByPassLogic: boolean;
  isShowHiddenQN: boolean;
  isPrevPgChnge: boolean;
  isDeviceCSS: string;
  isMobile: boolean;
  isTablet:boolean;
  cp_no:number;

  isBackClick: boolean = false;
  isCapchaManditorySkip: boolean = false;
  questionDisplayLogic: SurveyQuestionAnswerDisplayLogic;
  answerDisplayLogic: SurveyQuestionAnswerDisplayLogic;
  showLoader: boolean = false;
  embedlangOpt:number =  1;
  pageHeight: number = 0;
  lastScrollTop: number = 0;
  isNewParticipation: boolean;
  previewSurveyFormat: number;
  isFromSB:string ="0";
  surveyFormat:number = 0;
  newParticipationBtnText: string;
  questionSpacerHeight: number;
  isCapchaDarkTheme: boolean;
  isAcceptCookies: boolean;
  aceptCookiesCountryDatas: AcceptCookiesCountryData[];
  cookieTooltip: any;
  ResponseStartDate: string;
  ESTResponseStartDate:string;
  ESTResponseEndDate:string;
  isinitLoading: boolean = false;

  @ViewChild('topquestionspacer',{static:false,read:ElementRef}) topQuestionSpacer:ElementRef;
  @ViewChild('targetElement', { static: false }) targetElement: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    // Call the function to update max-width and min-width on resize
    this.calculateWidthPageFooter();
  }

  /**
   * This constructor use for accessing injectable data.
   * @param service
   * @param router
   * @param activatedRoute
   * @param titleService
   * @param preview
   * @param commonSetting
   * @param SignUp
   * @param errorsHandlerService
   * @param changeDetect
   * @param renderer
   * @param elementref
   * @param storage
   * @param connectionService
   * @param offlineSurvey
   */
  constructor(public service: ParticipationDataService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private titleService: Title, public preview: PreviewData,
    private commonSetting: CommonSetting,
    private SignUp:SignUp,
    private errorsHandlerService: CustomErrorsHandlerService,
    private changeDetect: ChangeDetectorRef,
    private renderer: Renderer2,
    private elementref: ElementRef,
    @Inject(LOCAL_STORAGE) private storage: StorageService
    ,
    private connectionService: ConnectionService,
    private offlineSurvey: OfflineSurvey
    ) {
      this.connectionService.monitor().subscribe(isConnected => {
        this.isConnected = isConnected;
        if(this.isConnected==undefined){
          this.isConnected = navigator.onLine;
        }
      })
      if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
        this.isOfflineSurvey=this.offlineSurvey.isOfflineSurvey;
      }
  }

  /**
   * this is onInit event.
   */
  ngOnInit() {
    this.isinitLoading=true;
    this.productName = this.commonSetting.productName;
    this.SurveyURL = this.commonSetting.SurveyURL;
    this.cp_no= this.commonSetting.cp_no;
    this.cookieCorpNO = this.commonSetting.cookieCorpNO;
    this.embedlangOpt = this.commonSetting.embedLangOpt;
    this.showLoader = true;

    this.getAcceptCookiesCountryData();
    this.GetData();
    if(!this.isOfflineSurvey){
      this.pageNumber = 0;
    }else if(!(this.pageNumber>0)){
      this.pageNumber = 0;
    }
    this.isLoading = true;
    //this.isConnected = navigator.onLine;
    if(this.isConnected==undefined){
      this.isConnected = navigator.onLine;
    }
    //this.isOfflinePage = !this.isConnected;
    // if(this.isOfflinePage){
    //   let path = 'Offline.aspx?' + this.GetUrlData(false);
    //   this.router.navigateByUrl(path);
    // }
    this.ResponseStartDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
    this.ESTResponseStartDate = this.getESTTimeString()
    
  }

  /**
   * this Event check DOM & handle dynamic CSS.
   */
  ngAfterViewInit() {

    
    // if (window.navigator.userAgent.indexOf("Chrome") != -1) {
    //   $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    // }

    this.calculateWidthPageFooter();

    // Listen for window resize events
    window.addEventListener('resize', () => {
      this.calculateWidthPageFooter();
    });

    let self = this;

    $('body').on('click', '.div-scroll-btn', function () {
      if($('.RTLDir').length > 0){
        $(this).parents('.divScroll').find('.fieldset-wrapper-scroll').animate({
          // scrollLeft: $(this).parents('.divScroll').find('.question-data').find('.fieldset-wrapper .answer-option-wrapper').outerWidth() - $(this).parents('.divScroll').find('.question-data').outerWidth()
          scrollLeft: $(this).parents('.divScroll').find('.fieldset-wrapper-scroll').scrollLeft() - $(this).parents('.divScroll').find('.question-data').outerWidth()
        }, 500);
      } else {
        $(this).parents('.divScroll').find('.fieldset-wrapper-scroll').animate({
          // scrollLeft: $(this).parents('.divScroll').find('.question-data').find('.fieldset-wrapper .answer-option-wrapper').outerWidth() - $(this).parents('.divScroll').find('.question-data').outerWidth()
          scrollLeft: $(this).parents('.divScroll').find('.fieldset-wrapper-scroll').scrollLeft() + $(this).parents('.divScroll').find('.question-data').outerWidth()
        }, 500);
      }
    });

    $('body').on('click','.see-more-webview, .see-more-overlay', function () {
      var embed_url='';
      embed_url= self.surveyData.SurveyDetails.strEmbedURL;
      window.open(embed_url, '_blank');
    });


    $(document).on('click mousedown keydown touchstart', function (e) {
      if (self.surveyData != undefined && self.surveyData.SurveyDetails.GroupType == "preview") {
        if ($('.settings-menu', parent.document)) {
          var ele = $('.settings-menu,.view-icon.view-settings-icon,.ui-tooltip.preview-tooltip', parent.document);
          if (!ele.is(e.target) && ele.has(e.target).length === 0) {
            $('.settings-menu', parent.document).removeClass('drop-menu');
            $('.view-icon.view-settings-icon', parent.document).removeClass('active');
          }
        }
      }

      if(!$(e.target).parents().hasClass('anonymous-msg') && !$(e.target).hasClass('anonymous-btn')){
        $('.anonymous-msg-wrap').hide();
      }

      if (!$(e.target).parents().hasClass('functional-toggle') && !$(e.target).hasClass('functional-toggle')) {
        $('.cd-tooltip').fadeOut(100);
        clearTimeout(self.cookieTooltip);
      }
    })

    $(document).on('click', '.next-button, .submit-button', function () {
      var btnheight = $(this).outerHeight();
      var  btnwidth = $(this).outerWidth();
        $(this).addClass('active');
        //$(this).children('.footer-btn-text').css('visibility','hidden');

    });

    $(document).keypress(
      function(event){
      if (event.which == '13' && event.target.tagName == "INPUT" && event.target.type == "text") {
        event.preventDefault();
      }
    });

    $(document).click(function () {
      if (!$(event.target).parents().hasClass('drill-down-search')) {
        $('.drill-down-search').removeClass('showDrillList');
      }
      if (!$(event.target).parents().hasClass('sl_input')) {
        $('.sl_input').removeClass('showRSValues');
      }


    });



    // if(this.surveyFormat == 1) {
    //   $("body").on("mouseover", ".ques-overlay", function() {
    //     self.activateQuestionOnHover(this);
    //   });
    // }

    this.showLoader = false;
    setTimeout(() => {
      if (this.surveyData != undefined && this.surveyData != null) {
        if (!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile) || this.commonSetting.isEmbedMobile || this.commonSetting.isEmbedPopMobile)
          this.bodyNiceScrollResize()
      }
    }, 250);

    setTimeout(() => {
     
      if (this.customCount ==0){
        if(this.surveyData != undefined && this.surveyData != null && !this.surveyData.SurveySettings.CustomScript != undefined) {
        const head = document.getElementsByTagName('head')[0];
    
          let cScript = document.createElement('script'); // creates the script tag
          cScript.type = 'text/javascript'; // set the script type
          var customScript = "$(document).ready(function () {"+ this.surveyData.SurveySettings.CustomScript +"});";
          cScript.innerText= customScript;
          head.appendChild(cScript);
          
        }
        this.customCount=1;
    }
    }, 1000);
    // this.changeDetect.detectChanges();
    
  }

  defaultBtnAlignWidth() {
    if(!this.isTablet && !this.isMobile) {
      if (this.surveyData.SurveyDetails.SurveyWidthType == 1) {
        return {
          'min-width': '735.938px',
          'max-width': '735.938px'
        };
      } 
      else if(this.surveyData.SurveyDetails.SurveyWidthType == 2) {
        return {
          'min-width': '995.469px',
          'max-width': '995.469px'
        };
      }
      else {
        return {
          'min-width': '1256px',
          'max-width': '1256px'
        };
      }
    }
    else if(this.isTablet) {
      return {
        'min-width': '713px',
        'max-width': '713px'
      };
    }
  }

  calculateWidthPageFooter(){
    if($('.fieldset-wrapper').width())
    {
      const sourceWidth = $('.fieldset-wrapper').width()
      $('.tblPageFooter').css('max-width',sourceWidth +'px');
      $('.tblPageFooter').css('min-width',sourceWidth +'px');
    }
  }

  /**
   * this method use for initial handle scroll on page.
   * @param index
   */
  addDivScroll(index: number) {
    if (this.surveyData.Pages[this.pageNumber].Questions.length == (index + 1)) {

      if (!this.isMobile) {
        this.ShowDivScroll();
      }

      this.isDivScroll = true;
      this.surveyData.Pages[this.pageNumber].isPageLoadComplete = true;

      // Issue No.  114391 : Open : [PM][ANG][iPAD/ mobile] navigation strip breaks for one page survey
      // if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)){
      //   this.bodyNiceScrollResize()
      // }

      if ((this.surveyData.SurveyDetails.GroupType != 'preview') && !this.isMobile && !this.isTablet) {
        this.bodyNiceScrollResize()
      }

      if(this.commonSetting.isEmbedMobile || this.commonSetting.isEmbedPopMobile)
      {
        this.bodyNiceScrollResize()
      }
      this.getFirstQuestionInFocus();
    }
  }

  /**
   * this method DOM checked.
   */
  ngAfterViewChecked(){

    // if (window.navigator.userAgent.indexOf("Chrome") != -1) {
    //   $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    // }

    if($('.langModal').length){
      if(this.isMobile) {
        if($('.exitModal').length > 0) {
          $('.langModal').css('max-height', $(window).height() - $('.languageHeader').outerHeight() - 25 + 'px');
        } else {
          $('.langModal').css('max-height', $(window).height() - $('.languageHeader').outerHeight() - 5 + 'px');
        }
      };
      if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)){
        $('.langModal').niceScroll({
          background: 'transparent',
          cursorcolor: '#7f7f7f',
          cursorwidth: '10px',
          autohidemode: false
        });
      }
    }
    if(this.isMobile && this.surveyData.SurveyDetails.GroupType != 'preview')
    {
      $('.langModal').css('overflow', 'auto');
    }
    if (this.surveyData != undefined && this.surveyData != null && !this.surveyData.CorpSettings.isPoweredByClient) {
      this.bottomfooterPos();
    }


  }

  /**
   * this event use for page destroy.
   */
  ngOnDestroy() {
    if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
      if(this.subscription_3){
        this.subscription_3.unsubscribe();
      }
    }
  }

  /**
   * this method use for page destroy.
   */
  //@HostListener('window:beforeunload')
  onBeforeUnload() {
    if (this.surveyData != undefined && this.surveyData != null) {
      let strfrom = (this.surveyData.SurveyDetails.strFrom != undefined ? '&strform=' + this.surveyData.SurveyDetails.strFrom : '&strform=');
      //let Uid = '&recno=' + this.surveyData.ResponseInfo.ResponseUID;
      let Uid = '&recno=' + encodeURIComponent(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", this.surveyData.ResponseInfo.ResponseUID));
      if (this.surveyData.SurveyDetails.GroupType != undefined
        && (this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PUBLIC"
          || this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PRIVATE")
        && this.pageNumber != 999) {
        let url = 'SurveyData/CloseEvent?k=' + this.surveyData.SurveyDetails.surveyKey + '&pageNo=' + (this.pageNumber + 1) + strfrom + Uid + "&strEvent=Close";
        if(this.isConnected==undefined){
          this.isConnected = navigator.onLine;
        }
        // if(this.isConnected && !this.isOfflineSurvey){
        if(!this.isOfflineSurvey){
          this.service.PostCloseEvent(url,
            JSON.stringify(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", this.surveyPageList))).subscribe();
        }
      }
    }
  }

  // @HostListener('window:unload')
  // unloadHandler() {
  //   let strfrom = (this.surveyData.SurveyDetails.strFrom != undefined ? '&strform=' + this.surveyData.SurveyDetails.strFrom : '&strform=');
  //   let Uid = '&recno='+this.surveyData.ResponseInfo.ResponseUID;
  //   if (this.surveyData.SurveyDetails.GroupType != undefined
  //     && (this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PUBLIC"
  //     || this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PRIVATE")
  //     && this.pageNumber != 999) {
  //     let url = 'SurveyData/CloseEvent?k=' + this.surveyData.SurveyDetails.surveyKey + '&pageNo=' + (this.pageNumber + 1) + strfrom + Uid ;
  //     this.service.PostCloseEvent(url).subscribe();
  //   }
  // }

  /**
   * this event use for mouse activity.
   */
   @HostListener('document:keyup')
   @HostListener('document:click')
   @HostListener('document:wheel')
   @HostListener('document:touchstart')
   @HostListener('document:touchend')
   resetTimer() {
     if(!this.isTimeOutMsg_2 && !this.isTimeOutMsg && !this.isOfflineSurvey){
       this.setTimer();
     }
     if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
       this.OfflineDashboard();
     }
   }

  /**
   * this event use for mouse activity.
   */
  @HostListener('document:keydown')
  focusTimeoutMessage() {
    if (this.isTimeOutMsg_2){
      this.elementref.nativeElement.querySelectorAll(".timeOutMsgWrapper")[0].focus();
    }
  }

  /**
   * this method use for set page expire time.
   */
  public setTimer() {
    if (this.surveyData != null && this.surveyData != undefined && 
      !(this.surveyData.SurveyDetails.intSourceID == 6 || this.surveyData.SurveyDetails.surveytype == 6 ||
        this.surveyData.SurveyDetails.intSourceID == 10 || this.surveyData.SurveyDetails.surveytype == 10 ) 
    ) {
      this.timer = timer((this.surveyData.SurveyDetails.TimeOutWarning1 * 1000) * 60);

      if(this.subscription){
        this.subscription.unsubscribe();
      }

      if(this.subscription_2){
        this.subscription_2.unsubscribe();
      }

      this.subscription = this.timer.subscribe(() => {
        if(!(this.isSaveAndContinue||this.isThankYouPage)){
          this.isTimeOutMsg = true;
          this.changeDetect.detectChanges();

          var self = this;
          setTimeout(() => {
            self.elementref.nativeElement.querySelectorAll(".timeOutMsgWrapper")[0].focus();
          }, 100);
        }
      });

      if (this.surveyData.SurveyDetails.TimeOutWarning1 > 0) {
        this.timer_2 = timer((this.surveyData.SurveyDetails.TimeOutWarning2 * 1000) * 60);

        this.subscription_2 = this.timer_2.subscribe(() => {
          if(!(this.isSaveAndContinue||this.isThankYouPage)){
            this.isTimeOutMsg = false;
            $('.ansclear-modal-overlay').hide();
            this.isTimeOutMsg_2 = true;
            this.changeDetect.detectChanges();
          }
        });
      }
    }
  }

  /**
   * this method use for handle div scroll.
   */
  ShowDivScroll() {
    $(document).ready(function () {
      $('.divScroll').each(function () {
        if ($(this).find('.answer-option-wrapper').outerWidth() > $(this).find('.question-data').outerWidth()) {
          $(this).find('.div-scroll-btn').show();
        }
      });

      $('.fieldset-wrapper-scroll').scroll(function () {
        if($('.RTLDir').length > 0) {
          if ($(this).find('.answer-option-wrapper').outerWidth() + $(this).scrollLeft() <= $(this).outerWidth() + 5) {
            $(this).parents('.divScroll').find('.div-scroll-btn').hide();
          } else if($(this).find('.answer-option-wrapper').outerWidth() + $(this).scrollLeft() > $(this).outerWidth() + 5) {
            $(this).parents('.divScroll').find('.div-scroll-btn').show();
          }
        } else {
          if ($(this).find('.answer-option-wrapper').outerWidth() - $(this).scrollLeft() <= $(this).outerWidth() + 5) {
            $(this).parents('.divScroll').find('.div-scroll-btn').hide();
          } else {
            $(this).parents('.divScroll').find('.div-scroll-btn').show();
          }
        }
      });
    });

    $(window).resize(function () {
      $('.divScroll').each(function () {
        if ($(this).find('.answer-option-wrapper').outerWidth() > $(this).outerWidth()) {
          $(this).find('.div-scroll-btn').show();
        } else {
          $(this).find('.div-scroll-btn').hide();
        }
      });
    });
  }

  /**
   * this method use for generating URL.
   * @param isLoading
   * @returns
   */
  GetUrlData(isLoading: boolean): any {
    this.activatedRoute.queryParams.subscribe(async params => {
      let k = params['k'];
      let Uid=""
      let Dir=""
      let langPop=""
      let lang = (params['lang'] == "" || params['lang'] == undefined) ? "0" : params['lang'];
      let goBackQuota = (params['isGoBackQuota'] == "" || params['isGoBackQuota'] == undefined) ? "" : "&isGoBackQuota=true";
      let isEmbedMobile   = (params['isEmbedMobile']=="" || params['isEmbedMobile'] == undefined)?"" : "&isEmbedMobile=1"
      let isEmbedPopMobile   = (params['isEmbedPopMobile']=="" || params['isEmbedPopMobile'] == undefined)?"" : "&isEmbedPopMobile=1"
      let isEmbedPopWeb  = (params['isEmbedPopWeb']=="" || params['isEmbedPopWeb'] == undefined)?"" : "&isEmbedPopWeb=1"
      let isPartial =  (params['isPartial']=="" || params['isPartial'] == undefined)?"" : "&isPartial=True"

      if (lang == undefined) {
        lang = (params['lang'] == "" || params['lang'] == undefined) ? "0" : params['lang'];
      }

      let status = (params['status'] != undefined || params['status'] != null || params['Status'] != undefined || params['Status'] != null ? '&status=preview' : '');

      if(status == '&status=preview'){
        this.isPreview = true;
        let isThankYou =  (params['isThankYou']=="" || params['isThankYou'] == undefined)?"" : "&isThankYou="+ params['isThankYou']
        let type =  (params['type'] == "" || params['type'] == undefined)?"" : "&type=" + params['type']
        let msgId =  (params['msgId'] == "" || params['msgId'] == undefined)?"" : "&msgId=" + params['msgId']
        let viewport =  (params['viewport'] == "" || params['viewport'] == undefined)?"" : "&viewport=" + params['viewport']
        status = status + isThankYou + type + msgId + viewport;
        if ($("#hdnCurrentLang", parent.document).val() != -1 && $("#hdnCurrentLang", parent.document).val()) {
          lang = $("#hdnCurrentLang", parent.document).val();
        }
      }

      if (!isLoading) {
        lang = this.selectedLang != undefined || this.selectedLang != null ? (this.selectedLang != this.surveyData.SurveySettings.primary_lang_id ? this.selectedLang : "0" ) : "0";
        //Dir = '&Dir=FST';
      }
      if (isLoading) {
        Uid = (params['Uid'] == "" || params['Uid'] == undefined) ? "" : '&responseID=' + encodeURIComponent(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", params['Uid']));
        Dir = (params['Dir'] == "" || params['Dir'] == undefined) ? "" : '&Dir=' + params['Dir'];
      }
      langPop = (params['langPop'] == "" || params['langPop'] == undefined) ? "" : '&langPop=' + params['langPop'];
      let data = params['data'];

      this.urlParam = 'k=' + k + '&lang=' + lang + Uid + status+ Dir + goBackQuota + isEmbedMobile+ isEmbedPopMobile +isEmbedPopWeb + isPartial + langPop;
      this.selectedLang = lang;
    });
    return this.urlParam;
  }

  /**
   * this method use for getData from API.
   * @param isLoading
   * @param responseUID
   * @param isLangChange
   */
  GetData(isLoading: boolean = true, responseUID: number = 0,isLangChange:boolean = false) {
    // // let url = 'assets/ParticipationData.json';
    // // let url = 'includes/Angular/assets/ParticipationData.json';

    // this.responseQuestions = [];
    // let strTick = "&Tick=" + this.commonSetting.strTick;
    // let dir = isLangChange ? 'FST' : '';
    // let URlData = this.GetUrlData(isLoading);

    // let url: any;
    // if (URlData.indexOf('responseUID') > 0) {
    //   url = 'SurveyData/get?' + this.GetUrlData(isLoading) + '&Dir=' + dir + strTick;
    // }
    // else {
    //   url = 'SurveyData/get?' + this.GetUrlData(isLoading) + '&responseUID=' + responseUID + '&Dir=' + dir + strTick;
    // }

    if(this.isConnected==undefined){
      this.isConnected = navigator.onLine;
    }
    // // if(this.isConnected && !this.isOfflineSurvey){
    if(!this.isOfflineSurvey){
      this.responseQuestions = [];
      let strTick = "&Tick=" + this.commonSetting.strTick;
      let dir = isLangChange ? 'FST' : '';
      let URlData = this.GetUrlData(isLoading);

      let url: any;
      if (URlData.indexOf('responseID') > 0) {
        url = 'SurveyData/get?' + this.GetUrlData(isLoading) + '&Dir=' + dir + strTick;
      }
      else {
        url = 'SurveyData/get?' + this.GetUrlData(isLoading) + '&responseID=' + encodeURIComponent(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", responseUID)) + '&Dir=' + dir + strTick;
      }
    this.service.GetData(url).subscribe(async (data) => {
      //this.surveyData = await data.SurveyData;
      //this.surveySpecificData = await data.SurveySpecificData;
      var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF", await data);
      //console.log('Encrypted :' + arrData);
      var arrData = JSON.parse(arrData);
      this.surveyData = await arrData.SurveyData;
      this.surveySpecificData = await arrData.SurveySpecificData;
      let Dir = "";
      let lang = "0";

      if (this.surveyData.SurveyDetails.GroupType.toLocaleLowerCase() != "preview" && this.surveySpecificData != undefined &&
        this.surveySpecificData.Participation_Message_Type != 51 && this.surveySpecificData.Participation_Message_Type != 5 &&
        this.getAcceptCookie("Consent") == "" && this.isEU_Country(this.surveySpecificData.GeoLocation)) {
        this.isAcceptCookies = true;
      }
      if (this.surveySpecificData.PrePopDetails) {
        let populationDetail = this.surveySpecificData.PrePopDetails.filter(rule => rule.isHide);
        if (populationDetail != null && populationDetail.length >0) {
          this.surveyData.SurveySettings.DisplayQno = false;
        }
      }

      this.setTimer();

      if (this.surveySpecificData.Participation_Message_Type != 0) {
        if (this.surveySpecificData.Participation_Messages.isErrorRedirect) {
          this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
          this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
          this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
          this.CheckCookieforDelete('Get Data 1');
          window.location.replace(this.surveySpecificData.Participation_Messages.RedirectURL);
        }
      }
      this.activatedRoute.queryParams.subscribe(async params => {
        Dir = params["Dir"]
        lang = params["lang"]
      });
      this.productName = this.surveyData.CorpSettings.strProduct;
      this.questionSpacerHeight = this.surveyData.SurveySettings.questionSpacer;


      //preview page handling.
      if (this.preview != undefined && this.surveyData.SurveyDetails.GroupType == 'preview' && !this.isEditedResponse) {
        this.PreviewPageHandling();
        this.service.setPreviewData(this.preview);
      }
      //Common Setting
      this.service.setCommonSetting(this.commonSetting);
      this.service.setIsEx(this.surveyData.SurveySettings.isEx);
      this.service.setdropDownCount(this.commonSetting.dropDownCount);
      this.service.setImageFolder(this.commonSetting.ImageFolder);
      this.service.setMDDdropDownCount(this.commonSetting.MDDdropDownCount);
      if (this.commonSetting != undefined) {

        this.isMobile = this.commonSetting.isMobileDevice;
        this.isTablet =this.commonSetting.isTablet;
        if(this.isTablet)
        {
            if(navigator.maxTouchPoints > 1  || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || navigator.userAgent.toLowerCase().indexOf('ipad') > -1)
            {
                this.isTablet  = true;
            }
            else
            {
              this.isTablet  = false;
            }
        }
        this.service.setMobile(this.isMobile);
        if (this.isMobile) {
          this.isDeviceCSS = "mobile-wrapper";
          if (this.isPreview && $("#previewViewport", parent.document).length == 0) {
            var body = document.body;
            body.classList.add('mobile-scroll');
          }
         else if(!this.isPreview && !this.commonSetting.isEmbedMobile && !this.commonSetting.isEmbedPopMobile)
         {
            var body = document.body;
            body.classList.add('mobile-scroll');
          }else if ((this.commonSetting.isEmbedMobile || this.commonSetting.isEmbedPopMobile)  && navigator.maxTouchPoints >= 1) {
            var body = document.body;
            body.classList.add('mobile-scroll');
          }
          if(this.commonSetting.isEmbedMobile)
          {
            var body = document.body;
            body.classList.add('mobile-embed');
          }
        }
        else if(this.isTablet){
          this.isDeviceCSS ="tablet-wrapper";
          if (this.isPreview && $("#previewViewport", parent.document).length == 0) {
            var body = document.body;
            body.classList.add('mobile-scroll');
          }
          else if(navigator.maxTouchPoints > 1)
          {
            var body = document.body;
            body.classList.add('mobile-scroll');
          }
        }
        else if(this.isPreview && $("#previewViewport", parent.document).length > 0)
        {
            var viewport = $("#previewViewport", parent.document).attr('src');
              if(viewport.indexOf('viewport=mobile') > 0 )
              {
                this.isDeviceCSS = "mobile-wrapper";
                this.isMobile = true;
              }
              else if(viewport.indexOf('viewport=tablet') > 0 )
              {
                this.isDeviceCSS = "tablet-wrapper";
                this.isTablet = true;
              }
        }
        else {
          this.isDeviceCSS = "";
        }
        // this.IsMobileDevice();
      }
      if((this.surveyData.SurveyDetails.intSourceID == 6 || this.surveyData.SurveyDetails.surveytype == 6 ||
        this.surveyData.SurveyDetails.intSourceID == 10 || this.surveyData.SurveyDetails.surveytype == 10 )) 
      {
        var body = document.body;
        body.classList.add('embed-survey');
      }
      this.checkcookie();
      this.service.setSurveyMessages(this.surveyData.SurveyMessages);
      if (this.surveyData.SurveyDetails.GroupType == 'preview'
        && $("#ddPreview", parent.document).length != 0
        && $("#ddPreview", parent.document).val() != 1
        ) {
          if($("#ddPreview", parent.document).val() == -1 && (this.preview.PrevPgNo != 999 && this.isPrevPgChnge))
          {
            $("#ddPreview", parent.document).val(1);
            this.pageNumber = 0;
            this.isThankYouPage =false;
          }
          else if($("#ddPreview", parent.document).val() == -1 && this.surveyData.SurveyDetails.isSurveyReopened)
          {
            $("#ddPreview", parent.document).val(1);
            this.pageNumber = 0;
            this.isThankYouPage =false;
          }

          if($("#ddPreview", parent.document).val() != -1) {
            this.pageNumber = ($("#ddPreview", parent.document).val() - 1);
          }

          if (this.preview.isPreviewToggle) {
            this.pageNumber = 0;
            this.isThankYouPage =false;
            $("#ddPreview", parent.document).val(1)
          }
      }
      else if(this.isPreview && this.preview.isPagePreview && this.preview.PrevPgNo!= 999 )
      {
          this.pageNumber = this.preview.PrevPgNo -1;
      }
      else if(this.surveyData.SurveyDetails.quotaPageNumber != null
        && this.surveyData.SurveyDetails.quotaPageNumber != undefined
        && this.surveyData.SurveyDetails.quotaPageNumber != 0)
      {
        this.pageNumber = (this.surveyData.SurveyDetails.quotaPageNumber -1)
      }
      else {
        this.pageNumber = 0;
      }

      this.titleService.setTitle(this.surveyData.SurveySettings.SurveyTitle);

      this.isPrintDownload = this.surveyData.SurveyDetails.IsPrintDownload;
      this.maxPageNumber = this.surveyData.SurveySettings.MaxPageNo;
      this.surveyTitle = this.surveyData.SurveySettings.SurveyTitle;
      this.nextButtonClickNo = 0;
      //if(this.surveyData.SurveyDetails.GroupType == 'preview'){
      if(this.isPreview && $("#previewViewport", parent.document).length > 0){
        parent.document.title = this.surveyTitle;
      }
      this.isRTL = this.surveyData.SurveyDetails.isRTL;
      this.service.setRTL(this.isRTL);
      this.service.setCustomAttachmentSizeSurveyID(this.surveyData.SurveyDetails.CustomAttachmentSizeSurveyID);
      this.service.setSurveyID(this.surveyData.SurveySettings.zarca_id.toString());
      this.service.setCorpNo(this.surveyData.CorpSettings.corporate_no.toString());
      this.service.setCurrencyNegativeMessage(this.surveyData.SurveyMessages.CurrencyNegativeValueMessage);

      if (isLoading) {

        this.service.setSureyDetails(this.surveyData.SurveyDetails.surveyKey, this.surveyData.ResponseInfo.ResponseUID,
          this.surveyData.SurveyDetails.GroupType, this.surveyData.SurveyMessages.ReEnterBlankMessage,
          this.surveySpecificData.GeoLocation, this.surveyData.CorpSettings.strProduct);
        this.isControlLoading = true;
        //this.surveyData.SurveyDetails.Dir = null;

          if(this.surveyData.Groups && this.surveyData.Groups.length > 0)
          {
            this.CheckAllQDLGroup();
          }

        if (this.surveyData.SurveyDetails.BGImgPosition == 'Gradients') {
          this.surveyBackground = this.surveyData.SurveySettings.SurveyBackgroundImage + ' BackGroundChanges';
        }
        else {
          this.surveyBackground = 'page-bg-img BackGroundChanges';
        }

        if (this.surveyData.LanguageDatas.length > 1
          && ((!this.preview.isPagePreview && !this.preview.isPrevPgChnge)
          || this.preview.isPreviewToggle)) {
            if (this.surveyData.SurveySettings.isAssessment &&
              this.surveySpecificData.Participation_Message_Type == 0 &&
              this.surveyData.SurveySettings.SurveyTimeLimit > 0 && !this.isAcceptCookies) {
              this.CountDownTimer();
            }
          if (this.surveyData.SurveyDetails.GroupType == 'preview'
              && $("#hdnCurrentLang", parent.document).length != 0 &&
              $("#hdnCurrentLang", parent.document).val() != -1) {
            this.selectedLang = $("#hdnCurrentLang", parent.document).val();
            if (this.preview.isPreviewToggle) {
              this.multiLanguage = true;
              this.setLangBasedOnBrowser();
            }
            else {
              this.multiLanguage = false;
            }
            this.selectedLanguage = true;
            let CurrentLandData = this.surveyData.LanguageDatas.filter(
              e => e.lang_id == this.selectedLang);
            this.selectedLanguageName = CurrentLandData[0].LanguageName;
          }
          else {
            if(Dir=="FST")
            {
              let selLang = (lang == "0" || lang == undefined) ? this.surveyData.SurveySettings.primary_lang_id : parseInt(lang);
              this.selectedLanguageName = this.getLanguageName(selLang);
              this.multiLanguage = false;
              this.selectedLanguage = true;
            }
            else if (!this.preview.isPrevPgChnge && this.preview.PrevPgNo!=0)
            {
              if (
                this.surveyData.SurveyDetails.GroupType == "preview" &&
                $("#hdnCurrentLang", parent.document).length != 0 &&
                $("#hdnCurrentLang", parent.document).val() != -1
              ) {
                this.selectedLang = $("#hdnCurrentLang", parent.document).val();
                let CurrentLandData = this.surveyData.LanguageDatas.filter(
                  e => e.lang_id == this.selectedLang
                );
                this.selectedLanguageName = CurrentLandData[0].LanguageName;
              } else {
                let selLang =
                  lang == "0" || lang == undefined || lang == ""
                    ? this.surveyData.SurveySettings.primary_lang_id
                    : parseInt(lang);
                this.selectedLanguageName = this.getLanguageName(selLang);
              }
              this.multiLanguage = false;
              this.selectedLanguage = true;
            }
            else
            {
              let lang = "";
              let langPop = "";
              this.activatedRoute.queryParams.subscribe(async params => {
                lang = (params['lang'] == "" || params['lang'] == undefined) ? "0" : params['lang'];
                langPop = (params['langPop'] == "" || params['langPop'] == undefined) ? "1" : params['langPop'];
              });
              if (langPop == "1") {
                this.multiLanguage = true;
                this.selectedLanguage = false;
                this.setLangBasedOnBrowser();
              
              } else {
                if (lang == "0" && this.surveyData.LanguageDatas.filter(
                  e => e.lang_id.toString() == lang
                ).length == 0) {
                  lang = this.surveyData.SurveySettings.primary_lang_id.toString();
                }
                this.GetLanguageId(this.surveyData.LanguageDatas.find(
                  e => e.lang_id.toString() == lang
                ))
              }
            }
          }
        } else {
          if (this.surveyData.SurveySettings.isAssessment &&
            this.surveySpecificData.Participation_Message_Type == 0 &&
            this.surveyData.SurveySettings.SurveyTimeLimit > 0 && !this.isAcceptCookies) {
            this.CountDownTimer();
          }

          this.multiLanguage = false;

          if (!this.isThankYouPage) {
            this.selectedLanguage = true;
          }

          if (
            this.surveyData.SurveyDetails.GroupType == "preview" &&
            $("#hdnCurrentLang", parent.document).length != 0 &&
            $("#hdnCurrentLang", parent.document).val() != -1
          ) {
            this.selectedLang = $("#hdnCurrentLang", parent.document).val();
            let CurrentLandData = this.surveyData.LanguageDatas.filter(
              e => e.lang_id == this.selectedLang
            );
            if (CurrentLandData.length == 0 && this.selectedLang == 0) {
              CurrentLandData = this.surveyData.LanguageDatas.filter(
                e => e.lang_id == this.surveyData.SurveySettings.primary_lang_id
              );
            }
            this.selectedLanguageName = CurrentLandData[0].LanguageName;
          } else {
            let selLang =
              lang == "0" || lang == undefined || lang == ""
                ? this.surveyData.SurveySettings.primary_lang_id
                : parseInt(lang);
            this.selectedLanguageName = this.getLanguageName(selLang);
          }
        }
        this.addPageBGClass();
      }
      if(this.surveyData.Groups && this.surveyData.Groups.length > 0)
      {
        this.CheckAllQDLGroup();
      }

      if (this.surveyData.Matrix != null && this.surveyData.Matrix != undefined) {
        this.MatrixGridQuationHandle();
      }
      let strSavedPageList = this.surveyData.SurveyDetails.SavedPageList;
      if(strSavedPageList != null
        && strSavedPageList != undefined
        && strSavedPageList !=""
        && strSavedPageList.indexOf(",") > 0)
      {
        this.surveyPageList = [];
        this.assesmentAutoSavePageList = [];
        this.ReopenPageList = [];
        let arrSavedPageList = strSavedPageList.split(',');
        for(let k = 0; k < arrSavedPageList.length; k++)
        {
          //if(this.surveyData.SurveyDetails.isSurveyReopened)
          //{
            this.ReopenPageList.push(parseInt(arrSavedPageList[k]));
          //}
          this.surveyPageList.push(parseInt(arrSavedPageList[k]));

          if (this.surveyData.SurveySettings.isAssessment) {
            this.assesmentAutoSavePageList.push(parseInt(arrSavedPageList[k]));
          }
        }
        if(this.surveySpecificData.Participation_Message_Type == 7 || this.surveySpecificData.Participation_Message_Type == 3)
        {
          let lastListPage = arrSavedPageList[(arrSavedPageList.length -1)];
          let isskippedPageList
          for(let k = 0; k < this.maxPageNumber; k++)
          {
            
            if(this.surveyPageList.indexOf((k+1)) == -1 && parseInt(lastListPage) > ((k+1)))
            {
              this.skippedPageList.push((k+1));
              // isskippedPageList = true;
              // this.surveyData.Pages[k].Questions.forEach(element => {
              //   if(this.surveySpecificData.ParticipationResponseData.ResponseDatas.filter(e=>(e.QuestionID==element.UniqueNumber)).length>0){
              //     isskippedPageList = false;
              //     return true;
              //   }
              // });
              // if(isskippedPageList){
                
              // }
            }
          }
        }
        else
        {
          for(let k = 0; k < this.maxPageNumber; k++)
          {
            if(this.surveyPageList.indexOf((k+1)) == -1)
            {
              this.skippedPageList.push((k+1));
            }
          }
        }
      }
      this.skippedPageList =this.UniqueArray(this.skippedPageList);

      if (this.surveySpecificData.Participation_Message_Type != 0) {
          this.isRemoveBackGround = true;
          this.removePageBGClass();
          this.isSaveAndContinue = true;
          this.multiLanguage = false;
          this.selectedLanguage = false;
          this.isPrintDownload = false;
          this.pageNumber = 999;
          this.changeDetect.detectChanges();
          // if (this.surveyData.SurveyDetails.GroupType == 'preview') {
          //   $("#ddPreview", parent.document).val(-1);
          // }
      }

      // Issue No.  124474 : Open : [ANG] 1st Pre hidden page is shown for a split second on reopening
      // Reopen case response update before page set.
      if (this.surveyData.SurveyDetails.isSurveyReopened &&
        this.surveySpecificData.Participation_Message_Type == 0 &&
        this.allQuestionHideOnPage(this.pageNumber, false, true, true, false)) {
        this.isEditedResponse = true;
        this.multiLanguage = false;
        this.selectedLanguage = true;
        this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
        this.SurveyResponseUpdate();
      }

      this.dataPopulationOnLoading(isLangChange);

      this.AllPageQuestionDisplayLogic();
      this.AllPageAnswerDisplayLogic();
      if (this.pageNumber != 999) {
        if (this.allQuestionHideOnPage(this.pageNumber, false, true,true,false)) {
          let showMessage = this.isAllQuestionHideMessage;
          if (this.pageNumber == 0 && !this.preview.isShowHiddenQN) {
            this.isAllQuestionHideOnPrevPages = true;
            this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
          }
          if (!this.isPrevPgChnge && !this.preview.isPagePreview) {
            this.selectedLanguage = false;
            this.GetNextPage(this.pageNumber,true);
          }
          else if (showMessage) {
            this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
            this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
          }
        }
        else if (this.pageNumber == 0 && this.preview.isShowHiddenQN) {
          this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
        }
        else if(this.isPrevPgChnge)
        {
          this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
          this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
        }
        else if(this.pageNumber == 0 && !this.isPreview)
        {
          this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
        }
      }

      this.isRTL = this.surveyData.SurveyDetails.isRTL;
      this.service.setRTL(this.isRTL);

      this.productName = this.surveyData.CorpSettings.strProduct;
      if(this.pageNumber == 999)
      {
        this.changeDetect.detectChanges();
      }


  
      if(isLangChange)
      {
        setTimeout(() => {
          if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile || this.commonSetting.isEmbedPopMobile)
          this.bodyNiceScrollResize()
        }, 250);
        this.showLoader = false;
      }


      if (this.surveySpecificData.ParticipationResponseData != null &&
        this.surveySpecificData.ParticipationResponseData.ResponseDatas != null  &&
         this.surveyData.CorpSettings.account_type != 10) {
        if (this.surveyData.SurveyDetails.GroupType == 'preview'
          && $("#ddPreview", parent.document).length != 0) {
          this.pageNumber = 0;
          $("#ddPreview", parent.document).val(1);
        }

        if((!this.surveyData.CorpSettings.IsSaveOnNext || this.surveyData.SurveySettings.isAssessment) && this.surveySpecificData.Participation_Message_Type == 0 && !this.surveyData.SurveyDetails.isTest)
        {
          this.multiLanguage = false;
          this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
          if(Dir == "FST"){
            this.SurveyResponseUpdate();
            this.AllPageQuestionDisplayLogic();
            this.AllPageAnswerDisplayLogic();
          }
        }
        else
        {
          this.multiLanguage = false;
          this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
          //this.selectedLanguage = true;
          this.selectedLanguageName = this.getLanguageName(this.surveyData.SurveyDetails.selectedLangId);
          this.SurveyResponseUpdate();
          this.AllPageQuestionDisplayLogic();
          this.AllPageAnswerDisplayLogic();
        }
        if(this.surveyData.SurveyDetails.isTest){
          this.selectedLanguage = true;
        }
      }

      if(this.surveyData.SurveyDetails.isSurveyReopened 
        && this.surveySpecificData.Participation_Message_Type == 0
        && this.surveyData.SurveyDetails.embedLangOpt > 0)
      {
        this.isHideHambugforEmbedMob = true;
        this.isHideEmbedWebHeader = true;
      }

       // Issue No.  124474 : Open : [ANG] 1st Pre hidden page is shown for a split second on reopening
      if (this.surveyData.SurveyDetails.isSurveyReopened &&
        this.surveySpecificData.Participation_Message_Type == 0 &&
        !this.allQuestionHideOnPage(this.pageNumber, false, true, true, false)) {
        this.isEditedResponse = true;
        this.multiLanguage = false;
        this.selectedLanguage = true;
        this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
        this.SurveyResponseUpdate();
        this.AllPageQuestionDisplayLogic();
        this.AllPageAnswerDisplayLogic();
      }

      if(this.preview.isPagePreview && this.isBlankPage(this.pageNumber)){
        this.isSaveAndContinue = true;
        this.multiLanguage = false;
        this.selectedLanguage = false;
        this.isPrintDownload = false;
        this.pageNumber = 999;
        this.surveySpecificData.Participation_Message_Type = 14;
        this.isRemoveBackGround = true;
        this.removePageBGClass();
        this.surveySpecificData.Participation_Messages.Error_Header = this.surveyData.SurveyMessages.Message;
        this.surveySpecificData.Participation_Messages.Error_Message = "This page contains all hidden question so no preview available for this page.";
        this.changeDetect.detectChanges();
      }

      //isSurveyEndonPage
      if(this.pageNumber != 999 && !this.preview.isPrevPgChnge && !this.preview.isShowHiddenQN)
      {
        this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
      }
      if(this.pageNumber != 999 && !this.preview.isShowHiddenQN){
        this.EndSurveyOnPage();
        if(this.surveyData.Pages[0].isEndSurvey)
        {
          this.isEndSurveyOnPage = true;
        }
      }



      if (this.pageNumber != 999 && this.pageNumber < this.maxPageNumber) {
        if(this.isOfflineSurvey){
          if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM' && !(e.qtype == 'T'  && (e.qsubtype == 71  || e.qsubtype == 72))).length > 0) {
            this.isMandatory = true;
          }
        }else{
          if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM').length > 0) {
            this.isMandatory = true;
          }
        }
      }

      this.surveyDisplayPageList1 = [];
      this.surveyDisplayPageList2 = [];
      let maxPageCount=0;
      this.isBackClick = true;
      if(this.surveyData.Pages !=null)
      {
      for (let i = 0; i < this.surveyData.Pages.length; i++) {
          if(!this.allQuestionHideOnPage(i,true,true,false,false))
          {
            maxPageCount = maxPageCount + 1;
            this.surveyDisplayPageList1.push((maxPageCount));
            this.surveyDisplayPageList2.push(this.surveyData.Pages[i].Page_no);
          }
      }
    }

      if (this.surveyData.SurveyDetails.GroupType == "preview" && this.previewSurveyFormat > -1) {
        if (this.previewSurveyFormat > 0) {
          if(this.previewSurveyFormat == 1)
          {
            this.questionSpacerHeight = 55;
          }
          else if(this.previewSurveyFormat == 2)
          {
            this.questionSpacerHeight = 255;
          }
          this.isNewParticipation = true;
          this.surveyFormat = this.previewSurveyFormat;
          if(this.surveyData.SurveyDetails.isNewParticipation){
            this.service.isAutoScroll = this.surveyData.SurveyDetails.isAutoScroll;
          }
          else{
            this.service.isAutoScroll = true;
          }

        } else {
          this.isNewParticipation = false;
          this.surveyFormat = 0;
          this.questionSpacerHeight = 40;
        }
      } else {
        this.isNewParticipation = this.surveyData.SurveyDetails.isNewParticipation;
        this.surveyFormat = this.surveyData.SurveyDetails.surveyFormat;
        this.service.isAutoScroll = this.surveyData.SurveyDetails.isAutoScroll;
      }

      if (this.surveyData.SurveyDetails.GroupType == "preview" && $(".surveyFormatDDValue", parent.document).length == 1) {
          if(this.surveyFormat == 1)
          {
              $(".surveyFormatDDValue", parent.document).text('Compact');
          }
          else if(this.surveyFormat == 2)
          {
              $(".surveyFormatDDValue", parent.document).text('Comfortable');
          }
          else
          {
            $(".surveyFormatDDValue", parent.document).text('Classic');
          }
      }


      var self = this
      if(this.surveyFormat == 1) {
        $("body").on("mouseover", ".ques-overlay", function() {
          self.activateQuestionOnHover(this);
        });
      }

      if (this.surveyData.SurveyDetails.GroupType == "preview") {
        $("#ddParticipationFormat", parent.document).val(this.surveyFormat);
      }

      this.service.isNewParticipation = this.isNewParticipation;
      this.service.surveyFormat = this.surveyFormat;
      if(this.isNewParticipation && (this.surveyFormat == 2 || this.surveyFormat == 1)){
        this.newParticipationBtnText = this.surveyData.SurveyDetails.newParticipationBtnText;
        this.service.newParticipationBtnText = this.newParticipationBtnText;
        this.showNewParticipationScroll();
        this.setIsFirstShowQuestion();
      }
      let selectedCulture;
      if (this.selectedLang == 0) {
        selectedCulture = this.getLanguageCulture(this.surveyData.SurveySettings.primary_lang_id);
      } else {
        selectedCulture = this.getLanguageCulture(this.selectedLang);
      }
     //let selectedCulture = this.getLanguageCulture(this.selectedLang);
      this.service.setSelectedLanguageCulture(selectedCulture);
      this.service.setSelectedLanguage(this.selectedLang);
      this.isCapchaDarkTheme = this.surveyData.SurveySettings.isDarkTheme;
      this.isBackClick = false;
      let path = 'survey1.aspx?' + this.GetUrlData(false);
      this.router.navigateByUrl(path);
      this.changeDetect.detectChanges();
      setTimeout(() => {
        this.calculateWidthPageFooter();
      }, 0);
     
      setTimeout(() => {
        if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
        this.bodyNiceScrollResize()
      

        if(this.commonSetting.isEmbed == 1 || this.commonSetting.isEmbedMobile == 1
          || this.commonSetting.isEmbedPopMobile== 1 ||this.commonSetting.isEmbedPopWeb == 1 || this.commonSetting.embedID > 0) {
          if(this.commonSetting.isEmbedNoScroll && window.location !== window.parent.location )
          {
            let docHeight = document.documentElement.scrollHeight;
            if ($('form').height() != undefined && $('form').height() != 0) {
              docHeight = $('form').height();
            }
              $('.langModal').css('max-height','unset');
              $('.langModal').css('overflow','auto'); 
      
              if(this.multiLanguage && docHeight < ($('.langModal').height() + 200) )
              {
                docHeight = ($('.langModal').height() + 250); 
              }
              if(isLoading && docHeight < 200)
              {
                docHeight = 400;
              }
              $('.langModal').css('max-height','calc(100vh - 20vh)');
              $('.langModal').css('overflow','hidden'); 
              this.postMessgesData = new PostMessgesData()
              this.postMessgesData.action=(this.isLangSetonLoading || isLoading)?'Project Load':'Project Language Change';
              this.postMessgesData.data='';
              this.postMessgesData.height= docHeight + (this.commonSetting.embedDefaultPx? this.commonSetting.embedDefaultPx : 0 ) ;
              this.postMessgesData.width = document.documentElement.scrollWidth;
              this.postMessgesData.embedid = this.commonSetting.embedID;
              this.isLangSetonLoading = false;
                parent.postMessage(JSON.stringify(this.postMessgesData),"*");
          }
        }
      }, 250);
      this.isinitLoading=false;
    }, error => {
      //console.log(error);
      this.errorsHandlerService.handleError(error);
      if(error.name =="HttpErrorResponse")
      {
        //this.form.resetForm();
          window.location.replace(this.service.getBasePath() +"/surveydecode.aspx?err=1&ng=1&cn=" + this.cp_no);
      }
    }
    );
    }else{

      let k='';
      let lang1='';
    this.activatedRoute.queryParams.subscribe(async params => {
      k = params['k'];
      //lang1= this.selectedLang.toString();// params["lang"];

      if (this.selectedLanguageName != undefined && this.selectedLang != undefined) {
        lang1 = this.selectedLang.toString();
      } else {
        lang1 = (params['lang'] == undefined) ? "0" : params['lang'];
      }
    });

      var Editresponse = this.storage.get('Editresponse_' + k) || [];

      if (Editresponse.length > 0) {
        Editresponse = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', Editresponse);
        Editresponse = JSON.parse(Editresponse);
      }

      this.isOfflineTimeout=false;
      var data1;
        if (Editresponse.ResponseDatas != undefined && Editresponse.ResponseDatas.length > 0) {
          lang1= Editresponse.ResponseCommanData.ResponseLangID;
          this.selectedLang=Number(lang1);
          //this.multiLanguage=false;
          //this.selectedLanguage=true;
          //this.pageNumber=0;
          data1 = this.storage.get('SurveyData1_' + k+'_'+lang1);

          var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF", data1);
          //console.log('Encrypted :' + arrData);
          data1 = JSON.parse(arrData);


          this.surveyData =  data1.SurveyData;
          this.surveySpecificData =  data1.SurveySpecificData;
          let Dir = "";
          let lang = "0";


        if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
          this.OfflineDashboard();
        }
        if (this.surveySpecificData.Participation_Message_Type != 0) {
          if (this.surveySpecificData.Participation_Messages.isErrorRedirect) {
            this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
            this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
            this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
            this.CheckCookieforDelete('Get Data 2');
            window.location.replace(this.surveySpecificData.Participation_Messages.RedirectURL);
          }
        }
        this.activatedRoute.queryParams.subscribe(async params => {
          Dir = params["Dir"]
          lang = params["lang"]
        });
        this.productName = this.surveyData.CorpSettings.strProduct;
        this.questionSpacerHeight = this.surveyData.SurveySettings.questionSpacer;


        //preview page handling.
        if (this.preview != undefined && this.surveyData.SurveyDetails.GroupType == 'preview' && !this.isEditedResponse) {
          this.PreviewPageHandling();
          this.service.setPreviewData(this.preview);
        }
        //Common Setting
        this.service.setCommonSetting(this.commonSetting);
        this.service.setIsEx(this.surveyData.SurveySettings.isEx);
        this.service.setdropDownCount(this.commonSetting.dropDownCount);
        this.service.setImageFolder(this.commonSetting.ImageFolder);
        this.service.setMDDdropDownCount(this.commonSetting.MDDdropDownCount);
        if (this.commonSetting != undefined) {

          this.isMobile = this.commonSetting.isMobileDevice;
          this.isTablet =this.commonSetting.isTablet;
          if(this.isTablet)
          {
              if(navigator.maxTouchPoints > 1  || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || navigator.userAgent.toLowerCase().indexOf('ipad') > -1)
              {
                  this.isTablet  = true;
              }
              else
              {
                this.isTablet  = false;
              }
          }
          this.service.setMobile(this.isMobile);
          if (this.isMobile) {
            this.isDeviceCSS = "mobile-wrapper";
            if (this.isPreview && $("#previewViewport", parent.document).length == 0) {
              var body = document.body;
              body.classList.add('mobile-scroll');
            }
           else if(!this.isPreview && !this.commonSetting.isEmbedMobile && !this.commonSetting.isEmbedPopMobile)
           {
              var body = document.body;
              body.classList.add('mobile-scroll');
            }
          }
          else if(this.isTablet){
            this.isDeviceCSS ="tablet-wrapper";
            if ($("#previewViewport", parent.document).length == 0) {
              var body = document.body;
              body.classList.add('mobile-scroll');
            }
            else if(navigator.maxTouchPoints > 1)
            {
              var body = document.body;
              body.classList.add('mobile-scroll');
            }
          }
          else if(this.isPreview && $("#previewViewport", parent.document).length > 0)
          {
              var viewport = $("#previewViewport", parent.document).attr('src');
                if(viewport.indexOf('viewport=mobile') > 0 )
                {
                  this.isDeviceCSS = "mobile-wrapper";
                  this.isMobile = true;
                }
                else if(viewport.indexOf('viewport=tablet') > 0 )
                {
                  this.isDeviceCSS = "tablet-wrapper";
                  this.isTablet = true;
                }
          }
          else {
            this.isDeviceCSS = "";
          }
          // this.IsMobileDevice();
        }
        this.checkcookie();
        this.service.setSurveyMessages(this.surveyData.SurveyMessages);
        if (this.surveyData.SurveyDetails.GroupType == 'preview'
          && $("#ddPreview", parent.document).length != 0
          && $("#ddPreview", parent.document).val() != 1
          ) {
            if($("#ddPreview", parent.document).val() == -1 && (this.preview.PrevPgNo != 999 && this.isPrevPgChnge))
            {
              $("#ddPreview", parent.document).val(1);
              this.pageNumber = 0;
            }
            else if($("#ddPreview", parent.document).val() == -1 && this.surveyData.SurveyDetails.isSurveyReopened)
            {
              $("#ddPreview", parent.document).val(1);
              this.pageNumber = 0;
            }

            if($("#ddPreview", parent.document).val() != -1) {
              this.pageNumber = ($("#ddPreview", parent.document).val() - 1);
            }

            if (this.preview.isPreviewToggle) {
              this.pageNumber = 0;
              $("#ddPreview", parent.document).val(1)
            }
        }
        else if(this.isPreview && this.preview.isPagePreview && this.preview.PrevPgNo!= 999 )
        {
            this.pageNumber = this.preview.PrevPgNo -1;
        }
        else if(this.surveyData.SurveyDetails.quotaPageNumber != null
          && this.surveyData.SurveyDetails.quotaPageNumber != undefined
          && this.surveyData.SurveyDetails.quotaPageNumber != 0)
        {
          this.pageNumber = (this.surveyData.SurveyDetails.quotaPageNumber -1)
        }
        else {
          this.pageNumber = 0;
        }

        this.titleService.setTitle(this.surveyData.SurveySettings.SurveyTitle);

        this.isPrintDownload = this.surveyData.SurveyDetails.IsPrintDownload;
        this.maxPageNumber = this.surveyData.SurveySettings.MaxPageNo;
        this.surveyTitle = this.surveyData.SurveySettings.SurveyTitle;
        this.nextButtonClickNo = 0;
        if(this.surveyData.SurveyDetails.GroupType == 'preview'){
          //parent.document.title = this.surveyTitle;
        }
        this.isRTL = this.surveyData.SurveyDetails.isRTL;
        this.service.setRTL(this.isRTL);
        this.service.setCustomAttachmentSizeSurveyID(this.surveyData.SurveyDetails.CustomAttachmentSizeSurveyID);
        this.service.setSurveyID(this.surveyData.SurveySettings.zarca_id.toString());
        this.service.setCorpNo(this.surveyData.CorpSettings.corporate_no.toString());
        this.service.setCurrencyNegativeMessage(this.surveyData.SurveyMessages.CurrencyNegativeValueMessage);

        if (isLoading) {

          this.service.setSureyDetails(this.surveyData.SurveyDetails.surveyKey, this.surveyData.ResponseInfo.ResponseUID,
            this.surveyData.SurveyDetails.GroupType, this.surveyData.SurveyMessages.ReEnterBlankMessage,
            this.surveySpecificData.GeoLocation, this.surveyData.CorpSettings.strProduct);
          this.isControlLoading = true;
          //this.surveyData.SurveyDetails.Dir = null;

          if(this.surveyData.Groups && this.surveyData.Groups.length > 0)
          {
            this.CheckAllQDLGroup();
          }

          if (this.surveyData.SurveyDetails.BGImgPosition == 'Gradients') {
            this.surveyBackground = this.surveyData.SurveySettings.SurveyBackgroundImage + ' BackGroundChanges';
          }
          else {
            this.surveyBackground = 'page-bg-img BackGroundChanges';
          }

          if (this.surveyData.LanguageDatas.length > 1
            && ((!this.preview.isPagePreview && !this.preview.isPrevPgChnge)
            || this.preview.isPreviewToggle)) {
            if (this.surveyData.SurveyDetails.GroupType == 'preview'
                && $("#hdnCurrentLang", parent.document).length != 0 &&
                $("#hdnCurrentLang", parent.document).val() != -1) {
              this.selectedLang = $("#hdnCurrentLang", parent.document).val();
              if (this.preview.isPreviewToggle) {
                this.multiLanguage = true;
                this.setLangBasedOnBrowser();
              }
              else {
                this.multiLanguage = false;
              }
              this.selectedLanguage = true;
              let CurrentLandData = this.surveyData.LanguageDatas.filter(
                e => e.lang_id == this.selectedLang);
              this.selectedLanguageName = CurrentLandData[0].LanguageName;
            }
            else {
              if(Dir=="FST")
              {
                let selLang = (lang == "0" || lang == undefined) ? this.surveyData.SurveySettings.primary_lang_id : parseInt(lang);
                this.selectedLanguageName = this.getLanguageName(selLang);
                this.multiLanguage = false;
                this.selectedLanguage = true;
              }
              else if (!this.preview.isPrevPgChnge && this.preview.PrevPgNo!=0)
              {
                if (
                  this.surveyData.SurveyDetails.GroupType == "preview" &&
                  $("#hdnCurrentLang", parent.document).length != 0 &&
                  $("#hdnCurrentLang", parent.document).val() != -1
                ) {
                  this.selectedLang = $("#hdnCurrentLang", parent.document).val();
                  let CurrentLandData = this.surveyData.LanguageDatas.filter(
                    e => e.lang_id == this.selectedLang
                  );
                  this.selectedLanguageName = CurrentLandData[0].LanguageName;
                } else {
                  let selLang =
                    lang == "0" || lang == undefined || lang == ""
                      ? this.surveyData.SurveySettings.primary_lang_id
                      : parseInt(lang);
                  this.selectedLanguageName = this.getLanguageName(selLang);
                }
                this.multiLanguage = false;
                this.selectedLanguage = true;
              }
              else if(Editresponse.ResponseDatas != undefined && Editresponse.ResponseDatas.length > 0){
                this.selectedLanguage = true;
                this.multiLanguage = false;
              }else
              {
                this.multiLanguage = true;
                this.setLangBasedOnBrowser();
                this.selectedLanguage = false;
              }
            }
          } else {
            if (this.surveyData.SurveySettings.isAssessment &&
              this.surveySpecificData.Participation_Message_Type == 0 &&
              this.surveyData.SurveySettings.SurveyTimeLimit > 0 && !this.isAcceptCookies) {
              this.CountDownTimer();
            }

            this.multiLanguage = false;

            if (!this.isThankYouPage) {
              this.selectedLanguage = true;
            }

            if (
              this.surveyData.SurveyDetails.GroupType == "preview" &&
              $("#hdnCurrentLang", parent.document).length != 0 &&
              $("#hdnCurrentLang", parent.document).val() != -1
            ) {
              this.selectedLang = $("#hdnCurrentLang", parent.document).val();
              let CurrentLandData = this.surveyData.LanguageDatas.filter(
                e => e.lang_id == this.selectedLang
              );
              this.selectedLanguageName = CurrentLandData[0].LanguageName;
            } else {
              let selLang =
                lang == "0" || lang == undefined || lang == ""
                  ? this.surveyData.SurveySettings.primary_lang_id
                  : parseInt(lang);
              this.selectedLanguageName = this.getLanguageName(selLang);
            }
          }
          this.addPageBGClass();
        }

        if(this.surveyData.Groups && this.surveyData.Groups.length > 0)
        {
          this.CheckAllQDLGroup();
        }
        let strSavedPageList = this.surveyData.SurveyDetails.SavedPageList;
        if(strSavedPageList != null
          && strSavedPageList != undefined
          && strSavedPageList !=""
          && strSavedPageList.indexOf(",") > 0)
        {
          this.surveyPageList = [];
          this.assesmentAutoSavePageList = [];
          this.ReopenPageList = [];
          let arrSavedPageList = strSavedPageList.split(',');
          for(let k = 0; k < arrSavedPageList.length; k++)
          {
            //if(this.surveyData.SurveyDetails.isSurveyReopened)
            //{
              this.ReopenPageList.push(parseInt(arrSavedPageList[k]));
            //}
            this.surveyPageList.push(parseInt(arrSavedPageList[k]));
            if (this.surveyData.SurveySettings.isAssessment) {
              this.assesmentAutoSavePageList.push(parseInt(arrSavedPageList[k]));
            }
          }

          for(let k = 0; k < this.maxPageNumber; k++)
          {
            if(this.surveyPageList.indexOf((k+1)) == -1)
            {
              this.skippedPageList.push((k+1));
            }
          }
        }
        this.skippedPageList =this.UniqueArray(this.skippedPageList);

        if (this.surveySpecificData.Participation_Message_Type != 0) {
            this.isRemoveBackGround = true;
            this.removePageBGClass();
            this.isSaveAndContinue = true;
            this.multiLanguage = false;
            this.selectedLanguage = false;
            this.isPrintDownload = false;
            this.pageNumber = 999;
            this.showLoader=false;
            this.changeDetect.detectChanges();
            // if (this.surveyData.SurveyDetails.GroupType == 'preview') {
            //   $("#ddPreview", parent.document).val(-1);
            // }
        }

        

        this.dataPopulationOnLoading();

        this.AllPageQuestionDisplayLogic();
        this.AllPageAnswerDisplayLogic();

        if(this.surveyData.SurveyDetails.isSurveyReopened 
          && this.surveySpecificData.Participation_Message_Type == 0
          && this.surveyData.SurveyDetails.embedLangOpt > 0)
        {
          this.isHideHambugforEmbedMob = true;
          this.isHideEmbedWebHeader = true;
        }

        if (this.pageNumber != 999) {
          if (this.allQuestionHideOnPage(this.pageNumber, false, true,true,false)) {
            let showMessage = this.isAllQuestionHideMessage;
            if (this.pageNumber == 0 && !this.preview.isShowHiddenQN) {
              this.isAllQuestionHideOnPrevPages = true;
              this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
            }
            if (!this.isPrevPgChnge && !this.preview.isPagePreview) {
              this.selectedLanguage = false;
              this.GetNextPage(this.pageNumber,true);
            }
            else if (showMessage) {
              this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
              this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
            }
          }
          else if (this.pageNumber == 0 && this.preview.isShowHiddenQN) {
            this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
          }
          else if(this.isPrevPgChnge)
          {
            this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
            this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
          }
          else if(this.pageNumber ==0 && !this.isPreview)
          {
            this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
          }
        }

        this.isRTL = this.surveyData.SurveyDetails.isRTL;
        this.service.setRTL(this.isRTL);

        this.productName = this.surveyData.CorpSettings.strProduct;
        if(this.pageNumber == 999)
        {
          this.changeDetect.detectChanges();
        }

        if (this.surveyData.Matrix != null && this.surveyData.Matrix != undefined) {
          this.MatrixGridQuationHandle();
        }
        if(isLangChange)
        {
          setTimeout(() => {
            if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
            this.bodyNiceScrollResize()
          }, 250);
          this.showLoader = false;
        }


        if (this.surveySpecificData.ParticipationResponseData != null &&
          this.surveySpecificData.ParticipationResponseData.ResponseDatas != null  &&
           this.surveyData.CorpSettings.account_type != 10) {
          if (this.surveyData.SurveyDetails.GroupType == 'preview'
            && $("#ddPreview", parent.document).length != 0) {
            this.pageNumber = 0;
            $("#ddPreview", parent.document).val(1);
          }

          if((!this.surveyData.CorpSettings.IsSaveOnNext || this.surveyData.SurveySettings.isAssessment) && this.surveySpecificData.Participation_Message_Type == 0)
          {
            if(Editresponse.ResponseDatas != undefined){
              this.multiLanguage = false;
              this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
              //this.selectedLanguage = true;
              this.selectedLanguageName = this.getLanguageName(this.surveyData.SurveyDetails.selectedLangId);
              this.SurveyResponseUpdate();
              this.AllPageQuestionDisplayLogic();
              this.AllPageAnswerDisplayLogic();
            }else{
              this.multiLanguage = false;
              this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
              if(this.surveyData.SurveySettings.isAssessment){
                this.SurveyResponseUpdate();
              }
            }
          }
          else
          {
            this.multiLanguage = false;
            this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
            //this.selectedLanguage = true;
            this.selectedLanguageName = this.getLanguageName(this.surveyData.SurveyDetails.selectedLangId);
            this.SurveyResponseUpdate();
            this.AllPageQuestionDisplayLogic();
            this.AllPageAnswerDisplayLogic();
          
          }
        }

        if(this.surveyData.SurveyDetails.isSurveyReopened && this.surveySpecificData.Participation_Message_Type == 0)
        {
          this.isEditedResponse = true;
          this.multiLanguage = false;
          this.selectedLanguage = true;
          this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
          this.SurveyResponseUpdate();
          this.AllPageQuestionDisplayLogic();
          this.AllPageAnswerDisplayLogic();
        }



        if(this.preview.isPagePreview && this.isBlankPage(this.pageNumber)){
          this.isSaveAndContinue = true;
          this.multiLanguage = false;
          this.selectedLanguage = false;
          this.isPrintDownload = false;
          this.pageNumber = 999;
          this.surveySpecificData.Participation_Message_Type = 14;
          this.isRemoveBackGround = true;
          this.removePageBGClass();
          this.surveySpecificData.Participation_Messages.Error_Header = this.surveyData.SurveyMessages.Message;
          this.surveySpecificData.Participation_Messages.Error_Message = "This page contains all hidden question so no preview available for this page.";
          this.changeDetect.detectChanges();
        }

        //isSurveyEndonPage
        if(this.pageNumber != 999 && !this.preview.isPrevPgChnge && !this.preview.isShowHiddenQN)
        {
          this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
        }
        if(this.pageNumber != 999 && !this.preview.isShowHiddenQN){
          this.EndSurveyOnPage();
          if(this.surveyData.Pages[0].isEndSurvey)
          {
            this.isEndSurveyOnPage = true;
          }
        }

        if (this.pageNumber != 999 && this.pageNumber < this.maxPageNumber) {
          if(this.isOfflineSurvey){
            if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM' && !(e.qtype == 'T'  && (e.qsubtype == 71  || e.qsubtype == 72))).length > 0) {
              this.isMandatory = true;
            }
          }else{
            if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM').length > 0) {
              this.isMandatory = true;
            }
          }
        }

        this.surveyDisplayPageList1 = [];
        this.surveyDisplayPageList2 = [];
        let maxPageCount=0;
        this.isBackClick = true;
        for (let i = 0; i < this.surveyData.Pages.length; i++) {
            if(!this.allQuestionHideOnPage(i,true,true,false,false))
            {
              maxPageCount = maxPageCount + 1;
              this.surveyDisplayPageList1.push((maxPageCount));
              this.surveyDisplayPageList2.push(this.surveyData.Pages[i].Page_no);
            }
        }

        if (this.surveyData.SurveyDetails.GroupType == "preview" && this.previewSurveyFormat > -1) {
          if (this.previewSurveyFormat > 0) {
            if(this.previewSurveyFormat == 1)
            {
              this.questionSpacerHeight = 55;
            }
            else if(this.previewSurveyFormat == 2)
            {
              this.questionSpacerHeight = 255;
            }
            this.isNewParticipation = true;
            this.surveyFormat = this.previewSurveyFormat;
            if(this.surveyData.SurveyDetails.isNewParticipation){
              this.service.isAutoScroll = this.surveyData.SurveyDetails.isAutoScroll;
            }
            else{
              this.service.isAutoScroll = true;
            }

          } else {
            this.isNewParticipation = false;
            this.surveyFormat = 0;
            this.questionSpacerHeight = 40;
          }
        } else {
          this.isNewParticipation = this.surveyData.SurveyDetails.isNewParticipation;
          this.surveyFormat = this.surveyData.SurveyDetails.surveyFormat;
          this.service.isAutoScroll = this.surveyData.SurveyDetails.isAutoScroll;
        }

        if (this.surveyData.SurveyDetails.GroupType == "preview" && $(".surveyFormatDDValue", parent.document).length == 1) {
            if(this.surveyFormat == 1)
            {
                $(".surveyFormatDDValue", parent.document).text('Compact');
            }
            else if(this.surveyFormat == 2)
            {
                $(".surveyFormatDDValue", parent.document).text('Comfortable');
            }
            else
            {
              $(".surveyFormatDDValue", parent.document).text('Classic');
            }
        }


        var self = this
        if(this.surveyFormat == 1) {
          $("body").on("mouseover", ".ques-overlay", function() {
            self.activateQuestionOnHover(this);
          });
        }

        if (this.surveyData.SurveyDetails.GroupType == "preview") {
          $("#ddParticipationFormat", parent.document).val(this.surveyFormat);
        }

        this.service.isNewParticipation = this.isNewParticipation;
        this.service.surveyFormat = this.surveyFormat;
        if(this.isNewParticipation && (this.surveyFormat == 2 || this.surveyFormat == 1)){
          this.newParticipationBtnText = this.surveyData.SurveyDetails.newParticipationBtnText;
          this.service.newParticipationBtnText = this.newParticipationBtnText;
          this.showNewParticipationScroll();
          this.setIsFirstShowQuestion();
        }


        let selectedCulture = this.getLanguageCulture(this.selectedLang);
        this.service.setSelectedLanguageCulture(selectedCulture);
        this.service.setSelectedLanguage(this.selectedLang);
        this.isCapchaDarkTheme = this.surveyData.SurveySettings.isDarkTheme;
        this.isBackClick = false;
        //this.selectedLanguage=true;
        //let path = 'Survey1.aspx?' + this.GetUrlData(false);
        let path = 'survey1.aspx?' + 'k='+ k + '&lang=' + lang1;
        this.router.navigateByUrl(path);
        this.changeDetect.detectChanges();
        setTimeout(() => {
          if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
          this.bodyNiceScrollResize()
        }, 250);
        window.scrollTo(0, 0);
        }else{
          if (navigator.onLine && false) {
            let url1: any;
            var OfflineUid = this.storage.get('SurveyresponseUID_' + k);
            var strTick1 = this.storage.get('SurveyTick_' + k);
           // url = 'SurveyData/get?' + this.GetUrlData(isLoading) + '&responseUID=' + responseUID + '&Dir=' + dir + strTick;
            url1='SurveyData/get?k='+k+'&lang='+ lang1+'&responseID='+encodeURIComponent(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", OfflineUid))+'&Dir=&Tick='+strTick1;
            //url1 = this.storage.get('SurveyUrl_' + k+'_'+ lang1) != undefined ? this.storage.get('SurveyUrl_' + k+'_'+ lang1) : "" ;
            this.service.GetData(url1).subscribe(async (data) => {
              //data1 = data;
              var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF", await data);
              //console.log('Encrypted :' + arrData);
              data1 = JSON.parse(arrData);

              if (data1.SurveyData == undefined) {
                data1 = this.storage.get('SurveyData_' + k + '_' + lang1);
                var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF", data1);
                //console.log('Encrypted :' + arrData);
                data1 = JSON.parse(arrData);
              } else {
                this.storage.set('SurveyData_' + k + '_' + lang1, data1)
              }
              this.surveyData =  data1.SurveyData;
              this.surveySpecificData =  data1.SurveySpecificData;
              let Dir = "";
              let lang = "0";


            if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
              this.OfflineDashboard();
            }
            if (this.surveySpecificData.Participation_Message_Type != 0) {
              if (this.surveySpecificData.Participation_Messages.isErrorRedirect) {
                this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
                this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
                this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
                this.CheckCookieforDelete('Get Data 3');
                window.location.replace(this.surveySpecificData.Participation_Messages.RedirectURL);
              }
            }
            this.activatedRoute.queryParams.subscribe(async params => {
              Dir = params["Dir"]
              lang = params["lang"]
            });
            this.productName = this.surveyData.CorpSettings.strProduct;
            this.questionSpacerHeight = this.surveyData.SurveySettings.questionSpacer;


            //preview page handling.
            if (this.preview != undefined && this.surveyData.SurveyDetails.GroupType == 'preview' && !this.isEditedResponse) {
              this.PreviewPageHandling();
              this.service.setPreviewData(this.preview);
            }
            //Common Setting
            this.service.setCommonSetting(this.commonSetting);
            this.service.setIsEx(this.surveyData.SurveySettings.isEx);
            this.service.setdropDownCount(this.commonSetting.dropDownCount);
            this.service.setImageFolder(this.commonSetting.ImageFolder);
            this.service.setMDDdropDownCount(this.commonSetting.MDDdropDownCount);
            if (this.commonSetting != undefined) {

              this.isMobile = this.commonSetting.isMobileDevice;
              this.isTablet =this.commonSetting.isTablet;
              if(this.isTablet)
              {
                  if(navigator.maxTouchPoints > 1  || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || navigator.userAgent.toLowerCase().indexOf('ipad') > -1)
                  {
                      this.isTablet  = true;
                  }
                  else
                  {
                    this.isTablet  = false;
                  }
              }
              this.service.setMobile(this.isMobile);
              if (this.isMobile) {
                this.isDeviceCSS = "mobile-wrapper";
                if (this.isPreview && $("#previewViewport", parent.document).length == 0) {
                  var body = document.body;
                  body.classList.add('mobile-scroll');
                }
               else if(!this.isPreview && !this.commonSetting.isEmbedMobile && !this.commonSetting.isEmbedPopMobile)
               {
                  var body = document.body;
                  body.classList.add('mobile-scroll');
                }
              }
              else if(this.isTablet){
                this.isDeviceCSS ="tablet-wrapper";
                if ($("#previewViewport", parent.document).length == 0) {
                  var body = document.body;
                  body.classList.add('mobile-scroll');
                }
                else if(navigator.maxTouchPoints > 1)
                {
                  var body = document.body;
                  body.classList.add('mobile-scroll');
                }
              }
              else if(this.isPreview && $("#previewViewport", parent.document).length > 0)
              {
                  var viewport = $("#previewViewport", parent.document).attr('src');
                    if(viewport.indexOf('viewport=mobile') > 0 )
                    {
                      this.isDeviceCSS = "mobile-wrapper";
                      this.isMobile = true;
                    }
                    else if(viewport.indexOf('viewport=tablet') > 0 )
                    {
                      this.isDeviceCSS = "tablet-wrapper";
                      this.isTablet = true;
                    }
              }
              else {
                this.isDeviceCSS = "";
              }
              // this.IsMobileDevice();
            }
            this.checkcookie();
            this.service.setSurveyMessages(this.surveyData.SurveyMessages);
            if (this.surveyData.SurveyDetails.GroupType == 'preview'
              && $("#ddPreview", parent.document).length != 0
              && $("#ddPreview", parent.document).val() != 1
              ) {
                if($("#ddPreview", parent.document).val() == -1 && (this.preview.PrevPgNo != 999 && this.isPrevPgChnge))
                {
                  $("#ddPreview", parent.document).val(1);
                  this.pageNumber = 0;
                }
                else if($("#ddPreview", parent.document).val() == -1 && this.surveyData.SurveyDetails.isSurveyReopened)
                {
                  $("#ddPreview", parent.document).val(1);
                  this.pageNumber = 0;
                }

                if($("#ddPreview", parent.document).val() != -1) {
                  this.pageNumber = ($("#ddPreview", parent.document).val() - 1);
                }

                if (this.preview.isPreviewToggle) {
                  this.pageNumber = 0;
                  $("#ddPreview", parent.document).val(1)
                }
            }
            else if(this.isPreview && this.preview.isPagePreview && this.preview.PrevPgNo!= 999 )
            {
                this.pageNumber = this.preview.PrevPgNo -1;
            }
            else if(this.surveyData.SurveyDetails.quotaPageNumber != null
              && this.surveyData.SurveyDetails.quotaPageNumber != undefined
              && this.surveyData.SurveyDetails.quotaPageNumber != 0)
            {
              this.pageNumber = (this.surveyData.SurveyDetails.quotaPageNumber -1)
            }
            else {
              this.pageNumber = 0;
            }

            this.titleService.setTitle(this.surveyData.SurveySettings.SurveyTitle);

            this.isPrintDownload = this.surveyData.SurveyDetails.IsPrintDownload;
            this.maxPageNumber = this.surveyData.SurveySettings.MaxPageNo;
            this.surveyTitle = this.surveyData.SurveySettings.SurveyTitle;
            this.nextButtonClickNo = 0;
            if(this.surveyData.SurveyDetails.GroupType == 'preview'){
              //parent.document.title = this.surveyTitle;
            }
            this.isRTL = this.surveyData.SurveyDetails.isRTL;
            this.service.setRTL(this.isRTL);
            this.service.setCustomAttachmentSizeSurveyID(this.surveyData.SurveyDetails.CustomAttachmentSizeSurveyID);
            this.service.setSurveyID(this.surveyData.SurveySettings.zarca_id.toString());
            this.service.setCorpNo(this.surveyData.CorpSettings.corporate_no.toString());
            this.service.setCurrencyNegativeMessage(this.surveyData.SurveyMessages.CurrencyNegativeValueMessage);

            if (isLoading) {

              this.service.setSureyDetails(this.surveyData.SurveyDetails.surveyKey, this.surveyData.ResponseInfo.ResponseUID,
                this.surveyData.SurveyDetails.GroupType, this.surveyData.SurveyMessages.ReEnterBlankMessage,
                this.surveySpecificData.GeoLocation, this.surveyData.CorpSettings.strProduct);
              this.isControlLoading = true;
              //this.surveyData.SurveyDetails.Dir = null;

              if(this.surveyData.Groups && this.surveyData.Groups.length > 0)
              {
                this.CheckAllQDLGroup();
              }

              if (this.surveyData.SurveyDetails.BGImgPosition == 'Gradients') {
                this.surveyBackground = this.surveyData.SurveySettings.SurveyBackgroundImage + ' BackGroundChanges';
              }
              else {
                this.surveyBackground = 'page-bg-img BackGroundChanges';
              }

              if (this.surveyData.LanguageDatas.length > 1
                && ((!this.preview.isPagePreview && !this.preview.isPrevPgChnge)
                || this.preview.isPreviewToggle)) {
                if (this.surveyData.SurveyDetails.GroupType == 'preview'
                    && $("#hdnCurrentLang", parent.document).length != 0 &&
                    $("#hdnCurrentLang", parent.document).val() != -1) {
                  this.selectedLang = $("#hdnCurrentLang", parent.document).val();
                  if (this.preview.isPreviewToggle) {
                    this.multiLanguage = true;
                    this.setLangBasedOnBrowser();
                  }
                  else {
                    this.multiLanguage = false;
                  }
                  this.selectedLanguage = true;
                  let CurrentLandData = this.surveyData.LanguageDatas.filter(
                    e => e.lang_id == this.selectedLang);
                  this.selectedLanguageName = CurrentLandData[0].LanguageName;
                }
                else {
                  if(Dir=="FST")
                  {
                    let selLang = (lang == "0" || lang == undefined) ? this.surveyData.SurveySettings.primary_lang_id : parseInt(lang);
                    this.selectedLanguageName = this.getLanguageName(selLang);
                    this.multiLanguage = false;
                    this.selectedLanguage = true;
                  }
                  else if (!this.preview.isPrevPgChnge && this.preview.PrevPgNo!=0)
                  {
                    if (
                      this.surveyData.SurveyDetails.GroupType == "preview" &&
                      $("#hdnCurrentLang", parent.document).length != 0 &&
                      $("#hdnCurrentLang", parent.document).val() != -1
                    ) {
                      this.selectedLang = $("#hdnCurrentLang", parent.document).val();
                      let CurrentLandData = this.surveyData.LanguageDatas.filter(
                        e => e.lang_id == this.selectedLang
                      );
                      this.selectedLanguageName = CurrentLandData[0].LanguageName;
                    } else {
                      let selLang =
                        lang == "0" || lang == undefined || lang == ""
                          ? this.surveyData.SurveySettings.primary_lang_id
                          : parseInt(lang);
                      this.selectedLanguageName = this.getLanguageName(selLang);
                    }
                    this.multiLanguage = false;
                    this.selectedLanguage = true;
                  }
                  else if(Editresponse.ResponseDatas != undefined && Editresponse.ResponseDatas.length > 0){
                    this.selectedLanguage = true;
                    this.multiLanguage = false;
                  }else
                  {
                    this.multiLanguage = true;
                    this.setLangBasedOnBrowser();
                    this.selectedLanguage = false;
                  }
                }
              } else {
                if (this.surveyData.SurveySettings.isAssessment &&
                  this.surveySpecificData.Participation_Message_Type == 0 &&
                  this.surveyData.SurveySettings.SurveyTimeLimit > 0 && !this.isAcceptCookies) {
                  this.CountDownTimer();
                }

                this.multiLanguage = false;

                if (!this.isThankYouPage) {
                  this.selectedLanguage = true;
                }

                if (
                  this.surveyData.SurveyDetails.GroupType == "preview" &&
                  $("#hdnCurrentLang", parent.document).length != 0 &&
                  $("#hdnCurrentLang", parent.document).val() != -1
                ) {
                  this.selectedLang = $("#hdnCurrentLang", parent.document).val();
                  let CurrentLandData = this.surveyData.LanguageDatas.filter(
                    e => e.lang_id == this.selectedLang
                  );
                  this.selectedLanguageName = CurrentLandData[0].LanguageName;
                } else {
                  let selLang =
                    lang == "0" || lang == undefined || lang == ""
                      ? this.surveyData.SurveySettings.primary_lang_id
                      : parseInt(lang);
                  this.selectedLanguageName = this.getLanguageName(selLang);
                }
              }
              this.addPageBGClass();
            }

            if(this.surveyData.Groups && this.surveyData.Groups.length > 0)
            {
              this.CheckAllQDLGroup();
            }
            
            let strSavedPageList = this.surveyData.SurveyDetails.SavedPageList;
            if(strSavedPageList != null
              && strSavedPageList != undefined
              && strSavedPageList !=""
              && strSavedPageList.indexOf(",") > 0)
            {
              this.surveyPageList = [];
              this.assesmentAutoSavePageList = [];
              this.ReopenPageList = [];
              let arrSavedPageList = strSavedPageList.split(',');
              for(let k = 0; k < arrSavedPageList.length; k++)
              {
                //if(this.surveyData.SurveyDetails.isSurveyReopened)
                //{
                  this.ReopenPageList.push(parseInt(arrSavedPageList[k]));
                //}
                this.surveyPageList.push(parseInt(arrSavedPageList[k]));
                if (this.surveyData.SurveySettings.isAssessment) {
                  this.assesmentAutoSavePageList.push(parseInt(arrSavedPageList[k]));
                }
              }

              for(let k = 0; k < this.maxPageNumber; k++)
              {
                if(this.surveyPageList.indexOf((k+1)) == -1)
                {
                  this.skippedPageList.push((k+1));
                }
              }
            }

            this.skippedPageList =this.UniqueArray(this.skippedPageList);
            if (this.surveySpecificData.Participation_Message_Type != 0) {
                this.isRemoveBackGround = true;
                this.removePageBGClass();
                this.isSaveAndContinue = true;
                this.multiLanguage = false;
                this.selectedLanguage = false;
                this.isPrintDownload = false;
                this.pageNumber = 999;
                this.showLoader=false;
                setTimeout(() => {
                  if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
                  this.bodyNiceScrollResize()
                }, 250);
                this.changeDetect.detectChanges();
                // if (this.surveyData.SurveyDetails.GroupType == 'preview') {
                //   $("#ddPreview", parent.document).val(-1);
                // }
            }


            this.dataPopulationOnLoading();

            this.AllPageQuestionDisplayLogic();
            this.AllPageAnswerDisplayLogic();
            if (this.pageNumber != 999) {
              if (this.allQuestionHideOnPage(this.pageNumber, false, true,true,false)) {
                let showMessage = this.isAllQuestionHideMessage;
                if (this.pageNumber == 0 && !this.preview.isShowHiddenQN) {
                  this.isAllQuestionHideOnPrevPages = true;
                  this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
                }
                if (!this.isPrevPgChnge && !this.preview.isPagePreview) {
                  this.selectedLanguage = false;
                  this.GetNextPage(this.pageNumber,true);
                }
                else if (showMessage) {
                  this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
                  this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
                }
              }
              else if (this.pageNumber == 0 && this.preview.isShowHiddenQN) {
                this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
              }
              else if(this.isPrevPgChnge)
              {
                this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
                this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
              }
            }

            this.isRTL = this.surveyData.SurveyDetails.isRTL;
            this.service.setRTL(this.isRTL);

            this.productName = this.surveyData.CorpSettings.strProduct;
            if(this.pageNumber == 999)
            {
              this.changeDetect.detectChanges();
            }

            if (this.surveyData.Matrix != null && this.surveyData.Matrix != undefined) {
              this.MatrixGridQuationHandle();
            }
            if(isLangChange)
            {
              setTimeout(() => {
                if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
                this.bodyNiceScrollResize()
              }, 250);
              this.showLoader = false;
            }


            if (this.surveySpecificData.ParticipationResponseData != null &&
              this.surveySpecificData.ParticipationResponseData.ResponseDatas != null  &&
               this.surveyData.CorpSettings.account_type != 10) {
              if (this.surveyData.SurveyDetails.GroupType == 'preview'
                && $("#ddPreview", parent.document).length != 0) {
                this.pageNumber = 0;
                $("#ddPreview", parent.document).val(1);
              }

              if((!this.surveyData.CorpSettings.IsSaveOnNext || this.surveyData.SurveySettings.isAssessment) && this.surveySpecificData.Participation_Message_Type == 0)
              {
                this.multiLanguage = false;
                this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
                if(this.surveyData.SurveySettings.isAssessment){
                  this.SurveyResponseUpdate();
                  this.AllPageQuestionDisplayLogic();
                  this.AllPageAnswerDisplayLogic();
                }
              }
              else
              {
                this.multiLanguage = false;
                this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
                //this.selectedLanguage = true;
                this.selectedLanguageName = this.getLanguageName(this.surveyData.SurveyDetails.selectedLangId);
                this.SurveyResponseUpdate();
                this.AllPageQuestionDisplayLogic();
                this.AllPageAnswerDisplayLogic();
              }
            }

            if(this.surveyData.SurveyDetails.isSurveyReopened && this.surveySpecificData.Participation_Message_Type == 0)
            {
              this.isEditedResponse = true;
              this.multiLanguage = false;
              this.selectedLanguage = true;
              this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
              this.SurveyResponseUpdate();
              this.AllPageQuestionDisplayLogic();
              this.AllPageAnswerDisplayLogic();
            }


            if(this.preview.isPagePreview && this.isBlankPage(this.pageNumber)){
              this.isSaveAndContinue = true;
              this.multiLanguage = false;
              this.selectedLanguage = false;
              this.isPrintDownload = false;
              this.pageNumber = 999;
              this.surveySpecificData.Participation_Message_Type = 14;
              this.isRemoveBackGround = true;
              this.removePageBGClass();
              this.surveySpecificData.Participation_Messages.Error_Header = this.surveyData.SurveyMessages.Message;
              this.surveySpecificData.Participation_Messages.Error_Message = "This page contains all hidden question so no preview available for this page.";
              this.changeDetect.detectChanges();
            }

            //isSurveyEndonPage
            if(this.pageNumber != 999 && !this.preview.isPrevPgChnge && !this.preview.isShowHiddenQN)
            {
              this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
            }
            if(this.pageNumber != 999 && !this.preview.isShowHiddenQN){
              this.EndSurveyOnPage();
              if(this.surveyData.Pages[0].isEndSurvey)
              {
                this.isEndSurveyOnPage = true;
              }
            }

            if (this.pageNumber != 999 && this.pageNumber < this.maxPageNumber) {
              if(this.isOfflineSurvey){
                if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM' && !(e.qtype == 'T'  && (e.qsubtype == 71  || e.qsubtype == 72))).length > 0) {
                  this.isMandatory = true;
                }
              }else{
                if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM').length > 0) {
                  this.isMandatory = true;
                }
              }
            }

            this.surveyDisplayPageList1 = [];
            this.surveyDisplayPageList2 = [];
            let maxPageCount=0;
            this.isBackClick = true;
            for (let i = 0; i < this.surveyData.Pages.length; i++) {
                if(!this.allQuestionHideOnPage(i,true,true,false,false))
                {
                  maxPageCount = maxPageCount + 1;
                  this.surveyDisplayPageList1.push((maxPageCount));
                  this.surveyDisplayPageList2.push(this.surveyData.Pages[i].Page_no);
                }
            }

            if (this.surveyData.SurveyDetails.GroupType == "preview" && this.previewSurveyFormat > -1) {
              if (this.previewSurveyFormat > 0) {
                if(this.previewSurveyFormat == 1)
                {
                  this.questionSpacerHeight = 55;
                }
                else if(this.previewSurveyFormat == 2)
                {
                  this.questionSpacerHeight = 255;
                }
                this.isNewParticipation = true;
                this.surveyFormat = this.previewSurveyFormat;
                if(this.surveyData.SurveyDetails.isNewParticipation){
                  this.service.isAutoScroll = this.surveyData.SurveyDetails.isAutoScroll;
                }
                else{
                  this.service.isAutoScroll = true;
                }

              } else {
                this.isNewParticipation = false;
                this.surveyFormat = 0;
                this.questionSpacerHeight = 40;
              }
            } else {
              this.isNewParticipation = this.surveyData.SurveyDetails.isNewParticipation;
              this.surveyFormat = this.surveyData.SurveyDetails.surveyFormat;
              this.service.isAutoScroll = this.surveyData.SurveyDetails.isAutoScroll;
            }

            if (this.surveyData.SurveyDetails.GroupType == "preview" && $(".surveyFormatDDValue", parent.document).length == 1) {
                if(this.surveyFormat == 1)
                {
                    $(".surveyFormatDDValue", parent.document).text('Compact');
                }
                else if(this.surveyFormat == 2)
                {
                    $(".surveyFormatDDValue", parent.document).text('Comfortable');
                }
                else
                {
                  $(".surveyFormatDDValue", parent.document).text('Classic');
                }
            }


            var self = this
            if(this.surveyFormat == 1) {
              $("body").on("mouseover", ".ques-overlay", function() {
                self.activateQuestionOnHover(this);
              });
            }

            if (this.surveyData.SurveyDetails.GroupType == "preview") {
              $("#ddParticipationFormat", parent.document).val(this.surveyFormat);
            }

            this.service.isNewParticipation = this.isNewParticipation;
            this.service.surveyFormat = this.surveyFormat;
            if(this.isNewParticipation && (this.surveyFormat == 2 || this.surveyFormat == 1)){
              this.newParticipationBtnText = this.surveyData.SurveyDetails.newParticipationBtnText;
              this.service.newParticipationBtnText = this.newParticipationBtnText;
              this.showNewParticipationScroll();
              this.setIsFirstShowQuestion();
            }


            let selectedCulture = this.getLanguageCulture(this.selectedLang);
            this.service.setSelectedLanguageCulture(selectedCulture);
            this.service.setSelectedLanguage(this.selectedLang);
            this.isCapchaDarkTheme = this.surveyData.SurveySettings.isDarkTheme;
            this.isBackClick = false;
            //this.selectedLanguage=true;


            let path = 'survey1.aspx?' + 'k='+ k + '&lang=' + lang1;
            this.router.navigateByUrl(path);
            this.changeDetect.detectChanges();
            setTimeout(() => {
              if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
              this.bodyNiceScrollResize()
            }, 250);
            window.scrollTo(0, 0);
            });
          }else{
            if (navigator.onLine){
              this.UpdateOfflineData(k,lang1);
            }

            data1 = this.storage.get('SurveyData_' + k+'_'+lang1);

            var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF",data1);
            //console.log('Encrypted :' + arrData);
            data1 = JSON.parse(arrData);


            this.surveyData =  data1.SurveyData;
            this.surveySpecificData =  data1.SurveySpecificData;
            let Dir = "";
            let lang = "0";


          if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
            this.OfflineDashboard();
          }
          if (this.surveySpecificData.Participation_Message_Type != 0) {
            if (this.surveySpecificData.Participation_Messages.isErrorRedirect) {
              this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
              this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
              this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
              this.CheckCookieforDelete('Get Data 4');
              window.location.replace(this.surveySpecificData.Participation_Messages.RedirectURL);
            }
          }
          this.activatedRoute.queryParams.subscribe(async params => {
            Dir = params["Dir"]
            lang = params["lang"]
          });
          this.productName = this.surveyData.CorpSettings.strProduct;
          this.questionSpacerHeight = this.surveyData.SurveySettings.questionSpacer;


          //preview page handling.
          if (this.preview != undefined && this.surveyData.SurveyDetails.GroupType == 'preview' && !this.isEditedResponse) {
            this.PreviewPageHandling();
            this.service.setPreviewData(this.preview);
          }
          //Common Setting
          this.service.setCommonSetting(this.commonSetting);
          this.service.setIsEx(this.surveyData.SurveySettings.isEx);
          this.service.setdropDownCount(this.commonSetting.dropDownCount);
          this.service.setImageFolder(this.commonSetting.ImageFolder);
          this.service.setMDDdropDownCount(this.commonSetting.MDDdropDownCount);
          if (this.commonSetting != undefined) {

            this.isMobile = this.commonSetting.isMobileDevice;
            this.isTablet =this.commonSetting.isTablet;
            if(this.isTablet)
            {
                if(navigator.maxTouchPoints > 1  || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || navigator.userAgent.toLowerCase().indexOf('ipad') > -1)
                {
                    this.isTablet  = true;
                }
                else
                {
                  this.isTablet  = false;
                }
            }
            this.service.setMobile(this.isMobile);
            if (this.isMobile) {
              this.isDeviceCSS = "mobile-wrapper";
              if (this.isPreview && $("#previewViewport", parent.document).length == 0) {
                var body = document.body;
                body.classList.add('mobile-scroll');
              }
             else if(!this.isPreview && !this.commonSetting.isEmbedMobile && !this.commonSetting.isEmbedPopMobile)
             {
                var body = document.body;
                body.classList.add('mobile-scroll');
              }
            }
            else if(this.isTablet){
              this.isDeviceCSS ="tablet-wrapper";
              if ($("#previewViewport", parent.document).length == 0) {
                var body = document.body;
                body.classList.add('mobile-scroll');
              }
              else if(navigator.maxTouchPoints > 1)
              {
                var body = document.body;
                body.classList.add('mobile-scroll');
              }
            }
            else if(this.isPreview && $("#previewViewport", parent.document).length > 0)
            {
                var viewport = $("#previewViewport", parent.document).attr('src');
                  if(viewport.indexOf('viewport=mobile') > 0 )
                  {
                    this.isDeviceCSS = "mobile-wrapper";
                    this.isMobile = true;
                  }
                  else if(viewport.indexOf('viewport=tablet') > 0 )
                  {
                    this.isDeviceCSS = "tablet-wrapper";
                    this.isTablet = true;
                  }
            }
            else {
              this.isDeviceCSS = "";
            }
            // this.IsMobileDevice();
          }
          this.checkcookie();
          this.service.setSurveyMessages(this.surveyData.SurveyMessages);
          if (this.surveyData.SurveyDetails.GroupType == 'preview'
            && $("#ddPreview", parent.document).length != 0
            && $("#ddPreview", parent.document).val() != 1
            ) {
              if($("#ddPreview", parent.document).val() == -1 && (this.preview.PrevPgNo != 999 && this.isPrevPgChnge))
              {
                $("#ddPreview", parent.document).val(1);
                this.pageNumber = 0;
              }
              else if($("#ddPreview", parent.document).val() == -1 && this.surveyData.SurveyDetails.isSurveyReopened)
              {
                $("#ddPreview", parent.document).val(1);
                this.pageNumber = 0;
              }

              if($("#ddPreview", parent.document).val() != -1) {
                this.pageNumber = ($("#ddPreview", parent.document).val() - 1);
              }

              if (this.preview.isPreviewToggle) {
                this.pageNumber = 0;
                $("#ddPreview", parent.document).val(1)
              }
          }
          else if(this.isPreview && this.preview.isPagePreview && this.preview.PrevPgNo!= 999 )
          {
              this.pageNumber = this.preview.PrevPgNo -1;
          }
          else if(this.surveyData.SurveyDetails.quotaPageNumber != null
            && this.surveyData.SurveyDetails.quotaPageNumber != undefined
            && this.surveyData.SurveyDetails.quotaPageNumber != 0)
          {
            this.pageNumber = (this.surveyData.SurveyDetails.quotaPageNumber -1)
          }
          else {
            this.pageNumber = 0;
          }

          this.titleService.setTitle(this.surveyData.SurveySettings.SurveyTitle);

          this.isPrintDownload = this.surveyData.SurveyDetails.IsPrintDownload;
          this.maxPageNumber = this.surveyData.SurveySettings.MaxPageNo;
          this.surveyTitle = this.surveyData.SurveySettings.SurveyTitle;
          this.nextButtonClickNo = 0;
          if(this.surveyData.SurveyDetails.GroupType == 'preview'){
            //parent.document.title = this.surveyTitle;
          }
          this.isRTL = this.surveyData.SurveyDetails.isRTL;
          this.service.setRTL(this.isRTL);
          this.service.setCustomAttachmentSizeSurveyID(this.surveyData.SurveyDetails.CustomAttachmentSizeSurveyID);
          this.service.setSurveyID(this.surveyData.SurveySettings.zarca_id.toString());
          this.service.setCorpNo(this.surveyData.CorpSettings.corporate_no.toString());
          this.service.setCurrencyNegativeMessage(this.surveyData.SurveyMessages.CurrencyNegativeValueMessage);

          if (isLoading) {

            this.service.setSureyDetails(this.surveyData.SurveyDetails.surveyKey, this.surveyData.ResponseInfo.ResponseUID,
              this.surveyData.SurveyDetails.GroupType, this.surveyData.SurveyMessages.ReEnterBlankMessage,
              this.surveySpecificData.GeoLocation, this.surveyData.CorpSettings.strProduct);
            this.isControlLoading = true;
            //this.surveyData.SurveyDetails.Dir = null;

            if(this.surveyData.Groups && this.surveyData.Groups.length > 0)
            {
              this.CheckAllQDLGroup();
            }

            if (this.surveyData.SurveyDetails.BGImgPosition == 'Gradients') {
              this.surveyBackground = this.surveyData.SurveySettings.SurveyBackgroundImage + ' BackGroundChanges';
            }
            else {
              this.surveyBackground = 'page-bg-img BackGroundChanges';
            }

            if (this.surveyData.LanguageDatas.length > 1
              && ((!this.preview.isPagePreview && !this.preview.isPrevPgChnge)
              || this.preview.isPreviewToggle)) {
              if (this.surveyData.SurveyDetails.GroupType == 'preview'
                  && $("#hdnCurrentLang", parent.document).length != 0 &&
                  $("#hdnCurrentLang", parent.document).val() != -1) {
                this.selectedLang = $("#hdnCurrentLang", parent.document).val();
                if (this.preview.isPreviewToggle) {
                  this.multiLanguage = true;
                  this.setLangBasedOnBrowser();
                }
                else {
                  this.multiLanguage = false;
                }
                this.selectedLanguage = true;
                let CurrentLandData = this.surveyData.LanguageDatas.filter(
                  e => e.lang_id == this.selectedLang);
                this.selectedLanguageName = CurrentLandData[0].LanguageName;
              }
              else {
                if(Dir=="FST")
                {
                  let selLang = (lang == "0" || lang == undefined) ? this.surveyData.SurveySettings.primary_lang_id : parseInt(lang);
                  this.selectedLanguageName = this.getLanguageName(selLang);
                  this.multiLanguage = false;
                  this.selectedLanguage = true;
                }
                else if (!this.preview.isPrevPgChnge && this.preview.PrevPgNo!=0)
                {
                  if (
                    this.surveyData.SurveyDetails.GroupType == "preview" &&
                    $("#hdnCurrentLang", parent.document).length != 0 &&
                    $("#hdnCurrentLang", parent.document).val() != -1
                  ) {
                    this.selectedLang = $("#hdnCurrentLang", parent.document).val();
                    let CurrentLandData = this.surveyData.LanguageDatas.filter(
                      e => e.lang_id == this.selectedLang
                    );
                    this.selectedLanguageName = CurrentLandData[0].LanguageName;
                  } else {
                    let selLang =
                      lang == "0" || lang == undefined || lang == ""
                        ? this.surveyData.SurveySettings.primary_lang_id
                        : parseInt(lang);
                    this.selectedLanguageName = this.getLanguageName(selLang);
                  }
                  this.multiLanguage = false;
                  this.selectedLanguage = true;
                }
                else if(Editresponse.ResponseDatas != undefined && Editresponse.ResponseDatas.length > 0){
                  this.selectedLanguage = true;
                  this.multiLanguage = false;
                }else
                {
                  this.multiLanguage = true;
                  this.setLangBasedOnBrowser();
                  this.selectedLanguage = false;
                }
              }
            } else {
              if (this.surveyData.SurveySettings.isAssessment &&
                this.surveySpecificData.Participation_Message_Type == 0 &&
                this.surveyData.SurveySettings.SurveyTimeLimit > 0 && !this.isAcceptCookies) {
                this.CountDownTimer();
              }

              this.multiLanguage = false;

              if (!this.isThankYouPage) {
                this.selectedLanguage = true;
              }

              if (
                this.surveyData.SurveyDetails.GroupType == "preview" &&
                $("#hdnCurrentLang", parent.document).length != 0 &&
                $("#hdnCurrentLang", parent.document).val() != -1
              ) {
                this.selectedLang = $("#hdnCurrentLang", parent.document).val();
                let CurrentLandData = this.surveyData.LanguageDatas.filter(
                  e => e.lang_id == this.selectedLang
                );
                this.selectedLanguageName = CurrentLandData[0].LanguageName;
              } else {
                let selLang =
                  lang == "0" || lang == undefined || lang == ""
                    ? this.surveyData.SurveySettings.primary_lang_id
                    : parseInt(lang);
                this.selectedLanguageName = this.getLanguageName(selLang);
              }
            }
            this.addPageBGClass();
          }

          if(this.surveyData.Groups && this.surveyData.Groups.length > 0)
          {
            this.CheckAllQDLGroup();
          }
          let strSavedPageList = this.surveyData.SurveyDetails.SavedPageList;
          if(strSavedPageList != null
            && strSavedPageList != undefined
            && strSavedPageList !=""
            && strSavedPageList.indexOf(",") > 0)
          {
            this.surveyPageList = [];
            this.assesmentAutoSavePageList = [];
            this.ReopenPageList = [];
            let arrSavedPageList = strSavedPageList.split(',');
            for(let k = 0; k < arrSavedPageList.length; k++)
            {
              //if(this.surveyData.SurveyDetails.isSurveyReopened)
              //{
                this.ReopenPageList.push(parseInt(arrSavedPageList[k]));
              //}
              this.surveyPageList.push(parseInt(arrSavedPageList[k]));
              if(this.surveyData.SurveySettings.isAssessment){
                this.assesmentAutoSavePageList.push(parseInt(arrSavedPageList[k]));
              }
            }

            for(let k = 0; k < this.maxPageNumber; k++)
            {
              if(this.surveyPageList.indexOf((k+1)) == -1)
              {
                this.skippedPageList.push((k+1));
              }
            }
          }
          this.skippedPageList =this.UniqueArray(this.skippedPageList);

          if (this.surveySpecificData.Participation_Message_Type != 0) {
              this.isRemoveBackGround = true;
              this.removePageBGClass();
              this.isSaveAndContinue = true;
              this.multiLanguage = false;
              this.selectedLanguage = false;
              this.isPrintDownload = false;
              this.pageNumber = 999;
              this.showLoader=false;
              this.changeDetect.detectChanges();
              // if (this.surveyData.SurveyDetails.GroupType == 'preview') {
              //   $("#ddPreview", parent.document).val(-1);
              // }
          }


          this.dataPopulationOnLoading();

          this.AllPageQuestionDisplayLogic();
          this.AllPageAnswerDisplayLogic();
          if (this.pageNumber != 999) {
            if (this.allQuestionHideOnPage(this.pageNumber, false, true,true,false)) {
              let showMessage = this.isAllQuestionHideMessage;
              if (this.pageNumber == 0 && !this.preview.isShowHiddenQN) {
                this.isAllQuestionHideOnPrevPages = true;
                this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
              }
              if (!this.isPrevPgChnge && !this.preview.isPagePreview) {
                this.selectedLanguage = false;
                this.GetNextPage(this.pageNumber,true);
              }
              else if (showMessage) {
                this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
                this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
              }
            }
            else if (this.pageNumber == 0 && this.preview.isShowHiddenQN) {
              this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
            }
            else if(this.isPrevPgChnge)
            {
              this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
              this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
            }
          }

          this.isRTL = this.surveyData.SurveyDetails.isRTL;
          this.service.setRTL(this.isRTL);

          this.productName = this.surveyData.CorpSettings.strProduct;
          if(this.pageNumber == 999)
          {
            this.changeDetect.detectChanges();
          }

          if (this.surveyData.Matrix != null && this.surveyData.Matrix != undefined) {
            this.MatrixGridQuationHandle();
          }
          if(isLangChange)
          {
            this.showLoader = false;
            setTimeout(() => {
              if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
              this.bodyNiceScrollResize()
            }, 250);
          }


          if (this.surveySpecificData.ParticipationResponseData != null &&
            this.surveySpecificData.ParticipationResponseData.ResponseDatas != null  &&
             this.surveyData.CorpSettings.account_type != 10) {
            if (this.surveyData.SurveyDetails.GroupType == 'preview'
              && $("#ddPreview", parent.document).length != 0) {
              this.pageNumber = 0;
              $("#ddPreview", parent.document).val(1);
            }

            if((!this.surveyData.CorpSettings.IsSaveOnNext || this.surveyData.SurveySettings.isAssessment) && this.surveySpecificData.Participation_Message_Type == 0)
            {
              this.multiLanguage = false;
              this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
              if(this.surveyData.SurveySettings.isAssessment){
                this.SurveyResponseUpdate();
                this.AllPageQuestionDisplayLogic();
                this.AllPageAnswerDisplayLogic();
              }
            }
            else
            {
              this.multiLanguage = false;
              this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
              //this.selectedLanguage = true;
              this.selectedLanguageName = this.getLanguageName(this.surveyData.SurveyDetails.selectedLangId);
              this.SurveyResponseUpdate();
              this.AllPageQuestionDisplayLogic();
              this.AllPageAnswerDisplayLogic();
            }
          }

          if(this.surveyData.SurveyDetails.isSurveyReopened && this.surveySpecificData.Participation_Message_Type == 0)
          {
            this.isEditedResponse = true;
            this.multiLanguage = false;
            this.selectedLanguage = true;
            this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
            this.SurveyResponseUpdate();
            this.AllPageQuestionDisplayLogic();
            this.AllPageAnswerDisplayLogic();
          }


          if(this.preview.isPagePreview && this.isBlankPage(this.pageNumber)){
            this.isSaveAndContinue = true;
            this.multiLanguage = false;
            this.selectedLanguage = false;
            this.isPrintDownload = false;
            this.pageNumber = 999;
            this.surveySpecificData.Participation_Message_Type = 14;
            this.isRemoveBackGround = true;
            this.removePageBGClass();
            this.surveySpecificData.Participation_Messages.Error_Header = this.surveyData.SurveyMessages.Message;
            this.surveySpecificData.Participation_Messages.Error_Message = "This page contains all hidden question so no preview available for this page.";
            this.changeDetect.detectChanges();
          }

          //isSurveyEndonPage
          if(this.pageNumber != 999 && !this.preview.isPrevPgChnge && !this.preview.isShowHiddenQN)
          {
            this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
          }
          if(this.pageNumber != 999 && !this.preview.isShowHiddenQN){
            this.EndSurveyOnPage();
            if(this.surveyData.Pages[0].isEndSurvey)
            {
              this.isEndSurveyOnPage = true;
            }
          }

          if (this.pageNumber != 999 && this.pageNumber < this.maxPageNumber) {
            if(this.isOfflineSurvey){
              if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM' && !(e.qtype == 'T'  && (e.qsubtype == 71  || e.qsubtype == 72))).length > 0) {
                this.isMandatory = true;
              }
            }else{
              if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM').length > 0) {
                this.isMandatory = true;
              }
            }
          }

          this.surveyDisplayPageList1 = [];
          this.surveyDisplayPageList2 = [];
          let maxPageCount=0;
          this.isBackClick = true;
          for (let i = 0; i < this.surveyData.Pages.length; i++) {
              if(!this.allQuestionHideOnPage(i,true,true,false,false))
              {
                maxPageCount = maxPageCount + 1;
                this.surveyDisplayPageList1.push((maxPageCount));
                this.surveyDisplayPageList2.push(this.surveyData.Pages[i].Page_no);
              }
          }

          if (this.surveyData.SurveyDetails.GroupType == "preview" && this.previewSurveyFormat > -1) {
            if (this.previewSurveyFormat > 0) {
              if(this.previewSurveyFormat == 1)
              {
                this.questionSpacerHeight = 55;
              }
              else if(this.previewSurveyFormat == 2)
              {
                this.questionSpacerHeight = 255;
              }
              this.isNewParticipation = true;
              this.surveyFormat = this.previewSurveyFormat;
              if(this.surveyData.SurveyDetails.isNewParticipation){
                this.service.isAutoScroll = this.surveyData.SurveyDetails.isAutoScroll;
              }
              else{
                this.service.isAutoScroll = true;
              }

            } else {
              this.isNewParticipation = false;
              this.surveyFormat = 0;
              this.questionSpacerHeight = 40;
            }
          } else {
            this.isNewParticipation = this.surveyData.SurveyDetails.isNewParticipation;
            this.surveyFormat = this.surveyData.SurveyDetails.surveyFormat;
            this.service.isAutoScroll = this.surveyData.SurveyDetails.isAutoScroll;
          }

          if (this.surveyData.SurveyDetails.GroupType == "preview" && $(".surveyFormatDDValue", parent.document).length == 1) {
              if(this.surveyFormat == 1)
              {
                  $(".surveyFormatDDValue", parent.document).text('Compact');
              }
              else if(this.surveyFormat == 2)
              {
                  $(".surveyFormatDDValue", parent.document).text('Comfortable');
              }
              else
              {
                $(".surveyFormatDDValue", parent.document).text('Classic');
              }
          }


          var self = this
          if(this.surveyFormat == 1) {
            $("body").on("mouseover", ".ques-overlay", function() {
              self.activateQuestionOnHover(this);
            });
          }

          if (this.surveyData.SurveyDetails.GroupType == "preview") {
            $("#ddParticipationFormat", parent.document).val(this.surveyFormat);
          }

          this.service.isNewParticipation = this.isNewParticipation;
          this.service.surveyFormat = this.surveyFormat;
          if(this.isNewParticipation && (this.surveyFormat == 2 || this.surveyFormat == 1)){
            this.newParticipationBtnText = this.surveyData.SurveyDetails.newParticipationBtnText;
            this.service.newParticipationBtnText = this.newParticipationBtnText;
            this.showNewParticipationScroll();
            this.setIsFirstShowQuestion();
          }


          let selectedCulture = this.getLanguageCulture(this.selectedLang);
          this.service.setSelectedLanguageCulture(selectedCulture);
          this.service.setSelectedLanguage(this.selectedLang);
          this.isCapchaDarkTheme = this.surveyData.SurveySettings.isDarkTheme;
          this.isBackClick = false;
          //this.selectedLanguage=true;
          //let path = 'Survey1.aspx?' + this.GetUrlData(false);
          let path = 'survey1.aspx?' + 'k='+ k + '&lang=' + lang1;
          this.router.navigateByUrl(path);
          this.changeDetect.detectChanges();
          setTimeout(() => {
            if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
            this.bodyNiceScrollResize()
          }, 250);
          window.scrollTo(0, 0);
          }
        }

    }
  }

  /**
   * this method use for get & update local storage offline data.
   * @param k
   * @param lang1
   */
  UpdateOfflineData(k: string,lang1: string){
    var data1;
    let url1: any;
    var OfflineUid = this.storage.get('SurveyresponseUID_' + k);
    var strTick1 = this.storage.get('SurveyTick_' + k);
   // url = 'SurveyData/get?' + this.GetUrlData(isLoading) + '&responseUID=' + responseUID + '&Dir=' + dir + strTick;
    url1='SurveyData/get?k='+k+'&lang='+ lang1+'&responseID='+encodeURIComponent(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", OfflineUid))+'&Dir=&Tick='+strTick1;
    this.service.GetData(url1).subscribe(async (data)=>{
      //data1 = data;
      var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF", await data);
      //console.log('Encrypted :' + arrData);
      data1 = JSON.parse(arrData);
      if(data1.SurveyData != undefined){
       let data = EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(data1));

        this.storage.set('SurveyData_' + k+'_'+lang1, data)
        data1.SurveyData.LanguageDatas.forEach(e => {
          if(e.lang_id!=lang1){
            url1='SurveyData/get?k='+k+'&lang='+ e.lang_id+'&responseID='+encodeURIComponent(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", OfflineUid))+'&Dir=&Tick='+strTick1;
            this.service.GetData(url1).subscribe(async (data2)=>{
              //data1 = data2;
              var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF", await data2);
              //console.log('Encrypted :' + arrData);
              data1 = JSON.parse(arrData);
              if(data1.SurveyData != undefined){
                let data = EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(data1));
                this.storage.set('SurveyData_' + k+'_'+e.lang_id, data)
              }
            });
          }
        });
      }
    });
  }

  /**
   * this page set last page survey.
   */
  EndSurveyOnPage(){

    for (let j = 0; j < this.surveyData.Pages.length; j++) {
      if (j + 1 < this.maxPageNumber && this.surveyData.Pages[j].isEndSurvey == true) {
        this.surveyData.SurveySettings.displaypagenumber = false;
      }
      if (this.surveyData.Pages[j].isAllQuestionsHide && !this.surveyData.Pages[j].isEndSurvey) {
          this.surveyData.Pages[j].isEndSurvey = true;
        break;
      }
    }
    // let isEndSurveyOnPage=true;
    // for(let j = 0; j < this.surveyData.Pages.length; j++){
    //   isEndSurveyOnPage =true;
    //   for (let i = j; i < this.surveyData.Pages.length; i++) {
    //     let questions = this.surveyData.Pages[i].Questions.filter(e => e.population_type != 2 && e.population_type != 5 );
    //     if (questions != null && questions.length > 0) {
    //       isEndSurveyOnPage=false;
    //     }
    //   }
    //   if(isEndSurveyOnPage && !this.surveyData.Pages[j].isEndSurvey)
    //   {
    //     this.surveyData.Pages[j].isEndSurvey=true;
    //   }
    // }
  }

  /**
   * this method load cookies country data.
   */
  getAcceptCookiesCountryData(){
    //let url = 'assets/AcceptCookiesCountry.json';
    let url = 'includes/Angular/assets/AcceptCookiesCountry.json?20072020';
    this.service.GetLocalData(url).subscribe(async (data) => {
      this.aceptCookiesCountryDatas = await data.AcceptCookiesCountryData;
    }, error => {
      this.errorsHandlerService.handleError(error);
    });
  }

  /**
   * this method validate EU country
   * @param countryName
   * @returns
   */
  isEU_Country(countryName: string): boolean{
    var self=this;
    //cookie less participation for Embed Survey
    if((self.surveyData.SurveyDetails.intSourceID == 6 || self.surveyData.SurveyDetails.surveytype == 6 || self.surveyData.SurveyDetails.intSourceID == 10 || self.surveyData.SurveyDetails.surveytype == 10)) //&& self.cookieCorpNO.indexOf(self.surveyData.CorpSettings.corporate_no.toString()) > -1
    {
        return false;
    }
    if (countryName != null && countryName != "" && countryName != '-') {
      if (this.aceptCookiesCountryDatas != null && this.aceptCookiesCountryDatas != undefined) {
        if (this.aceptCookiesCountryDatas.find(e => e.Country == countryName) != undefined) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  /**
   * this method use for accept cookie
   */
  acceptCookies() {
    this.manageCookiesAccept(true);
  }

  /**
   * this method use for manage cookie accept
   * @param isSetCookies
   */
  manageCookiesAccept(isSetCookies: boolean) {
    if (isSetCookies) {
      this.setAcceptCookie('Consent', '11', 365);
      if(typeof gaTracker == 'function')
      {
          gaTracker();
      }
    } else {
      this.setAcceptCookie('Consent', '10', 365);
    }

    this.isAcceptCookies = false;

    if (this.surveyData.SurveySettings.isAssessment &&
      this.surveySpecificData.Participation_Message_Type == 0 &&
      this.surveyData.SurveySettings.SurveyTimeLimit > 0 && !this.multiLanguage) {
      this.CountDownTimer();
    }
    this.changeDetect.detectChanges();
  }

  /**
   * this methode use for split message
   * @param val
   * @returns
   */
  splitAcceptCookieMessage(val: number) {
    if (val == 1) {
      return this.surveyData.SurveyMessages.AcceptCookieMessage.split('<MP>')[1];
    } else {
      return this.surveyData.SurveyMessages.AcceptCookieMessage.split('<MP>')[0];
    }
  }

  /***
   * this method use for set cookies
   */
  setAcceptCookie(cname: string, cvalue: string, exdays: number) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();

    if (this.SurveyURL.indexOf('https://') > -1) {
      document.cookie = 'Enabled=true;SameSite=None; Secure;';
    } else {
      document.cookie = 'Enabled=true;';
    }

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  /**
   * this method use for get cookies
   * @param cname
   * @returns
   */
  getAcceptCookie(cname: string) {
    let name = cname + "=11";
    let name_2 = cname + "=10";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0 || c.indexOf(name_2) == 0) {
        return c.toString();
      }
    }
    return "";
  }

  /**
   * this method use for onloading handle population data
   */
  dataPopulationOnLoading(isLangChange:boolean = false) {

    if (this.surveyData != null && this.surveyData.Pages !=null ) {

      for (let i = 0; i < this.surveyData.Pages.length; i++) {
        let questions;
        let pageNO = (i+1)
        if (this.surveySpecificData.Participation_Message_Type != 3 &&
          this.surveySpecificData.Participation_Message_Type != 7)
          {
            if(!this.surveyData.SurveyDetails.isSaveandContinueSurvey)
            {
             questions = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 1 || e.population_type == 2 || e.population_type == 3);
            }
            else
            {
                 questions = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 2 || e.population_type == 3);
            }
          }
          else
          {
              //113896:[PM][ANG] Pre edit value is not retained when drop out on page 2
              if(!this.surveyData.SurveyDetails.isSaveandContinueSurvey)
              {

                if(this.surveyPageList.length > 0 &&  pageNO < this.surveyPageList[this.surveyPageList.length - 1])
                {
                  questions = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 2 || e.population_type == 3);
                }
                else
                {
                  questions = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 1 || e.population_type == 2 || e.population_type == 3);
                }
              }
              else
              {
                questions = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 2 || e.population_type == 3);
              }
          }

        if (questions != null && questions.length > 0) {
          for (let j = 0; j < questions.length; j++) {
            if (this.surveyData.SurveyDetails.isSurveyReopened && questions[j].population_type == 1) {
                  this.DataPopulation(questions[j], questions[j].population_type);
                  let index = this.surveyData.Pages[i].Questions.indexOf(questions[j]);
                  this.surveyData.Pages[i].Questions[index] = questions[j];
            }
            else if(questions[j].population_type == 1 && this.surveySpecificData.ParticipationResponseData 
              && this.surveySpecificData.ParticipationResponseData.ResponseDatas.find(e => e.QuestionID == questions[j].UniqueNumber ))
            {
              if(!isLangChange)
                continue;
              else{
                this.DataPopulation(questions[j], questions[j].population_type);
                let index = this.surveyData.Pages[i].Questions.indexOf(questions[j]);
                this.surveyData.Pages[i].Questions[index] = questions[j];
              }
            }
            else {
              this.DataPopulation(questions[j], questions[j].population_type);
              let index = this.surveyData.Pages[i].Questions.indexOf(questions[j]);
              this.surveyData.Pages[i].Questions[index] = questions[j];
            }
          }
        }

        if(this.surveyData.SurveySettings.isEmbedPrePop){
          questions = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 0);
          if(questions != null && questions.length > 0){
            for (let j = 0; j < questions.length; j++) {
              this.DataPopulation(questions[j], questions[j].population_type);
              let index = this.surveyData.Pages[i].Questions.indexOf(questions[j]);
              this.surveyData.Pages[i].Questions[index] = questions[j];
            }
          }
        }

        if(this.surveyData.directoryLinkedQuestionDetails && this.surveyData.directoryLinkedQuestionDetails.linkedQuestions != null)
        {
          questions = this.surveyData.Pages[i].Questions.filter(e => e.isDirectoryLinkedQ == true);
          for (let j = 0; j < questions.length; j++) {
            let linkedQuestionsData = this.surveyData.directoryLinkedQuestionDetails.linkedQuestions.filter(e=> e.questionID == questions[j].UniqueNumber);
            if(linkedQuestionsData[0].directoryColumnValue != '' && linkedQuestionsData[0].directoryColumnValue != undefined)
            {
                questions[j].AnswerText = linkedQuestionsData[0].directoryColumnValue;
                questions[j].PrePopText = linkedQuestionsData[0].directoryColumnValue;
                questions[j].isDirectoryHidden = linkedQuestionsData[0].isHide;
            }
            let index = this.surveyData.Pages[i].Questions.indexOf(questions[j]);
            this.surveyData.Pages[i].Questions[index] = questions[j];
          }
        }
      }
    }
  }

  /**
   * this method use for timer in assesment.
   */
  CountDownTimer() {
    let counter = this.surveyData.SurveySettings.SurveyTimeLimit * 60;
    let tik = 1000;
    this.countDown = timer(0, tik).pipe(map(() => --counter));
    this.countDown_2 = timer((this.surveyData.SurveySettings.SurveyTimeLimit * 1000) * 60);

    this.start();

    this.subscription_CountDown = this.countDown_2.subscribe(() => {
    });
  }

  /**
   * this method use for timer pop-up.
   */
  timeCounterAlert() {
    //this.timeouttext='Quiz time limit is over, your answers have been submitted.';
    $('.timeout-modal-overlay').show();
    // alert('Quiz time limit is over, your answers have been submitted.');
    // this.UpdateLocalJson();
    // this.SubmitData(false, true);

    // if (this.subscription_CountDown) {
    //   this.subscription_CountDown.unsubscribe();
    // }
  }

  /**
   * this method use for sumbitting responses after time-up.
   */
  timeCounterAlert1() {
    //alert('Quiz time limit is over, your answers have been submitted.');
    $('.timeout-modal-overlay').hide();
    this.UpdateLocalJson();
    this.SubmitData(false, true);

    if (this.subscription_CountDown) {
      this.subscription_CountDown.unsubscribe();
    }
  }

  /**
   * this method use for time counter.
   */
  start() {
    this.currentValue = this.formatValue((this.surveyData.SurveySettings.SurveyTimeLimit * 60));
    const t: Observable<number> = interval(1000);

    let currentTime: Date = new Date();

    setInterval(() => {
      currentTime = new Date();
    }, 1);

    let hrs = currentTime.getHours();
    let mins = currentTime.getMinutes();
    let sec = currentTime.getSeconds();

    let start = this.surveyData.SurveySettings.SurveyTimeLimit * 60;

    let isSubmit: boolean = false;

    t.pipe(take((this.surveyData.SurveySettings.SurveyTimeLimit * 60)))
      .subscribe(v => {
        (--start)
        start = (this.surveyData.SurveySettings.SurveyTimeLimit * 60) - this.checkTime(currentTime, hrs, mins, sec);
        this.currentValue = this.formatValue(start);
        this.changeDetect.detectChanges();
        if (start <= 0 && !this.isResetPage && !this.isAssesmentSubmit && !isSubmit) {
          setTimeout(() => {
            if(!isSubmit){
              this.timeCounterAlert();
            }
            isSubmit = true;
          }, 500);
        }
      });
  }

  /**
   * this method use for display time.
   * @param checkTime
   * @param hrs
   * @param mins
   * @param sec
   * @returns
   */
  checkTime(checkTime: any, hrs: number, mins: number, sec: number): number {
    if (checkTime.getHours() != hrs) {
      return ((checkTime.getMinutes() + (60 - mins) * 60) + checkTime.getSeconds()) - sec;
    } else if (checkTime.getMinutes() != mins) {
      return (((checkTime.getMinutes() - mins) * 60) + checkTime.getSeconds()) - sec;
    } else {
      return checkTime.getSeconds() - sec;
    }
  }

  /**
   * this method use for formating timer.
   * @param value
   * @returns
   */
  formatValue(value: number) {
    if (value >= 0) {
      const hours: number = Math.floor(value / 3600);
      const minutes: number = Math.floor((value % 3600) / 60);
      return ('00' + hours).slice(-2) + ':' + ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
    } else {
      return ('00').slice(-2) + ':' + ('00').slice(-2) + ':' + ('00').slice(-2);
    }
  }


    allAnswersADLHide(question: Questions,pageNumber:number,isSubmit: boolean):boolean
    {
        let blnAllAnswersADLHide = false;
        if(!this.isByPassLogic)
        {
          let AnswerCount = question.Answers.length;
          let ADLHiddenAnswers = question.Answers.filter(e=> e.isADLHide);

          let indQ= this.surveyData.Pages[pageNumber].Questions.indexOf(question);
          if(ADLHiddenAnswers && ADLHiddenAnswers.length == AnswerCount)
          {
            this.surveyData.Pages[pageNumber].Questions[indQ].isAllADLHide = true;
            blnAllAnswersADLHide = true;
          }
          else{
            this.surveyData.Pages[pageNumber].Questions[indQ].isAllADLHide = false;
          }

          if(this.surveyData.Pages[pageNumber].Questions[indQ].population_type != 0
            && this.surveyData.Pages[pageNumber].Questions[indQ].IsADLRuleApplied)
            {
              let qPrepopValueID = question.PrePopValue;
              if(this.surveyData.Pages[pageNumber].Questions[indQ].population_type == 3)
              {
                if(question.qtype == 'C' && (this.surveySpecificData.PrePopDetails !=undefined && this.surveySpecificData.PrePopDetails!=null))
                {
                  let populationDetail = this.surveySpecificData.PrePopDetails.filter(rule => rule.UniqueNumber == question.UniqueNumber);
                  //let CBSelectedList = question.selectedOptionList;
                  if (populationDetail != undefined && populationDetail != null && populationDetail.length > 0) {
                    let hideCount = 0;
                    for (let j = 0; j < populationDetail.length; j++) {
                      let SelectHide = this.surveyData.Pages[pageNumber].Questions[indQ].Answers.filter(e=> e.isADLHide && e.value_id == populationDetail[j].preValue);
                      if(SelectHide && SelectHide.length > 0)
                      {
                        hideCount++;
                      }
                    }
                    if(populationDetail.length == hideCount)
                    {
                      this.surveyData.Pages[pageNumber].Questions[indQ].isAllADLHide = true;
                      blnAllAnswersADLHide = true;
                    }

                  }
                  if(qPrepopValueID == 0)
                  {
                    this.surveyData.Pages[pageNumber].Questions[indQ].isAllADLHide = true;
                    blnAllAnswersADLHide = true;
                  }


                }
                else
                {
                    let preReadShow = question.Answers.filter(e=> e.value_id == qPrepopValueID && e.isADLHide);
                    if(preReadShow && preReadShow.length > 0)
                    {
                      this.surveyData.Pages[pageNumber].Questions[indQ].isAllADLHide = true;
                      blnAllAnswersADLHide = true;
                    }

                    if(qPrepopValueID == 0)
                    {
                      this.surveyData.Pages[pageNumber].Questions[indQ].isAllADLHide = true;
                      blnAllAnswersADLHide = true;
                    }

                }
              }

              if(isSubmit)
              {
                if(question.qtype == 'C' && (this.surveySpecificData.PrePopDetails !=undefined && this.surveySpecificData.PrePopDetails!=null))
                {
                  let populationDetail = this.surveySpecificData.PrePopDetails.filter(rule => rule.UniqueNumber == question.UniqueNumber);
                  let CBSelectedList = question.selectedOptionList;
                  for (let j = 0; j < CBSelectedList.length; j++) {
                    let checkprepopdetail = populationDetail.filter(e => e.preValue == CBSelectedList[j].value_id)
                    let checkisHide = this.surveyData.Pages[pageNumber].Questions[indQ].Answers.filter(e => e.value_id == CBSelectedList[j].value_id && e.isADLHide)

                    if(checkprepopdetail.length == 0){
                      break;
                    }
                    else if(checkisHide.length > 0)
                    {
                      let selItem = question.selectedOptionList.find(e=> e.value_id == CBSelectedList[j].value_id)
                      if (selItem != null && selItem != undefined) {
                        let selInd = question.selectedOptionList.indexOf(selItem);
                        question.selectedOptionList.splice(selInd,1)
                      }
                    }
                  }

                }
                else
                {
                  let preReadShow = question.Answers.filter(e=> e.value_id == qPrepopValueID && e.isADLHide);
                  if(preReadShow && preReadShow.length > 0 && preReadShow[0].value_id == question.selectAnsValue)
                  {
                    question.AnswerID = null;
                    question.selectAnsValue = 0;
                    question.AnswerText = null;
                    question.isValid = false;
                  }
                }
              }

            }
        }
        return blnAllAnswersADLHide;
    }

  /**
   * this method use for check all Question hide on page.
   * @param pageNumber
   * @param isProgressBar
   * @param isLoading
   * @param isShowMessage
   * @param isCallForPageCheck
   * @returns
   */
  allQuestionHideOnPage(pageNumber: number, isProgressBar: boolean, isLoading: boolean,isShowMessage:boolean, isCallForPageCheck:boolean): boolean {
    let QDLHideonPage = 0;
    let PrePopHideonPage = 0;
    let OfflineQuestionLength = 0;
    if (!isCallForPageCheck) {

      for(let i =0 ; i< this.surveyData.Pages[pageNumber].Questions.length;i++)
      {
        this.allAnswersADLHide(this.surveyData.Pages[pageNumber].Questions[i],pageNumber,false);
      }
      let qdlQuestions = this.surveyData.Pages[pageNumber].Questions.filter(e => ((e.isCQ && e.isCQHide) || (e.isDirectoryLinkedQ && e.isDirectoryHidden)  || (e.IsADLRuleApplied && e.isAllADLHide) 
                        || this.surveyData.Pages[pageNumber].Questions.filter(r => (e.group_no == r.group_no  && e.group_no > 0 
                          && r.Rule_id == e.Rule_id && r.isCQ && r.isCQHide)).length > 0) 
                        && (e.population_type != 2 && e.population_type != 5 && !e.isHiddenQ));
      let Questionslength = 0;
      if (qdlQuestions != null && qdlQuestions.length > 0) {

        let matrixQdlQuestions = qdlQuestions.filter(e => e.isMatrixQuestion);
        let matrixQdlLength = 0;

        if( matrixQdlQuestions && matrixQdlQuestions.length > 0)
        {          
           let matrixGroup = matrixQdlQuestions.map(e => e.group_no).filter((value, index, self) => self.indexOf(value) === index)
           if(matrixGroup.length > 0)
           {
                for(let k= 0; k < matrixGroup.length; k++)
                {
                  let matrixQDLQs = this.surveyData.Pages[pageNumber].Questions.filter(e=> e.group_no != matrixGroup[k] 
                    &&  this.surveyData.Groups.filter(f => f.group_no == e.group_no 
                    && f.Matrix_id ==this.surveyData.Groups.filter(g => g.group_no == matrixGroup[k])[0].Matrix_id).length > 0 )
                    if(matrixQDLQs && matrixQDLQs.length > 0)
                    {
                      matrixQdlLength += matrixQDLQs.length;
                    }
                }

           }
        }
        


        //Issue No.  122192 : Open : [ANG] Response not rec. when QDL applied to MG for a case
        // qdlQuestions.forEach(e => {
        //   Questionslength = Questionslength + this.surveyData.Pages[pageNumber].Questions.filter(f => f.Rule_id == e.Rule_id).length
        // });
        Questionslength = qdlQuestions.length + matrixQdlLength;
      }
      //Commenting this it breaks the single prehide, Single QDL and piping scenarios - RW
      // if (this.isBackClick && this.surveyData.Pages[pageNumber].Questions.length == Questionslength) {
      //   return false;
      // }
      let pipeansQuestions = this.surveyData.Pages[pageNumber].Questions.filter(e =>
        (e.Answers.length == 0 && !e.isCQHide) || e.isMultiQuestionPiping);

      if (pipeansQuestions != undefined && pipeansQuestions.length > 0 &&
        qdlQuestions != undefined && qdlQuestions.length > 0) {

        for (let index = 0; index < qdlQuestions.length; index++) {
          if (pipeansQuestions.find(e => e.Rule_id == qdlQuestions[index].Rule_id) != undefined) {
            Questionslength = Questionslength - pipeansQuestions.filter(
              f => f.Rule_id == qdlQuestions[index].Rule_id).length;
          }
        }
      }

      Questionslength = Questionslength + pipeansQuestions.length;
      if ((qdlQuestions != null || pipeansQuestions != null)
        && Questionslength > 0 && !this.preview.isByPassLogic) {
        QDLHideonPage = Questionslength;
      }
      
      if (isProgressBar && QDLHideonPage == this.surveyData.Pages[pageNumber].Questions.length && this.surveyData.Pages[pageNumber].Questions.length != 0)
      {
          return false;
      }

    }

    let offlineSkipQuestion = this.surveyData.Pages[pageNumber].Questions.filter(e => e.IsOfflineSkipQuestion);


    let population = this.surveyData.Pages[pageNumber].Questions.filter(e => e.population_type == 2 || e.population_type == 5 || e.isHiddenQ || !(this.DrillDownHide(e, pageNumber)));
    if (population != null && !this.preview.isShowHiddenQN) {
      PrePopHideonPage = population.length;
    }
    
    if(population.filter(e=> e.qsubtype == 3 && e.qtype == "RW" && e.PrePopText == null).length > 0)
    {
      let prepopDrill = population.filter(e=> e.qsubtype == 3 && e.qtype == "RW" && e.PrePopText == null);
      for(let k = 0; k < prepopDrill.length; k++)
      {
        if(this.surveyData.Pages[pageNumber].Questions.filter(e=>e.group_no == prepopDrill[k].group_no && e.sub_qno > prepopDrill[k].sub_qno).length > 0)
        {
          PrePopHideonPage = PrePopHideonPage+ this.surveyData.Pages[pageNumber].Questions.filter(e=>e.group_no == prepopDrill[k].group_no && e.sub_qno > prepopDrill[k].sub_qno).length;
        }
      }
      

    }



    if (offlineSkipQuestion != null && offlineSkipQuestion.length > 0) {
      OfflineQuestionLength =  offlineSkipQuestion.length;
    }


    if (this.surveyData.Pages[pageNumber].Questions.length == (QDLHideonPage + PrePopHideonPage + OfflineQuestionLength) ) {
      if (isShowMessage) {
        if (this.isPrevPgChnge && this.surveyData.SurveyDetails.GroupType == 'preview' && isLoading) {
          this.isAllQuestionHideMessage = true;
        } else {
          this.isAllQuestionHideMessage = false;
        }
      }
      if (OfflineQuestionLength > 0) {
        this.surveyData.SurveySettings.DisplayQno = false;
      }
      return true;
    }
    else {
      return false;
    }

  }

  /**
   * this method use for matrix grid question splited.
   */
  MatrixGridQuationHandle() {
    let matrix = this.surveyData.Matrix.filter(e => !e.isMulti && !e.IsSingleGrid);

    if (matrix.length > 0) {

      for (let i = 0; i < matrix.length; i++) {
        let groups = this.surveyData.Groups.filter(e => e.Matrix_id == matrix[i].matrix_id);
        let grp_ruleID = 0;
        let grp_isCQ = false;
        let grp_isCQHide = false;
        if (groups.length > 0) {

          for (let j = 0; j < groups.length; j++) {

            for (let k = 0; k < this.surveyData.Pages.length; k++) {

              let questions = this.surveyData.Pages[k].Questions.filter(e => e.group_no == groups[j].group_no);

              if (questions != null && questions.length > 0) {

                if (questions[0].answer_style == 2) {
                  questions = CommonLogic.RandomQuestionsAnswerHandling(questions);
                }
                let allGrupRule = questions.filter(e=> e.Rule_id !=0 && e.Rule_id == questions[0].Rule_id);
                let allDiffGrupRule = questions.filter(e=> e.Rule_id !=0);
                if(allGrupRule.length == questions.length)
                {
                  for(let i = 0; i<questions.length; i++)
                  {
                      questions[i].isGroupRule = true;
                  }
                }
                else if(allDiffGrupRule.length == questions.length)
                {
                  for(let i = 0; i<questions.length; i++)
                  {
                      questions[i].isNOGroupRule = true;
                  }
                }

                for (let l = 0; l < questions.length; l++) {
                  let index = this.surveyData.Pages[k].Questions.indexOf(questions[l]);

                  if (groups[j].isAnchorReverse) {
                    if(this.isMobile){
                      if(!(questions[i].qsubtype == 1 && this.isRTL)){
                        questions[l].Answers.sort((n1, n2) => n2.weight - n1.weight);
                      }
                      questions[l].isAnchorReverse = true;
                    }else{
                      questions[l].Answers.sort((n1, n2) => n2.weight - n1.weight);
                    }
                  }

                  if(matrix[i].isBranchEnabled){
                    let target = matrix[i].TargetGrid.toString().split(',');

                    if(target.indexOf(questions[l].group_no.toString()) >= 0){
                      this.surveyData.Pages[k].Questions[index].IsDisabled = true;
                    }else{
                      this.surveyData.Pages[k].Questions[index].IsDisabled = false;
                    }
                  }

                  // if (questions[i].isSQ && this.isControlLoading && !this.isByPassLogic) {
                  //   this.QuestionDisplayLogic(questions[i]);
                  // }

                  this.surveyData.Pages[k].Questions[index].isMatrixQuestion = true;

                  if (this.surveyData.Pages[k].Questions[index].qtype == 'GD' ||
                    (this.surveyData.Pages[k].Questions[index].qtype == 'RW' &&
                      this.surveyData.Pages[k].Questions[index].qsubtype == 2)) {
                    this.surveyData.Pages[k].Questions[index].selectAnsValue = -1;
                  }
                  if (this.surveyData.Pages[k].Questions[index].Rule_id != 0) {
                    grp_ruleID = this.surveyData.Pages[k].Questions[index].Rule_id;
                    grp_isCQHide = this.surveyData.Pages[k].Questions[index].isCQHide;
                    grp_isCQ = this.surveyData.Pages[k].Questions[index].isCQ;
                  }
                  else if (this.surveyData.Pages[k].Questions[index].Rule_id == 0 
                    && grp_ruleID != 0 && questions[0].isGroupRule
                    ) { 
                    this.surveyData.Pages[k].Questions[index].Rule_id = grp_ruleID;
                    this.surveyData.Pages[k].Questions[index].isCQHide = grp_isCQHide;
                    this.surveyData.Pages[k].Questions[index].isCQ = grp_isCQ;
                  }

                }

                break;
              }
            }
          }
        }
      }
    }
  }

  CheckAllQDLGroup(){
    let groups = this.surveyData.Groups;
    for (let j = 0; j < groups.length; j++) {
      for (let k = 0; k < this.surveyData.Pages.length; k++) {
        let questions = this.surveyData.Pages[k].Questions.filter(e => e.group_no == groups[j].group_no);
        if (questions != null && questions.length > 0) {
          let allGrupRule = questions.filter(e=> e.Rule_id !=0 && e.Rule_id == questions[0].Rule_id);
          let allDiffGrupRule = questions.filter(e=> e.Rule_id !=0);
          if(allGrupRule.length == questions.length)
          {
            for(let i = 0; i<questions.length; i++)
            {
            questions[i].isGroupRule = true;
            }
          }
          else if(allDiffGrupRule.length == questions.length)
          {
            for(let i = 0; i<questions.length; i++)
            {
            questions[i].isNOGroupRule = true;
            }
          }
        }
      }
    }
  }
  /**
   * this method use for preview page.
   */
  PreviewPageHandling() {
    this.isManditorySkip = this.preview.isManditorySkip;
    this.isShowHiddenQN = this.preview.isShowHiddenQN;
    this.isByPassLogic = this.preview.isByPassLogic;
    this.isPrevPgChnge = this.preview.isPrevPgChnge;
    this.previewSurveyFormat = this.preview.surveyFormat;
    this.isFromSB = this.preview.isFromSB;
    this.service.setPrevPgChnge(this.isPrevPgChnge);

    if(this.preview.isPagePreview){
      this.isByPassLogic = true;
    }

    if (this.preview.isPrevPgChnge || this.preview.isPagePreview) {
      if (this.preview.PrevPgNo == 999) {
        this.pageNumber = 999;
        //this.ThankYouMessagePiping();
        this.QuestionPiping(null,null,null,null,true);
        this.isThankYouPage = true;
        this.multiLanguage = false;
        this.selectedLanguage = false;
        // this.surveyData.SurveyDetails.IsPrintDownload = false;
        this.isPrintDownload = false;

        if (this.surveyData.SurveyDetails.GroupType == 'preview') {
          $("#ddPreview", parent.document).val(-1);
          if(this.preview.isPagePreview)
          {
            $("#ddPreview", parent.document).prop('disabled', true);
          }
        }

      } else if (this.preview.PrevPgNo > 1 && this.preview.PrevPgNo < 999) {
        this.pageNumber = this.preview.PrevPgNo - 1;
        if(this.pageNumber != 0 && this.pageNumber != 999)
        {
            this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
        }
        this.isThankYouPage =false;
        this.multiLanguage = false;
        this.selectedLanguage = true;
        this.AllPageQuestionDisplayLogic();
        this.AllPageAnswerDisplayLogic();
        this.service.setAnswerPipeMessage(this.surveyData.SurveyMessages.strHiddenAnswerPipingText);
      }
      else if(this.preview.PrevPgNo == 0)
      {
        this.pageNumber = 0;
        this.multiLanguage = false;
        this.selectedLanguage = true;
        this.AllPageQuestionDisplayLogic();
        this.AllPageAnswerDisplayLogic();
        $("#ddPreview", parent.document).val(1);
      }
    }
  }

  /**
   * this method for get Language ID
   * @param languageData
   */
  GetLanguageId(languageData: LanguageData) {

    this.selectedLang = languageData.lang_id;
    this.selectedLanguageName = languageData.LanguageName;
    let langChange = false;

    let path = '';
    if (!this.isOfflineSurvey) {
      path = 'survey1.aspx?' + this.GetUrlData(false);
    } else {
      let k = '';
      this.activatedRoute.queryParams.subscribe(async params => {
        k = params['k'];
      });

      path = 'survey1.aspx?' + 'k=' + k + '&lang=' + this.selectedLang;
    }

    this.router.navigateByUrl(path);
    let checkSelectedLanguageID=0;
    //getting primary langualge ID if other than english

    if(this.surveyData.SurveyDetails.selectedLangId == 0)
    {
      checkSelectedLanguageID = this.surveyData.SurveySettings.primary_lang_id;
    }
    else
    {
      checkSelectedLanguageID = this.surveyData.SurveyDetails.selectedLangId;
    }

    if (this.selectedLang != checkSelectedLanguageID){
      langChange=true;
      if (this.surveyData.SurveyDetails.GroupType == 'preview' &&
        $("#hdnCurrentLang", parent.document).length != 0) {
        $("#hdnCurrentLang", parent.document).val(this.selectedLang);

        if (this.surveyData.SurveyDetails.GroupType == 'preview'
          && $("#ddPreview", parent.document).length != 0
          && $("#ddPreview", parent.document).val() != 1) {
          $("#ddPreview", parent.document).val(1);
          this.pageNumber = 0;
        }
      }
      this.isEndSurveyOnPage = false;
      this.maxPageNumber = 0;
      this.showLoader = true;
      this.GetData(false, this.surveyData.ResponseInfo.ResponseUID,true);
      //this.showLoader = false;
      this.selectedLanguage = true;
      this.form.resetForm();
      this.isControlLoading = true;
      this.lastScrollTop = 0;
      this.isSubmittedForm = false;
    }
    else {
      if (this.surveyData.SurveyDetails.GroupType == 'preview' &&
        $("#hdnCurrentLang", parent.document).length != 0) {
        $("#hdnCurrentLang", parent.document).val(this.selectedLang);
      }
      this.UpdateLocalJson();
      this.changeDetect.detectChanges();
    }

    this.multiLanguage = false;
    this.selectedLanguage = true;
    this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
    if (this.surveyData.SurveySettings.isAssessment &&
      this.surveySpecificData.Participation_Message_Type == 0 &&
      this.surveyData.SurveySettings.SurveyTimeLimit > 0 &&
      !this.subscription_CountDown) {
      this.CountDownTimer();
    }
    $('html').attr('lang',languageData.culture);
    setTimeout(() => {
      this.calculateWidthPageFooter();
    }, 0);
    
    setTimeout(() => {
      if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
      this.bodyNiceScrollResize()
      if (this.commonSetting.isEmbedMobile || this.commonSetting.isEmbedPopMobile) {
        this.bodyNiceScrollResize()
      }
    
      if (!langChange && this.commonSetting.isEmbedNoScroll && window.location !== window.parent.location) {
        let docHeight = document.documentElement.scrollHeight;
        if ($('form').height() != undefined && $('form').height() != 0) {
          docHeight = $('form').height();
        }
        this.postMessgesData = new PostMessgesData()
        this.postMessgesData.action = 'Project Language Change';
        this.postMessgesData.data = '';
        this.postMessgesData.height = docHeight + (this.commonSetting.embedDefaultPx? this.commonSetting.embedDefaultPx : 0 );
        this.postMessgesData.width = document.documentElement.scrollWidth;
        this.postMessgesData.embedid = this.commonSetting.embedID;
        parent.postMessage(JSON.stringify(this.postMessgesData), "*");
        
      } 
    }, 250);
  }

  /**
   * this method use for get language details.
   */
  GetLanguageDetails() {
    this.multiLanguage = true;
    this.selectedLanguage = false;
    this.isLoading = false;
    this.isAllQuestionHideOnPrevPages =false;
    var self = this;


    setTimeout(function(){
      if(self.isMobile) {
        if($('.exitModal').length > 0) {
          $('.langModal').css('max-height', $(window).height() - $('.languageHeader').outerHeight() - 25 + 'px');
        } else {
          $('.langModal').css('max-height', $(window).height() - $('.languageHeader').outerHeight() - 5 + 'px');
        }
      };
      if(!(!(self.surveyData.SurveyDetails.GroupType == 'preview') && self.isMobile)){
        $('.langModal').niceScroll({
          background: 'transparent',
          cursorcolor: '#7f7f7f',
          cursorwidth: '10px',
          autohidemode: false
        });
      }
      if (self.commonSetting.isEmbedNoScroll && window.location !== window.parent.location) {
        let docHeight = document.documentElement.scrollHeight;
        if ($('form').height() != undefined && $('form').height() != 0) {
          docHeight = $('form').height();
        }
        $('.langModal').css('max-height','unset');
        $('.langModal').css('overflow','auto'); 
 
        if(docHeight < ($('.langModal').height() + 250) )
        {
          docHeight = ($('.langModal').height() + 250);
        }
        $('.langModal').css('max-height','calc(100vh - 20vh)');
        $('.langModal').css('overflow','hidden'); 
        self.postMessgesData = new PostMessgesData()
        self.postMessgesData.action= 'Language Pop UP';
        self.postMessgesData.data='';
        self.postMessgesData.height= docHeight + (self.commonSetting.embedDefaultPx? self.commonSetting.embedDefaultPx : 0 );
        self.postMessgesData.width = document.documentElement.scrollWidth;
        self.postMessgesData.embedid = self.commonSetting.embedID;
       
          parent.postMessage(JSON.stringify(self.postMessgesData),"*");
      } 
    }, 0);
    if(this.isMobile && this.surveyData.SurveyDetails.GroupType != 'preview')
    {
      $('.langModal').css('overflow', 'auto');
    }
    if(this.isMobile){
      this.overFlow();
    }

  }

  /**
   * this method use for hadling language pop-up.
   */
  CancelLanguage() {
    this.multiLanguage = false;
    this.selectedLanguage = true;
    if(this.isMobile){
      if(this.commonSetting.isEmbedMobile == 1|| this.commonSetting.isEmbedPopMobile == 1)
        {
          $('body').css('overflow-y', 'hidden');
        }
        else
        {
          $('body').css('overflow', 'hidden');
        }
    }
    this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
    this.UpdateLocalJson();
  }

  /**
   * this method use for single question control handle.
   * @param question
   * @param index
   * @returns
   */
  GetQuestionsString(question: Questions, index: number): string {
    // if (question.mandatory && !(question.qtype == 'CM' && question.qsubtype == 1)) {
    //   this.isMandatory = true;
    // }
    if (question.isAnchorReverse && question.qtype == 'R' && question.qsubtype == 2) {
      question.Answers.sort((n1, n2) => n2.value_id - n1.value_id);
    }
    if (question.AnswerText == null && question.mandatory && !question.isHiddenQ) {
      question.isMandatoryInvalid = true;
    } else {
      question.isMandatoryInvalid = false;
    }

    if (question.Showcharlimit) {
      question.RemainingChr = this.surveyData.SurveyMessages.RemainingChr;
    }
    if (question.qtype == 'CM' && question.qsubtype == 1 && question.AnswerText == undefined) {
      question.AnswerText = null;
    }
    if (question.qtype == "C" || question.qtype == "ML") {

      if (question.ansConstraint != null && question.ansConstraint != "") {
        let ansCons = question.ansConstraint.split(' ');

        let errorMsg = question.error_msg.replace("<N>", ansCons[1]);
        question.error_msg = errorMsg;
      }
    }

    if (this.surveyData.SurveyMessages.ReEnterBlankMessage != null) {
      question.ReEnterBlankMessage = this.surveyData.SurveyMessages.ReEnterBlankMessage;
    }

    if (question.qtype == "RK" && question.error_msg != null) {
      let errorMsg = question.error_msg.replace("<N>", question.rank_limit.toString());
      question.error_msg = errorMsg;
    }

    if (question.qtype == 'T' && question.AnswerText == null && question.date_default != null &&
      (question.qsubtype == 1 || question.qsubtype == 2 ||
        question.qsubtype == 3 || question.qsubtype == 4)) {
      question.AnswerText = question.date_default;
    }

    // if (question.population_type > 0) {
    //   this.DataPopulation(question, question.population_type);
    // }

    if (question.isSQ && this.isControlLoading && !this.isByPassLogic) {
      this.QuestionDisplayLogic(question);
    }


    if (question.isADLSQ && this.isControlLoading && !this.isByPassLogic) {
      this.AnswerDisplayLogic(question,true);
    }

    if (question.piping && !this.surveyData.Pages[this.pageNumber].isPageLoadComplete ||
      (question.piping && question.isCQ && !question.isCQHide)) {
      question = this.QuestionPiping(question, index);
    }

    question.Answers.forEach(element => {
      var pattern = new RegExp(/(?:<.+.>)(.*?)(?=<.*\/.+.?>)/g);
      if(!pattern.test(element.value_text)){
        element.value_text=element.value_text.replace(/</g, "&lt;").replace(/>/g, "&gt;")
      }
    });
    this.questionLength = 1;
    return JSON.stringify(question);
  }

  /**
   * this method use for multi question control handle
   * @param question
   * @param index
   * @returns
   */
  GetMultiQuestionsString(question: Questions, index: number): string {
    let multiQuestions = this.surveyData.Pages[index].Questions.filter(
      e => e.qno == question.qno && e.group_no == question.group_no);

    if (multiQuestions != null && multiQuestions != undefined) {

      let mandatoryObj = multiQuestions.filter(e => e.mandatory && !e.isHiddenQ);

      // if (mandatoryObj.length > 0) {
      //   this.isMandatory = true;
      // }

      for(let question of mandatoryObj){
        if (question.AnswerText == null && question.mandatory && !question.isHiddenQ) {
          question.isMandatoryInvalid = true;
        } else {
          question.isMandatoryInvalid = false;
        }
      }

      if (multiQuestions[0].piping) {
        let group = this.GetGroupData(multiQuestions[0].group_no);

        if (group != undefined && group != null) {
          multiQuestions[0] = this.QuestionPiping(multiQuestions[0], index, true, group.gtitle);

          let groupPiping: GroupPiping = new GroupPiping();

          groupPiping.group_no = multiQuestions[0].group_no;
          groupPiping.pipeTitle = multiQuestions[0].pipingQuationTitle;

          this.service.setPiping(groupPiping);
        }
      }

      for (let i = 0; i < multiQuestions.length; i++) {

        if (this.surveyData.SurveyMessages.ReEnterBlankMessage != null) {
          question.ReEnterBlankMessage = this.surveyData.SurveyMessages.ReEnterBlankMessage;
        }

        if (multiQuestions[i].piping) {
          multiQuestions[i] = this.QuestionPiping(multiQuestions[i], index);
        }

        if (multiQuestions[i].Showcharlimit) {
          multiQuestions[i].RemainingChr = this.surveyData.SurveyMessages.RemainingChr;
        }

        if (multiQuestions[i].qtype == "C") {

          if (multiQuestions[i].ansConstraint != null) {
            let ansCons = multiQuestions[i].ansConstraint.split(' ');

            let errorMsg = multiQuestions[i].error_msg.replace("<N>", ansCons[1]);
            multiQuestions[i].error_msg = errorMsg;
          }
        }

        if (multiQuestions[i].qtype == 'T' && multiQuestions[i].AnswerText == null &&
         (multiQuestions[i].date_default != null && multiQuestions[i].date_default != "") &&
          (multiQuestions[i].qsubtype == 1 || multiQuestions[i].qsubtype == 2 ||
            multiQuestions[i].qsubtype == 3 || multiQuestions[i].qsubtype == 4)) {
          multiQuestions[i].AnswerText = multiQuestions[i].date_default;
        }

        if (multiQuestions[i].qtype == "RK" && multiQuestions[i].rank_limit > 0) {
          let errorMsg = multiQuestions[i].error_msg.replace("<N>", multiQuestions[i].rank_limit.toString());
          multiQuestions[i].error_msg = errorMsg;
        }

        // if(this.surveyData.SurveyDetails.GroupType == 'preview' && this.preview.isShowHiddenQN
        //   && (multiQuestions[0].population_type == 2 || multiQuestions[0].population_type == 5))
        // {
        //   multiQuestions[0].population_type = 0;
        // }

        if (multiQuestions[i].isSQ && this.isControlLoading && !this.isByPassLogic) {
          this.QuestionDisplayLogic(multiQuestions[i]);
        }

        if (multiQuestions[i].isADLSQ && this.isControlLoading && !this.isByPassLogic) {
          this.AnswerDisplayLogic(multiQuestions[i],false);
        }

        if (multiQuestions[i].UniqueNumber != question.UniqueNumber) {
          multiQuestions[i].isMultiQuestion = true;
        }

        if (this.surveyData.SurveySettings.isMandatoryUpfront) {
          multiQuestions[i].isMandatoryStar = true;
        }

        let findQuestion = this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == multiQuestions[i].UniqueNumber);

        if (findQuestion != null && findQuestion != undefined) {
          let ind = this.surveyData.Pages[index].Questions.indexOf(findQuestion);

          this.surveyData.Pages[index].Questions[ind] = multiQuestions[i];
        }
      }
      this.questionLength = multiQuestions.length;
      return JSON.stringify(multiQuestions);
    }
  }

  /**
   * this method use for handling matrix grid control.
   * @param question
   * @param index
   * @param isValidObj
   * @returns
   */
  GetMatrixGridQuestionsString(question: Questions, index: number, isValidObj: boolean = false): string {
    let groupData = this.GetGroupData(question.group_no);

    if (groupData != null && groupData != undefined) {
      let matrixData = this.GetMatrixData(groupData);

      if (matrixData != null && matrixData != undefined) {
        let groupDatas = this.surveyData.Groups.filter(
          e => e.Matrix_id == matrixData.matrix_id);

        if (question.piping) {
          question = this.QuestionPiping(question, index, true, matrixData.Mtitle);

          let matrixPiping: MatrixPiping = new MatrixPiping();

          matrixPiping.matrix_id = matrixData.matrix_id;
          matrixPiping.pipeTitle = question.pipingQuationTitle;

          this.service.setMatrixPiping(matrixPiping);
        }

        if (groupDatas != null && groupDatas != undefined) {

          let matrixQuestions = [];

          for (let i = 0; i < groupDatas.length; i++) {
            let questionDatas = this.surveyData.Pages[index].Questions.filter(
              e => e.group_no == groupDatas[i].group_no);

            // if (questionDatas.filter(e => e.mandatory).length > 0 && !this.isMandatory) {
            //   this.isMandatory = true;
            // }

            if (questionDatas.length > 0) {
              for (let j = 0; j < questionDatas.length; j++) {

                if (questionDatas[j].UniqueNumber != question.UniqueNumber && !isValidObj) {
                  questionDatas[j].isMultiQuestion = true;
                }

                if (this.surveyData.SurveySettings.isMandatoryUpfront && !isValidObj) {
                  questionDatas[j].isMandatoryStar = true;
                }

                if (questionDatas[j].piping) {
                  questionDatas[j] = this.QuestionPiping(questionDatas[j], index);
                }

                let findQuestion = this.surveyData.Pages[index].Questions.find(
                  e => e.UniqueNumber == questionDatas[j].UniqueNumber);

                if (findQuestion != null && findQuestion != undefined && !isValidObj) {
                  let ind = this.surveyData.Pages[index].Questions.indexOf(findQuestion);

                  this.surveyData.Pages[index].Questions[ind] = questionDatas[j];
                }
                if (question.qtype == 'RG' && groupDatas[i].isAnchorReverse) {
                  if(this.isMobile){
                    if(!(questionDatas[j].qsubtype == 1 && this.isRTL)){
                      questionDatas[j].Answers.sort((n1, n2) => n2.weight - n1.weight);
                    }
                  }else{
                    questionDatas[j].Answers.sort((n1, n2) => n2.weight - n1.weight);
                  }
                } else if ((questionDatas[j].qtype == 'GR' || questionDatas[j].qtype == 'SR') && (questionDatas[j].qsubtype == 1||(questionDatas[j].qsubtype == 2 && questionDatas[j].qtype == 'GR')) && groupDatas[i].isAnchorReverse) {
                  questionDatas[j].Answers.sort((n1, n2) => n2.value_id - n1.value_id);
                }
                if (questionDatas[j].Showcharlimit) {
                  questionDatas[j].RemainingChr = this.surveyData.SurveyMessages.RemainingChr;
                }
                matrixQuestions.push(questionDatas[j]);
              }
            }
          }
          this.questionLength = matrixQuestions.length;
          return JSON.stringify(matrixQuestions);
        }
      }
    }
  }

  /**
   * this method use for group data.
   * @param group_no
   * @returns
   */
  GetGroupData(group_no: number): Group {
    if (this.surveyData.Groups != null) {
      return this.surveyData.Groups.find(e => e.group_no == group_no);
    }
  }

  /**
   * this method use for handle multiple group data.
   * @param matrix
   * @returns
   */
  GetGroupDatas(matrix: Matrix): Group[] {
    if (this.surveyData.Groups != null) {
      return this.surveyData.Groups.filter(e => e.Matrix_id == matrix.matrix_id);
    }
  }

  /**
   * this method use for matrix data.
   * @param group
   * @returns
   */
  GetMatrixData(group: Group): Matrix {
    if (this.surveyData.Matrix != null) {
      return this.surveyData.Matrix.find(e => e.matrix_id == group.Matrix_id);
    }
  }

  /**
   * this method use for check multiple question
   * @param group
   * @returns
   */
  GetIsMulti(group: Group): boolean {
    if (this.surveyData.Matrix != null && group != undefined) {
      return this.surveyData.Matrix.find(e => e.matrix_id == group.Matrix_id).isMulti;
    }
  }

  /**
   * this method use for check IsSingleGrid
   * @param group
   * @returns
   */
  GetIsSingle(group: Group): boolean {
    if (this.surveyData.Matrix != null && group != undefined) {
      return this.surveyData.Matrix.find(e => e.matrix_id == group.Matrix_id).IsSingleGrid;
    }
  }



  /**
   * this method use for question piping.
   * @param question
   * @param index
   * @param isRecursive
   * @param updatedTitle
   * @param isThankYouPagePiping
   * @returns
   */
  QuestionPiping(question: Questions, index: number, isRecursive: boolean = false,
    updatedTitle: string = null, isThankYouPagePiping: boolean = false): Questions {
    if (this.surveyData != null) {

      let title = '';
      if (isThankYouPagePiping) {
        index = this.surveyData.Pages.length;
        if (this.surveySpecificData.Participation_Messages.thankYou_message == null ||
          this.surveySpecificData.Participation_Messages.thankYou_message == undefined) {
          title = this.surveyData.Participation_Messages.thankYou_message.ThankyouPage;
          this.surveyData.Participation_Messages.thankYou_message.ThankyouPage = '';
        } else {
          title = this.surveySpecificData.Participation_Messages.thankYou_message.ThankyouPage;
          this.surveySpecificData.Participation_Messages.thankYou_message.ThankyouPage = '';
        }
      } else {
        title = question.qtitle
        question.pipingQuationTitle = '';
      }

      if (isRecursive) {
        title = updatedTitle;
      }

      if (title == null || title == "") {
        return question;
      }

      let newTitle = title.split('[[');

      if (newTitle.length > 0) {
        for (let i = 0; i < newTitle.length; i++) {

          if (newTitle[i] == null || newTitle[i] == "") {
            continue;
          }

          let element = newTitle[i];
          let intRight = element.indexOf(']]');

          if (intRight > 0 && element.toUpperCase().indexOf("DIR_") == -1) {
            let newId = element.substring(0, intRight);
            for (let j = index - 1; j >= 0; j--) {
              this.skippedPageList =this.UniqueArray(this.skippedPageList);
              if (this.skippedPageList != null && this.skippedPageList.length > 0) {
                if (this.skippedPageList.indexOf(j + 1) >= 0) {
                  continue;
                }
              }
              //for (let k = 0; k < this.surveyData.Pages[j].Questions.length; k++) {
              let pipingQN = this.surveyData.Pages[j].Questions.find(e => e.UniqueNumber == parseInt(newId));
              if (pipingQN != null && pipingQN != undefined) {
                element = element.replace('&nbsp;', ' ');
                if (pipingQN.AnswerText != null) {
                  if (pipingQN.selectedOptionList != null &&
                    pipingQN.selectedOptionList.length > 0) {
                    element = element.replace(newId, this.selectedAnswerOptions(pipingQN.selectedOptionList, pipingQN));
                  } else {
                    if (pipingQN.isOtherAnswer) {
                      let anstext = pipingQN.otherAnswer;
                      if (anstext == null || anstext == undefined) {
                        anstext = '';
                      }
                      element = element.replace(newId, anstext);
                    } else {
                      if (pipingQN.qtype == "RS") {
                        let ans = pipingQN.Answers.find(
                          e => e.value_id == pipingQN.selectAnsValue);
                        if (ans != undefined && ans != null) {
                          let anstext;
                          if (ans.isNA) {
                            if (ans.value_text) {
                              anstext = ans.value_text;
                            } else {
                              anstext = pipingQN.AnswerText;
                            }
                          } else {
                            if (ans.value_text) {
                              anstext = ans.weight + " - " + ans.value_text;
                            } else {
                              anstext = ans.weight;
                            }
                          }
                          element = element.replace(newId, anstext);
                        }
                      } else {
                        if (pipingQN.qtype == "RG" && pipingQN.qsubtype == 1) {
                          let ans = pipingQN.Answers.find(
                            e => e.value_id == pipingQN.selectAnsValue && e.isNA == true);
                          if (ans != undefined && ans != null) {
                            if (pipingQN.AnswerText == "") {
                              element = element.replace(newId, "N/A");
                            } else {
                              element = element.replace(newId, pipingQN.AnswerText.replace("N/A", ""));
                            }
                          } else {
                            element = element.replace(newId, pipingQN.AnswerText);
                          }
                        }
                        else if (pipingQN.qtype == "GQ") {
                          let selectedAnswerID = pipingQN.AnswerID;
                          let selectedAnswer = pipingQN.Answers.find(e => e.ms_id == selectedAnswerID)
                          element = element.replace(newId, selectedAnswer.value_text);
                        }
                        else {
                          element = element.replace(newId, pipingQN.AnswerText);
                        }
                      }
                    }
                  }
                  //}
                } else {
                  element = element.replace(newId, '');
                  //element = element.replace('<br />', '');
                }
                element = element.replace('[[', '')
                element = element.replace(']]', '');

                if (isThankYouPagePiping) {
                  if (this.surveySpecificData.Participation_Messages.thankYou_message == null || this.surveySpecificData.Participation_Messages.thankYou_message == undefined) {
                    this.surveyData.Participation_Messages.thankYou_message.ThankyouPage += element;
                  } else {
                    this.surveySpecificData.Participation_Messages.thankYou_message.ThankyouPage += element;
                  }
                } else {
                  question.pipingQuationTitle += element;
                }
                //isBreak = true;
                break;
              }
              else {
                if(element!=''){
                  element = element.replace('&nbsp;', ' ');
                  element = element.replace('[[', '');
                  element = element.replace(']]', '');
                  if (isThankYouPagePiping && j == 0) {
                    if (this.surveySpecificData.Participation_Messages.thankYou_message == null || this.surveySpecificData.Participation_Messages.thankYou_message == undefined) {
                      this.surveyData.Participation_Messages.thankYou_message.ThankyouPage += element;
                    } else {
                      this.surveySpecificData.Participation_Messages.thankYou_message.ThankyouPage += element;
                    }
                  }
                }
                continue;
              }
              //}
            }
            
          }
          else if (intRight > 0 && element.toUpperCase().indexOf("DIR_")> -1 &&  element.split('_').length == 4)
            {
              let newId = element.substring(0, intRight);
              let arrDirPipe = newId.split('_')
              let dirPipe = this.surveyData.dirQuestionPipings.filter(e=> e.directoryId == parseInt(arrDirPipe[1]) && e.activityId == parseInt(arrDirPipe[2]) && e.columnId == parseInt(arrDirPipe[3]) && e.columnData !="" );
              if(dirPipe.length > 0)
              {
                  element = element.replace(newId, dirPipe[0].columnData);
              }  
              else{
                  element = element.replace(newId, '');
              }
              element = element.replace('[[', '')
              element = element.replace(']]', '');
              question.pipingQuationTitle += element;
            } 
          else{
            if (isThankYouPagePiping) {
              if (this.surveySpecificData.Participation_Messages.thankYou_message == null || this.surveySpecificData.Participation_Messages.thankYou_message == undefined) {
                this.surveyData.Participation_Messages.thankYou_message.ThankyouPage += element;
              } else {
                this.surveySpecificData.Participation_Messages.thankYou_message.ThankyouPage += element;
              }
            } else {
              question.pipingQuationTitle += element;
            }
            continue;
          }
        }
      }
      return question;
    }
  }

  /**
   * this method use for sort multi-value control data.
   * @param selectedOptionList
   * @param question
   * @returns
   */
  selectedAnswerOptions(selectedOptionList: SelectedOptionList[], question: Questions): string {
    let ansText;

    let list = selectedOptionList.find(e => e.isOther);

    if (list != undefined && list != null) {
      // If List contains isOther Push it at last place
      let index = selectedOptionList.indexOf(list);
      selectedOptionList.splice(index, 1);
      selectedOptionList.sort((n1, n2) => n1.value_id - n2.value_id);
      selectedOptionList.push(list);
    } else {
      selectedOptionList.sort((n1, n2) => n1.value_id - n2.value_id);
    }

    for (let i = 0; i < selectedOptionList.length; i++) {
      // if 0 dont append , at last
      if (i == 0) {
        if (selectedOptionList[i].isOther) {
          if (question.otherAnswer != null || question.otherAnswer != undefined)
            ansText = question.otherAnswer;
        } else {
          if (question.qtype == 'CS') {
            if (selectedOptionList[i].value_text != null && selectedOptionList[i].value_text != undefined && selectedOptionList[i].value_text.trim() != '') {
              ansText = selectedOptionList[i].value_text;
            }
            else {
              ansText = 0;
            }
          }
          else if(question.qtype == 'RK') {
            ansText = question.Answers.find(e => e.ControlAns == selectedOptionList[i].value_id).value_text;
          }
          else {

            if(selectedOptionList[i].value_text != null && selectedOptionList[i].value_text != undefined && selectedOptionList[i].value_text.trim() != ''){
              ansText = selectedOptionList[i].value_text;
            } else {
              ansText = question.Answers.find(e => e.value_id == selectedOptionList[i].value_id).value_text;
            }
          }
        }
      }
      // else append , at last
      else {
        if (selectedOptionList[i].isOther) {
          if (question.otherAnswer != null || question.otherAnswer != undefined)
            ansText += ansText != undefined ? ', ' + question.otherAnswer : '' + question.otherAnswer;
        } else {
          if (question.qtype == 'CS') {
            if (selectedOptionList[i].value_text != null && selectedOptionList[i].value_text != undefined && selectedOptionList[i].value_text.trim() != '') {
              ansText = parseFloat(ansText) + parseFloat(selectedOptionList[i].value_text);
            }
          }
          else if(question.qtype == 'RK') {
            if(ansText){
              ansText += ', ' + question.Answers.find(e => e.ControlAns == selectedOptionList[i].value_id).value_text;
            }
            else{
              ansText += '' + question.Answers.find(e => e.ControlAns == selectedOptionList[i].value_id).value_text;
            }
          }
          else {
            if(selectedOptionList[i].value_text != null && selectedOptionList[i].value_text != undefined && selectedOptionList[i].value_text.trim() != ''){
              ansText += ansText != undefined ? ', ' + selectedOptionList[i].value_text : '' + selectedOptionList[i].value_text;
            }else{
              ansText += ansText != undefined ? ', ' + question.Answers.find(e => e.value_id == selectedOptionList[i].value_id).value_text : '' + question.Answers.find(e => e.value_id == selectedOptionList[i].value_id).value_text;
            }

          }
        }
      }
    }

    return (ansText != undefined && question.qtype != 'CS') || (question.qtype == 'CS' && ansText != 0) ? ansText : '';
  }

  /**
   * this method use for data population data in control.
   * @param question
   * @param populationType
   */
  DataPopulation(question: Questions, populationType: number) {

    if(this.surveySpecificData.PrePopDetails){
      let populationDetail = this.surveySpecificData.PrePopDetails.filter(rule => rule.UniqueNumber == question.UniqueNumber);

      if(populationDetail != null && populationDetail.length >0){
        question.PrePopText = populationDetail[0].preText;
        question.PrePopValue = populationDetail[0].preValue;

        if (question.PrePopText == "") {
          question.PrePopText = null;
        }

        if (populationDetail[0].isHide) {
          question.population_type = 2;
        }
      }
    }
    if (question.isSoftRequired && !question.isHiddenQ) {
      question.isSoftRequiredHandle = false;
    }
    if (question.Answers != null) {
      if (((question.qtype == 'C' || question.qtype == 'ML' || question.qtype == 'GC' || question.qtype == 'SC') && (question.qsubtype == 0 || question.qsubtype == 1) ) || (question.qtype == 'RW' && question.qsubtype == 2)) {
        if (question.PrePopText != null && question.PrePopText != undefined) {
          let populationDetail = this.surveySpecificData.PrePopDetails.filter(rule => rule.UniqueNumber == question.UniqueNumber);
          if (populationDetail != undefined && populationDetail != null && populationDetail.length > 0) {
            for (let i = 0; i < populationDetail.length; i++) {
              let updateItem = question.Answers.find(e => e.value_id == populationDetail[i].preValue && question.PrePopValue != 0);

              // if (this.surveyData.SurveySettings.isEmbedPrePop && question.PrePopValue == 999) {
              //   updateItem = question.Answers.find(e => e.value_id == 0);
              // }
              question.PrePopValue = question.selectAnsValue = (question.selectAnsValue == null|| question.selectAnsValue == -1) ? populationDetail[0].preValue : question.selectAnsValue;
              question.PrePopText = question.AnswerText = question.AnswerText == null ? populationDetail[0].preText : question.AnswerText;
              if(updateItem != undefined){
                let index = question.Answers.indexOf(updateItem);
                question.Answers[index].selectdId = 1;
                this.InsertSelectedOptionList(question, question.Answers[index].value_id,
                  question.Answers[index].value_text, question.Answers[index].isOther);
                  question.Answers[index].ControlAns = true;
                  question.pageto = question.Answers[index].pageto;
              }
            }
            if (question.selectedOptionList && question.selectedOptionList.length > 0) {
              if (question.selectedOptionList.find(e => e.isOther == true) != undefined) {
                question.isOtherAnswer = true;
              } else {
                question.isOtherAnswer = false;
              }
            }
          }
        }
      } else {
      let updateItem = question.Answers.find(e => e.value_id == question.PrePopValue && question.PrePopValue != 0);

      if (this.surveyData.SurveySettings.isEmbedPrePop && question.PrePopValue == 999) {
        updateItem = question.Answers.find(e => e.value_id == 0);
        question.PrePopValue = 0;
      }

      question.PrePopValue = question.selectAnsValue = (question.selectAnsValue == null|| question.selectAnsValue == -1)? question.PrePopValue : question.selectAnsValue;
      question.PrePopText = question.AnswerText = question.AnswerText == null ?question.PrePopText : question.AnswerText;

      if (question.qtype == "T" && question.qsubtype == 21 && question.AllowOnlyInteger && question.AnswerText != undefined && question.AnswerText != null) {
        question.AnswerText = Math.round(parseFloat(question.AnswerText)).toString();
        question.PrePopText = Math.round(parseFloat(question.AnswerText)).toString();
      }

      if (question.qtype == "GQ" && question.AnswerText != undefined && question.AnswerText != null) {
        question.AnswerText = question.PrePopValue.toString();
      }

      if (updateItem != undefined && updateItem != null) {
        let index = question.Answers.indexOf(updateItem);

        // question.PrePopValue = question.selectAnsValue = question.PrePopValue == null ? question.selectAnsValue : question.PrePopValue;
        //question.PrePopValue = question.selectAnsValue = question.selectAnsValue == null ? question.PrePopValue : question.selectAnsValue;
        question.pageto = question.Answers[index].pageto;
        question.AnswerID = question.Answers[index].ms_id;

        if (question.qtype == "T") {
          question.Answers[index].ControlAns = question.PrePopText;
        }
        else if (question.qtype == "RS" && (question.RS_Type == 0 || question.RS_Type == 2 || question.RS_Type == 3 || question.RS_Type == 4)) {
          question.Answers[index].ControlAns = question.PrePopValue.toString();
        }  else
          question.Answers[index].ControlAns = question.Answers[index].value_text;

        if (question.qtype == "RS" && question.RS_Type == 0) {       
          if (question.Answers[index].isNA) {
            question.isNA = true;
          } else {
            question.isNA = false;
          }
        }  


        // question.PrePopText = question.AnswerText = question.PrePopText == null ? question.AnswerText : question.PrePopText;
        //question.PrePopText = question.AnswerText = question.AnswerText == null ?question.PrePopText : question.AnswerText;
        question.Answers[index].selectdId = 1;

        if (question.qtype == 'C' || question.qtype == 'CS' ||
          question.qtype == 'ML' || question.qtype == 'RK' || question.qtype == 'GC') {
          this.InsertSelectedOptionList(question, question.Answers[index].value_id,
            question.Answers[index].value_text, question.Answers[index].isOther);

          if (question.qtype == 'C' || question.qtype == 'ML' || question.qtype == 'GC') {
            question.Answers[index].ControlAns = true;
          }
        }

        if (question.Answers[index].isOther) {
          question.isOtherAnswer = true;
        }
        else {
          question.isOtherAnswer = false;
        }

        if (question.qtype == 'RW' && question.qsubtype == 3) {
          question.isLoading = true;
        }
      }

      if (question.qtype == "T" && (populationType == 2 || populationType == 3)) {
        question.pageto = question.Answers[0].pageto;
      }
    }
    }
  }

  /**
   * this method use for track by unique question.
   * @param index
   * @param question
   * @returns
   */
  trackByUniqueNumber(index: number, question: Questions): string {
    return question.UniqueNumber.toString();
  }

  /**
   * this method use for handling next page.
   * @param index
   * @param isLoading
   * @param isAllQuestionOnPageQDL
   * @returns
   */
  GetNextPage(index: number, isLoading: boolean = false, isAllQuestionOnPageQDL: boolean = false) {
   
    this.isDivScroll = false;
    this.formValisandSubmited = true;
    this.isAllQuestionHideMessage = false;
    // this.preview.isPrevPgChnge=false;
    if (this.nextButtonClickNo != 1000) {
      this.nextButtonClickNo++;
    }
    this.service.setNextButtonClickNo(this.nextButtonClickNo);
    this.isSubmittedForm = false;
    this.UpdateLocalJson();
    //let qdlQuestions;
    // let qdlQuestionsat;
    // if(this.pageNumber < this.maxPageNumber - 1){
    //   for (let i = this.pageNumber; i <= (this.maxPageNumber - 1); i++) {
    //     qdlQuestions = this.surveyData.Pages[i].Questions.filter(e => e.isCQ && (!e.isCQHide));
    //     if(qdlQuestions.length>0){
    //       qdlQuestionsat=true;
    //       break;
    //     }
    //   }
    // }
    //window
    var PageNo = this.pageNumber;
    if (this.IsSubmitted(index)) {
      this.service.emitFormSubmitEvent.next(true);
      this.formValisandSubmited = false;
      this.isSubmittedForm = true;
      this.changeDetect.detectChanges();
      return;
    } else if (this.pageNumber == this.maxPageNumber - 1 || (this.isEndSurveyOnPage && !isAllQuestionOnPageQDL)) {
      if(this.surveyData.SurveyDetails.isTest)
      {
        setTimeout(() => {
          $('.test-modal-overlay').show();
          this.selectedLanguage = false;
          this.changeDetect.detectChanges();
        }, 0);
        //alert(this.surveyData.SurveyMessages.TestWarningMsg);
      }
      else
      {
        if(this.pageNumber < this.maxPageNumber - 1 )
        {
          for (let i = this.pageNumber + 1; i <this.maxPageNumber; i++) {
            let surveypageindex = this.surveyPageList.indexOf((i + 1));
            if (surveypageindex >= 0) {
              this.surveyPageList.splice(surveypageindex, 1);
            }
          }
        }
        this.selectedLanguage = false;
        this.service.emitFormSubmitEvent.next(false);
        this.SubmitData();

        if (isLoading) {
          this.pageNumber = 999;
        }
      }
    }
    else {
      if(index == 0)
      {
        this.skippedPageList = [];
      }
      if(!this.isAllQuestionHideOnPrevPages)

      this.form.resetForm();
      this.formValisandSubmited = false;
      this.service.emitFormSubmitEvent.next(false);
      this.isControlLoading = true;
      this.showLoader = true;

      if(this.surveyData.SurveyDetails.isSurveyReopened && this.pageNumber== 0)
      {
        this.surveyPageList = [];
        this.assesmentAutoSavePageList = [];
      }
      if (this.pageNumber == 0 && this.surveyPageList.indexOf(1) < 0) {
        this.surveyPageList.push(1);
        if (this.surveyData.SurveySettings.isAssessment) {
          this.assesmentAutoSavePageList.push(1);
        }
      } else if (this.isPrevPgChnge && this.surveyPageList.indexOf(this.pageNumber) < 0) {
        this.surveyPageList.push(this.pageNumber + 1);
        if (this.surveyData.SurveySettings.isAssessment) {
          this.assesmentAutoSavePageList.push(this.pageNumber + 1);
        }
      }
      this.SaveOnNext(index,isLoading);
    }
    this.lastScrollTop = 0;
  }

  /**
   * this method handling next page data.
   * @param index
   * @param isLoading
   * @returns
   */
  NextPageHandling(index: number,isLoading:boolean) {
    if (this.pageNumber < this.maxPageNumber) {

      if (this.nextButtonClickNo > 1 &&
        !this.surveyData.Pages[this.pageNumber].isSoftRequiredHandle) {
          this.surveyData.Pages[this.pageNumber].isSoftRequiredHandle = true;
      }

      this.service.setPageIsSoftRequiredHandle(true);
      if(this.isPrevPgChnge){
        this.isPrevPgChnge =false;
        this.service.setPrevPgChnge(this.isPrevPgChnge);
      }
      let branchObj = this.surveyData.Pages[index].Questions.filter(e => e.branch && !e.isCQHide);
      if (branchObj.length > 0 && !this.isByPassLogic) {
        let pageNo = 0;
        if (branchObj[0].isOtherAnswer && branchObj[0].qtype != "C" && branchObj[0].qtype != "ML") {
          pageNo = branchObj[0].other_pageto;
        } else if (branchObj[0].selectAnsValue > 0 ||
          (branchObj[0].qtype == "T" && branchObj[0].AnswerText != null) ||
          (branchObj[0].selectedOptionList != null && branchObj[0].selectedOptionList.length > 0)) {
          if (branchObj[0].pageto == 0) {
            pageNo = this.pageNumber + 2;
          } else if (branchObj[0].pageto == null) {
            pageNo = branchObj[0].dna_pageto;
          } else {
            pageNo = branchObj[0].pageto;
          }
        }
        else {
          pageNo = branchObj[0].dna_pageto;
        }

        if (pageNo == 999) {
          branchObj[0].pageto = pageNo;
          if (!this.isAllQuestionHideOnPrevPages)
            this.form.resetForm();
          pageNo = this.maxPageNumber;
          this.selectedLanguage = false;
            //Issue No.  120722 : Open : [Pif-120609]Let's try this again for page with mandatory ques after end and exit
            if (this.surveyPageList != null && this.surveyPageList != undefined && this.surveyPageList.length > 0) {
              let pageList = [];
              for (let i = 0; i < this.maxPageNumber; i++) {

                if (this.surveyPageList.indexOf(i+1) != -1 &&
                    i <= this.pageNumber) {
                  pageList.push(i+1);
                }
              }
              this.surveyPageList = pageList;
              if (this.surveyData.SurveySettings.isAssessment) {
                this.assesmentAutoSavePageList = pageList;
              }
            }
          this.SubmitData(true);
        } else {
          this.answerPiping(pageNo - 1);
          //this.ContactQuestionDisplayLogic(pageNo - 1);
          this.skippedPageList =this.UniqueArray(this.skippedPageList);
          if (((pageNo) - (this.pageNumber + 1)) != 1) {
            for (let i = (this.pageNumber + 1); i < pageNo - 1; i++) {
              if (this.skippedPageList.indexOf((i + 1)) == -1) {
                this.skippedPageList.push((i + 1));
              }
              let surveypageindex = this.surveyPageList.indexOf((i + 1));
              if (surveypageindex >= 0) {
                //this.ClearPageAnswers(surveypageindex);
                this.surveyPageList.splice(surveypageindex, 1);
              }
            }
          }
          this.surveyPageList.push(pageNo);
          if(this.surveyData.SurveySettings.isAssessment){
            this.assesmentAutoSavePageList.push(pageNo);
          }
          this.skippedPageList =this.UniqueArray(this.skippedPageList);
          let skipppageindex = this.skippedPageList.indexOf(pageNo);
          if (skipppageindex >= 0) {
            this.skippedPageList.splice(skipppageindex, 1);
          }
          let nextPageNo = this.pageNumber + 1;
          if (nextPageNo != (pageNo - 1)) {
            for (let i = nextPageNo; i < (pageNo - 1); i++) {
              this.skippedPageList.push((i + 1));
            }
          }
          this.pageNumber = pageNo - 1;
          this.selectedLanguage = true;
          if (this.allQuestionHideOnPage(this.pageNumber, false, true,false,false)) {
            this.selectedLanguage = false;
            for(let i=this.pageNumber;i<this.maxPageNumber; i++)
              {
                  if (this.allQuestionHideOnPage(i, false, true,false,false)) {
                  let prehideQs = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 2 || e.population_type == 5 || e.isHiddenQ);
                  if(prehideQs != undefined && prehideQs != null && prehideQs.length == 0 )
                  {
                    this.skippedPageList =this.UniqueArray(this.skippedPageList);
                    let skipppageindex = this.skippedPageList.indexOf(i + 1);
                    if (skipppageindex == -1 ) {
                      this.skippedPageList.push(i+1);
                    }
                  }
                  if (prehideQs != undefined && prehideQs != null && prehideQs.length == this.surveyData.Pages[i].Questions.length){
                     this.surveyPageList.push(i + 1);
                  }
                  else{
                    let surveypageindex = this.surveyPageList.indexOf((i + 1));
                    if (surveypageindex > -1) {
                      this.surveyPageList.splice(surveypageindex, 1);
                    }
                  }
                 
                  this.pageNumber = i;
                }
                else{
                  this.pageNumber = (i-1);
                  break;
                }
              }
            this.GetNextPage(this.pageNumber,isLoading);
            return;
          }
          if (this.pageNumber != 0 && this.pageNumber != 999) {
            if (this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.population_type != 2 && e.population_type != 5 && !e.isHiddenQ).length == 0 && this.pageNumber == this.maxPageNumber - 1) {
              this.form.resetForm();
              pageNo = this.maxPageNumber;
              this.selectedLanguage = false;
              this.SubmitData();
            } else {
              this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
            }
            this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
          }
        }
      } else {
        if (this.saveOnNextData != null && !this.isByPassLogic) {
          if (this.saveOnNextData.NextPageNo == 999) {
            //this.pageNumber = this.saveOnNextData.NextPageNo;
          }
          else {
            if (((this.saveOnNextData.NextPageNo) - (this.pageNumber + 1)) != 1) {
              this.skippedPageList =this.UniqueArray(this.skippedPageList);
              for (let i = (this.pageNumber + 1); i < this.saveOnNextData.NextPageNo - 1; i++) {
                if (this.skippedPageList.indexOf((i + 1)) == -1) {
                  this.skippedPageList.push((i + 1));
                }
                let surveypageindex = this.surveyPageList.indexOf((i + 1));
                if (surveypageindex >= 0) {
                   //this.ClearPageAnswers(surveypageindex);
                  this.surveyPageList.splice(surveypageindex, 1);
                }
              }
            }
            this.pageNumber = this.saveOnNextData.NextPageNo - 1;
          }

          if (this.pageNumber != 0 && this.pageNumber != 999) {
            this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
          }
          if (this.saveOnNextData.NextPageNo == 999) {
            this.isThankYouPage = false;
            this.multiLanguage = false;
            this.selectedLanguage = false;
            this.isPrintDownload = false;
            //Issue No.  120722 : Open : [Pif-120609]Let's try this again for page with mandatory ques after end and exit
            if (this.surveyPageList != null && this.surveyPageList != undefined && this.surveyPageList.length > 0) {
              let pageList = [];
              for (let i = 0; i < this.maxPageNumber; i++) {

                if (this.surveyPageList.indexOf(i+1) != -1 &&
                    i <= this.pageNumber) {
                  pageList.push(i+1);
                }
              }
              this.surveyPageList = pageList;
              if (this.surveyData.SurveySettings.isAssessment) {
                this.assesmentAutoSavePageList = pageList;
              }
            }
            this.SubmitData(true);
            this.changeDetect.detectChanges();
            return;
          }
        } else {
          this.pageNumber++;          
          this.ContactQuestionDisplayLogic(this.pageNumber);
          if (this.pageNumber != 0 && this.pageNumber != 999) {
            this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
          }
        }
        if (this.allQuestionHideOnPage(this.pageNumber, false, true,false,false)) {
            this.selectedLanguage = false;
          
          for(let i=this.pageNumber;i<this.maxPageNumber; i++)
          {
              if (this.allQuestionHideOnPage(i, false, true,false,false)) {
              let prehideQs = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 2 || e.population_type == 5 || e.isHiddenQ);
              if(prehideQs != undefined && prehideQs != null && prehideQs.length == 0 )
              {
                this.skippedPageList =this.UniqueArray(this.skippedPageList);
                let skipppageindex = this.skippedPageList.indexOf(i + 1);
                if (skipppageindex == -1 ) {
                  this.skippedPageList.push(i+1);
                }
              }
              if (prehideQs != undefined && prehideQs != null && prehideQs.length == this.surveyData.Pages[i].Questions.length){
                this.surveyPageList.push(i + 1);
              }
              else{
                let surveypageindex = this.surveyPageList.indexOf((i + 1));
                  if (surveypageindex > -1) {
                    this.surveyPageList.splice(surveypageindex, 1);
                  }
                }
              this.pageNumber = i;
            }
            else{
              this.pageNumber = (i-1);
              break;
            }
          }
        
          this.GetNextPage(this.pageNumber, isLoading, true);
          return;
        }
        else {
          this.selectedLanguage = true;
          this.surveyPageList.push(this.pageNumber + 1);
          if (this.surveyData.SurveySettings.isAssessment) {
            this.assesmentAutoSavePageList.push(this.pageNumber + 1);
          }
          this.skippedPageList =this.UniqueArray(this.skippedPageList);
          let skipppageindex = this.skippedPageList.indexOf(this.pageNumber + 1);
          if (skipppageindex >= 0) {
            this.skippedPageList.splice(skipppageindex, 1);
          }
          this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
          if(this.isAllQuestionHideOnPrevPages
            && this.surveyData.LanguageDatas != null && this.surveyData.LanguageDatas.length > 1
            && isLoading && !this.selectedLanguage)
          {
              this.multiLanguage = true;
              this.setLangBasedOnBrowser();
          }
          this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
        }

      }
      if (this.surveyData.SurveyDetails.GroupType == 'preview') {
        if (this.isThankYouPage == true) {
          $("#ddPreview", parent.document).val(-1);
        }
        else {
          $("#ddPreview", parent.document).val((this.pageNumber + 1));
        }
      }

      if (this.pageNumber != 999 && this.pageNumber < this.maxPageNumber) {
        if ((this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM').length > 0 && !this.isOfflineSurvey)||
        ((this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM' && !(e.qtype == 'T'  && (e.qsubtype == 71  || e.qsubtype == 72))).length > 0) && this.isOfflineSurvey)) {
          this.isMandatory = true;
        } else {
          this.isMandatory = false;
        }
      }

      this.QDLForSkippedQuestions(this.UniqueArray(this.skippedPageList));

      if (this.nextButtonClickNo != 1000) {
        this.nextButtonClickNo = 0;
      }
      this.changeDetect.detectChanges();
      var self = this;

      setTimeout(() => {
        this.fadePage();
        this.calculateWidthPageFooter();
       
      }, 10);
      window.scrollTo(0, 0);
      this.surveyPageList = this.UniqueArray(this.surveyPageList);

      this.lastScrollTop = 0;
      if(!this.AllQuestionHideONPrevPages(this.pageNumber) && this.surveyData.SurveyDetails.embedLangOpt > 0 )
        {

        this.isHideHambugforEmbedMob = true;
       }
      this.form.resetForm();
      if(!this.surveyData.SurveySettings.isAssessment)
      {
      let strfrom = (this.surveyData.SurveyDetails.strFrom != undefined ? '&strform=' + this.surveyData.SurveyDetails.strFrom : '&strform=');
      let Uid = '&recno='+ encodeURIComponent(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", this.surveyData.ResponseInfo.ResponseUID));
      if (this.surveyData.SurveyDetails.GroupType != undefined
        && (this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PUBLIC"
        || this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PRIVATE")
        && this.pageNumber != 999) {
        let url = 'SurveyData/CloseEvent?k=' + this.surveyData.SurveyDetails.surveyKey + '&pageNo=' + (this.pageNumber + 1) + strfrom  + Uid +"&strEvent=Next";
        if(this.isConnected==undefined){
          this.isConnected = navigator.onLine;
        }
        // if(this.isConnected && !this.isOfflineSurvey){
        if(!this.isOfflineSurvey){
          this.service.PostCloseEvent(url,JSON.stringify(EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", this.surveyPageList))).subscribe();
        }
      }
    }
      setTimeout(() => {
        for (let i = 0; i < self.surveyData.Pages[self.pageNumber].Questions.length; i++) {
          if (self.surveyData.Pages[self.pageNumber].Questions[i].isCQHide ||
            self.surveyData.Pages[self.pageNumber].Questions[i].population_type == 2) {
            continue;
          } else {
             let strelement = $(this.topQuestionSpacer.nativeElement).closest(".main-ques-cont").find(".first-div");
            $(strelement).attr('tabindex',-1);
            strelement.focus();
            break;
          }
        }
        // if (this.isMobile) {
        //   this.bodyNiceScrollResize()
        // }
        if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)){
          this.bodyNiceScrollResize()
        }
        if(this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
        {
          this.bodyNiceScrollResize()
        }
        if ( this.commonSetting.isEmbedNoScroll && window.location !== window.parent.location) {
          this.fnPostMessage('Next Button Click');
          let docHeight = document.documentElement.scrollHeight;
        } 
        

      } , 200);
    }
  }

  /**
   * this method use for saveOnNext Data.
   * @param pageIndex
   * @param isLoading
   * @param isAutoSave
   */
  SaveOnNext(pageIndex: number, isLoading:boolean, isAutoSave: boolean = false) {
    this.participationResponseData = new ParticipationResponseData();
    this.participationResponseData.ResponseDatas = []
    this.participationResponseData.ResponseCommanData = new ResponseCommanData();
    this.participationResponseData.contactRules = this.surveySpecificData.contactRules;
    let QDLSkippedQID:string = null;
    let QDLSkippedBranchQID:number=0;

    for (let i = 0; i < this.maxPageNumber; i++) {

      if (i != 0 && this.surveyPageList.indexOf(i + 1) < 0) {
        if(this.ReopenPageList.length > 0 && this.ReopenPageList.indexOf(i + 1) >= 0 && i >= pageIndex)
        { 
        }
        else if(this.allQuestionHideOnPage(i,false,false,false,false) )
        {
          let prehideQs = this.surveyData.Pages[i].Questions.filter(e => e.population_type == 2 || e.population_type == 5 || e.isHiddenQ);
          if(prehideQs != undefined && prehideQs != null && prehideQs.length ==  this.surveyData.Pages[i].Questions.length)
          {
          }
          else{
            continue;
          }
        }
      
      }

      for (let k = 0; k < this.surveyData.Pages[i].Questions.length; k++) {

        this.allAnswersADLHide(this.surveyData.Pages[i].Questions[k],i,true);

        if((this.surveyData.Pages[i].Questions[k].isCQHide && !this.surveyData.Pages[i].Questions[k].InlineQDL) || this.surveyData.Pages[i].Questions[k].isAllADLHide){
          if(QDLSkippedQID == null)
          {
            QDLSkippedQID = this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
          }
          else
          {
          QDLSkippedQID = QDLSkippedQID + "|" +  this.surveyData.Pages[i].Questions[k].UniqueNumber;
          }
          QDLSkippedBranchQID = this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;

          continue;

        }
        else if (this.surveyData.Pages[i].Questions[k].InlineQDL &&
           this.surveyData.Pages[i].Questions[k].qtype == 'T' 
           && this.surveyData.Pages[i].Questions[k].QDLCondStatuses !=null 
           && this.surveyData.Pages[i].Questions[k].QDLCondStatuses !=undefined 
            && !this.ExecuteRuleExpression(this.surveyData.Pages[i].Questions[k],this.surveyData.Pages[i].Questions[k].QDLCondStatuses[0].rule_expression)) {
          this.surveyData.Pages[i].Questions[k].AnswerID = null;
          this.surveyData.Pages[i].Questions[k].selectAnsValue = 0;
          this.surveyData.Pages[i].Questions[k].AnswerText = null;
          this.surveyData.Pages[i].Questions[k].isValid = false;
          this.surveyData.Pages[i].Questions[k].selectedOptionList = [];
          if (this.surveyData.Pages[i].Questions[k].Answers != null) {
            for (let l = 0; l < this.surveyData.Pages[i].Questions[k].Answers.length; l++) {
              this.surveyData.Pages[i].Questions[k].Answers[l].ControlAns = null;
              this.surveyData.Pages[i].Questions[k].Answers[l].selectdId = 0;
            }
          }
      
        }
        //Issue No.  125720 : Triage : [ANG][BRK] Multi question branching not working on participation - Response not Recorded.
        // if((this.surveyData.Pages[i].Questions[k].branch || this.surveyData.Pages[i].Questions[k].isadvbranching)
        // &&  !(this.surveyData.Pages[i].Questions[k].population_type == 2 && this.surveyData.Pages[i].Questions[k].PrePopText == null)){
        //   QDLSkippedQID = QDLSkippedQID + "|" +  this.surveyData.Pages[i].Questions[k].UniqueNumber;
        //   continue;
        // }
        if (this.surveyData.Pages[i].Questions[k].qtype == "C" ||
            this.surveyData.Pages[i].Questions[k].qtype == 'CS' ||
            this.surveyData.Pages[i].Questions[k].qtype == 'GC' ||
            this.surveyData.Pages[i].Questions[k].qtype == 'RK' ||
            this.surveyData.Pages[i].Questions[k].qtype == 'ML' ||
            this.surveyData.Pages[i].Questions[k].qtype == 'SC') {
          let answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
          let answerText = this.surveyData.Pages[i].Questions[k].AnswerText;

          let questionID = this.surveyData.Pages[i].Questions[k].UniqueNumber;
          //let surveyID = this.surveyData.SurveySettings.zarca_id;
          let questionType = this.surveyData.Pages[i].Questions[k].qtype;
          let isOther = false;
          //let responseUID = this.surveyData.ResponseInfo.ResponseUID;
          let Qno = this.surveyData.Pages[i].Questions[k].qno;
          let page_no = this.surveyData.Pages[i].Questions[k].page_no;
          let BranchQID = this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;
          if (this.surveyData.Pages[i].Questions[k].selectedOptionList != null &&
            this.surveyData.Pages[i].Questions[k].selectedOptionList.length > 0) {


            for (let j = 0; j < this.surveyData.Pages[i].Questions[k].selectedOptionList.length; j++) {
              answerID = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].value_id;
              answerText = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].value_text;

              if (this.surveyData.Pages[i].Questions[k].selectedOptionList[j].isOther) {
                isOther = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].isOther;
                if (this.surveyData.Pages[i].Questions[k].otherAnswer != null) {
                  answerText = this.surveyData.Pages[i].Questions[k].otherAnswer;
                } else {
                  answerText = "";
                }
              } else {
                isOther = false;
              }

              if ((this.surveyData.Pages[i].Questions[k].qtype == 'C' ||
                this.surveyData.Pages[i].Questions[k].qtype == 'ML') &&
                this.surveyData.Pages[i].Questions[k].isValid &&
                this.surveyData.Pages[i].Questions[k].ansConstraint != null && i < this.pageNumber) {
                this.participationResponseData.ResponseCommanData.isConstraintAlert = true;
              }

              this.participationResponseData.ResponseDatas.push(
                { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
                //{ AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, SurveyID: surveyID, IsOther: isOther, ResponseUID: responseUID, Qno: Qno,QType: questionType ,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened,isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate});
            }
          }
          else {
            this.participationResponseData.ResponseDatas.push(
              { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
              //{ AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, SurveyID: surveyID, IsOther: isOther, ResponseUID: responseUID, Qno: Qno,QType: questionType ,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened,isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate});
          }
        } else {
          let answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
          let answerText = this.surveyData.Pages[i].Questions[k].AnswerText;

          if (this.surveyData.Pages[i].Questions[k].isOtherAnswer) {
            if (this.surveyData.Pages[i].Questions[k].otherAnswer != null) {
              answerText = this.surveyData.Pages[i].Questions[k].otherAnswer;
            } else {
              answerText = "";
            }
          }

          if(this.surveyData.Pages[i].Questions[k].qtype == 'RS'){
            answerText = null;

            // if (answerID != undefined) {
            //   answerID = answerID + 1;
            // }
          }

          let questionID = this.surveyData.Pages[i].Questions[k].UniqueNumber;
          let questionType = this.surveyData.Pages[i].Questions[k].qtype;
          //let surveyID = this.surveyData.SurveySettings.zarca_id;
          let isOther = this.surveyData.Pages[i].Questions[k].isOtherAnswer;
          //let responseUID = this.surveyData.ResponseInfo.ResponseUID;
          let Qno = this.surveyData.Pages[i].Questions[k].qno;
          let page_no = this.surveyData.Pages[i].Questions[k].page_no;
          let BranchQID = (this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0);
          this.participationResponseData.ResponseDatas.push(
            { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
            //{ AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, SurveyID: surveyID, IsOther: isOther, ResponseUID: responseUID, Qno: Qno,QType: questionType ,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened,isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate});
        }
      }
    }
    this.surveyPageList = this.UniqueArray(this.surveyPageList);
    this.participationResponseData.ResponseCommanData.SurveyID = this.surveyData.SurveySettings.zarca_id;
    this.participationResponseData.ResponseCommanData.ResponseUID = this.surveyData.ResponseInfo.ResponseUID;
    this.participationResponseData.ResponseCommanData.SavedPageList = this.surveyPageList.toString();
    this.participationResponseData.ResponseCommanData.isReopenSurvey = this.surveyData.SurveyDetails.isSurveyReopened;
    this.participationResponseData.ResponseCommanData.isEmbedMobile = this.surveyData.SurveyDetails.isEmbedMobile;
    this.participationResponseData.ResponseCommanData.isEmbedPopMobile = this.surveyData.SurveyDetails.isEmbedPopMobile;
    this.participationResponseData.ResponseCommanData.isEmbedPopWeb = this.surveyData.SurveyDetails.isEmbedPopWeb;
    this.participationResponseData.ResponseCommanData.Screen_Resolution = this.getResolution();
    this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.surveyData.SurveyDetails.dtResponseStartDate;
    this.participationResponseData.directoryLinkedQuestionDetails = this.surveyData.directoryLinkedQuestionDetails;
    this.participationResponseData.dirQuestionPipings = this.surveyData.dirQuestionPipings;
    if (QDLSkippedQID && this.participationResponseData.ResponseDatas.length > 0) {
      this.participationResponseData.ResponseCommanData.QDLSkippedQID = QDLSkippedQID;
      if(QDLSkippedBranchQID != 0){
        this.participationResponseData.ResponseDatas[0].BranchQID = QDLSkippedBranchQID;
      }
    }

    let strTick = "&Tick=" + this.commonSetting.strTick;
    let strisAutoSave = "&isAutoSave=" + (isAutoSave ? "true" :"false");
    let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" || this.isPreview ? '&status=preview' : '');

    let url = 'SurveyData/PostSaveOnNext?k=' + this.surveyData.SurveyDetails.surveyKey + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + '&strDir=NXT&pageNo=' + (this.pageNumber + 1) + status + strTick +strisAutoSave;

    // if(this.isConnected && !this.isOfflineSurvey){
    if(!this.isOfflineSurvey){
    this.service.postDataUsingPromise(url, JSON.stringify(
      EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.participationResponseData)))).then(async (data) => {
        //this.saveOnNextData = await data;
        var arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
        //console.log('Encrypted :' + arrData);
        //var arrData = JSON.parse(arrData);

        this.saveOnNextData = await JSON.parse(arrData);

        if (!isAutoSave) {
          if (this.saveOnNextData.Participation_Messages.isErrorRedirect) {
            this.form.resetForm();
            this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
            this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
            this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
            this.CheckCookieforDelete('Save on Next');
            window.location.replace(this.saveOnNextData.Participation_Messages.RedirectURL);
          }
          else {
            if (this.saveOnNextData.Participation_Message_Type != 0) {
              this.surveySpecificData.Participation_Message_Type = this.saveOnNextData.Participation_Message_Type;
              this.surveySpecificData.Participation_Messages = this.saveOnNextData.Participation_Messages;
              //this.form.resetForm();
              this.isRemoveBackGround = true;
              this.removePageBGClass();
              this.isSaveAndContinue = true;
              this.multiLanguage = false;
              this.selectedLanguage = false;
              this.isPrintDownload = false;
              this.pageNumber = 999;
              // if (this.surveyData.SurveyDetails.GroupType == 'preview') {
              //   $("#ddPreview", parent.document).val(-1);
              // }
            }
            else {
              // Answer Piping
              this.answerPiping(this.saveOnNextData.NextPageNo - 1);
              this.surveySpecificData.contactRules = this.saveOnNextData.contactRules;
              this.surveyData.dirQuestionPipings = this.saveOnNextData.dirQuestionPipings;
              this.ContactQuestionDisplayLogic(this.saveOnNextData.NextPageNo);
              this.NextPageHandling(pageIndex, isLoading);
            }
          }
          this.showLoader = false;
          this.changeDetect.detectChanges(); 
        }
        
      }, error => {
        //console.log(error);
           this.showLoader = false;
            this.errorsHandlerService.handleError(error);
            if(error.name =="HttpErrorResponse")
            {
              this.form.resetForm();
                window.location.replace(this.service.getBasePath() +"/surveydecode.aspx?err=1&ng=2&cn=" + this.cp_no);
            }
      });
    }else{
      this.showLoader = false;
      if(!this.isOfflineTimeout){
        this.NextPageHandling(pageIndex, isLoading);
      }else{
        let k='';
        let lang1='';
        this.activatedRoute.queryParams.subscribe(async params => {
          k = params['k'];
          lang1= params["lang"];
        });
       // this.OfflineResponseData = this.storage.get('ResponseData_' + k) || [];
        let encryptedData = this.storage.get('ResponseData_' + k) || [];

        if (encryptedData.length > 0) {
          encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
          this.OfflineResponseData = JSON.parse(encryptedData);
        }

        // if(this.OfflineResponseData.length>0){
        var Editresponse = this.storage.get('Editresponse_' + k) || [];

        if (Editresponse.length > 0) {
          Editresponse = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', Editresponse);
          Editresponse = JSON.parse(Editresponse);
        }
         if (Editresponse.ResponseDatas != undefined && Editresponse.ResponseDatas.length > 0) {
          // let index;
          // for (let i = 0; i < this.OfflineResponseData.length; i++) {
          //   if(this.OfflineResponseData[i].ResponseCommanData.ResponseUID==Editresponse.ResponseCommanData.ResponseUID){
          //     index=i;
          //   }
          // }
          // this.OfflineResponseData[index].ResponseDatas = this.participationResponseData.ResponseDatas;
          // //this.OfflineResponseData.ResponseCommanData=this.participationResponseData.ResponseCommanData;
          // this.storage.set('ResponseData_' + k, this.OfflineResponseData);
         }else{
           let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
           let ESTCurrentDate = this.getESTTimeString();
           this.participationResponseData.ResponseCommanData.ResponseLangID=Number(lang1);
           if (this.OfflineResponseData.length > 0) {
             // let currentDate: Date = new Date();
             // let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
             this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.ESTResponseStartDate
             this.participationResponseData.ResponseCommanData.dtDispResponseStartDate = this.ResponseStartDate
             this.participationResponseData.ResponseCommanData.dtResponseEndDate = ESTCurrentDate
             this.participationResponseData.ResponseCommanData.dtDispResponseEndDate = currentDate
             this.participationResponseData.ResponseCommanData.ResponseUID = this.OfflineResponseData[this.OfflineResponseData.length - 1].ResponseCommanData.ResponseUID + 1
             // for (let i = 0; i < this.participationResponseData.ResponseCommanData.length; i++) {
             //   //this.responseDatas[i].ResponseUID = this.responseDatas[i].ResponseUID + this.OfflineResponseData.length-1;
             //   this.participationResponseData.ResponseDatas[i].ResponseUID = this.OfflineResponseData[this.OfflineResponseData.length-1][0].ResponseUID+1
             // }
           } else {
             // let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
             this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.ESTResponseStartDate
             this.participationResponseData.ResponseCommanData.dtDispResponseStartDate = this.ResponseStartDate
             this.participationResponseData.ResponseCommanData.dtResponseEndDate = ESTCurrentDate
             this.participationResponseData.ResponseCommanData.dtDispResponseEndDate = currentDate
             this.participationResponseData.ResponseCommanData.ResponseUID = 1;
           }
           this.participationResponseData.ResponseCommanData.ResponseStatus="INCOMPLETE";
          this.OfflineResponseData.push(this.participationResponseData);
          // }else{
          //   this.OfflineResponseData.push(this.responseDatas);
          // }
          this.storage.set('ResponseData_' + k, EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.OfflineResponseData)));
          this.storage.set('ResponseCount_' + k, (this.storage.get('ResponseCount_' + k) || 0)+1)
          // if(this.OfflineResponseData !=null){
          //   this.OfflineResponseData.push(this.responseDatas);
          // }else{

          // }
         }
      }
    }

  }

  /**
   * this method use for save on back data.
   * @param pageIndex
   * @param index
   */
  SaveOnBack(pageIndex: number, index: number) {
    this.participationResponseData = new ParticipationResponseData();
    this.participationResponseData.ResponseDatas = []
    this.participationResponseData.ResponseCommanData = new ResponseCommanData();

    for (let i = 0; i < this.maxPageNumber; i++) {

      if (i != 0 && this.surveyPageList.indexOf(i + 1) < 0) {
        if (this.ReopenPageList.length > 0
          && this.ReopenPageList.indexOf(i + 1) >= 0 && i >= pageIndex) { }
        else {
          continue;
        }
      }

      for (let k = 0; k < this.surveyData.Pages[i].Questions.length; k++) {
        if (this.surveyData.Pages[i].Questions[k].isCQHide && !this.surveyData.Pages[i].Questions[k].InlineQDL) {
          continue;
        }
        if (this.surveyData.Pages[i].Questions[k].qtype == "C" ||
          this.surveyData.Pages[i].Questions[k].qtype == 'CS' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'GC' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'RK' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'ML' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'SC') {
          let answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
          let answerText = this.surveyData.Pages[i].Questions[k].AnswerText;

          let questionID = this.surveyData.Pages[i].Questions[k].UniqueNumber;
          let questionType = this.surveyData.Pages[i].Questions[k].qtype;
          let isOther = false;
          let Qno = this.surveyData.Pages[i].Questions[k].qno;
          let page_no = this.surveyData.Pages[i].Questions[k].page_no;
          let BranchQID = this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;
          if (this.surveyData.Pages[i].Questions[k].selectedOptionList != null &&
            this.surveyData.Pages[i].Questions[k].selectedOptionList.length > 0) {


            for (let j = 0; j < this.surveyData.Pages[i].Questions[k].selectedOptionList.length; j++) {
              answerID = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].value_id;
              answerText = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].value_text;

              if (this.surveyData.Pages[i].Questions[k].selectedOptionList[j].isOther) {
                isOther = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].isOther;
                if (this.surveyData.Pages[i].Questions[k].otherAnswer != null) {
                  answerText = this.surveyData.Pages[i].Questions[k].otherAnswer;
                } else {
                  answerText = "";
                }
              } else {
                isOther = false;
              }

              this.participationResponseData.ResponseDatas.push(
                { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
            }
          }
          else {
            this.participationResponseData.ResponseDatas.push(
              { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
          }
        } else {
          let answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
          let answerText = this.surveyData.Pages[i].Questions[k].AnswerText;

          if (this.surveyData.Pages[i].Questions[k].isOtherAnswer) {
            if (this.surveyData.Pages[i].Questions[k].otherAnswer != null) {
              answerText = this.surveyData.Pages[i].Questions[k].otherAnswer;
            } else {
              answerText = "";
            }
          }

          if (this.surveyData.Pages[i].Questions[k].qtype == 'RS') {
            answerText = null;
          }

          let questionID = this.surveyData.Pages[i].Questions[k].UniqueNumber;
          let questionType = this.surveyData.Pages[i].Questions[k].qtype;
          let isOther = this.surveyData.Pages[i].Questions[k].isOtherAnswer;
          let Qno = this.surveyData.Pages[i].Questions[k].qno;
          let page_no = this.surveyData.Pages[i].Questions[k].page_no;
          let BranchQID = (this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0);
          this.participationResponseData.ResponseDatas.push(
            { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
        }
      }
    }
    this.surveyPageList = this.UniqueArray(this.surveyPageList);
    this.participationResponseData.ResponseCommanData.SurveyID = this.surveyData.SurveySettings.zarca_id;
    this.participationResponseData.ResponseCommanData.ResponseUID = this.surveyData.ResponseInfo.ResponseUID;
    this.participationResponseData.ResponseCommanData.SavedPageList = this.surveyPageList.toString();
    this.participationResponseData.ResponseCommanData.isReopenSurvey = this.surveyData.SurveyDetails.isSurveyReopened;
    this.participationResponseData.ResponseCommanData.isEmbedMobile = this.surveyData.SurveyDetails.isEmbedMobile;
    this.participationResponseData.ResponseCommanData.isEmbedPopMobile = this.surveyData.SurveyDetails.isEmbedPopMobile;
    this.participationResponseData.ResponseCommanData.isEmbedPopWeb = this.surveyData.SurveyDetails.isEmbedPopWeb;
    this.participationResponseData.ResponseCommanData.Screen_Resolution = this.getResolution();
    this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.surveyData.SurveyDetails.dtResponseStartDate;
    this.participationResponseData.directoryLinkedQuestionDetails = this.surveyData.directoryLinkedQuestionDetails;

    let strTick = "&Tick=" + this.commonSetting.strTick;
    let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" || this.isPreview ? '&status=preview' : '');

    let url = 'SurveyData/PostSaveOnBack?k=' + this.surveyData.SurveyDetails.surveyKey + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + '&strDir=NXT&pageNo=' + (this.pageNumber + 1) + status + strTick;
    // if(this.isConnected && !this.isOfflineSurvey){
      if(!this.isOfflineSurvey){
      this.service.postDataUsingPromise(url, JSON.stringify(
        EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.participationResponseData)))).then(async (data) => {
          //this.saveOnNextData = await data;
          var arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
          //console.log('Encrypted :' + arrData);
          //var arrData = JSON.parse(arrData);
          this.saveOnNextData = await JSON.parse(arrData);

          if (this.saveOnNextData.Participation_Messages.isErrorRedirect) {
            this.form.resetForm();
            this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
            this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
            this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
            this.CheckCookieforDelete('Save on Back');
            window.location.replace(this.saveOnNextData.Participation_Messages.RedirectURL);
          } else if (this.saveOnNextData.Participation_Message_Type != 0) {
            this.surveySpecificData.Participation_Message_Type = this.saveOnNextData.Participation_Message_Type;
            this.surveySpecificData.Participation_Messages = this.saveOnNextData.Participation_Messages;
            this.isRemoveBackGround = true;
            this.removePageBGClass();
            this.isSaveAndContinue = true;
            this.multiLanguage = false;
            this.selectedLanguage = false;
            this.isPrintDownload = false;
            this.pageNumber = 999;
          } else {
            let pageNo = this.surveyPageList[index == 0 ? 0 : index - 1];
            //this.surveyPageList.splice(index, this.surveyPageList.length - index);
            this.pageNumber = pageNo - 1;
            this.backPageSetAfterCode();
            this.isDivScroll = false;
          }

        }, error => {
          //console.log(error);
          this.errorsHandlerService.handleError(error);
          if (error.name == "HttpErrorResponse") {
            this.form.resetForm();
            window.location.replace(this.service.getBasePath() + "/surveydecode.aspx?err=1&ng=3&cn=" + this.cp_no);
          }
        });
    } else {
      let pageNo = this.surveyPageList[index == 0 ? 0 : index - 1];
      //this.surveyPageList.splice(index, this.surveyPageList.length - index);
      this.pageNumber = pageNo - 1;
      this.backPageSetAfterCode();
      this.isDivScroll = false;
    }
  }

  /**
   * this method use for answer piping.
   * @param nextPageNo
   */
  answerPiping(nextPageNo: number) {
    if (nextPageNo < this.maxPageNumber) {
      let noOfQuestions = this.surveyData.Pages[nextPageNo].Questions.length;
      for (let p = 0; p < noOfQuestions; p++) {
        if (this.surveyData.Pages[nextPageNo].Questions[p].group_no > 0) {
          if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeQID != 0) {

            let SQuestion: Questions;
            for (let i = 0; i < this.surveyData.Pages.length; i++) {
              SQuestion = this.surveyData.Pages[i].Questions.find(
                e => e.UniqueNumber == this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeQID);

              if (SQuestion != undefined && SQuestion != null) {
                break;
              }
            }

            if (SQuestion != null && SQuestion != undefined && SQuestion.Answers != null) {
              this.surveyData.Pages[nextPageNo].Questions[p].Answers = this.surveyData.Pages[nextPageNo].Questions[p].Answers.filter(e => !e.IsAnsPipe);
              if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.SelectedAnswer) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && (e.ControlAns != null &&  e.ControlAns)) == undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                }
              } else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.DisplayedAnswer) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && (!e.isHide || !e.isQuotaHide)) == undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                }
              } else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.UnselectedAnswer) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && (e.ControlAns == null || e.ControlAns == false) && (!e.isHide || !e.isQuotaHide)) == undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                }
              } else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.NotDiplayedAnswer) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && (e.isHide || e.isQuotaHide)) != undefined ||
                  SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno) == undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                }
              } else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.RankLowerThan) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && e.ControlAns != null &&
                  e.ControlAns > this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeRankLimit) != undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                }
              } else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.RankHigherThan) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && e.ControlAns != null &&
                  e.ControlAns < this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeRankLimit) != undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                }
              } else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.RankOptionEqual) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && e.ControlAns != null &&
                  e.ControlAns == this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeRankLimit) != undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                }
              } else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.RankOptionHighest) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && e.ControlAns != null &&
                  e.ControlAns == 1) != undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                }
              } else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.RankOptionLowest) {
                if (SQuestion.Answers.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].sub_qno && e.ControlAns != null &&
                  e.ControlAns == (SQuestion.rank_limit == 0 ? SQuestion.Answers.length : SQuestion.rank_limit)) != undefined) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = false;
                } else {
                  this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping = true;
                }
              }

              if (this.surveyData.Pages[nextPageNo].Questions[p].isMultiQuestionPiping) {
                this.ClearQDLAnswerOnHide(this.surveyData.Pages[nextPageNo].Questions[p], true);
              }

              if (this.surveyData.Pages[nextPageNo].Questions[p].isSQ && !this.isByPassLogic) {
                this.QuestionDisplayLogic(this.surveyData.Pages[nextPageNo].Questions[p]);
              }

              if (this.surveyData.Pages[nextPageNo].Questions[p].isADLSQ && !this.isByPassLogic) {
                this.AnswerDisplayLogic(this.surveyData.Pages[nextPageNo].Questions[p],false);
              }
            }
          }

        } else {
          if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeQID != 0 && this.saveOnNextData != undefined) {
            let Qid = this.surveyData.Pages[nextPageNo].Questions[p].UniqueNumber;
            let PipedAnswers = this.saveOnNextData.pipedAnswers.filter(e => e.zarca_q_id == Qid);
            let SQuestionHide = false
            let SQPageNo = -1;
            if (PipedAnswers != undefined && PipedAnswers != null && PipedAnswers.length > 0) {
              for (let i = 0; i < this.surveyData.Pages.length; i++) {

                let SQuestion = this.surveyData.Pages[i].Questions.find(
                  e => e.UniqueNumber == this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeQID);

                if (SQuestion != undefined && SQuestion != null) {
                  SQPageNo = i;
                  if ((SQuestion.isCQ && SQuestion.isCQHide) || (SQuestion.IsADLRuleApplied && SQuestion.isAllADLHide)) {
                    SQuestionHide = true;
                    break;
                  }
                }
              }

              let ADLAnswer = this.surveyData.Pages[nextPageNo].Questions[p].Answers.filter(e => e.isADLHide);
              let quotaDisableAnswers = this.surveyData.Pages[nextPageNo].Questions[p].Answers.filter(e => e.isQuotaDisable);
              this.surveyData.Pages[nextPageNo].Questions[p].Answers.splice(0, this.surveyData.Pages[nextPageNo].Questions[p].Answers.length);

              if (PipedAnswers.filter(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].selectAnsValue).length == 0 && this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == 3) {
                this.surveyData.Pages[nextPageNo].Questions[p].selectAnsValue = -1;
              }

              for (let j = 0; j < PipedAnswers.length; j++) {
                let isADLPUSH = true;
                if(this.surveyData.Pages[nextPageNo].Questions[p].IsADLRuleApplied)
                {
                  let ADLAns = ADLAnswer.filter(e=> e.ms_id == PipedAnswers[j].ms_id);
                  if(ADLAns && ADLAns.length > 0)
                  {
                    PipedAnswers[j].adlCondStatus = ADLAns[0].adlCondStatus;
                    PipedAnswers[j].isADLAnswer = ADLAns[0].isADLAnswer;
                    PipedAnswers[j].isADLHide = ADLAns[0].isADLHide;
                  }
                }
                let SQuestion
                if(SQPageNo!=-1){
                  SQuestion = this.surveyData.Pages[SQPageNo].Questions.find(
                    e => e.UniqueNumber == this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeQID);
                }
                if (SQuestion != undefined && SQuestion != null) {
                  let ADLAnswers = SQuestion.Answers.filter(e => e.isADLAnswer);
                  if (SQuestion.IsADLRuleApplied) {
                    let ADLAns = ADLAnswers.filter(e=> e.value_id == PipedAnswers[j].value_id);
                    if(ADLAns && ADLAns.length > 0)
                    {
                      if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.NotDiplayedAnswer
                        && ADLAns[0].isADLHide == false)
                      {
                        isADLPUSH = false;
                      }

                      if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition == AnswerPipingType.DisplayedAnswer
                        && ADLAns[0].isADLHide == true)
                      {
                        isADLPUSH = false;
                      }
                    }
                  }
                }



                if(((SQuestionHide && !PipedAnswers[j].IsAnsPipe)||!SQuestionHide) && isADLPUSH){
                PipedAnswers[j].isQuotaDisable = false;
                this.surveyData.Pages[nextPageNo].Questions[p].Answers.push(PipedAnswers[j]);


                if (this.surveyData.Pages[nextPageNo].Questions[p].selectAnsValue == PipedAnswers[j].value_id) {
                  this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].ControlAns = PipedAnswers[j].value_text;
                    this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].selectdId = 1;
                }
                else if (this.surveyData.Pages[nextPageNo].Questions[p].AnsPipeCondition != 3 && this.surveyData.Pages[nextPageNo].Questions[p].qtype != "L" && this.surveyData.Pages[nextPageNo].Questions[p].qtype != "RT" && this.surveyData.Pages[nextPageNo].Questions[p].qtype != "R") {
                  this.surveyData.Pages[nextPageNo].Questions[p].selectAnsValue = -1;
                }

                if (this.surveyData.Pages[nextPageNo].Questions[p].qtype == "CS" &&
                  this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList != null &&
                  this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.length > 0) {

                  if (this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].value_id) != undefined) {
                    this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].ControlAns =
                      this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].value_id).value_text;
                  }
                  //this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].ControlAns = this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList[j].value_text
                }

                if ((this.surveyData.Pages[nextPageNo].Questions[p].qtype == "C" || this.surveyData.Pages[nextPageNo].Questions[p].qtype == "ML") &&
                  this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList != null && this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.length > 0) {
                  this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].ControlAns = this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.filter(
                    e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].value_id).length > 0;
                }
                if(this.surveyData.Pages[nextPageNo].Questions[p].qtype == "RK")
                {
                if (this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList != null &&
                  this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.length > 0) {
                  if (this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.find(
                    e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].value_id) != undefined) {
                    //this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].ControlAns = this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList[j].value_text
                    this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].ControlAns = this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.find(
                      e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].Answers[j].value_id).value_text;
                  }
                }
                else
                {
                  this.surveyData.Pages[nextPageNo].Questions[p].AnswerText=null;
                }
              }
                
              }
              }
              
              if(quotaDisableAnswers.length > 0){
                 for (let index = 0; index < quotaDisableAnswers.length; index++) {
                   if (this.surveyData.Pages[nextPageNo].Questions[p].Answers.find(e => e.value_id == quotaDisableAnswers[index].value_id) != undefined) {
                    this.surveyData.Pages[nextPageNo].Questions[p].Answers.find(e => e.value_id == quotaDisableAnswers[index].value_id).isQuotaDisable = true;
                   }
                 }
              }
              // Update List for Checkbox and Listbox
              if ((this.surveyData.Pages[nextPageNo].Questions[p].qtype == "C" || this.surveyData.Pages[nextPageNo].Questions[p].qtype == "ML" ||
                  this.surveyData.Pages[nextPageNo].Questions[p].qtype == "RK" || this.surveyData.Pages[nextPageNo].Questions[p].qtype == "CS")
                  && this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList) {
                let answerList = PipedAnswers;
                let optionList = [];

                for (let i = 0; i < this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.length; i++) {
                  if (this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList[i].isOther) {
                    optionList.push(this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList[i])
                  } else {
                    if (answerList.find(e => e.value_id == this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList[i].value_id) != undefined) {
                      optionList.push(this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList[i])
                    }
                  }
                }

                this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList = optionList;

                if (this.surveyData.Pages[nextPageNo].Questions[p].qtype == "RK" && this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.length > 0 &&
                  this.surveyData.Pages[nextPageNo].Questions[p].selectedOptionList.length != answerList.length) {
                  this.surveyData.Pages[nextPageNo].Questions[p].isValid = true;
                  this.surveyData.Pages[nextPageNo].Questions[p].isAlertDanger = true;
                }
              }
            // }
            // else {
            //   this.surveyData.Pages[nextPageNo].Questions[p].Answers = [];
            // }
            } else {
              this.surveyData.Pages[nextPageNo].Questions[p].Answers = [];
            }
          }
        }
      }
    }
  }

  /**
   * this method use for get back page.
   * @returns
   */
  GetBackPage() {
    if (this.pageNumber > 0) {
      this.UpdateLocalJson();
      this.isBackClick = true;
      //this.isDivScroll = false;
      this.surveyData.Pages[this.pageNumber].isPageLoadComplete = false;
      if (this.IsSubmitted(this.pageNumber, true)) {
        return;
      } else {
        this.showLoader = true;
        this.isControlLoading = true;
        this.isEndSurveyOnPage = false;

        if (!this.surveyData.Pages[this.pageNumber].isSoftRequiredHandle) {
          this.nextButtonClickNo = 0;
        }
        else {
          this.nextButtonClickNo = 1000;
        }
        this.service.setNextButtonClickNo(this.nextButtonClickNo);
        let pageIndex = this.surveyPageList.indexOf(this.pageNumber + 1);

        

        if (pageIndex >= 0) {

         this.SaveOnBack(this.pageNumber, pageIndex)
        } else if (this.isPrevPgChnge) {
          this.pageNumber--;
          this.backPageSetAfterCode();
        }else if(this.preview.isPrevPgChnge)
        {
          this.pageNumber--;
          this.backPageSetAfterCode();
        }
      }
      if(this.preview.PrevPgNo==this.pageNumber){
        this.service.setPrevPgChnge(true);
        this.isPrevPgChnge=true;
      }
      this.resetCaptcha(this.pageNumber);
      this.isBackClick = false;
      this.isCapchaDarkTheme = this.surveyData.SurveySettings.isDarkTheme;
    }
    this.surveyPageList = this.UniqueArray(this.surveyPageList);
    this.lastScrollTop = 0;
    this.showLoader= false;

  

  }

  /**
   * this method use for se back page in list
   */
  backPageSetAfterCode() {
    this.isAllQuestionHideMessage = false;
    // if(this.pageNumber != 0 && this.pageNumber != 999)
    // {
    //     this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
    // }
    if (this.allQuestionHideOnPage(this.pageNumber, false, false, false, false)) {
      if (this.pageNumber == 0) {
        this.selectedLanguage = false;
        this.GetNextPage(this.pageNumber, false);
      }
      else {
        this.GetBackPage();
      }
    }
    else {
      this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
      this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
    }
    //this.QuestionHideOnPage(this.pageNumber, false, false);

    if (this.pageNumber != 999 && this.pageNumber < this.maxPageNumber) {
      if ((this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM').length > 0 && !this.isOfflineSurvey)||
        ((this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.mandatory && !e.isHiddenQ && e.qtype != 'CM' && !(e.qtype == 'T'  && (e.qsubtype == 71  || e.qsubtype == 72))).length > 0) && this.isOfflineSurvey)) {
          this.isMandatory = true;
        } else {
          this.isMandatory = false;
        }
    }
    if((this.AllQuestionHideONPrevPages(this.pageNumber)|| this.pageNumber == 0) && this.embedlangOpt > 1)
      { 
          this.isHideHambugforEmbedMob = false;
      } 
    this.isSubmittedForm = false;
    this.fadePage();
    window.scrollTo(0, 0);
    this.changeDetect.detectChanges();
    if (this.surveyData.SurveyDetails.GroupType == 'preview') {
      $("#ddPreview", parent.document).val((this.pageNumber + 1));
    }
    $('.back-button').removeClass('active');
    $('.back-button').children('.footer-btn-text').css('visibility', 'visible');
    this.form.resetForm();

    var self = this;
      setTimeout(() => {
      
        if ( this.commonSetting.isEmbedNoScroll && window.location !== window.parent.location) {
          this.fnPostMessage('Back Button Click');
        } 
      let strelement = $(this.topQuestionSpacer.nativeElement).closest(".main-ques-cont").find(".first-div");
      //let element = $("#questionWrapper");
      strelement.attr("tabindex",-1);
      strelement.focus();

      if (!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)) {
        this.bodyNiceScrollResize()
      }
      if (this.commonSetting.isEmbedMobile || this.commonSetting.isEmbedPopMobile) {
        this.bodyNiceScrollResize()
      }
      this.setBackPageActiveQues();
    }, 200);
  }

  /**
   * this method for show reset page pop-up.
   * @param pageIndex
   */
  ResetPage1(pageIndex: number) {
    this.pageIndexnum = pageIndex;
    $('.ansclear-modal-overlay').show();
  }

  /**
   * this mthod use for handle pop-up.
   * @param clear
   * @returns
   */
  closeansclearModal(clear: number) {
    $('.ansclear-modal-overlay').hide();
    if (clear == 0) {
      return;
    } else {
      this.ResetPage(this.pageIndexnum);
    }
  }

  /**
   * this method use for reset page all controls.
   * @param pageIndex
   */
   ClearPageAnswers(pageIndex: number) {
    this.UpdateLocalJson();
    if(this.surveySpecificData.contactRules && this.surveySpecificData.contactRules.length > 0)
      {
        this.ContactQuestionDisplayLogic(this.surveyData.Pages[pageIndex].Page_no);
      }

    if (this.surveyData != null) {
      for (let i = 0; i < this.surveyData.Pages[pageIndex].Questions.length; i++) {

        if (!this.isShowHiddenQN && (this.surveyData.Pages[pageIndex].Questions[i].population_type == 3 ||
          this.surveyData.Pages[pageIndex].Questions[i].population_type == 2)) {
          continue;
        }

        if (this.surveyData.Pages[pageIndex].Questions[i].Answers != null) {

          if (this.surveyData.Pages[pageIndex].Questions[i].qtype == 'C' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'CS' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'RK' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'GC' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'SC' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'ML') {

            if (this.surveyData.Pages[pageIndex].Questions[i].isAlertDanger) {
              this.surveyData.Pages[pageIndex].Questions[i].isAlertDanger = false;
            }

            if (this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList != null &&
              this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList.length > 0) {


              for (let k = 0; k < this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList.length; k++) {
                let ans = this.surveyData.Pages[pageIndex].Questions[i].Answers.find(
                  e => e.value_id == this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList[k].value_id);

                if (ans != null && ans != undefined) {
                  let index = this.surveyData.Pages[pageIndex].Questions[i].Answers.indexOf(ans);
                  this.surveyData.Pages[pageIndex].Questions[i].Answers[index].ControlAns = null;
                  this.surveyData.Pages[pageIndex].Questions[i].Answers[index].selectdId = 0;

                  if (this.surveyData.Pages[pageIndex].Questions[i].Answers[index].isValid) {
                    this.surveyData.Pages[pageIndex].Questions[i].Answers[index].isValid = false;
                  }
                }
              }

              this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList = [];
            }

          } else {
            let updateItem = this.surveyData.Pages[pageIndex].Questions[i].Answers.find(
              e => e.ms_id == this.surveyData.Pages[pageIndex].Questions[i].AnswerID);

            if (updateItem != null && updateItem != undefined) {
              let index = this.surveyData.Pages[pageIndex].Questions[i].Answers.indexOf(updateItem);

              this.surveyData.Pages[pageIndex].Questions[i].Answers[index].selectdId = 0;
              this.surveyData.Pages[pageIndex].Questions[i].Answers[index].ControlAns = null;
            }
          }
        }

        this.surveyData.Pages[pageIndex].Questions[i].AnswerID = 0;
        this.surveyData.Pages[pageIndex].Questions[i].pageto = 0;
        this.surveyData.Pages[pageIndex].Questions[i].selectAnsValue = -1;
        this.surveyData.Pages[pageIndex].Questions[i].PrePopValue = -1;
        this.surveyData.Pages[pageIndex].Questions[i].PrePopText = null;
        this.surveyData.Pages[pageIndex].Questions[i].AnswerText = null;
        this.surveyData.Pages[pageIndex].Questions[i].otherAnswer = null;
        this.surveyData.Pages[pageIndex].Questions[i].isOtherAnswer = false;

        if (this.surveyData.Pages[pageIndex].Questions[i].isValid) {
          this.surveyData.Pages[pageIndex].Questions[i].isValid = false;
        }

        if (this.surveyData.Pages[pageIndex].Questions[i].isReEnterEmailValid) {
          this.surveyData.Pages[pageIndex].Questions[i].isReEnterEmailValid = false;
        }

        if (this.surveyData.Pages[pageIndex].Questions[i].isreenter == 1 &&
          this.surveyData.Pages[pageIndex].Questions[i].qsubtype == 31) {
          this.surveyData.Pages[pageIndex].Questions[i].isReEnterEmail = true;
        }

        if (this.surveyData.Pages[pageIndex].Questions[i].qtype == 'RS') {
          this.surveyData.Pages[pageIndex].Questions[i].isNA = false;
        }

        if(this.surveyData.Pages[pageIndex].Questions[i].isSQ && !this.isByPassLogic){
          this.QuestionDisplayLogic(this.surveyData.Pages[pageIndex].Questions[i]);
        }

        if(this.surveyData.Pages[pageIndex].Questions[i].isADLSQ && !this.isByPassLogic){
          this.AnswerDisplayLogic(this.surveyData.Pages[pageIndex].Questions[i],false);
        }
      }
      this.changeDetect.detectChanges();
    }
  }


  /**
   * this method use for reset page all controls.
   * @param pageIndex
   */
  ResetPage(pageIndex: number) {

    // if (!confirm(this.surveyData.SurveyMessages.AreUsureClear)) {
    //   return;
    // }
    this.service.emitFormSubmitEvent.next(false);
    this.service.emitResetPageEvent.next(true);
    this.isSubmittedForm = false;
    this.isResetPage = true;
    this.UpdateLocalJson();

    if (this.surveyData != null) {
      if(this.surveySpecificData.contactRules && this.surveySpecificData.contactRules.length > 0)
        {
          this.ContactQuestionDisplayLogic( this.surveyData.Pages[pageIndex].Page_no);
        }

      for (let i = 0; i < this.surveyData.Pages[pageIndex].Questions.length; i++) {

        if (!this.isShowHiddenQN && (this.surveyData.Pages[pageIndex].Questions[i].population_type == 3 ||
          this.surveyData.Pages[pageIndex].Questions[i].population_type == 2)) {
          continue;
        }

        if (this.surveyData.Pages[pageIndex].Questions[i].Answers != null) {

          if (this.surveyData.Pages[pageIndex].Questions[i].qtype == 'C' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'CS' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'RK' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'GC' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'SC' ||
            this.surveyData.Pages[pageIndex].Questions[i].qtype == 'ML') {

            if (this.surveyData.Pages[pageIndex].Questions[i].isAlertDanger) {
              this.surveyData.Pages[pageIndex].Questions[i].isAlertDanger = false;
            }

            if (this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList != null &&
              this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList.length > 0) {


              for (let k = 0; k < this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList.length; k++) {
                let ans = this.surveyData.Pages[pageIndex].Questions[i].Answers.find(
                  e => e.value_id == this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList[k].value_id);

                if (ans != null && ans != undefined) {
                  let index = this.surveyData.Pages[pageIndex].Questions[i].Answers.indexOf(ans);
                  this.surveyData.Pages[pageIndex].Questions[i].Answers[index].ControlAns = null;
                  this.surveyData.Pages[pageIndex].Questions[i].Answers[index].selectdId = 0;

                  if (this.surveyData.Pages[pageIndex].Questions[i].Answers[index].isValid) {
                    this.surveyData.Pages[pageIndex].Questions[i].Answers[index].isValid = false;
                  }
                }
              }

              this.surveyData.Pages[pageIndex].Questions[i].selectedOptionList = [];
            }

          } else {
            let updateItem = this.surveyData.Pages[pageIndex].Questions[i].Answers.find(
              e => e.ms_id == this.surveyData.Pages[pageIndex].Questions[i].AnswerID);

            if (updateItem != null && updateItem != undefined) {
              let index = this.surveyData.Pages[pageIndex].Questions[i].Answers.indexOf(updateItem);

              this.surveyData.Pages[pageIndex].Questions[i].Answers[index].selectdId = 0;
              this.surveyData.Pages[pageIndex].Questions[i].Answers[index].ControlAns = null;
            }
          }
        }

        this.surveyData.Pages[pageIndex].Questions[i].AnswerID = 0;
        this.surveyData.Pages[pageIndex].Questions[i].pageto = 0;
        this.surveyData.Pages[pageIndex].Questions[i].selectAnsValue = -1;
        this.surveyData.Pages[pageIndex].Questions[i].PrePopValue = -1;
        this.surveyData.Pages[pageIndex].Questions[i].PrePopText = null;
        this.surveyData.Pages[pageIndex].Questions[i].AnswerText = null;
        this.surveyData.Pages[pageIndex].Questions[i].otherAnswer = null;
        this.surveyData.Pages[pageIndex].Questions[i].isOtherAnswer = false;

        if (this.surveyData.Pages[pageIndex].Questions[i].isValid) {
          this.surveyData.Pages[pageIndex].Questions[i].isValid = false;
        }

        if (this.surveyData.Pages[pageIndex].Questions[i].isReEnterEmailValid) {
          this.surveyData.Pages[pageIndex].Questions[i].isReEnterEmailValid = false;
        }

        if (this.surveyData.Pages[pageIndex].Questions[i].isreenter == 1 &&
          this.surveyData.Pages[pageIndex].Questions[i].qsubtype == 31) {
          this.surveyData.Pages[pageIndex].Questions[i].isReEnterEmail = true;
        }

        if (this.surveyData.Pages[pageIndex].Questions[i].qtype == 'RS') {
          this.surveyData.Pages[pageIndex].Questions[i].isNA = false;
        }

        if(this.surveyData.Pages[pageIndex].Questions[i].isSQ && !this.isByPassLogic){
          this.QuestionDisplayLogic(this.surveyData.Pages[pageIndex].Questions[i]);
        }

        if(this.surveyData.Pages[pageIndex].Questions[i].isADLSQ && !this.isByPassLogic){
          this.AnswerDisplayLogic(this.surveyData.Pages[pageIndex].Questions[i],false);
        }
      }

      // this.nextButtonClickNo = 0;
      this.form.resetForm();
      this.fadePage();
      window.scrollTo(0, 0);
      //this.responseDatas = [];
      var self = this;

      var currElem = $('.active-ques');
      var prevElem = currElem.prevAll('.inactive-ques').has('.question-data').eq(currElem.prevAll('.inactive-ques').has('.question-data').length-1);
      var beforePrevElem = currElem.prevAll('.inactive-ques').has('.question-data').eq(1);
      if (prevElem.length > 0) {
        $('.next-arrow').removeClass('disabled');
        this.service.hideQuestion(currElem[0]);

        let isHidden = $(prevElem).find(".question-data").attr("hidden")
        if (isHidden != undefined && isHidden) {
          this.service.showQuestion(beforePrevElem[0]);
        } else {
          this.service.showQuestion(prevElem[0]);
        }
        this.lastScrollTop = 0;
        if (beforePrevElem.length == 0 && $('.showBackBtn').length == 0) {
          $('.back-arrow').addClass('disabled');
        }
      }

      setTimeout(() => {
        // let element = this.renderer.selectRootElement("#dv_spacer_"+self.surveyData.Pages[self.pageNumber].Questions[0].UniqueNumber);
        // element.setAttribute("tabindex","-1");
        // element.focus();

        for (let i = 0; i < self.surveyData.Pages[self.pageNumber].Questions.length; i++) {
          if (self.surveyData.Pages[self.pageNumber].Questions[i].isCQHide ||
            self.surveyData.Pages[self.pageNumber].Questions[i].population_type == 2) {
            continue;
          } else {
            let element = this.renderer.selectRootElement("#dv_spacer_" + self.surveyData.Pages[self.pageNumber].Questions[i].UniqueNumber);
            element.setAttribute("tabindex", "-1");
            element.focus();
            break;
          }
        }
      } , 200);

      setTimeout(() => {
        if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)){
          this.bodyNiceScrollResize()
        }
        if(this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
        {
          this.bodyNiceScrollResize()
        }
      }, 100);

      this.isResetPage = false;
      this.isCapchaDarkTheme = this.surveyData.SurveySettings.isDarkTheme;
      this.changeDetect.detectChanges();
    }
  }

  /**
   * this method use for save & continue data handling.
   * @param pageIndex
   * @param isAutoSave
   * @returns
   */
  SaveAndContinue(pageIndex: number, isAutoSave: boolean = false) {
    this.UpdateLocalJson();
    let QDLSkippedQID:string = null;
    if (this.IsSubmitted(pageIndex, true)) {
      this.service.emitFormSubmitEvent.next(true);
      return;
    }

    this.isSaveAndContinueDisabled = true;
    this.participationResponseData = new ParticipationResponseData();
    this.participationResponseData.ResponseDatas = []
    this.participationResponseData.ResponseCommanData = new ResponseCommanData();
    let currentPageList = this.surveyPageList;
    currentPageList =this.UniqueArray(currentPageList);
    this.surveyPageList = [];
    let QDLSkippedBranchQID:number=0;


    let branchObj = this.surveyData.Pages[pageIndex].Questions.filter(e => e.branch);
    if (branchObj.length > 0 && !this.isByPassLogic) {
      let pageNo = 0;
      if (branchObj[0].isOtherAnswer && branchObj[0].qtype != "C" && branchObj[0].qtype != "ML") {
        pageNo = branchObj[0].other_pageto;
      } else if (branchObj[0].selectAnsValue > 0 ||
        (branchObj[0].qtype == "T" && branchObj[0].AnswerText != null) ||
        (branchObj[0].selectedOptionList != null && branchObj[0].selectedOptionList.length > 0)) {
        if (branchObj[0].pageto == 0) {
          pageNo = this.pageNumber + 2;
        } else {
          pageNo = branchObj[0].pageto;
        }
      }
      else {
        pageNo = branchObj[0].dna_pageto;
      }

      for (let i = (pageIndex +1); i < (pageNo-1); i++) {
        if(this.skippedPageList.indexOf((i+1)) == -1)
        {
          this.skippedPageList.push((i+1));
        }
        if(this.ReopenPageList.length > 0
          && this.ReopenPageList.indexOf(i + 1) > -1)
          { 
          var reopenpgIndex =this.ReopenPageList.indexOf(i+1)
          if(reopenpgIndex > -1)
          {
              this.ReopenPageList.splice(reopenpgIndex,1)
          }
          }
      }
    }

    
    this.skippedPageList =this.UniqueArray(this.skippedPageList);
    for (let i = 0; i < this.maxPageNumber; i++) {

      if (this.skippedPageList.indexOf(i + 1) >= 0) {
        if(this.ReopenPageList.length > 0
          && this.ReopenPageList.indexOf(i + 1) >= 0 && i >= pageIndex)
          { }
          else
          {
          continue;
          }
      }
      this.surveyPageList.push(i+1)
      //121882 : Triage : [PM][BRK]Unable to go back after autosave exe
      // if(this.surveyData.Pages[i].isEndSurvey)
      // {
      //   break;
      // }

      for (let k = 0; k < this.surveyData.Pages[i].Questions.length; k++) {

        if ( currentPageList != undefined && currentPageList.length > 0 && currentPageList.indexOf(i + 1) > -1 
        || (currentPageList.length == 0 && pageIndex == 0 && i==0)) {
          this.allAnswersADLHide(this.surveyData.Pages[i].Questions[k], i, true);
          if ((this.surveyData.Pages[i].Questions[k].isCQHide && !this.surveyData.Pages[i].Questions[k].InlineQDL) || this.surveyData.Pages[i].Questions[k].isAllADLHide) {
            let QDLQ = this.surveyData.Pages[i].Questions[k];
            if (QDLQ.group_no == 0) {
              if (QDLSkippedQID == null) {
                QDLSkippedQID = QDLQ.UniqueNumber.toString();
              } else {
                QDLSkippedQID = QDLSkippedQID + ',' + QDLQ.UniqueNumber.toString();
              }
              QDLSkippedBranchQID = this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;
            }
            else {
              let arrGroup = this.surveyData.Groups.filter(e => e.group_no == QDLQ.group_no)
              if (arrGroup[0].Matrix_id > 0) {
                let arrMGroup = this.surveyData.Groups.filter(e => e.Matrix_id == arrGroup[0].Matrix_id);
                if (arrMGroup.length > 0) {
                  let strQDLQ = "";
                  arrMGroup.forEach(element1 => {
                    let arrQDLQ = this.surveyData.Pages[i].Questions.filter(e => e.group_no == element1.group_no && e.isGroupRule)
                    arrQDLQ.forEach(element => {
                      this.surveyData.Pages[i].Questions.find(e => e.UniqueNumber == element.UniqueNumber).isCQHide = true;
                      strQDLQ = strQDLQ + element.UniqueNumber.toString() + ',';
                    });
                  });

                  arrMGroup.forEach(element1 => {
                    let arrQDLQ = this.surveyData.Pages[i].Questions.filter(e => e.group_no == element1.group_no && e.isGroupRule == false && e.isCQ == true && e.isCQHide)
                    arrQDLQ.forEach(element => {
                      strQDLQ = strQDLQ + element.UniqueNumber.toString() + ',';
                    });
                  });


                  if (QDLSkippedQID == null) {
                    QDLSkippedQID = strQDLQ.slice(0, -1);
                  } else {
                    QDLSkippedQID = QDLSkippedQID + ',' + strQDLQ.slice(0, -1);
                  }
                }
              }
              else {
                let arrQDLQ = this.surveyData.Pages[i].Questions.filter(e => e.group_no == QDLQ.group_no && e.isGroupRule)
                let arrQDLQG = this.surveyData.Pages[i].Questions.filter(e => e.group_no == QDLQ.group_no && e.isGroupRule == false && e.isCQ && e.isCQHide)
                let strQDLQ = "";
                arrQDLQ.forEach(element => {
                  strQDLQ = strQDLQ + element.UniqueNumber.toString() + ',';
                });
                arrQDLQG.forEach(element => {
                  strQDLQ = strQDLQ + element.UniqueNumber.toString() + ',';
                });
                if (QDLSkippedQID == null) {
                  QDLSkippedQID = strQDLQ.slice(0, -1);
                } else {
                  QDLSkippedQID = QDLSkippedQID + ',' + strQDLQ.slice(0, -1);
                }
              }
            }
            continue;
          } else if (this.surveyData.Pages[i].Questions[k].isCQHide && this.surveyData.Pages[i].Questions[k].InlineQDL &&
            !this.surveyData.Pages[i].Questions[k].isLoading && this.surveyData.Pages[i].Questions[k].qtype == 'T') {
            if (QDLSkippedQID == null) {
              QDLSkippedQID = this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
            } else {
              QDLSkippedQID = QDLSkippedQID + ',' + this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
            }
            continue;
          }
          if (this.surveyData.Pages[i].Questions[k].AnsPipeQID > 0 && this.surveyData.Pages[i].Questions[k].Answers.length == 0) {
            if (QDLSkippedQID == null) {
              QDLSkippedQID = this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
            } else {
              QDLSkippedQID = QDLSkippedQID + ',' + this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
            }
            continue;
          }
        }



        if(this.surveyData.Pages[i].Questions[k].isCQHide && !this.surveyData.Pages[i].Questions[k].InlineQDL){
          continue;
        }
        else if (this.surveyData.Pages[i].Questions[k].InlineQDL &&
         this.surveyData.Pages[i].Questions[k].qtype == 'T'
         && this.surveyData.Pages[i].Questions[k].QDLCondStatuses !=null 
         && this.surveyData.Pages[i].Questions[k].QDLCondStatuses !=undefined 
          && !this.ExecuteRuleExpression(this.surveyData.Pages[i].Questions[k],this.surveyData.Pages[i].Questions[k].QDLCondStatuses[0].rule_expression)) {
          this.surveyData.Pages[i].Questions[k].AnswerID = null;
          this.surveyData.Pages[i].Questions[k].selectAnsValue = 0;
          this.surveyData.Pages[i].Questions[k].AnswerText = null;
          this.surveyData.Pages[i].Questions[k].isValid = false;
          this.surveyData.Pages[i].Questions[k].selectedOptionList = [];
          if (this.surveyData.Pages[i].Questions[k].Answers != null) {
            for (let l = 0; l < this.surveyData.Pages[i].Questions[k].Answers.length; l++) {
              this.surveyData.Pages[i].Questions[k].Answers[l].ControlAns = null;
              this.surveyData.Pages[i].Questions[k].Answers[l].selectdId = 0;
            }
          }
      
        }
        if (this.surveyData.Pages[i].Questions[k].qtype == "C" ||
           this.surveyData.Pages[i].Questions[k].qtype == 'CS' ||
           this.surveyData.Pages[i].Questions[k].qtype == 'GC' ||
           this.surveyData.Pages[i].Questions[k].qtype == 'ML' ||
           this.surveyData.Pages[i].Questions[k].qtype == 'RK' ||
           this.surveyData.Pages[i].Questions[k].qtype == 'SC') {
          let answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
          let answerText = this.surveyData.Pages[i].Questions[k].AnswerText;

          let questionID = this.surveyData.Pages[i].Questions[k].UniqueNumber;
          //let surveyID = this.surveyData.SurveySettings.zarca_id;
          let questionType = this.surveyData.Pages[i].Questions[k].qtype;
          let isOther = false;
          //let responseUID = this.surveyData.ResponseInfo.ResponseUID;
          let Qno = this.surveyData.Pages[i].Questions[k].qno;
          let page_no = this.surveyData.Pages[i].Questions[k].page_no;
          let BranchQID = this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;
          if (this.surveyData.Pages[i].Questions[k].selectedOptionList != null &&
            this.surveyData.Pages[i].Questions[k].selectedOptionList.length > 0) {

            for (let j = 0; j < this.surveyData.Pages[i].Questions[k].selectedOptionList.length; j++) {
              answerID = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].value_id;
              answerText = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].value_text;

              if (this.surveyData.Pages[i].Questions[k].selectedOptionList[j].isOther) {
                isOther = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].isOther;
                if (this.surveyData.Pages[i].Questions[k].otherAnswer != null) {
                  answerText = this.surveyData.Pages[i].Questions[k].otherAnswer;
                } else {
                  answerText = "";
                }
              } else {
                isOther = false;
              }
              this.participationResponseData.ResponseDatas.push(
                { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
                //{ AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, SurveyID: surveyID, IsOther: isOther, ResponseUID: responseUID, Qno: Qno,QType: questionType ,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened,isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate});
            }
          }
          else {
            this.participationResponseData.ResponseDatas.push(
              { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
              //{ AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, SurveyID: surveyID, IsOther: isOther, ResponseUID: responseUID, Qno: Qno,QType: questionType ,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened,isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate});

          }

        } else {

          let answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
          let answerText = this.surveyData.Pages[i].Questions[k].AnswerText;

          if (this.surveyData.Pages[i].Questions[k].qtype == 'RS') {
            answerText = null;

            // if (answerID != undefined) {
            //   answerID = answerID + 1;
            // }
          }

          if (this.surveyData.Pages[i].Questions[k].isOtherAnswer) {
            if (this.surveyData.Pages[i].Questions[k].otherAnswer != null) {
              answerText = this.surveyData.Pages[i].Questions[k].otherAnswer;
            } else {
              answerText = "";
            }
          }

          let questionID = this.surveyData.Pages[i].Questions[k].UniqueNumber;
          let questionType = this.surveyData.Pages[i].Questions[k].qtype;
         // let surveyID = this.surveyData.SurveySettings.zarca_id;
          let isOther = this.surveyData.Pages[i].Questions[k].isOtherAnswer;
          //let responseUID = this.surveyData.ResponseInfo.ResponseUID;
          let Qno = this.surveyData.Pages[i].Questions[k].qno;
          let page_no =  this.surveyData.Pages[i].Questions[k].page_no;
          let BranchQID = this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;
          this.participationResponseData.ResponseDatas.push(
            { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, IsOther: isOther, Qno: Qno, QType: questionType, BranchQID: BranchQID });
            //{ AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, SurveyID: surveyID, IsOther: isOther, ResponseUID: responseUID, Qno: Qno,QType: questionType ,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened,isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID ,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate});
        }
      }

      //121882 : Triage : [PM][BRK]Unable to go back after autosave exe
      if(this.surveyData.Pages[i].isEndSurvey)
      {
        if(this.allQuestionHideOnPage((i+1),false,false,false,false) )
        {
          let prehideQs = this.surveyData.Pages[(i+1)].Questions.filter(e => e.population_type == 2 || e.population_type == 5 || e.isHiddenQ);
          if(prehideQs != undefined && prehideQs != null && prehideQs.length ==  this.surveyData.Pages[(i+1)].Questions.length)
          { 
            continue;
          }
          else{
            break;
          }
        }
        else
        {
        break;
        }
      }
    }
    this.surveyPageList = this.UniqueArray(this.surveyPageList);
    this.participationResponseData.ResponseCommanData.SurveyID = this.surveyData.SurveySettings.zarca_id;
    this.participationResponseData.ResponseCommanData.ResponseUID = this.surveyData.ResponseInfo.ResponseUID;
    this.participationResponseData.ResponseCommanData.SavedPageList = this.surveyPageList.toString();
    this.participationResponseData.ResponseCommanData.isReopenSurvey = this.surveyData.SurveyDetails.isSurveyReopened;
    this.participationResponseData.ResponseCommanData.isEmbedMobile = this.surveyData.SurveyDetails.isEmbedMobile;
    this.participationResponseData.ResponseCommanData.isEmbedPopMobile = this.surveyData.SurveyDetails.isEmbedPopMobile;
    this.participationResponseData.ResponseCommanData.isEmbedPopWeb = this.surveyData.SurveyDetails.isEmbedPopWeb;
    this.participationResponseData.ResponseCommanData.Screen_Resolution = this.getResolution();
    this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.surveyData.SurveyDetails.dtResponseStartDate;
    this.participationResponseData.directoryLinkedQuestionDetails = this.surveyData.directoryLinkedQuestionDetails;
    if (QDLSkippedQID && this.participationResponseData.ResponseDatas.length > 0) {
      this.participationResponseData.ResponseCommanData.QDLSkippedQID = QDLSkippedQID;
      if(QDLSkippedBranchQID != 0){
        this.participationResponseData.ResponseDatas[0].BranchQID = QDLSkippedBranchQID;
      }
    }

    if (!isAutoSave) {
            this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
            this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
            this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
            this.CheckCookieforDelete('Save and Continue');
    }

    let strTick = "&Tick=" + this.commonSetting.strTick;
    let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" || this.isPreview ? '&status=preview' : '');

    let url = 'SurveyData/ResponseData?k=' + this.surveyData.SurveyDetails.surveyKey + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + '&Dir=SAV' + status  + "&PageNo="+(this.pageNumber+1) + strTick;
    if(!this.isOfflineSurvey){
    this.service.postDataUsingPromise(url, JSON.stringify(
      EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.participationResponseData)))).then(async (data) => {

        if (!isAutoSave) {
          //this.surveySpecificData.Participation_Messages = await data;
          var arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
          //console.log('Encrypted :' + arrData);
          //var arrData = JSON.parse(arrData);
          this.surveySpecificData.Participation_Messages = await JSON.parse(arrData);

            this.form.resetForm();
            this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
            this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
            this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
            this.CheckCookieforDelete('Save and Continue');
          if (this.surveySpecificData.Participation_Messages.isErrorRedirect) {
            window.location.replace(this.surveySpecificData.Participation_Messages.RedirectURL);
          }
          else {
            if ((this.surveySpecificData.Participation_Messages.partial_url_message.partially_header != undefined ||
              this.surveySpecificData.Participation_Messages.partial_url_message.partially_header != null) &&
              this.surveySpecificData.Participation_Messages.Participation_Message_Type == 6) {
              this.surveySpecificData.Participation_Message_Type = 6
              this.isRemoveBackGround = true;
              this.removePageBGClass();
              this.form.resetForm();
              this.isSaveAndContinue = true;
              this.isThankYouPage = false;
              this.multiLanguage = false;
              this.selectedLanguage = false;
              this.isPrintDownload = false;
              this.pageNumber = 999;
            }
            else if(this.surveySpecificData.Participation_Messages.Participation_Message_Type == 5 ||
              this.surveySpecificData.Participation_Messages.Participation_Message_Type == 51)
              {
                this.surveySpecificData.Participation_Message_Type = this.surveySpecificData.Participation_Messages.Participation_Message_Type;
                this.isRemoveBackGround = true;
                this.removePageBGClass();
                this.form.resetForm();
                this.isSaveAndContinue = true;
                this.isThankYouPage = false;
                this.multiLanguage = false;
                this.selectedLanguage = false;
                this.isPrintDownload = false;
                this.pageNumber = 999;
              }
            else {
              this.surveySpecificData.Participation_Message_Type = 2;
              this.isRemoveBackGround = true;
              this.removePageBGClass();
              this.form.resetForm();
              this.isSaveAndContinue = true;
              this.isThankYouPage = false;
              this.multiLanguage = false;
              this.selectedLanguage = false;
              this.isPrintDownload = false;
              this.pageNumber = 999;
            }
            // if (this.surveyData.SurveyDetails.GroupType == 'preview') {
            //   $("#ddPreview", parent.document).val(-1);
            // }
          }
        }

        if (this.autoSaveSubscription) {
          this.autoSaveSubscription.unsubscribe();
        }

        this.changeDetect.detectChanges();

      }, error => {
        //console.log(error);
        this.errorsHandlerService.handleError(error);
        this.form.resetForm();
        if(error.name =="HttpErrorResponse")
        {
          this.form.resetForm();
            window.location.replace(this.service.getBasePath() +"/surveydecode.aspx?err=1&ng=4&cn=" + this.cp_no);
        }
      });

    }else if(this.isOfflineTimeout){
      let k='';
        let lang1='';
        this.activatedRoute.queryParams.subscribe(async params => {
          k = params['k'];
          lang1= params["lang"];
        });
        //this.OfflineResponseData = this.storage.get('ResponseData_' + k) || [];
        let encryptedData = this.storage.get('ResponseData_' + k) || [];

        if (encryptedData.length > 0) {
          encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
          this.OfflineResponseData = JSON.parse(encryptedData);
        }
        // if(this.OfflineResponseData.length>0){
        var Editresponse = this.storage.get('Editresponse_' + k) || [];

        if (Editresponse.length > 0) {
          Editresponse = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', Editresponse);
          Editresponse = JSON.parse(Editresponse);
        }

         if (Editresponse.ResponseDatas != undefined && Editresponse.ResponseDatas.length > 0) {
          let index;
          for (let i = 0; i < this.OfflineResponseData.length; i++) {
            if(this.OfflineResponseData[i].ResponseCommanData.ResponseUID==Editresponse.ResponseCommanData.ResponseUID){
              index=i;
            }
          }
          this.participationResponseData.ResponseCommanData.ResponseStatus="INCOMPLETE";
          this.OfflineResponseData[index].ResponseDatas = this.participationResponseData.ResponseDatas;
          this.OfflineResponseData[index].ResponseCommanData.ResponseStatus=this.participationResponseData.ResponseCommanData.ResponseStatus;
          //this.OfflineResponseData.ResponseCommanData=this.participationResponseData.ResponseCommanData;
          this.storage.set('ResponseData_' + k, EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.OfflineResponseData)));
         }else{
           let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
           let ESTCurrentDate = this.getESTTimeString();
           this.participationResponseData.ResponseCommanData.ResponseLangID=Number(lang1);
           //let ticks = ((new Date().getTime() * 10000) + 621355968000000000);
           let ticks = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString();
           if (ticks.length > 9) {
            ticks = ticks.substring(ticks.length - 9, 9);
           }

           this.participationResponseData.ResponseCommanData.OfflineUID = parseInt(ticks);
           if (this.OfflineResponseData.length > 0) {
             // let currentDate: Date = new Date();
             // let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
             this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.ESTResponseStartDate
             this.participationResponseData.ResponseCommanData.dtDispResponseStartDate = this.ResponseStartDate
             this.participationResponseData.ResponseCommanData.dtResponseEndDate = ESTCurrentDate
             this.participationResponseData.ResponseCommanData.dtDispResponseEndDate = currentDate
             this.participationResponseData.ResponseCommanData.ResponseUID = this.OfflineResponseData[this.OfflineResponseData.length - 1].ResponseCommanData.ResponseUID + 1
             // for (let i = 0; i < this.participationResponseData.ResponseCommanData.length; i++) {
             //   //this.responseDatas[i].ResponseUID = this.responseDatas[i].ResponseUID + this.OfflineResponseData.length-1;
             //   this.participationResponseData.ResponseDatas[i].ResponseUID = this.OfflineResponseData[this.OfflineResponseData.length-1][0].ResponseUID+1
             // }
           } else {
             // let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
             this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.ESTResponseStartDate
             this.participationResponseData.ResponseCommanData.dtDispResponseStartDate = this.ResponseStartDate
             this.participationResponseData.ResponseCommanData.dtResponseEndDate = ESTCurrentDate
             this.participationResponseData.ResponseCommanData.dtDispResponseEndDate = currentDate
             this.participationResponseData.ResponseCommanData.ResponseUID = 1;
           }
           this.participationResponseData.ResponseCommanData.ResponseStatus="INCOMPLETE";
          this.OfflineResponseData.push(this.participationResponseData);
          // }else{
          //   this.OfflineResponseData.push(this.responseDatas);
          // }
          //this.storage.set('ResponseData_' + k, this.OfflineResponseData);
          this.storage.set('ResponseData_' + k, EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.OfflineResponseData)));

          this.storage.set('ResponseCount_' + k, (this.storage.get('ResponseCount_' + k) || 0)+1)
          // if(this.OfflineResponseData !=null){
          //   this.OfflineResponseData.push(this.responseDatas);
          // }else{

          // }
         }
        }
  }

  /**
   * this method use for submit responses.
   * @param isBranchingSubmit
   * @param isAssessmentSubmit
   */
  SubmitData(isBranchingSubmit: boolean = false, isAssessmentSubmit: boolean = false) {

    if (this.subscription_CountDown) {
      this.subscription_CountDown.unsubscribe();
      this.isAssesmentSubmit = true;
      this.countDown = timer(0, 1000).pipe(map(() => 0));
    }

    this.showLoader = true;
    let isCheckNextPageHide = false;
    let pageLength;
    if ((this.isEndSurveyOnPage && !this.surveyData.Pages[this.pageNumber].isAllQuestionsHide) ||
        isBranchingSubmit) {
      pageLength = this.pageNumber + 1;
    }
    else {
      pageLength = this.surveyData.Pages.length;
      isCheckNextPageHide = true;
    }

    this.participationResponseData = new ParticipationResponseData();
    this.participationResponseData.ResponseDatas = []
    this.participationResponseData.ResponseCommanData = new ResponseCommanData();
    let SkipLogicHiddenQIdsAll: string = null;
    let QDLSkippedQID:string = null;
    let QDLSkippedBranchQID:number = 0;

    // if((pageLength-1)>this.pageNumber){
    //   for (let i = this.pageNumber-1; i < pageLength; i++) {
    //     if(!this.surveyPageList.includes(i + 1) && this.allQuestionHideOnPage(i,true,true,false,false)){
    //       this.surveyPageList.push(i + 1)
    //     }
    //   }
    // }

    if (this.pageNumber != 999 && isCheckNextPageHide) {
      for (let i = (this.pageNumber + 1); i < pageLength; i++) {
        if(i==1 && !this.surveyPageList.includes(1))
          {
            this.surveyPageList.push(i);
          }
        if (!this.surveyPageList.includes(i+1) &&  this.allQuestionHideOnPage((i), false, true, false, false)) {
          this.surveyPageList.push(i + 1);
        }
      }
    }


    this.skippedPageList =this.UniqueArray(this.skippedPageList);
    for (let i = 0; i < pageLength; i++) {

      if (this.surveyData.SurveySettings.isAssessment) {
        if (this.skippedPageList.indexOf(i + 1) >= 0) {
          var SurveypgIndex = this.assesmentAutoSavePageList.indexOf(i + 1)
          if (SurveypgIndex > -1) {
            this.assesmentAutoSavePageList.splice(SurveypgIndex, 1)
          }
        }
      }

      if (this.skippedPageList.indexOf(i + 1) >= 0) {
          var SurveypgIndex =this.surveyPageList.indexOf(i+1)
          if(SurveypgIndex > -1)
          {
              this.surveyPageList.splice(SurveypgIndex,1)
          }
        continue;
      }

      for (let k = 0; k < this.surveyData.Pages[i].Questions.length; k++) {
          this.allAnswersADLHide(this.surveyData.Pages[i].Questions[k],i,true);
        if((this.surveyData.Pages[i].Questions[k].isCQHide && !this.surveyData.Pages[i].Questions[k].InlineQDL)||this.surveyData.Pages[i].Questions[k].isAllADLHide){
          let QDLQ = this.surveyData.Pages[i].Questions[k];
          if(QDLQ.group_no == 0 )
          {
            if (QDLSkippedQID == null) {
              QDLSkippedQID = QDLQ.UniqueNumber.toString();
            } else {
              QDLSkippedQID = QDLSkippedQID + ',' + QDLQ.UniqueNumber.toString();
            }
            QDLSkippedBranchQID= this.surveyData.Pages[i].Questions[k].pageto == 999 ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;
          }
          else
          {
            let arrGroup = this.surveyData.Groups.filter(e => e.group_no == QDLQ.group_no)
            if(arrGroup[0].Matrix_id > 0)
            {
              let arrMGroup = this.surveyData.Groups.filter(e=> e.Matrix_id == arrGroup[0].Matrix_id);
                if(arrMGroup.length > 0)
                {
                  let strQDLQ = "";
                  arrMGroup.forEach(element1 => {
                    let arrQDLQ = this.surveyData.Pages[i].Questions.filter(e => e.group_no == element1.group_no && e.isGroupRule)
                    arrQDLQ.forEach(element => {
                      this.surveyData.Pages[i].Questions.find(e => e.UniqueNumber == element.UniqueNumber).isCQHide=true;
                      strQDLQ = strQDLQ + element.UniqueNumber.toString() + ',';
                    });
                  });

                  arrMGroup.forEach(element1 => {
                    let arrQDLQ = this.surveyData.Pages[i].Questions.filter(e => e.group_no == element1.group_no && e.isGroupRule == false && e.isCQ==true && e.isCQHide)
                    arrQDLQ.forEach(element => {
                      strQDLQ = strQDLQ + element.UniqueNumber.toString() + ',';
                    });
                  });


                if (QDLSkippedQID == null) {
                  QDLSkippedQID = strQDLQ.slice(0,-1);
                } else {
                  QDLSkippedQID = QDLSkippedQID + ',' + strQDLQ.slice(0,-1);
                }
              }
            }
            else{
              let arrQDLQ = this.surveyData.Pages[i].Questions.filter(e => e.group_no == QDLQ.group_no && e.isGroupRule)
              let arrQDLQG = this.surveyData.Pages[i].Questions.filter(e => e.group_no == QDLQ.group_no && e.isGroupRule == false && e.isCQ && e.isCQHide)
              let strQDLQ = "";
              arrQDLQ.forEach(element => {
                strQDLQ = strQDLQ + element.UniqueNumber.toString() + ',';
              });
              arrQDLQG.forEach(element => {
                strQDLQ = strQDLQ + element.UniqueNumber.toString() + ',';
              });
              if (QDLSkippedQID == null) {
                QDLSkippedQID = strQDLQ.slice(0,-1);
              } else {
                QDLSkippedQID = QDLSkippedQID + ',' + strQDLQ.slice(0,-1);
              }
            }
          }
          continue;
        } else if (this.surveyData.Pages[i].Questions[k].InlineQDL &&
           this.surveyData.Pages[i].Questions[k].qtype == 'T'        
            && this.surveyData.Pages[i].Questions[k].QDLCondStatuses !=null 
           && this.surveyData.Pages[i].Questions[k].QDLCondStatuses !=undefined 
            && !this.ExecuteRuleExpression(this.surveyData.Pages[i].Questions[k],this.surveyData.Pages[i].Questions[k].QDLCondStatuses[0].rule_expression)) {
            this.surveyData.Pages[i].Questions[k].AnswerID = null;
            this.surveyData.Pages[i].Questions[k].selectAnsValue = 0;
            this.surveyData.Pages[i].Questions[k].AnswerText = null;
            this.surveyData.Pages[i].Questions[k].isValid = false;
            this.surveyData.Pages[i].Questions[k].selectedOptionList = [];
            if (this.surveyData.Pages[i].Questions[k].Answers != null) {
              for (let l = 0; l < this.surveyData.Pages[i].Questions[k].Answers.length; l++) {
                this.surveyData.Pages[i].Questions[k].Answers[l].ControlAns = null;
                this.surveyData.Pages[i].Questions[k].Answers[l].selectdId = 0;
              }
            }
          if (QDLSkippedQID == null) {
            QDLSkippedQID = this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
          } else {
            QDLSkippedQID = QDLSkippedQID + ',' + this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
          }
          continue;
        }
        if(this.surveyData.Pages[i].Questions[k].AnsPipeQID > 0 && this.surveyData.Pages[i].Questions[k].Answers.length == 0){
          if (QDLSkippedQID == null) {
            QDLSkippedQID = this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
          } else {
            QDLSkippedQID = QDLSkippedQID + ',' + this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
          }
          continue;
        }

        if (this.surveyData.Pages[i].Questions[k].IsDisabled){ 
            if(this.surveyData.Pages[i].Questions[k].mandatory && !this.surveyData.Pages[i].Questions[k].isHiddenQ) {
              if (SkipLogicHiddenQIdsAll == null) {
                SkipLogicHiddenQIdsAll = this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
              } else {
                SkipLogicHiddenQIdsAll = SkipLogicHiddenQIdsAll + ',' +
                this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
              }
            }
            else{
              if (QDLSkippedQID == null) {
                QDLSkippedQID = this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
              } else {
                QDLSkippedQID = QDLSkippedQID + ',' + this.surveyData.Pages[i].Questions[k].UniqueNumber.toString();
              }
            }
        }

        if (this.surveyData.Pages[i].Questions[k].qtype == 'C' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'CS' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'RK' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'GC' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'SC' ||
          this.surveyData.Pages[i].Questions[k].qtype == 'ML') {

          let answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
          let answerText = this.surveyData.Pages[i].Questions[k].AnswerText;
          let questionType = this.surveyData.Pages[i].Questions[k].qtype;
          let questionID = this.surveyData.Pages[i].Questions[k].UniqueNumber;
          let surveyID = this.surveyData.SurveySettings.zarca_id;
          let isOther = false;
          let responseUID = this.surveyData.ResponseInfo.ResponseUID;
          let Qno = this.surveyData.Pages[i].Questions[k].qno;
          let page_no = this.surveyData.Pages[i].Questions[k].page_no;
          let BranchQID

          if((this.surveyData.Pages[i].Questions[k].qtype == 'RK' && (this.surveyData.Pages[i].Questions[k].selectedOptionList == null
            || this.surveyData.Pages[i].Questions[k].selectedOptionList.length == 0 )) ||
            (this.surveyData.Pages[i].Questions[k].qtype == 'CS' && this.isEmptyList(this.surveyData.Pages[i].Questions[k])))
            {
              answerID = -1;
            }


          if(this.isEndSurveyOnPage)
          {
              BranchQID = this.surveyData.Pages[this.pageNumber].Questions[this.surveyData.Pages[this.pageNumber].Questions.length -1].UniqueNumber;
          }
          else
          {
              BranchQID = (this.surveyData.Pages[i].Questions[k].pageto == 999 || this.surveyData.Pages[i].isEndSurvey) ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;
          }
          if (this.surveyData.Pages[i].Questions[k].selectedOptionList != null &&
            this.surveyData.Pages[i].Questions[k].selectedOptionList.length > 0 && !this.isEmptyList(this.surveyData.Pages[i].Questions[k])) {
            for (let j = 0; j < this.surveyData.Pages[i].Questions[k].selectedOptionList.length; j++) {
              answerID = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].value_id;
              answerText = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].value_text;

              if(this.surveyData.Pages[i].Questions[k].qtype == 'C' ||
                this.surveyData.Pages[i].Questions[k].qtype == 'ML' ||
                this.surveyData.Pages[i].Questions[k].qtype == 'GC' ||
                this.surveyData.Pages[i].Questions[k].qtype == 'SC'){
                  answerText = null;
                }

              if (this.surveyData.Pages[i].Questions[k].selectedOptionList[j].isOther) {
                isOther = this.surveyData.Pages[i].Questions[k].selectedOptionList[j].isOther;
                if (this.surveyData.Pages[i].Questions[k].otherAnswer != null) {
                  answerText = this.surveyData.Pages[i].Questions[k].otherAnswer;
                } else {
                  answerText = "";
                }
              } else {
                isOther = false;
              }

              if ((this.surveyData.Pages[i].Questions[k].qtype == 'C' ||
                this.surveyData.Pages[i].Questions[k].qtype == 'ML') &&
                this.surveyData.Pages[i].Questions[k].isValid &&
                this.surveyData.Pages[i].Questions[k].ansConstraint != null) {
                this.participationResponseData.ResponseCommanData.isConstraintAlert = true;
              }

              this.participationResponseData.ResponseDatas.push(
                { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID,  IsOther: isOther, Qno: Qno, QType: questionType, BranchQID:BranchQID});
                  //SurveyID: surveyID,ResponseUID: responseUID,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened, isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate });
            }
          }
          else {

            

            this.participationResponseData.ResponseDatas.push(
              { page_no: page_no, AnswerID: answerID, AnswerText: answerText, QuestionID: questionID,  IsOther: isOther, Qno: Qno, QType: questionType, BranchQID:BranchQID});
             // { AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, SurveyID: surveyID, IsOther: isOther, ResponseUID: responseUID, Qno: Qno,QType: questionType ,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened , isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate });

          }

        } else {
          let answerID,answerText;
          // if(this.surveyData.Pages[i].Questions[k].population_type==1 && !this.surveyData.Pages[i].Questions[k].IsADLRuleApplied){
          //   answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue == 0 ? this.surveyData.Pages[i].Questions[k].PrePopValue : this.surveyData.Pages[i].Questions[k].selectAnsValue;
          //   answerText = this.surveyData.Pages[i].Questions[k].AnswerText == null ? this.surveyData.Pages[i].Questions[k].PrePopText : this.surveyData.Pages[i].Questions[k].AnswerText;

          //   // answerID = this.surveyData.Pages[i].Questions[k].PrePopValue;
          //   // answerText = this.surveyData.Pages[i].Questions[k].PrePopText;
          // } else
          if (this.surveyData.Pages[i].Questions[k].population_type == 2 && this.surveyData.Pages[i].Questions[k].qtype == 'T' &&
            (this.surveyData.Pages[i].Questions[k].qsubtype == 1 || this.surveyData.Pages[i].Questions[k].qsubtype == 2 || this.surveyData.Pages[i].Questions[k].qsubtype == 3 || this.surveyData.Pages[i].Questions[k].qsubtype == 4) &&
            this.surveyData.Pages[i].Questions[k].AnswerText == null && this.surveyData.Pages[i].Questions[k].date_default != null) {
              let currentDate;
            if (this.surveyData.Pages[i].Questions[k].qsubtype == 2 || this.surveyData.Pages[i].Questions[k].qsubtype == 4) {
              currentDate = formatDate(new Date(), 'dd/M/yyyy', 'en');
            }
            else {
             currentDate = formatDate(new Date(), 'M/dd/yyyy', 'en');
            }
            answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
            if (this.surveyData.Pages[i].Questions[k].date_default == "current") {
              answerText = currentDate;
            }
            else {
              answerText = this.surveyData.Pages[i].Questions[k].date_default;
            }
          }
          else{
            answerID = this.surveyData.Pages[i].Questions[k].selectAnsValue;
            answerText = this.surveyData.Pages[i].Questions[k].AnswerText;
          }

          if (this.surveyData.Pages[i].Questions[k].isOtherAnswer) {
            if (this.surveyData.Pages[i].Questions[k].otherAnswer != null) {
              answerText = this.surveyData.Pages[i].Questions[k].otherAnswer;
            } else {
              answerText = "";
            }
          }

          if (this.surveyData.Pages[i].Questions[k].qtype == 'RS') {
            answerText = null;
          }

          if(this.surveyData.Pages[i].Questions[k].qtype == "T"){
            answerID = 0;
          }

          let questionID = this.surveyData.Pages[i].Questions[k].UniqueNumber;
          let questionType = this.surveyData.Pages[i].Questions[k].qtype;
          //let surveyID = this.surveyData.SurveySettings.zarca_id;
          let isOther = this.surveyData.Pages[i].Questions[k].isOtherAnswer;
          let responseUID = this.surveyData.ResponseInfo.ResponseUID;
          let Qno = this.surveyData.Pages[i].Questions[k].qno;
          let page_no = this.surveyData.Pages[i].Questions[k].page_no;
          let BranchQID
          if(this.isEndSurveyOnPage)
          {
              BranchQID = this.surveyData.Pages[this.pageNumber].Questions[this.surveyData.Pages[this.pageNumber].Questions.length -1].UniqueNumber;
          }
          else
          {
              BranchQID = (this.surveyData.Pages[i].Questions[k].pageto == 999 || this.surveyData.Pages[i].isEndSurvey) ? this.surveyData.Pages[i].Questions[k].UniqueNumber : 0;
          }
          this.participationResponseData.ResponseDatas.push(
            {page_no: page_no,  AnswerID: answerID, AnswerText: answerText, QuestionID: questionID,  IsOther: isOther, Qno: Qno, QType: questionType, BranchQID:BranchQID });
            //{ AnswerID: answerID, AnswerText: answerText, QuestionID: questionID, SurveyID: surveyID, IsOther: isOther, ResponseUID: responseUID, Qno: Qno,QType: questionType ,BranchQID:BranchQID,SavedPageList: this.surveyPageList.toString(),isReopenSurvey:this.surveyData.SurveyDetails.isSurveyReopened, isEmbedMobile:this.surveyData.SurveyDetails.isEmbedMobile,QDLSkippedQID:QDLSkippedQID,Screen_Resolution:this.getResolution(),dtResponseStartDate:this.surveyData.SurveyDetails.dtResponseStartDate });
        }

      }

      if (this.surveyData.SurveySettings.isAssessment) {
        if (isAssessmentSubmit && this.surveyData.Pages[i].isEndSurvey) {
          break;
        }
      }
    }

    this.participationResponseData.ResponseCommanData.SurveyID = this.surveyData.SurveySettings.zarca_id;
    this.participationResponseData.ResponseCommanData.ResponseUID = this.surveyData.ResponseInfo.ResponseUID;

    if(this.surveyData.SurveySettings.isAssessment &&  isAssessmentSubmit){
      let subPageNumber = this.pageNumber + 1;
      let AutoSavePageList = this.assesmentAutoSavePageList.toString();
      if (subPageNumber <= pageLength) {
        if(subPageNumber == 1 && AutoSavePageList == '')
        {
          AutoSavePageList = "1,"
        }
        for (var i = subPageNumber; i <= pageLength; i++) {
          if(!AutoSavePageList.includes(i.toString()))
          {
            AutoSavePageList = AutoSavePageList + "," + i;
          }
          let branchObj = this.surveyData.Pages[(i-1)].Questions.filter(e => e.branch);
          let BranchpageNo = 0;
          //Check if SQB on Current Page is AssessmentSubmit
          if (branchObj.length > 0 && !this.isByPassLogic) {
            if (branchObj[0].isOtherAnswer && branchObj[0].qtype != "C" && branchObj[0].qtype != "ML") {
              BranchpageNo = branchObj[0].other_pageto;
            } else if (branchObj[0].selectAnsValue > 0 ||
              (branchObj[0].qtype == "T" && branchObj[0].AnswerText != null) ||
              (branchObj[0].selectedOptionList != null && branchObj[0].selectedOptionList.length > 0)) {
              if (branchObj[0].pageto == 0) {
                BranchpageNo = i + 2;
              } else {
                BranchpageNo = branchObj[0].pageto;
              }
            }
            else {
              BranchpageNo = branchObj[0].dna_pageto;
            }
          }
          if(BranchpageNo != 0 )
          {
            if(BranchpageNo != 999)
                i=(BranchpageNo - 1);
            else
                break;
          }
        }
        this.participationResponseData.ResponseCommanData.SavedPageList = AutoSavePageList.toString();
      }else{
        this.assesmentAutoSavePageList = this.UniqueArray(this.assesmentAutoSavePageList);
        this.participationResponseData.ResponseCommanData.SavedPageList = this.assesmentAutoSavePageList.toString();
      }
    } else{
      this.surveyPageList = this.UniqueArray(this.surveyPageList);
      this.participationResponseData.ResponseCommanData.SavedPageList = this.surveyPageList.toString();
    }

    this.participationResponseData.ResponseCommanData.isReopenSurvey = this.surveyData.SurveyDetails.isSurveyReopened;
    this.participationResponseData.ResponseCommanData.isEmbedMobile = this.surveyData.SurveyDetails.isEmbedMobile;
    this.participationResponseData.ResponseCommanData.isEmbedPopMobile = this.surveyData.SurveyDetails.isEmbedPopMobile;
    this.participationResponseData.ResponseCommanData.isEmbedPopWeb = this.surveyData.SurveyDetails.isEmbedPopWeb;
    this.participationResponseData.ResponseCommanData.Screen_Resolution = this.getResolution();
    this.participationResponseData.directoryLinkedQuestionDetails = this.surveyData.directoryLinkedQuestionDetails;
    this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.surveyData.SurveyDetails.dtResponseStartDate;

    if (QDLSkippedQID && (this.participationResponseData.ResponseDatas.length > 0 || this.surveySpecificData.contactRules.length > 0) ) {
      this.participationResponseData.ResponseCommanData.QDLSkippedQID = QDLSkippedQID;
      if(QDLSkippedBranchQID != 0){
        this.participationResponseData.ResponseDatas[0].BranchQID = QDLSkippedBranchQID;
      }
    }

      this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
      this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
      this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
      this.CheckCookieforDelete('Submit Data');

    // this.DownloadJsonData(JSON.stringify(this.surveyData));
    //this.DownloadJsonData(JSON.stringify(this.responseDatas));
    let strTick = "&Tick=" + this.commonSetting.strTick;
    let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" || this.isPreview ? '&status=preview' : '');

    let url = 'SurveyData/ResponseData?k=' + this.surveyData.SurveyDetails.surveyKey + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + '&Dir=NXT' + status +
     "&PageNo="+ (this.pageNumber == 999 ? this.pageNumber : (this.pageNumber + 1)) + strTick + "&intelMatrix=" + SkipLogicHiddenQIdsAll + "&isAssessmentSubmit="+ isAssessmentSubmit;
     // if(this.isConnected && !this.isOfflineSurvey){
    if(!this.isOfflineSurvey){
      let ng5 = "50";
    this.service.postDataUsingPromise(url, JSON.stringify(
      EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.participationResponseData)))).then(async (data) => {
        //this.surveySpecificData.Participation_Messages = await data;
        ng5 = "51";
        var arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
        //console.log('Encrypted :' + arrData);
        //var arrData = JSON.parse(arrData);
        ng5 = "52";
        this.surveySpecificData.Participation_Messages = await JSON.parse(arrData);
        ng5 = "53";
        this.form.resetForm();
        
        ng5 = "55";
        if (this.surveyData.SurveySettings.isSubscriptionModel && this.surveyData.CorpSettings.account_type == 10) {
          window.location.replace(this.surveySpecificData.Participation_Messages.RedirectURL);
          ng5 = "56";
        }
        else if (this.surveySpecificData.Participation_Messages.isErrorRedirect) {
          window.location.replace(this.surveySpecificData.Participation_Messages.RedirectURL);
          ng5 = "57";
        }
        else {
          if ((this.surveySpecificData.Participation_Messages.partial_and_quota_message.partial_header != undefined ||
            this.surveySpecificData.Participation_Messages.partial_and_quota_message.partial_header != null)) {
              ng5 = "58";
            this.surveySpecificData.Participation_Message_Type = 2;
            this.isRemoveBackGround = true;
            this.removePageBGClass();
            this.isSaveAndContinue = true;
            this.multiLanguage = false;
            this.selectedLanguage = false;
            this.isPrintDownload = false;
            this.pageNumber = 999;
          }
          else if ((this.surveySpecificData.Participation_Messages.partial_url_message.partially_header != undefined ||
            this.surveySpecificData.Participation_Messages.partial_url_message.partially_header != null) &&
            this.surveySpecificData.Participation_Messages.Participation_Message_Type == 6) {
              ng5 = "59";
            this.surveySpecificData.Participation_Message_Type = 6
            this.isRemoveBackGround = true;
            this.removePageBGClass();
            this.isSaveAndContinue = true;
            this.multiLanguage = false;
            this.selectedLanguage = false;
            this.isPrintDownload = false;
            this.pageNumber = 999;
          }
          else if(this.surveySpecificData.Participation_Messages.Participation_Message_Type == 5 ||
            this.surveySpecificData.Participation_Messages.Participation_Message_Type == 51)
            {
              ng5 = "501";
              this.surveySpecificData.Participation_Message_Type = this.surveySpecificData.Participation_Messages.Participation_Message_Type;
              this.isRemoveBackGround = true;
              this.removePageBGClass();
              this.form.resetForm();
              this.isSaveAndContinue = true;
              this.isThankYouPage = false;
              this.multiLanguage = false;
              this.selectedLanguage = false;
              this.isPrintDownload = false;
              this.pageNumber = 999;
            }
          else {
            //this.ThankYouMessagePiping();
            ng5 = "502";
            this.QuestionPiping(null, null, null, null, true);
            this.form.resetForm();
            ng5 = "503";
            this.isThankYouPage = true;
            let path = 'survey1.aspx?' + this.GetUrlData(false);
            this.router.navigateByUrl(path);
            ng5 = "504";
            this.multiLanguage = false;
            this.selectedLanguage = false;
            this.isPrintDownload = false;
            this.pageNumber = 999;
            if (this.autoSaveSubscription) {
              this.autoSaveSubscription.unsubscribe();
            }
            ng5 = "505";
            if (this.surveyData.SurveyDetails.GroupType == 'preview') {
              $("#ddPreview", parent.document).val(-1);
            }

          }
        }
        ng5 = "506";
        this.showLoader = false;
        setTimeout(() => {
          if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
          this.bodyNiceScrollResize()
          ng5 = "507";
        }, 250);
        this.changeDetect.detectChanges();

      }, error => {
        //console.log(error);
        this.errorsHandlerService.handleError(error);
        if(error.name =="HttpErrorResponse")
        {
          this.form.resetForm();
            window.location.replace(this.service.getBasePath() +"/surveydecode.aspx?err=1&ng="+ ng5 +"&cn=" + this.cp_no);
        }
      });
    }else{
      let k='';
      let lang1='';
      this.activatedRoute.queryParams.subscribe(async params => {
        k = params['k'];
        lang1= params["lang"];
      });
      //this.OfflineResponseData = this.storage.get('ResponseData_' + k) || [];
      let encryptedData = this.storage.get('ResponseData_' + k) || [];
      if (encryptedData.length > 0) {
        encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
        this.OfflineResponseData = JSON.parse(encryptedData);
      }
      // if(this.OfflineResponseData.length>0){
      var Editresponse = this.storage.get('Editresponse_' + k) || [];

      if (Editresponse.length > 0) {
        Editresponse = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', Editresponse);
        Editresponse = JSON.parse(Editresponse);
      }

       if (Editresponse.ResponseDatas != undefined && Editresponse.ResponseDatas.length > 0) {
        let index;
        for (let i = 0; i < this.OfflineResponseData.length; i++) {
          if(this.OfflineResponseData[i].ResponseCommanData.ResponseUID==Editresponse.ResponseCommanData.ResponseUID){
            index=i;
          }
        }
        this.participationResponseData.ResponseCommanData.ResponseStatus="COMPLETE";
        this.OfflineResponseData[index].ResponseDatas = this.participationResponseData.ResponseDatas;
        this.OfflineResponseData[index].ResponseCommanData.ResponseStatus=this.participationResponseData.ResponseCommanData.ResponseStatus;
        //this.OfflineResponseData.ResponseCommanData=this.participationResponseData.ResponseCommanData;
        //this.storage.set('ResponseData_' + k, this.OfflineResponseData);
        this.storage.set('ResponseData_' + k, EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.OfflineResponseData)));
       }else{
         let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
         let ESTCurrentDate = this.getESTTimeString();
         this.participationResponseData.ResponseCommanData.ResponseLangID=Number(lang1);

        //let ticks = ((new Date().getTime() * 10000) + 621355968000000000);
         let ticks = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString();
         if (ticks.length > 9) {
           ticks = ticks.substring(ticks.length - 9, 9);
         }

         this.participationResponseData.ResponseCommanData.OfflineUID = parseInt(ticks);
         if (this.OfflineResponseData.length > 0) {
           // let currentDate: Date = new Date();
           // let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
           this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.ESTResponseStartDate
             this.participationResponseData.ResponseCommanData.dtDispResponseStartDate = this.ResponseStartDate
             this.participationResponseData.ResponseCommanData.dtResponseEndDate = ESTCurrentDate
             this.participationResponseData.ResponseCommanData.dtDispResponseEndDate = currentDate
           this.participationResponseData.ResponseCommanData.ResponseUID = this.OfflineResponseData[this.OfflineResponseData.length - 1].ResponseCommanData.ResponseUID + 1
           // for (let i = 0; i < this.participationResponseData.ResponseCommanData.length; i++) {
           //   //this.responseDatas[i].ResponseUID = this.responseDatas[i].ResponseUID + this.OfflineResponseData.length-1;
           //   this.participationResponseData.ResponseDatas[i].ResponseUID = this.OfflineResponseData[this.OfflineResponseData.length-1][0].ResponseUID+1
           // }
         } else {
           // let currentDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
           this.participationResponseData.ResponseCommanData.dtResponseStartDate = this.ESTResponseStartDate
           this.participationResponseData.ResponseCommanData.dtDispResponseStartDate = this.ResponseStartDate
           this.participationResponseData.ResponseCommanData.dtResponseEndDate = ESTCurrentDate
           this.participationResponseData.ResponseCommanData.dtDispResponseEndDate = currentDate
           this.participationResponseData.ResponseCommanData.ResponseUID = 1;
           this.participationResponseData.directoryLinkedQuestionDetails = this.surveyData.directoryLinkedQuestionDetails;
         }
         this.participationResponseData.ResponseCommanData.ResponseStatus="COMPLETE";
        this.OfflineResponseData.push(this.participationResponseData);
        // }else{
        //   this.OfflineResponseData.push(this.responseDatas);
        // }
        //this.storage.set('ResponseData_' + k, this.OfflineResponseData);
        this.storage.set('ResponseData_' + k, EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.OfflineResponseData)));
        this.storage.set('ResponseCount_' + k, (this.storage.get('ResponseCount_' + k) || 0)+1)
        // if(this.OfflineResponseData !=null){
        //   this.OfflineResponseData.push(this.responseDatas);
        // }else{

        // }
       }

      if (this.form != undefined) {
        this.form.resetForm();
      }

       this.QuestionPiping(null, null, null, null, true);

       this.showLoader = false;
       this.isThankYouPage = true;
      let path = 'survey1.aspx?' + 'k='+ k + '&lang='+ lang1;
        // let path = 'Offline.aspx?' + this.GetUrlData(false);
       this.router.navigateByUrl(path);
       this.multiLanguage = false;
       this.selectedLanguage = false;
       this.isPrintDownload = false;
       this.pageNumber = 999;
       if (this.autoSaveSubscription) {
         this.autoSaveSubscription.unsubscribe();
       }
       if (this.surveyData.SurveyDetails.GroupType == 'preview') {
         $("#ddPreview", parent.document).val(-1);
       }
    }
  }

  /**
   * this method for download json data.
   * @param json
   */
  DownloadJsonData(json: string) {
    const blob = new Blob([json], { type: 'application/json' });
    //saveAs(blob, 'data.json');
  }

  /**
   * this method use for move scroll on control
   */
  Scroll(element: HTMLElement) {
    element.scrollIntoView();
    element.scrollLeft = 0;
  }

  /**
   * this method use for scroll object list
   * @param question
   * @param scrollQuestions
   */
  PutScrollQuestions(question: Questions, scrollQuestions: any) {
    let curVal;
    if (question.qtype == "CM" && question.qsubtype == 1) {
      curVal = {
        'qno': question.uniqueqno,
        'UniqueNumber': question.UniqueNumber
      }
    } else {
      curVal = {
        'qno': question.qno,
        'UniqueNumber': question.UniqueNumber
      }
    }
    scrollQuestions.push(curVal);
  }

  /**
   * this method use for validate control data.
   * @param index
   * @param isValidCheck
   * @returns
   */
  IsSubmitted(index: number, isValidCheck: boolean = false): boolean {

    if (this.surveyData != null) {
      let returnVal = false;
      let scrollQuestions = [];


      let reEnterEmailValidCompare = this.surveyData.Pages[index].Questions.filter(
        e => e.qtype == "T" && e.qsubtype == 31 && e.isreenter == 1 &&
          e.AnswerText != e.otherAnswer &&
         !e.isValid && (e.population_type != 2 && e.population_type != 3)&& (!this.isBackClick))

         if (reEnterEmailValidCompare != null && reEnterEmailValidCompare.length > 0) {
          returnVal = true;
          for (let i = 0; i < reEnterEmailValidCompare.length; i++) {
            let obj = this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == reEnterEmailValidCompare[i].UniqueNumber);

              if (obj != null && obj != undefined) {
                let objIndex = this.surveyData.Pages[index].Questions.indexOf(obj);
                this.surveyData.Pages[index].Questions[objIndex].isReEnterEmailValid = true;
              }
          }
        }


      let reEnterEmailValid = this.surveyData.Pages[index].Questions.filter(
        e => e.qtype == "T" && e.qsubtype == 31 && e.isreenter == 1 &&
         (e.AnswerText != null || e.PrePopText != null) && e.otherAnswer == null &&
         !e.isValid && (e.population_type != 2 && e.population_type != 3)&& (!this.isBackClick))

      if (reEnterEmailValid != null && reEnterEmailValid.length > 0) {
        returnVal = true;
        for (let i = 0; i < reEnterEmailValid.length; i++) {
          let obj = this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == reEnterEmailValid[i].UniqueNumber);

            if (obj != null && obj != undefined) {
              let objIndex = this.surveyData.Pages[index].Questions.indexOf(obj);
              this.surveyData.Pages[index].Questions[objIndex].isReEnterEmailValid = true;
              this.surveyData.Pages[index].Questions[objIndex].isValid = true;
            }
        }
      }

      let signatureValidObj = this.surveyData.Pages[index].Questions.filter(
        e => (e.qtype == 'T' && e.qsubtype == 72) && e.isValid && e.group_no > 0);


      let mandatoryObj = this.surveyData.Pages[index].Questions.filter(e => e.mandatory  && !e.isHiddenQ
        && (((e.AnswerText == null || e.AnswerText == undefined || (e.AnswerText=='Selected Answer Option' && e.selectedOptionList.length==0 )) && (e.isCQHide == false || (e.InlineQDL && e.isCQHide && e.isLoading)))||
        ((e.qtype == 'R' || e.qtype == 'C' || e.qtype == 'L' || e.qtype == 'ML' || e.qtype == 'HR') && e.isOtherAnswer && e.otherAnswer == null))
        && e.DemographicFieldID == 0 && e.group_no == 0 && !e.IsOfflineSkipQuestion && !this.isAllQuestionAnswersExausts(e) && !this.allAnswersADLHide(e,(e.page_no -1),false));

        if (mandatoryObj.length == 0) {
          mandatoryObj = this.surveyData.Pages[index].Questions.filter(e => e.mandatory  && !e.isHiddenQ && e.qtype == 'L' && e.selectAnsValue == -1 &&
            e.AnswerText != null && e.AnswerText!=undefined && (e.isCQHide == false || (e.InlineQDL && e.isCQHide && e.isLoading))
            && e.DemographicFieldID == 0 && e.group_no == 0 && !this.isAllQuestionAnswersExausts(e) && !this.allAnswersADLHide(e,(e.page_no -1),false));
        }


      let softRequiredObj = this.surveyData.Pages[index].Questions.filter(e => e.isSoftRequired && !e.isHiddenQ &&
        e.AnswerText == null && (e.isCQHide == false || (e.InlineQDL && e.isCQHide && e.isLoading)) &&
        e.DemographicFieldID == 0 && (e.group_no == 0 || e.qtype == 'GQ') && !this.isAllQuestionAnswersExausts(e) && !this.allAnswersADLHide(e,(e.page_no -1),false));

      let softRequiredSignature = this.surveyData.Pages[index].Questions.filter(e => e.isSoftRequired && !e.isHiddenQ &&
        e.AnswerText == null && e.qtype == 'T' && e.qsubtype == 72 && e.isCQHide == false);

      let isValidObj = this.surveyData.Pages[index].Questions.filter(
        e => (e.qtype == 'T' || e.qtype == 'C' || e.qtype == 'ML' || e.qtype == 'CS' || e.qtype == 'RK' || (e.qtype == "RS" && e.RS_Type == 0)) && e.isValid && e.group_no == 0);

      let demographicMandatoryObj = this.surveyData.Pages[index].Questions.filter(
        e => e.DemographicFieldID != 0 && e.mandatory  && !e.isHiddenQ && (e.AnswerText == null || e.AnswerText == undefined) && !e.isCQHide);

      if (demographicMandatoryObj.length == 0) {
        demographicMandatoryObj = this.surveyData.Pages[index].Questions.filter(
          e => e.DemographicFieldID != 0 && e.mandatory  && !e.isHiddenQ && e.qtype == "RW" && e.AnswerText != null && e.AnswerText != undefined && e.selectAnsValue == -1 && !e.isCQHide);

        if (demographicMandatoryObj.length > 0) {
          for (let i = 0; i < demographicMandatoryObj.length; i++) {
            if (this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == demographicMandatoryObj[i].UniqueNumber) != undefined) {
              this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == demographicMandatoryObj[i].UniqueNumber).AnswerText = null;
            }
          }
        }
      }

      let demographicValidObj = this.surveyData.Pages[index].Questions.filter(
          e => e.DemographicFieldID != 0 && e.isValid);

      let multiControlMandatory = this.surveyData.Pages[index].Questions.filter(
        e => e.DemographicFieldID == 0 && e.mandatory  && !e.isHiddenQ && !e.IsOfflineSkipQuestion && (e.AnswerText == null || e.AnswerText == undefined) && e.group_no > 0 && !e.isMatrixQuestion && !e.isMultiQuestionPiping &&
          // e.isCQHide == false &&
            this.surveyData.Pages[index].Questions.filter(f => f.group_no == e.group_no && f.Rule_id ==e.Rule_id && f.isCQHide == true).length == 0)
          ;
      if (multiControlMandatory.length == 0) {
        multiControlMandatory = this.surveyData.Pages[index].Questions.filter(
          e => e.DemographicFieldID == 0 && e.mandatory  && !e.isHiddenQ && e.AnswerText != null && e.AnswerText!=undefined && (e.selectAnsValue == -1 || e.selectAnsValue == 0) && e.group_no > 0 && !e.isMatrixQuestion &&
          !e.isMultiQuestionPiping && (e.qtype == "RW" && (e.qsubtype == 2 || e.qsubtype == 3)) &&
          this.surveyData.Pages[index].Questions.filter(f => f.group_no == e.group_no && f.Rule_id ==e.Rule_id  && f.isCQHide == true).length == 0
          );

        if (multiControlMandatory.length > 0) {
          for (let i = 0; i < multiControlMandatory.length; i++) {
            if (this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == multiControlMandatory[i].UniqueNumber) != undefined) {
              this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == multiControlMandatory[i].UniqueNumber).AnswerText = null;
            }
          }
        }
      }

      let multiControlValidObj = this.surveyData.Pages[index].Questions.filter(
        e => (e.qtype == 'T' || e.qtype == 'C' || e.qtype == 'CS' || e.qtype == 'RK')
          && e.isValid && e.group_no > 0 && !e.isMatrixQuestion && e.DemographicFieldID == 0);

      let matrixGridMandatory = this.surveyData.Pages[index].Questions.filter(
        e => e.DemographicFieldID == 0 && e.mandatory  && !e.isHiddenQ && (e.AnswerText == null || e.AnswerText == undefined) &&
          e.group_no > 0 && e.isMatrixQuestion && !e.IsDisabled && //!e.isCQHide
          this.surveyData.Pages[index].Questions.filter(f => ((f.Rule_id ==e.Rule_id && f.isCQHide == true) ||(f.sub_qno == e.sub_qno && f.isCQHide == true)  ) &&
            this.surveyData.Groups.filter(h => h.group_no == f.group_no &&
              h.Matrix_id == this.surveyData.Groups.filter(g => g.group_no == e.group_no)[0].Matrix_id).length > 0).length == 0 && !e.isMultiQuestionPiping);

      if (matrixGridMandatory.length == 0) {
        matrixGridMandatory = this.surveyData.Pages[index].Questions.filter(
          e => e.DemographicFieldID == 0 && e.mandatory  && !e.isHiddenQ && e.AnswerText != null && e.AnswerText !=undefined
            && e.selectAnsValue == -1 && (e.qtype == "GD" || (e.qtype == "RW" && e.qsubtype == 2)) &&
            e.group_no > 0 && e.isMatrixQuestion && !e.IsDisabled && //!e.isCQHide
            this.surveyData.Pages[index].Questions.filter(f => ((f.Rule_id ==e.Rule_id && f.isCQHide == true) ||(f.sub_qno == e.sub_qno && f.isCQHide == true)  ) &&
              this.surveyData.Groups.filter(h => h.group_no == f.group_no &&
                h.Matrix_id == this.surveyData.Groups.filter(g => g.group_no == e.group_no)[0].Matrix_id).length > 0).length == 0 && !e.isMultiQuestionPiping);

        if (matrixGridMandatory.length > 0) {
          for (let i = 0; i < matrixGridMandatory.length; i++) {
            if (this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == matrixGridMandatory[i].UniqueNumber) != undefined) {
              this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == matrixGridMandatory[i].UniqueNumber).AnswerText = null;
            }
          }
        }
      }

      let matrixGridValidObj = this.surveyData.Pages[index].Questions.filter(
        e => (e.qtype == 'T') && e.isValid && e.group_no > 0 && e.isMatrixQuestion);

      // if (mandatoryObj.length == 0 && !this.isManditorySkip) {
      //   this.isMandatory = false;
      // }

      if (!isValidCheck && !this.isManditorySkip && (mandatoryObj.length > 0 ||
        ((softRequiredObj.length > 0 || softRequiredSignature.length > 0) && this.nextButtonClickNo <= 1 &&
          !this.surveyData.Pages[this.pageNumber].isSoftRequiredHandle))) {
        returnVal = true;

        if (mandatoryObj.length > 0) {
          this.PutScrollQuestions(mandatoryObj[0], scrollQuestions);
          this.isSubmittedForm = true;
        }

        if (softRequiredObj.length > 0) {
          this.PutScrollQuestions(softRequiredObj[0], scrollQuestions);
          //this.service.setNextButtonClickNo(1);
        }

        if (softRequiredSignature.length > 0) {
          this.PutScrollQuestions(softRequiredSignature[0], scrollQuestions);
          //this.service.setNextButtonClickNo(1);
        }
      }

      if (isValidObj.length > 0) {

        // for (let i = 0; i < isValidObj.length; i++) {
        //   let obj = this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == isValidObj[i].UniqueNumber);

        //   if (obj != null && obj != undefined) {
        //     let objIndex = this.surveyData.Pages[index].Questions.indexOf(obj);
        //     this.surveyData.Pages[index].Questions[objIndex] = isValidObj[i];

        //     //this.surveyData.Pages[index].Questions[objIndex].isAlertDanger = true;
        //   }
        // }

        returnVal = true;
        this.PutScrollQuestions(isValidObj[0], scrollQuestions);
      }

      if (signatureValidObj.length > 0) {
        returnVal = true;
        this.PutScrollQuestions(signatureValidObj[0], scrollQuestions);
      }

      if (!isValidCheck && !this.isManditorySkip && demographicMandatoryObj != null && demographicMandatoryObj != undefined && demographicMandatoryObj.length > 0) {

        demographicMandatoryObj.sort((n1, n2) => n1.qno - n2.qno);
        this.PutScrollQuestions(demographicMandatoryObj[0], scrollQuestions);
        for (let i = 0; i < demographicMandatoryObj.length; i++) {
          let findQN = this.surveyData.Pages[index].Questions.find(
            e => e.qno == demographicMandatoryObj[i].qno &&
              e.group_no == demographicMandatoryObj[i].group_no &&
              !e.isMultiQuestion && !demographicMandatoryObj[i].isCQHide)


          if (findQN != null && findQN != undefined) {
            let indx = this.surveyData.Pages[index].Questions.indexOf(findQN);
            this.surveyData.Pages[index].Questions[indx].isMultiControlValid = true;
            this.isSubmittedForm = true;
            returnVal = true;
          }
        }
      }

      if (!isValidCheck && !this.isManditorySkip && multiControlMandatory != null && multiControlMandatory != undefined && multiControlMandatory.length > 0) {
        returnVal = true;
        for (let i = 0; i < multiControlMandatory.length; i++) {
          let findQN = this.surveyData.Pages[index].Questions.find(
            e => e.qno == multiControlMandatory[i].qno &&
              e.group_no == multiControlMandatory[i].group_no &&
              !e.isMultiQuestion)


          if (findQN != null && findQN != undefined) {
            let indx = this.surveyData.Pages[index].Questions.indexOf(findQN);
            this.surveyData.Pages[index].Questions[indx].isMultiControlValid = true;

            this.PutScrollQuestions(this.surveyData.Pages[index].Questions[indx], scrollQuestions);
            this.isSubmittedForm = true;
          }
        }
      }

      if (demographicValidObj != null && demographicValidObj != undefined && demographicValidObj.length > 0) {
        returnVal = true;
        demographicValidObj.sort((n1, n2) => n1.qno - n2.qno);
        this.PutScrollQuestions(demographicValidObj[0], scrollQuestions);
      }

      if (multiControlValidObj != null && multiControlValidObj != undefined && multiControlValidObj.length > 0) {
        returnVal = true;
        for (let i = 0; i < multiControlValidObj.length; i++) {

          if (scrollQuestions.indexOf(scrollQuestions.find(e => e.qno == multiControlValidObj[i].qno)) >= 0) {
            continue;
          } else {
            let findQN = this.surveyData.Pages[index].Questions.find(
              e => e.qno == multiControlValidObj[i].qno &&
                e.group_no == multiControlValidObj[i].group_no &&
                !e.isMultiQuestion)

            if (findQN != null && findQN != undefined) {
              let indx = this.surveyData.Pages[index].Questions.indexOf(findQN);

              this.PutScrollQuestions(this.surveyData.Pages[index].Questions[indx], scrollQuestions);
            }
          }
        }
      }

      let multiControlRemoveMandatoryObj = this.surveyData.Pages[index].Questions.filter(
        e => (e.DemographicFieldID == 0 || e.DemographicFieldID != 0) && e.isMultiControlValid && !e.isMultiQuestion && e.group_no > 0)

      if (multiControlRemoveMandatoryObj != null && multiControlRemoveMandatoryObj != undefined && multiControlRemoveMandatoryObj.length > 0) {

        for (let i = 0; i < multiControlRemoveMandatoryObj.length; i++) {
          let multiControlMandatoryRemove = this.surveyData.Pages[index].Questions.filter(
            e => e.group_no == multiControlRemoveMandatoryObj[i].group_no && e.mandatory  && !e.isHiddenQ &&
              e.AnswerText == null && !e.isMatrixQuestion)

          if (multiControlMandatoryRemove != null && multiControlMandatoryRemove.length == 0) {
            let findQN = this.surveyData.Pages[index].Questions.find(
              e => e.UniqueNumber == multiControlRemoveMandatoryObj[i].UniqueNumber)

            if (findQN != null && findQN != undefined) {
              let indx = this.surveyData.Pages[index].Questions.indexOf(findQN);
              this.surveyData.Pages[index].Questions[indx].isMultiControlValid = false;
            }
          }
        }
      }

      if (!isValidCheck && !this.isManditorySkip && matrixGridMandatory != null &&
        matrixGridMandatory != undefined && matrixGridMandatory.length > 0) {
        returnVal = true;
        this.isSubmittedForm = true;
        let matrixObj = JSON.parse(this.GetMatrixGridQuestionsString(matrixGridMandatory[0], index, true));
        if (matrixObj != null && matrixObj != undefined) {

          let findQN = matrixObj.find(e => !e.isMultiQuestion && e.isMatrixQuestion)
          if (findQN != null && findQN != undefined) {
            this.PutScrollQuestions(findQN, scrollQuestions);
          }
        }
      }

      if (matrixGridValidObj != null && matrixGridValidObj != undefined &&
        matrixGridValidObj.length > 0) {
        returnVal = true;

        let matrixObj = JSON.parse(this.GetMatrixGridQuestionsString(matrixGridValidObj[0], index, true));

        if (matrixObj != null && matrixObj != undefined) {

          let findQN = matrixObj.find(e => !e.isMultiQuestion && e.isMatrixQuestion)
          if (findQN != null && findQN != undefined) {
            this.PutScrollQuestions(findQN, scrollQuestions);
          }
        }
      }

      if (this.isManditorySkip) {
        if (this.surveyData.Pages[index].Questions.filter(e => e.qtype == 'CM'
          && e.AnswerText == null && e.qsubtype == 1).length > 0 && !this.isBackClick) {
            returnVal = true;
            this.isCapchaManditorySkip = true;
            this.service.setIsCapchaMandatorySkip(this.isCapchaManditorySkip);

            if(!this.surveyData.SurveySettings.isDarkTheme) {
              this.isCapchaDarkTheme = true;
            }

        } else {
          this.form.resetForm();
          this.isCapchaDarkTheme = this.surveyData.SurveySettings.isDarkTheme;
        }
      }

      if (this.pageNumber == this.maxPageNumber - 1) {
        $('.submit-button').removeClass('active');
        $('.submit-button').children('.footer-btn-text').css('visibility', 'visible');
      }
      else {
        $('.next-button').removeClass('active');
        $('.next-button').children('.footer-btn-text').css('visibility', 'visible');
      }
      if (returnVal) {
        //this.isSubmittedForm = true;
        if (scrollQuestions != null && scrollQuestions.length > 0) {
          scrollQuestions.sort((n1, n2) => n1.qno - n2.qno);
          let focusQ =this.surveyData.Pages[this.pageNumber].Questions.filter(e=> e.UniqueNumber == scrollQuestions[0].UniqueNumber)
          if(!focusQ[0].isHiddenQ){
            let element = this.renderer.selectRootElement(`#dv_main_${scrollQuestions[0].UniqueNumber}`,true)
          
            let focusQno:number =0;
            if(focusQ.length > 0  && focusQ[0].group_no > 0 )
            {
              focusQno = this.surveyData.Pages[this.pageNumber].Questions.filter(e=> e.group_no == focusQ[0].group_no)[0].UniqueNumber;
              element = this.renderer.selectRootElement(`#dv_main_${focusQno}`,true);
            }
            if(this.isFromSB == "0")
            {
              this.Scroll(element);
            }
            element.setAttribute("tabindex","-1")
            element.focus();
  
            // For New Participation
            let parentElement = this.renderer.parentNode(element);
            if (this.isNewParticipation) {
              setTimeout(() => {
                this.service.showQuestion(parentElement);
              }, 100);
            }
  
            $('html').scrollTop($('html').scrollTop() - 20);
            $('body').scrollTop($('body').scrollTop() - 20); // Scroll doesn't work on 'html' in older versions of Edge
            // For PRT 105770
            var isIE = false;
            isIE = ((window.navigator.userAgent.indexOf('MSIE ') > -1) || (window.navigator.userAgent.indexOf('Trident/') > -1));
  
            if (this.surveyData.SurveyDetails.GroupType == "preview" && this.commonSetting.isTablet && isIE) {
              $("#previewViewport", parent.document).css("left", "0");
              setTimeout(() => {
                $("#deviceWrapper", parent.document).css("position", "absolute");
                $("#previewViewport", parent.document).css("position", "absolute");
                $("#previewViewport", parent.document).css("left", "50%");
              }, 1);
            }
  
            //113807
            if(this.surveyData.SurveyDetails.GroupType == "preview" && $("#ddPreview", parent.document).length != 0  && (this.commonSetting.isTablet || this.commonSetting.isMobileDevice)){
              window.parent.scroll(0,0);
            }
          }
        }

        if(!this.surveyData.SurveySettings.isDarkTheme) {
          this.isCapchaDarkTheme = true;
        }

        return true;
      }
    }
  }

  /**
   * this method use for index of object.
   * @param question
   * @returns
   */
  findIndexToUpdate(question) {
    return question === this;
  }

  /**
   * this method handle onLoad all page Question Display Logic.
   */
  AllPageQuestionDisplayLogic() {

    if (this.surveyData != null && this.surveyData.Pages != null) {
      for (let i = 0; i < this.surveyData.Pages.length; i++) {
        let sourceQuestions = this.surveyData.Pages[i].Questions.filter(e => e.isSQ);
    if((this.surveySpecificData.contactRules 
      && this.surveySpecificData.contactRules.filter(e => e.ConditionQPageNo ==  this.surveyData.Pages[i].Page_no).length > 0) && !this.isByPassLogic)
      {
        this.ContactQuestionDisplayLogic(this.surveyData.Pages[i].Page_no);
      }

        if (sourceQuestions != null && sourceQuestions.length > 0) {
          for (let j = 0; j < sourceQuestions.length; j++) {
            if (sourceQuestions[j].isSQ && !this.isByPassLogic) {
              this.QuestionDisplayLogic(sourceQuestions[j]);
            }
          }
        }
      }
    }
  }


  AllPageAnswerDisplayLogic() {
    if (this.surveyData != null && this.surveyData.Pages != null) {
      for (let i = 0; i < this.surveyData.Pages.length; i++) {
        let sourceQuestions = this.surveyData.Pages[i].Questions.filter(e => e.isADLSQ);

        if (sourceQuestions != null && sourceQuestions.length > 0) {
          for (let j = 0; j < sourceQuestions.length; j++) {
            if (sourceQuestions[j].isADLSQ && !this.isByPassLogic) {
              this.AnswerDisplayLogic(sourceQuestions[j],true);
            }
          }
        }
      }
    }
  }



  /**
   * this method handle on page Question Display Logic.
   * @param question
   */
  QuestionDisplayLogic(question: Questions) {
    if (question.rules != null) {
      for (let i = 0; i < question.rules.length; i++) {
        //let values = question.rules[i].ConditionValue.split(",");
        //let index = -1;
        let ruleValue = question.rules[i].ConditionValue;
        let curVal = question.AnswerText;
        let multiValueControl: boolean;
        let Operator = question.rules[i].Operator;
        let SourveValueID = question.rules[i].SourceValueId;
        this.questionDisplayLogic = new SurveyQuestionAnswerDisplayLogic();
        multiValueControl = this.questionDisplayLogic.ShowHideQuestion(question, ruleValue, curVal, SourveValueID, Operator);
        let updateItem = this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions.find(
          e => e.UniqueNumber == question.rules[i].ConditionQID);

        if (updateItem != null && updateItem != undefined) {
          let ind = this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions.indexOf(updateItem);
          let QDLstatusQ = this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses.find(
            e=> e.SourceQID == question.UniqueNumber && e.CondName == question.rules[i].condition_name );
            if(QDLstatusQ != undefined && QDLstatusQ != null)
            {
              
              let QDLStatIndex = this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses.indexOf(QDLstatusQ);
              if(QDLStatIndex != undefined && QDLStatIndex != null)
              {
                if(multiValueControl)
                {
                  this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses[QDLStatIndex].Status=true;
                }
                else
                {
                  this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses[QDLStatIndex].Status=false;
                }
            }
            }
            let MultiCondStatus = this.ExecuteRuleExpression(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind],question.rules[i].rule_expression);
           

          if (MultiCondStatus) {
           
            if(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isCQHide)          
            {
              this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isCQHide = false;
              this.RemoveUpdateQuestionsData(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
            
            //Issue No.  122192 : Open : [ANG] Response not rec. when QDL applied to MG for a case
            if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].group_no > 0) {
              this.CQHideHanldeFalse(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
            }

            if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].population_type != 1 &&
              this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].population_type != 3 
              && !this.isinitLoading && !question.rules[i].InlineQDL) {
              this.ClearQDLAnswerOnShow(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
            }
          }
          if (question.rules[i].InlineQDL) {
            this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].InlineQDL = true;
            this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isCQHide = true;
            if (!this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isLoading &&
              (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].AnswerText == null||
                this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].population_type == 1)) {
              this.service.SetQDL(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
            }
            if (question.rules[i].DestinationQID > 0) {
              this.destinationQuestionHandle(question.rules[i], question.qtype == 'T' && !question.isLoading ? false : true);
            }
          }
          else {
            this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].InlineQDL = false;
          }

          // setTimeout(() => {
          //   //Update loacal json for condition question
          //  let responseQuestion:any;
          // if (this.responseQuestions != null && this.responseQuestions.length > 0
          //   &&  this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses.length > 1
          //   &&  this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isCQHide==false) {
          //   responseQuestion = this.responseQuestions.find(e =>
          //     e.UniqueNumber == this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].UniqueNumber);
          //     if(responseQuestion)
          //     {
          //       alert(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isCQHide + '1');
          //       responseQuestion.isCQHide =  this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isCQHide;        
          //       //this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]=responseQuestion;
          //     }
          // } 
          // }, 0);
            
          }
          else {
            if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isCQHide == false) {
              this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isCQHide = true;

              //Issue No.  122192 : Open : [ANG] Response not rec. when QDL applied to MG for a case
              if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].group_no > 0) {
                this.CQHideHanldeTrue(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
              }
              if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].population_type != 1 &&
                this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].population_type != 3
                && !this.isinitLoading) {
                this.ClearQDLAnswerOnHide(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
              }
              else if ((this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].population_type == 1 ||
                this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].population_type == 3) &&
                this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].qtype == "GQ") {

                this.setSRS_GroupCQ_hide(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].page_no,
                  this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].group_no);
              }

            }
            if (question.rules[i].InlineQDL) {
              this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].InlineQDL = true;
              this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isLoading = false;

              if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isValid) {
                this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isValid = false;
              }
              if(this.surveyData.Pages[question.rules[i].ConditionQPageNo -1].Questions[ind].isCQHide == true)
              {
                this.ClearQDLAnswerOnHide(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
              }
              this.service.SetQDL(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);

              if (question.rules[i].DestinationQID > 0) {
                this.destinationQuestionHandle(question.rules[i], false);
              }
            }
            else {
              this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].InlineQDL = false;
            }
          }
        

          if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isSQ) {
            let responseQuestion:any;

            if (this.responseQuestions != null && this.responseQuestions.length > 0) {
              responseQuestion = this.responseQuestions.find(e =>
                e.UniqueNumber == this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].UniqueNumber);
            }
            if (this.isNewParticipation) {
              setTimeout(() => {
                if (responseQuestion != null && responseQuestion != undefined) {
                  if (question.rules[i].InlineQDL) {
                    this.service.SetQDL(responseQuestion);
                  }
                  this.QuestionDisplayLogic(responseQuestion);
                } else {
                  if (question.rules[i].InlineQDL) {
                    this.service.SetQDL(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
                  }

                  this.QuestionDisplayLogic(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
                }
              }, 0);
            } else {
              //this.UpdateLocalJson();

              // if (question.rules[i].InlineQDL) {
              //   this.service.SetQDL(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
              // }

              // this.QuestionDisplayLogic(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);

              if (responseQuestion != null && responseQuestion != undefined) {
                if (question.rules[i].InlineQDL) {
                  this.service.SetQDL(responseQuestion);
                }
                this.QuestionDisplayLogic(responseQuestion);
              } else {
                if (question.rules[i].InlineQDL) {
                  this.service.SetQDL(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
                }

                this.QuestionDisplayLogic(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);
              }
            }
          }
          else if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].isADLSQ) {
            let responseQuestion:any;

            if (this.responseQuestions != null && this.responseQuestions.length > 0) {
              responseQuestion = this.responseQuestions.find(e =>
                e.UniqueNumber == this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].UniqueNumber);
            }
            if (this.isNewParticipation) {
              setTimeout(() => {
                if (responseQuestion != null && responseQuestion != undefined) {
                  this.AnswerDisplayLogic(responseQuestion,false);
                } else {
                  this.AnswerDisplayLogic(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind],false);
                }
              }, 0);
            } else {

              if (responseQuestion != null && responseQuestion != undefined) {

                this.AnswerDisplayLogic(responseQuestion,false);
              } else {
                this.AnswerDisplayLogic(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind],false);
              }
            }
          }

          else if (this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind].group_no > 0 &&
            this.multiQuestionFindIsSQ(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind])) {
             // this.UpdateLocalJson();

            let sqQuestions = this.multiQuestionFind(this.surveyData.Pages[question.rules[i].ConditionQPageNo - 1].Questions[ind]);

            if (sqQuestions != null && sqQuestions.length > 0) {
              for (let i = 0; i < sqQuestions.length; i++) {
                let responseQuestion:any;

                if (this.responseQuestions != null && this.responseQuestions.length > 0) {
                  responseQuestion = this.responseQuestions.find(e => e.UniqueNumber == sqQuestions[i].UniqueNumber);
                }

                if (responseQuestion != null && responseQuestion != undefined) {
                  this.QuestionDisplayLogic(responseQuestion);
                } else {
                  this.QuestionDisplayLogic(sqQuestions[i]);
                }
              }
            }
          }

          


        }
       
      }
    }
  }

  ContactQuestionDisplayLogic(pageNumber:number) {
    if (this.surveySpecificData.contactRules != null && this.surveySpecificData.contactRules.length > 0 ) {
     let contactRules= this.surveySpecificData.contactRules.filter(e=> e.ConditionQPageNo == pageNumber);
      for (let i = 0; i < contactRules.length; i++) {
        //let values = question.rules[i].ConditionValue.split(",");
        //let index = -1;
        let ruleValue = contactRules[i].ConditionValue;
        let curVal = contactRules[i].ContactValue;
        let multiValueControl: boolean;
        let Operator = contactRules[i].Operator;
        let SourveValueID = 0;
        this.questionDisplayLogic = new SurveyQuestionAnswerDisplayLogic();
        multiValueControl = this.questionDisplayLogic.ShowHideContact(contactRules[i].DataType, ruleValue, curVal, SourveValueID, Operator);
        if(contactRules[i].Condition_Type == 3)
        {
            if((contactRules[i].isLinked && contactRules[i].ConditionValue.toUpperCase() == 'YES')|| (contactRules[i].isLinked == false && contactRules[i].ConditionValue.toUpperCase() == 'NO'))
            {
              multiValueControl = true;
            }
        }
        let updateItem = this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions.find(
          e => e.UniqueNumber == contactRules[i].ConditionQID);

        if (updateItem != null && updateItem != undefined) {
          let ind = this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions.indexOf(updateItem);
          let QDLstatusQ = this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses.find(
            e=> e.SourceQID == contactRules[i].DirectoryId && e.CondName == contactRules[i].condition_name );
            if(QDLstatusQ != undefined && QDLstatusQ != null)
            {
              
              let QDLStatIndex = this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses.indexOf(QDLstatusQ);
              if(QDLStatIndex != undefined && QDLStatIndex != null)
              {
                if(multiValueControl)
                {
                  this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses[QDLStatIndex].Status=true;
                }
                else
                {
                  this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].QDLCondStatuses[QDLStatIndex].Status=false;
                }
            }
            }
            let MultiCondStatus = this.ExecuteRuleExpression(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind],contactRules[i].rule_expression);
          
          if (MultiCondStatus) {
           
            if(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isCQHide)          
            {
              this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isCQHide = false;
              this.RemoveUpdateQuestionsData(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
            
            //Issue No.  122192 : Open : [ANG] Response not rec. when QDL applied to MG for a case
            if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].group_no > 0) {
              this.CQHideHanldeFalse(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
            }

            if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].population_type != 1 &&
              this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].population_type != 3 
              && !this.isinitLoading && !contactRules[i].InlineQDL) {
              this.ClearQDLAnswerOnShow(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
            }
          }
          if (contactRules[i].InlineQDL) {
            this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].InlineQDL = true;
            this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isCQHide = true;
            if (!this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isLoading &&
              (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].AnswerText == null||
                this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].population_type == 1)) {
              this.service.SetQDL(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
            }
            if (contactRules[i].DestinationQID > 0) {
              this.ContactdestinationQuestionHandle(contactRules[i],false);
            }
          }
          else {
            this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].InlineQDL = false;
          }  
          }
          else {
            if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isCQHide == false) {
              this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isCQHide = true;

              //Issue No.  122192 : Open : [ANG] Response not rec. when QDL applied to MG for a case
              if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].group_no > 0) {
                this.CQHideHanldeTrue(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
              }
              if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].population_type != 1 &&
                this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].population_type != 3
                && !this.isinitLoading) {
                this.ClearQDLAnswerOnHide(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
              }
              else if ((this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].population_type == 1 ||
                this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].population_type == 3) &&
                this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].qtype == "GQ") {

                this.setSRS_GroupCQ_hide(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].page_no,
                  this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].group_no);
              }

            }
            if (contactRules[i].InlineQDL) {
              this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].InlineQDL = true;
              this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isLoading = false;

              if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isValid) {
                this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isValid = false;
              }
              this.service.SetQDL(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);

              if (contactRules[i].DestinationQID > 0) {
                this.ContactdestinationQuestionHandle(contactRules[i], false);
              }
            }
            else {
              this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].InlineQDL = false;
            }
          }
        

          if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isSQ) {
            let responseQuestion:any;

            if (this.responseQuestions != null && this.responseQuestions.length > 0) {
              responseQuestion = this.responseQuestions.find(e =>
                e.UniqueNumber == this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].UniqueNumber);
            }
            if (this.isNewParticipation) {
              setTimeout(() => {
                if (responseQuestion != null && responseQuestion != undefined) {
                  if (contactRules[i].InlineQDL) {
                    this.service.SetQDL(responseQuestion);
                  }
                  this.QuestionDisplayLogic(responseQuestion);
                } else {
                  if (contactRules[i].InlineQDL) {
                    this.service.SetQDL(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
                  }
                  this.QuestionDisplayLogic(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
                }
              }, 0);
            } else {
              if (responseQuestion != null && responseQuestion != undefined
              ) {
                if (contactRules[i].InlineQDL) {
                  this.service.SetQDL(responseQuestion);
                }
                this.QuestionDisplayLogic(responseQuestion);
              } else {
                if (contactRules[i].InlineQDL) {
                  this.service.SetQDL(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
                }

                this.QuestionDisplayLogic(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);
              }
            }
          }
          else if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].isADLSQ) {
            let responseQuestion:any;

            if (this.responseQuestions != null && this.responseQuestions.length > 0) {
              responseQuestion = this.responseQuestions.find(e =>
                e.UniqueNumber == this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].UniqueNumber);
            }
            if (this.isNewParticipation) {
              setTimeout(() => {
                if (responseQuestion != null && responseQuestion != undefined) {
                  this.AnswerDisplayLogic(responseQuestion,false);
                } else {
                  this.AnswerDisplayLogic(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind],false);
                }
              }, 0);
            } else {

              if (responseQuestion != null && responseQuestion != undefined) {

                this.AnswerDisplayLogic(responseQuestion,false);
              } else {
                this.AnswerDisplayLogic(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind],false);
              }
            }
          }

          else if (this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind].group_no > 0 &&
            this.multiQuestionFindIsSQ(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind])) {
             // this.UpdateLocalJson();

            let sqQuestions = this.multiQuestionFind(this.surveyData.Pages[contactRules[i].ConditionQPageNo - 1].Questions[ind]);

            if (sqQuestions != null && sqQuestions.length > 0) {
              for (let i = 0; i < sqQuestions.length; i++) {
                let responseQuestion:any;

                if (this.responseQuestions != null && this.responseQuestions.length > 0) {
                  responseQuestion = this.responseQuestions.find(e => e.UniqueNumber == sqQuestions[i].UniqueNumber);
                }

                if (responseQuestion != null && responseQuestion != undefined) {
                  this.QuestionDisplayLogic(responseQuestion);
                } else {
                  this.QuestionDisplayLogic(sqQuestions[i]);
                }
              }
            }
          }
        }
       
      }
    }
  }

  ExecuteRuleExpression(question: Questions, ruleExp: string): boolean {
    let qdlCond = question.QDLCondStatuses;
    let ruleExpString = ruleExp +" ";
    for (let i = 0; i < qdlCond.length; i++) {
      if (ruleExpString.indexOf(qdlCond[i].CondName.trim()) > -1) {
        if (qdlCond[i].Status == true) {
          var truePart = qdlCond[i].CondName.trim()
          var trueReg = new RegExp('\\b'+truePart+'\\b', 'g');
          //alert(qdlCond[i].CondName );          
          ruleExpString = ruleExpString.replace(trueReg, "1==1");
        } else {
          var falsePart = qdlCond[i].CondName.trim();
          var falseReg = new RegExp('\\b'+falsePart+'\\b', 'g');
          //alert(qdlCond[i].CondName );          
          ruleExpString = ruleExpString.replace(falseReg, "1==0");
        }
      }
    }
    ruleExpString = ruleExpString.replace(/AND/g, "&&").replace(/OR/g, "||");
    let result = false;
    try {
      result = Function("return " + ruleExpString)();
    }
    catch (e) {
      result = false;
    }
    return result;
  }


  /**
   * this method handle on page Question Display Logic.
   * @param question
   */
  AnswerDisplayLogic(question: Questions,isLoading:boolean) {
    if (question.ADLRules != null) {
      let CurrConditionQID:number = 0;
        for (let i = 0; i < question.ADLRules.length; i++) {
          //let values = question.rules[i].ConditionValue.split(",");
          //let index = -1;

          let ruleValue = question.ADLRules[i].ADLConditions[0].ConditionValue;
          let curVal = question.AnswerText;
          let multiValueControl: boolean;
          let Operator = question.ADLRules[i].ADLConditions[0].Operator;
          let SourveValueID = question.ADLRules[i].ADLConditions[0].SourceValueId;
          let ADLRule_id = question.ADLRules[i].Rule_id;
          if ((question.qtype == "CS" || question.qtype == "RK") && question.Answers.length > 0 && question.Answers.find(e => e.value_id == SourveValueID)) {
            curVal = question.Answers.find(e => e.value_id == SourveValueID).ControlAns;
          }
          let adlRuleInd: any;
          this.answerDisplayLogic = new SurveyQuestionAnswerDisplayLogic();
          multiValueControl = this.answerDisplayLogic.ShowHideAnswers(question, ruleValue, curVal, SourveValueID, Operator);
          let updateItem = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions.find(
            e => e.UniqueNumber == question.ADLRules[i].ADLConditions[0].ConditionQID);


          if (updateItem != null && updateItem != undefined) {
            let ind = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions.indexOf(updateItem);

            let updateItemAnswer = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.find(
              e=> e.value_id == question.ADLRules[i].ADLValueId);

          if (updateItemAnswer != null && updateItemAnswer != undefined) {
            let Ansind = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.indexOf(updateItemAnswer);

            let adlRule = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].adlCondStatus.find(
              e => e.rule_id == ADLRule_id)

              if (adlRule != null && adlRule != undefined) {
                adlRuleInd = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].adlCondStatus.indexOf(adlRule);
              }

            if (multiValueControl) {
              //this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].isADLHide = false;
              this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].adlCondStatus[adlRuleInd].status = true;
            }
            else {
              this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].adlCondStatus[adlRuleInd].status = false;
            }

            let adlTrueCount = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].adlCondStatus.filter(
              e => e.status == true)
              if(adlTrueCount.length > 0)
              {
                let isADLHidedQ: boolean;
                
                isADLHidedQ=this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].isADLHide;

                if (isADLHidedQ) {
                 this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind];
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].isADLHide = false;
                  this.RemoveUpdateQuestionsData(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind]);

                                  
                if (!isLoading && (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 1 ||
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 3) &&
                  this.surveySpecificData.PrePopDetails &&
                  this.surveySpecificData.PrePopDetails.filter(e=> e.UniqueNumber ==  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].UniqueNumber && e.preValue == this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].value_id ).length > 0 
                  ) {
                    this.DataPopulation(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind],
                      this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type);
                      let index = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions.indexOf(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind]);
                      this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[index] = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind];
                }

                  if (!isLoading && (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype == 'L' 
                  || (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype == "RT" &&
                    this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qsubtype == 0))) {
                     
                    if (((this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 1 ||
                      this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 3))
                      && this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].PrePopValue != 0
                      && this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].PrePopValue == this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].value_id ) 
                      {
                        let adlPreValueID = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].PrePopValue;
                        let adlPreAnsID = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.filter(e => e.value_id == adlPreValueID);
                        if (adlPreAnsID != undefined && adlPreAnsID.length > 0) 
                        {
                          let PreReadAns = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.find(
                            e => e.value_id == adlPreValueID);
                          if (PreReadAns != null && PreReadAns != undefined) {
                            let Ansind = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.indexOf(PreReadAns);
                            this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].ControlAns = adlPreAnsID[0].value_text
                            this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].selectdId = 1
                          }
                          this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].selectAnsValue = adlPreValueID;
                          this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].AnswerID = adlPreAnsID[0].ms_id;
                          this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].AnswerText = adlPreAnsID[0].value_text;
                          this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].isValid = true;
                        }
                       
                     }
                     if ((this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type >0
                      &&  this.surveySpecificData.PrePopDetails &&
                      this.surveySpecificData.PrePopDetails.filter(e=> e.UniqueNumber ==  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].UniqueNumber).length ==0)||
                      this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 0
                      )
                     {
                        this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].selectAnsValue = -1;
                        this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].AnswerID = 0;
                        this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].AnswerText = null;
                        
                        
                        if (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.find(e => e.selectdId == 1) != undefined) {
                          this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.find(e => e.selectdId == 1).ControlAns = null;
                          this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.find(e => e.selectdId == 1).selectdId = 0;
                        }
                     }
                  } else if (!isLoading && this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype == 'RK') {
                    this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].selectedOptionList = [];
                    this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].isValid = false;
                    this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].isAlertDanger = false;
                    if (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers != null) {
                      for (let i1 = 0; i1 < this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.length; i1++) {
                        this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[i1].ControlAns = null;

                        // this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[i].selectdId = 0;
                      }
                    }
                  }
                }
              }
              else{

                let isADLHidedQ: boolean;
                isADLHidedQ = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].isADLHide

                if(!isADLHidedQ){
                this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].isADLHide = true;
                
                if (!isLoading && (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 1 ||
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 3) &&
                  (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype !='L'&&
                  (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype !='RT' ))
                  ) {
                  this.ClearADLAnswerOnHide(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind],Ansind);
                  let index = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions.indexOf(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind]);
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[index] = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind];
                  }
                  if (!isLoading && (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 1 ||
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 3) &&
                  (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype =='RT'&&
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qsubtype==7
                  )) {
                  this.ClearADLAnswerOnHide(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind],Ansind);
                  let index = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions.indexOf(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind]);
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[index] = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind];
                  }
                
                if (!isLoading && this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type != 1 &&
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type != 3 && !isADLHidedQ) {
                  this.ClearADLAnswerOnHide(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind],Ansind);
                }
                else if ((this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype=='L'||
                (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype=='RT' &&
                this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qsubtype==0)) &&
                  (((this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].value_id == this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].PrePopValue ||
                    this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].PrePopValue == 0) &&
                  (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 1 ||
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 3))||
                  (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 0 && !isLoading)))
                {
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].selectAnsValue = -1;
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].AnswerID = 0;
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].AnswerText = null;
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].isValid = false;
                  if (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.find(e => e.selectdId == 1) != undefined) {
                    this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.find(e => e.selectdId == 1).ControlAns = null;
                    this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.find(e => e.selectdId == 1).selectdId = 0;
                  }

                } else if ((this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].qtype=='RK') &&
                ((this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[Ansind].value_id == this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].PrePopValue &&
                  (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 1 ||
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 3))||
                  (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].population_type == 0 && !isLoading)))
                {
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].selectedOptionList = [];
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].isValid = false;
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].isAlertDanger = false;
                  if (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers != null) {
                    for (let i1 = 0; i1 < this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.length; i1++) {
                      this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[i1].ControlAns = null;
                      // this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers[i].selectdId = 0;
                    }
                  }

                }
              }
              }

            if (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].isADLSQ 
              && this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].UniqueNumber !=CurrConditionQID ) {
              let responseQuestion:any;

              if (this.responseQuestions != null && this.responseQuestions.length > 0) {
                responseQuestion = this.responseQuestions.find(e =>
                  e.UniqueNumber == this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].UniqueNumber);
                  if (responseQuestion != null && responseQuestion != undefined) {
                  this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].Answers.filter(e => (e.isADLHide)).forEach(element => {
                    responseQuestion.Answers.find(e => e.value_id == element.value_id).isADLHide = true;
                  });
                }
              }
              if (this.isNewParticipation) {
                setTimeout(() => {
                  if (responseQuestion != null && responseQuestion != undefined) {
                    this.AnswerDisplayLogic(responseQuestion,isLoading);
                  } else {
                    this.AnswerDisplayLogic(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind],isLoading);
                  }
                }, 0);
              } else {

                if (responseQuestion != null && responseQuestion != undefined) {
                  this.AnswerDisplayLogic(responseQuestion,isLoading);
                } else {
                  this.AnswerDisplayLogic(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind],isLoading);
                }
              }
            } else if (this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].group_no > 0 &&
              this.multiQuestionFindIsSQ(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind])
              && this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].UniqueNumber != CurrConditionQID) {
               // this.UpdateLocalJson();
              let sqQuestions = this.multiQuestionFind(this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind]);
              if (sqQuestions != null && sqQuestions.length > 0) {
                for (let i = 0; i < sqQuestions.length; i++) {
                  let responseQuestion:any;

                  if (this.responseQuestions != null && this.responseQuestions.length > 0) {
                    responseQuestion = this.responseQuestions.find(e => e.UniqueNumber == sqQuestions[i].UniqueNumber);
                  }
                  if (responseQuestion != null && responseQuestion != undefined) {
                    this.AnswerDisplayLogic(responseQuestion,isLoading);
                  } else {
                    this.AnswerDisplayLogic(sqQuestions[i],isLoading);
                  }
                }
              }
            }

            if(CurrConditionQID != this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].UniqueNumber)
            {
              CurrConditionQID = this.surveyData.Pages[question.ADLRules[i].ADLConditions[0].ConditionQPageNo - 1].Questions[ind].UniqueNumber;
            }

          }
          }
        }
    }
  }


  /**
   * this method use for handle multi-question find source question.
   * @param question
   * @returns
   */
  multiQuestionFindIsSQ(question: Questions) {
    if (this.surveyData.Pages[question.page_no - 1].Questions.filter(e => e.Rule_id == question.Rule_id && e.isSQ) != null &&
      this.surveyData.Pages[question.page_no - 1].Questions.filter(e => e.Rule_id == question.Rule_id && e.isSQ).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * this method return source Question.
   * @param question
   * @returns
   */
  multiQuestionFind(question: Questions): Questions[] {
    // if (this.surveyData.Pages[question.page_no - 1].Questions.find(e => e.Rule_id == question.Rule_id && e.isSQ) != undefined) {
    //   return this.surveyData.Pages[question.page_no - 1].Questions.find(e => e.Rule_id == question.Rule_id && e.isSQ);
    // }
    let sqQuestions = this.surveyData.Pages[question.page_no - 1].Questions.filter(e => e.Rule_id == question.Rule_id && e.isSQ);

    if (sqQuestions != null && sqQuestions.length) {
     return sqQuestions;
    }
  }

  /**
   * this method use for handle destinatio Question
   * @param rule
   * @param isLoad
   */
  destinationQuestionHandle(rule: Rules, isLoad: boolean) {
    this.UpdateLocalJson();
    let destinationQN = this.surveyData.Pages[rule.ConditionQPageNo - 1].Questions.find(
      e => e.UniqueNumber == rule.DestinationQID)

    if (destinationQN != null && destinationQN != undefined) {
      let destinationQuestions: DestinationQuestion[];

      if (destinationQN.DestinationQuestions != null && destinationQN.DestinationQuestions != undefined) {
        destinationQuestions = destinationQN.DestinationQuestions;
      } else {
        destinationQuestions = [];
      }

      let selectedList = destinationQuestions.find(e => e.rule_id == rule.Rule_id);

      if (isLoad) {
        if (destinationQuestions.indexOf(selectedList) < 0) {
          destinationQuestions.push(
            { rule_id: rule.Rule_id, ConditionQID: rule.ConditionQID });
        }
      } else {
        if (selectedList != null && selectedList != undefined) {
          let ind = destinationQuestions.indexOf(selectedList);

          destinationQuestions.splice(ind, 1);
        }
      }
      let destinationIndex = this.surveyData.Pages[rule.ConditionQPageNo - 1].Questions.indexOf(destinationQN);
      this.surveyData.Pages[rule.ConditionQPageNo - 1].Questions[destinationIndex].DestinationQuestions = destinationQuestions;
    }
  }

  /**
   * this method use for handle destinatio Question
   * @param rule
   * @param isLoad
   */
  ContactdestinationQuestionHandle(rule: ContactRules, isLoad: boolean) {
    this.UpdateLocalJson();
    let destinationQN = this.surveyData.Pages[rule.ConditionQPageNo - 1].Questions.find(
      e => e.UniqueNumber == rule.DestinationQID)

    if (destinationQN != null && destinationQN != undefined) {
      let destinationQuestions: DestinationQuestion[];

      if (destinationQN.DestinationQuestions != null && destinationQN.DestinationQuestions != undefined) {
        destinationQuestions = destinationQN.DestinationQuestions;
      } else {
        destinationQuestions = [];
      }

      let selectedList = destinationQuestions.find(e => e.rule_id == rule.Rule_id);

      if (isLoad) {
        if (destinationQuestions.indexOf(selectedList) < 0) {
          destinationQuestions.push(
            { rule_id: rule.Rule_id, ConditionQID: rule.ConditionQID });
        }
      } else {
        if (selectedList != null && selectedList != undefined) {
          let ind = destinationQuestions.indexOf(selectedList);

          destinationQuestions.splice(ind, 1);
        }
      }
      let destinationIndex = this.surveyData.Pages[rule.ConditionQPageNo - 1].Questions.indexOf(destinationQN);
      this.surveyData.Pages[rule.ConditionQPageNo - 1].Questions[destinationIndex].DestinationQuestions = destinationQuestions;
    }
  }

  /**
   * this method used for loading time update responses.
   * @param question
   */
  UpdateLoadingQuestionsData(question: Questions){
    this.UpdateQuestionsData(question, true);
  }

  /**
   * this method use for collecting child control response data.
   * @param question
   * @param isLoading
   */
  UpdateQuestionsData(question: Questions, isLoading: boolean = false) {

    if (!isLoading) {
      this.isControlLoading = false;
    }

    if(question.qtype=="T" && question.isDirectoryLinkedQ)
    {
        let linkq = this.surveyData.directoryLinkedQuestionDetails.linkedQuestions.filter(e=> e.questionID == question.UniqueNumber)
        if(linkq.length > 0 )
        {
          linkq[0].directoryColumnValue = question.AnswerText;
          let lnkind = this.surveyData.directoryLinkedQuestionDetails.linkedQuestions.indexOf(linkq[0]);
          this.surveyData.directoryLinkedQuestionDetails.linkedQuestions[lnkind] = linkq[0];
        }
    }

    if (question.InlineQDL) {
      this.service.SetQDL(question);
    }
    if (this.surveyData.CorpSettings.isAutoSave &&
      this.surveyData.SurveyDetails.GroupType.toLocaleLowerCase() == 'private' &&
      !this.surveyData.SurveySettings.isEx && !this.surveyData.SurveySettings.isAssessment) {
      this.SetAutoSave();
    }
    if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
      this.OfflineDashboard();
    }
    if (this.responseQuestions.length > 0 && this.responseQuestions != undefined) {
      let updateItem = this.responseQuestions.find(e => e.UniqueNumber == question.UniqueNumber);

      if (updateItem != null && updateItem != undefined) {
        let ind = this.responseQuestions.indexOf(updateItem);
        this.responseQuestions[ind] = question;
      }
      else {
        this.responseQuestions.push(question);
      }
    }
    else {
      this.responseQuestions.push(question);
    }
    if (question.isSQ && !this.isByPassLogic) {
      
      this.QuestionDisplayLogic(question);
      this.changeDetect.detectChanges();
      setTimeout(() => {
        if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)){
          this.bodyNiceScrollResize()
        }
        if(this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
        {
          this.bodyNiceScrollResize()
        }
        if(this.commonSetting.isEmbedNoScroll && window.location !== window.parent.location )
        {
          this.fnPostMessage('Project Resize');
        } 
      }, 0);
    }

    if (question.isADLSQ && !this.isByPassLogic) {
      this.AnswerDisplayLogic(question,false);
      this.changeDetect.detectChanges();
      setTimeout(() => {
        if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)){
          this.bodyNiceScrollResize()
        }
        if(this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
        {
          this.bodyNiceScrollResize()
        }
        if(this.commonSetting.isEmbedNoScroll && window.location !== window.parent.location )
        {
          this.fnPostMessage('Project Resize');
        } 

      }, 0);
    }


  }

  /**
   * this method remove response from response object
   * @param question
   */
  RemoveUpdateQuestionsData(question: Questions) {
    if (this.responseQuestions.length > 0 && this.responseQuestions != undefined) {
      let updateItem = this.responseQuestions.find(e => e.UniqueNumber == question.UniqueNumber);

      if (updateItem != null && updateItem != undefined) {
        let ind = this.responseQuestions.indexOf(updateItem);

        this.responseQuestions.splice(ind, 1);
      }
    }
  }

  /**
   * this method use for update responses in question data.
   */
  UpdateLocalJson() {
    if (this.responseQuestions.length > 0 && this.surveyData != null) {
      for (let i = 0; i < this.responseQuestions.length; i++) {

        let index = this.responseQuestions[i].page_no - 1;

        let updateItem = this.surveyData.Pages[index].Questions.find(
          e => e.UniqueNumber == this.responseQuestions[i].UniqueNumber);

        if (updateItem != null && updateItem != undefined) {
          let ind = this.surveyData.Pages[index].Questions.indexOf(updateItem);
          this.responseQuestions[i].isCQHide = this.surveyData.Pages[index].Questions[ind].isCQHide;

          if (this.responseQuestions[i].qtype == 'T' && this.responseQuestions[i].InlineQDL) {
            this.responseQuestions[i].isLoading = this.surveyData.Pages[index].Questions[ind].isLoading;
            this.responseQuestions[i].QDLCondStatuses = this.surveyData.Pages[index].Questions[ind].QDLCondStatuses;
          }

          this.surveyData.Pages[index].Questions[ind] = this.responseQuestions[i];
        }
      }
      this.responseQuestions = [];
    }
  }

  /**
   * this method used for tooltip bar percentage.
   */
  GetPercentage(): number {
    if(!this.surveyData.Pages[this.pageNumber].isEndSurvey || (this.preview.isPreviewToggle && !this.preview.isManditorySkip)){
      let index = this.surveyDisplayPageList2.indexOf((this.pageNumber + 1));
      let val;
      if(index != -1)
      {
        val = (this.surveyDisplayPageList1[index] / this.surveyDisplayPageList1.length) * 100;
      }
      else
      {
        val = ((this.pageNumber+1) / this.maxPageNumber) * 100;
      }
      if(val < 1){
        return 1;
      }
      return Math.floor(val);
    }
    else{
      return 100;
    }

  }

  /**
   * this method use for add animation on control loading.
   */
  fadePage() {
    if (this.transition !== null || this.transition !== undefined) {
      clearInterval(this.transition);
    }

    this.startAnimation = 0;
    document.getElementById('questionWrapper').style.opacity = '0';
    this.transition = setInterval(() => {
      if (this.startAnimation >= 1) {
        clearInterval(this.transition);
        this.startAnimation = 0;
      } else {
        this.startAnimation = this.startAnimation + 0.1;
        document.getElementById('questionWrapper').style.opacity = '' + this.startAnimation;
      }
    }, 50);
  }

  /**
   * this method use for show Anonymous
   * @param isShow
   */
  ShowAnonymous(isShow: boolean) {
    // if((this.selectedLang == 1 || this.selectedLang == 4) && !this.surveyData.SurveySettings.IsSemiAnonymous)
    // {
    //   window.open(this.surveyData.SurveyMessages.AnonymousMessage);
    // }
    // else
    // {
      this.showAnonymous = isShow;
    // }
  }

  /**
   * this method use for onKeyPress pop message.
   * @param event
   */
  ShowAnonymousKeydown(event){
    if(event.keyCode == 13 || event.keyCode == 32){
      this.ShowAnonymous(true);
    }
  }

  /**
   * this method use for GDPR message.
   * @param isShow
   */
  ShowGDPR(isShow: boolean) {
    if (this.surveyData.CorpSettings.GDPROption == 1) {
      let url: string = '';
      if (!/^http[s]?:\/\//.test(this.surveyData.CorpSettings.GDPRURL)) {
        url += 'http://';
      }

      url += this.surveyData.CorpSettings.GDPRURL;
      window.open(url, "_blank");
    }
    else {
      this.showGDPR = isShow;
    }
  }

  /**
   * this method use for show GDPR on keyPress event.
   */
  ShowGDPRKeyboard(event){
    if(event.keyCode == 13 || event.keyCode == 32){
      this.ShowGDPR(true);
    }
  }

  /**
   * this method use for new responses.
   */
  StartNewResponse(){
    this.isThankYouPage = false;
    this.isEditedResponse = false;
    this.formValisandSubmited = false;
    this.surveyPageList = [];
    this.isAllQuestionHideOnNextPages =false;

    let k = '';
    let lang1 = '';
    this.activatedRoute.queryParams.subscribe(async params => {
      k = params['k'];
      lang1 = (params['lang'] == undefined) ? "0" : params['lang'];
    });
    this.storage.set('Editresponse_' + k, [])
      //let path ='Survey1.aspx?' + 'k=' + k;
      //let path = 'Survey1.aspx?' + 'k='+ k + '&lang=' + lang1;
      //window.location.replace(path);
      //this.router.navigateByUrl(path);
      //this.isRemoveBackGround=false;
      //this.ResponseStartDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
      //this.GetData();
      //this.form.resetForm();

       // Response limit restriction Handle.
    if (this.OfflineResponseData.length < 100) {
      let path = 'survey1.aspx?' + 'k='+ k + '&lang=' + lang1;
      this.router.navigateByUrl(path);
      this.ResponseStartDate = formatDate(new Date(), 'M/d/y h:mm:ss a', 'en');
      this.GetData();
    } else {
      alert('Response Limit reached please upload pending responses and try again');
      let path = 'offline.aspx?' + 'k='+ k + '&lang=' + lang1;
      this.router.navigateByUrl(path);
    }
  }

  /**
   * this method use for goBackQuota, ..etc.
   * @param event
   */
   EditResponceHandling(event: any) {
    if(!(event != undefined && event.length == 3 && event[2]=="send")){
      this.isThankYouPage = false;
      this.isSaveAndContinue = false;
      this.isEditedResponse = true;
      this.pageNumber = 0;
      this.surveyPageList = [];
      let EventName;
      if(!event.length){
        EventName = event.target.name;
      }
      this.isPrintDownload = this.surveyData.SurveyDetails.IsPrintDownload;
      if(event != undefined && EventName == "goBackQuota")
      {
        this.multiLanguage = false;
        this.selectedLanguage = false;
        let key = this.surveyData.SurveyDetails.surveyKey;
        let path = this.service.getBasePath() + '/survey1.aspx?' + 'k=' + key + '&Dir=Quota&lang=' + this.surveyData.SurveyDetails.selectedLangId + "&Uid=" + this.surveyData.ResponseInfo.ResponseUID;
        window.location.replace(path);
        this.isRemoveBackGround=false;
        this.form.resetForm();
        this.surveyPageList = [];
      }
      else if (this.participation_Messages != null && this.participation_Messages != undefined) {
          this.multiLanguage = false;
          this.selectedLanguage = true;
          let key = this.participation_Messages.thankYou_message.ReOpenkey == null ? this.surveyData.SurveyDetails.surveyKey : this.participation_Messages.thankYou_message.ReOpenkey;
          let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" ? '&status=preview' : '');
          let path = 'survey1.aspx?' + 'k=' + key + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + status ;
          this.isRemoveBackGround=false;
          this.router.navigateByUrl(path);
      }
      else {
        this.multiLanguage = false;
        this.selectedLanguage = true;
        this.isRemoveBackGround = false;
        this.addPageBGClass();
      }
      if (event != undefined && event.length == 3) {
        this.form.resetForm();
        this.isRemoveBackGround = false;
        this.isSaveAndContinue = true;
        this.isThankYouPage = false;
        this.multiLanguage = false;
        this.selectedLanguage = false;
        this.isPrintDownload = false;
        this.pageNumber = 999;
        this.surveyData.SurveyDetails.isSystemBGImage = true;
        this.surveyBackground = 'body-bg BackGroundChanges';
      }
    }else if(event != undefined && event.length == 3 && event[2]=="send"){
      let key = this.surveySpecificData.Participation_Messages.partial_and_quota_message.unique_key == null ? this.surveyData.SurveyDetails.surveyKey : this.surveySpecificData.Participation_Messages.partial_and_quota_message.unique_key;
      let url = 'SurveyData/PartialDataMail?k=' + key + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + '&recno='+ this.surveyData.ResponseInfo.ResponseUID + "&mailid=" + event[1];
      this.service.PostPartialDataMail(url).subscribe(async (data) => {
        }, error => {
          //console.log(error);
          this.errorsHandlerService.handleError(error);
        });
    }

  }

  /**
   * this method return language name.
   * @param lang_id
   * @returns
   */
  getLanguageName(lang_id: number): string {
    if (this.surveyData.LanguageDatas != null && this.surveyData.LanguageDatas.length > 0) {
      let currlang= lang_id;
      if(lang_id == 0 && this.surveyData.SurveySettings.primary_lang_id != 0)
      {
        currlang  = this.surveyData.SurveySettings.primary_lang_id;
      }
      if(this.surveyData.LanguageDatas.filter(e => e.lang_id == currlang).length>0){
        return this.surveyData.LanguageDatas.find(e => e.lang_id == currlang).LanguageName;
      }else{
        return this.surveyData.LanguageDatas[0].LanguageName;
      }
    }
  }

  /**
   * this method use for lest left page.
   */
  lastLeftOffAnswerPiping() {
    if (this.surveyData != null) {
      for (let i = this.pageNumber; i > 0; i--) {
        let sourceQuestions = this.surveyData.Pages[i].Questions.filter(e => e.AnsPipeCondition > 1 && e.group_no > 0);

        if (sourceQuestions != null && sourceQuestions.length > 0) {
          this.answerPiping(i)
        }
      }
    }
  }

  /**
   * this method use for handling partial responses
   * @param event
   */
  partialResponceHandling(event: any) {
    this.isThankYouPage = false;
    this.multiLanguage = false;
    this.selectedLanguage = true;
    this.isEditedResponse = true;
    this.isSaveAndContinue = false;
    let lastLeftPgNo = this.surveyData.SurveyDetails.lastLeftPgNo == null ? 0 : this.surveyData.SurveyDetails.lastLeftPgNo;
    let responseType = event.target.attributes.name.value;
    this.selectedLang = this.surveyData.SurveyDetails.selectedLangId;
    this.isEditedResponse = false;
    this.selectedLanguageName = this.getLanguageName(this.surveyData.SurveyDetails.selectedLangId);
    if (responseType == "LastLeftResponse") {
      this.pageNumber = (lastLeftPgNo == 0 ? 0 : lastLeftPgNo - 1);
      if (this.pageNumber != 0 && this.pageNumber != 999) {
        this.EndSurveyOnPage();
        this.isEndSurveyOnPage = this.surveyData.Pages[this.pageNumber].isEndSurvey;
        this.isAllQuestionHideOnPrevPages = this.AllQuestionHideONPrevPages(this.pageNumber);
        this.isAllQuestionHideOnNextPages = this.AllQuestionHideONNextPages(this.pageNumber);
        this.lastLeftOffAnswerPiping();
        this.QDLForSkippedQuestions(this.UniqueArray(this.skippedPageList));
      }
      this.AllPageQuestionDisplayLogic();
      this.AllPageAnswerDisplayLogic();

      window.scrollTo(0, 0);
      this.isRemoveBackGround = false;
      this.addPageBGClass();
    }
    else if(responseType == "BeginNewResponse")
    {
      this.skippedPageList =this.UniqueArray(this.skippedPageList);
      this.pageNumber = 0;
      if (this.allQuestionHideOnPage(this.pageNumber, false, true,true,false)) {
        this.surveyPageList = [];
        if (this.surveyPageList.indexOf((this.pageNumber + 1)) == -1) {
          this.skippedPageList.push((this.pageNumber + 1));
        }
        this.GetNextPage(this.pageNumber,true);
      } else{
        this.surveyPageList = [];
      }
      //Issue No.  120722 : Open : [Pif-120609]Let's try this again for page with mandatory ques after end and exit
      this.assesmentAutoSavePageList = [];
      this.isRemoveBackGround = false;
      this.addPageBGClass();
    }
    else if (responseType == "SurveyEdiited") {
      this.selectedLanguage = false;
      this.isEditedResponse = false;
      let key = this.surveyData.SurveyDetails.surveyKey;
      this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
      this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
      this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
      this.CheckCookieforDelete('Partial Survey Edited');
      //let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" ? '&status=preview' : '');
      let path = this.service.getBasePath() + '/survey1.aspx?' + 'k=' + key + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + "&Uid=" + this.surveyData.ResponseInfo.ResponseUID + "&Dir=FST";
      window.location.replace(path);
      this.surveyPageList = [];
      this.assesmentAutoSavePageList = [];
    }
    else if (responseType == "BrowserContinue") {
      this.selectedLanguage = false;
      this.isEditedResponse = false;
      let key = this.surveyData.SurveyDetails.surveyKey;
      this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
      this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
      this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
      this.CheckCookieforDelete('Partial BrowserContinue');
      let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" ? '&status=preview' : '');
      let path = this.service.getBasePath() + '/survey1.aspx?' + 'k=' + key + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + "&Uid=" + this.surveyData.ResponseInfo.ResponseUID + status+ "&Dir=BRWS";
      this.isRemoveBackGround=false;
      this.addPageBGClass();
      window.location.replace(path);
      this.surveyPageList = [];
      this.assesmentAutoSavePageList = [];
    }
    else if (responseType == "BeginNewResponseRef") {
      this.selectedLanguage = false;
      this.isEditedResponse = false;
      this.deleteCookie("PublicCorpNo" + this.surveyData.CorpSettings.corporate_no);
      this.deleteCookie("PublicSurveyNo" + this.surveyData.SurveyDetails.survey_no);
      this.deleteCookie("PublicRecNo" + this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
      this.CheckCookieforDelete('Partial begin new response');
      let key = this.surveyData.SurveyDetails.surveyKey;
      //let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" ? '&status=preview' : '');
      let path = this.service.getBasePath() + '/survey1.aspx?' + 'k=' + key + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + "&Dir=PUB&OUid=" + this.surveyData.ResponseInfo.ResponseUID;
      window.location.replace(path);
      this.isRemoveBackGround=false;
      this.addPageBGClass();
      this.form.resetForm();
      this.surveyPageList = [];
      this.assesmentAutoSavePageList = [];
    }
    this.isPrintDownload = this.surveyData.SurveyDetails.IsPrintDownload;
    if (this.participation_Messages != null && this.participation_Messages != undefined) {
      let key = this.participation_Messages.thankYou_message.ReOpenkey == null ? this.surveyData.SurveyDetails.surveyKey : this.participation_Messages.thankYou_message.ReOpenkey;
      let status = (this.surveyData.SurveyDetails.GroupType != undefined && this.surveyData.SurveyDetails.GroupType.toUpperCase() == "PREVIEW" ? '&status=preview' : '');
      let path = 'survey1.aspx?' + 'k=' + key + '&lang=' + this.surveyData.SurveyDetails.selectedLangId + status;
      this.isRemoveBackGround = false
      
      this.router.navigateByUrl(path);
    }
    setTimeout(() => {
      this.calculateWidthPageFooter();   
    }, 0);
     }

  /**
   * this method use for reopen survey updating responses.
   */
  SurveyResponseUpdate() {
    if (this.surveySpecificData.ParticipationResponseData && this.surveySpecificData.ParticipationResponseData.ResponseDatas != null ) {

      let strSavedPageList = this.surveySpecificData.ParticipationResponseData.ResponseCommanData.SavedPageList;
      if(strSavedPageList != null
        && strSavedPageList != undefined
        && strSavedPageList !=""
        && strSavedPageList.indexOf(",") > 0)
      {
        this.surveyPageList = [];
        this.assesmentAutoSavePageList = [];
        let arrSavedPageList = strSavedPageList.split(',');
        for(let k = 0; k < arrSavedPageList.length; k++)
        {
          this.surveyPageList.push(parseInt(arrSavedPageList[k]));
          if (this.surveyData.SurveySettings.isAssessment) {
            this.assesmentAutoSavePageList.push(parseInt(arrSavedPageList[k]));
          }
        }
      }
      for (let i = 0; i < this.surveySpecificData.ParticipationResponseData.ResponseDatas.length; i++) {

        if (this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerID == 0 &&
          this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerText == null &&
          !this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].IsOther) {
          continue;
        }

        for (let j = 0; j < this.surveyData.Pages.length; j++) {
          this.resetCaptcha(j);
          let question = this.surveyData.Pages[j].Questions.find(
            e => e.UniqueNumber == this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].QuestionID);

          if (question != null && question != undefined) {
            let index = this.surveyData.Pages[j].Questions.indexOf(question);
            question.AnswerID = this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerID;
            question.AnswerText = this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerText;
            question.selectAnsValue = this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerID;

            if (question.qtype == 'RW' && question.qsubtype == 3) {
              question.isLoading = true;
            }

            if (question.qtype == 'T' && question.isCQHide == true && question.InlineQDL == true) {
              question.isLoading = true;
            }

            // if (question.qtype == 'RS') {
            //   question.selectAnsValue = question.selectAnsValue - 1;
            // }

            if (this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].IsOther) {
              question.isOtherAnswer = this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].IsOther;
              question.otherAnswer = question.AnswerText;
              question.AnswerText = question.other_text;
            }

            if (question.isSoftRequired && !question.isHiddenQ) {
              question.isSoftRequiredHandle = true;
            }

            // 107339 Case 2
            // if (question.qtype == 'T' && question.qsubtype == 31 && question.isreenter == 1) {
            //   question.otherAnswer = question.AnswerText;
            // }

            if (question.Answers != null && question.Answers != undefined && question.Answers.length > 0) {
              let ans = question.Answers.find(e => e.value_id == this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerID);

              if (this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].IsOther) {
                ans = question.Answers.find(e => e.isOther);
              }

              // if (question.qtype == 'RS') {
              //   ans = question.Answers.find(e => e.value_id == (this.surveySpecificData.ResponseDatas[i].AnswerID - 1));
              // }

              if (ans != null && ans != undefined) {
                if (question.qtype == 'R' || question.qtype == 'HR' ||
                  question.qtype == 'GR' || question.qtype == 'RG' ||
                  (question.qtype == 'RW' && question.qsubtype == 0) ||
                  (question.qtype == 'RW' && question.qsubtype == 1) ||
                  (question.qtype == 'RW' && question.qsubtype == 3) ||
                  (question.qtype == 'RT') || question.qtype == 'L' ||
                  question.qtype == 'SR') {
                  if (!question.isGoBackQuota && !ans.isQuotaDisable) {
                    ans.ControlAns = ans.value_text;
                    question.AnswerID = ans.ms_id;
                    question.selectAnsValue = ans.value_id;
                    question.AnswerText = ans.value_text;
                    ans.selectdId = 1;
                  } else {
                    question.AnswerID = null;
                    question.AnswerText = null;
                    if (question.qtype == 'L') {
                      question.selectAnsValue = -1;

                    }
                    else {
                      question.selectAnsValue = -1;

                    }
                  }
                } else if (question.qtype == 'RS') {
                  if (question.RS_Type == 2 || question.RS_Type == 4 || question.RS_Type == 3 ||(question.RS_Type == 0 && question.RSFormat == 2) ) {
                    ans.ControlAns = ans.value_id.toString();
                  } else {
                    ans.ControlAns = ans.value_id
                  }
                  question.AnswerID = ans.ms_id;
                  question.selectAnsValue = ans.value_id;
                  question.AnswerText = ans.value_text;
                  ans.selectdId = 1;
                } else if (question.qtype == 'GD' || (question.qtype == 'RW' && question.qsubtype == 2)) {
                  question.AnswerText = ans.value_text;
                }
                else if (question.qtype == 'C' || question.qtype == 'ML' || question.qtype == 'GC') {
                  if (!question.isGoBackQuota && !ans.isQuotaDisable) {
                    ans.ControlAns = true;
                    ans.selectdId = 1;
                    question.AnswerText = "Selected Answer Option"
                    this.InsertSelectedOptionList(question, this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerID,
                      this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerText,
                      this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].IsOther);

                    if (question.ansConstraint != null &&  question.qtype != 'GC' &&
                      question.selectedOptionList.length > 0 && !ans.IsNoneAbove) {
                      question = this.AnsConstraintHandling(question);
                    }
                  }
                  else {

                    ans.ControlAns = false;
                    ans.selectdId = 0;
                    question.AnswerID = null;
                    question.AnswerText = null;
                    question.selectAnsValue = -1;
                  }
                } else if (question.qtype == 'CS') {
                  ans.ControlAns = this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerText;
                  question.AnswerText = "Option Filled";
                  this.InsertSelectedOptionList(question, this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerID,
                    this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerText,
                    this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].IsOther);
                } else if (question.qtype == 'SC') {
                  ans.ControlAns = ans.value_text;
                  question.AnswerText = "Option Filled";
                  this.InsertSelectedOptionList(question, this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerID,
                    this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerText,
                    this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].IsOther);
                } else if (question.qtype == 'RK') {
                  ans.ControlAns = this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerText;
                  question.AnswerText = "Option Filled";
                  this.InsertSelectedOptionList(question, this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerID,
                    this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].AnswerText,
                    this.surveySpecificData.ParticipationResponseData.ResponseDatas[i].IsOther);
                }
                question.pageto = ans.pageto;
                let ind = question.Answers.indexOf(ans);

                if (question.qtype == 'RS' || (question.qtype=='RG' && question.RSFormat == 2)) {
                  if (ans.isNA) {
                    question.isNA = true;
                  }
                }

                question.Answers[ind] = ans;
              }
            }

            if (question.qtype == 'T') {
              question.pageto = question.Answers[0].pageto;

              if (question.qsubtype == 21 && question.AllowOnlyInteger) {
                question.AnswerText = Math.round(parseFloat(question.AnswerText)).toString();
              }
            }
            if(question.qtype == "CM" && question.qsubtype ==1)
            {
              question.AnswerText = null;
            }

            this.surveyData.Pages[j].Questions[index] = question;
            break;
          }
        }
      }
    }
  }

  /**
   * this method use for handling constraint on control.
   * @param questions
   * @returns
   */
  AnsConstraintHandling(questions: Questions) : Questions{
    let ansCons = questions.ansConstraint.split(' ');

    if (ansCons[0] == '=') {
      if (questions.selectedOptionList.length == parseInt(ansCons[1])) {
        questions.isValid = false;
        questions.isAlertDanger = false;
      } else {
        questions.isValid = true;
        questions.isAlertDanger = true;
      }
    } else if (ansCons[0] == '>=') {
      if (questions.selectedOptionList.length >= parseInt(ansCons[1])) {
        questions.isValid = false;
        questions.isAlertDanger = false;
      } else {
        questions.isValid = true;
        questions.isAlertDanger = true;
      }
    } else if (ansCons[0] == '<=') {
      if (questions.selectedOptionList.length <= parseInt(ansCons[1])) {
        questions.isValid = false;
        questions.isAlertDanger = false;
      } else {
        questions.isValid = true;
        questions.isAlertDanger = true;
      }
    }

    return questions;
  }

  /**
   * this method use for multi-value control list insertion
   * @param question
   * @param answerID
   * @param answerText
   * @param isOther
   */
  InsertSelectedOptionList(question: Questions, answerID: number, answerText: string, isOther: boolean) {

    let selectedOptionList: SelectedOptionList[];

    if (question.selectedOptionList != null && question.selectedOptionList != undefined) {
      selectedOptionList = question.selectedOptionList;
    } else {
      selectedOptionList = [];
    }

    let selectedList = selectedOptionList.find(e => e.value_id == answerID);

    if (selectedOptionList.indexOf(selectedList) < 0) {
      selectedOptionList.push(
        { value_id: answerID, value_text: answerText, isOther: isOther });

      question.selectedOptionList = selectedOptionList;
    }
  }

  /**
   * this method use for clear responses on QDL hide Question.
   * @param question
   * @param isRecursive
   */
  ClearQDLAnswerOnHide(question: Questions, isRecursive: boolean = false) {
    question.AnswerID = null;
    if(question.qtype == "T"){
      question.selectAnsValue = 0;
    }
    else{
      question.selectAnsValue = -1;
    }
     question.AnswerText = null;
    question.isValid = false;
    question.selectedOptionList = [];
    if (question.Answers != null) {
      for (let i = 0; i < question.Answers.length; i++) {
        question.Answers[i].ControlAns = null;
        question.Answers[i].selectdId = 0;
      }
    }

    if (question.isMatrixQuestion && !isRecursive) {
      this.matrixGroupClearAnswer(question)
    } else if (!isRecursive && question.group_no > 0) {
      this.clearGroupAnswer(question.page_no, question.group_no);
    }


    this.RemoveUpdateQuestionsData(question);
  }

   /**
   * this method use for clear responses on QDL hide Question.
   * @param question
   * @param isRecursive
   */
   ClearQDLAnswerOnShow(question: Questions, isRecursive: boolean = false) {
    question.AnswerID = null;
    if(question.qtype == "T"){
      question.selectAnsValue = 0;
      if(question.isDirectoryLinkedQ)
        {
          let linkedQuestionsData = this.surveyData.directoryLinkedQuestionDetails.linkedQuestions.filter(e=> e.questionID == question.UniqueNumber);
          if(linkedQuestionsData[0].directoryColumnValue != '' && linkedQuestionsData[0].directoryColumnValue != undefined)
          {
            question.AnswerText = linkedQuestionsData[0].directoryColumnValue;
          }
        }
    }
    else{
      question.selectAnsValue = -1;
    }

    
    question.AnswerText = null;
    question.isValid = false;

    if(question.isDirectoryLinkedQ)
      {
        let linkedQuestionsData = this.surveyData.directoryLinkedQuestionDetails.linkedQuestions.filter(e=> e.questionID == question.UniqueNumber);
        if(linkedQuestionsData[0].directoryColumnValue != '' && linkedQuestionsData[0].directoryColumnValue != undefined)
        {
          question.AnswerText = linkedQuestionsData[0].directoryColumnValue;
        }
      }

    question.selectedOptionList = [];
    if (question.Answers != null) {
      for (let i = 0; i < question.Answers.length; i++) {
        question.Answers[i].ControlAns = null;
        question.Answers[i].selectdId = 0;
      }
    }

    if (question.isMatrixQuestion && !isRecursive) {
      this.matrixGroupClearAnswerShow(question)
    } else if (!isRecursive && question.group_no > 0) {
      this.clearGroupAnswerShow(question.page_no, question.group_no);
    }


    this.RemoveUpdateQuestionsData(question);
  }




  /**
   * this method use for clear responses on QDL hide Question.
   * @param question
   * @param isRecursive
   */
   ClearADLAnswerOnHide(question: Questions,AnsInd:any, isRecursive: boolean = false) {
   // question.AnswerID = null;
    //if(question.qtype == "T"){
    //  question.selectAnsValue = 0;
    //}
    //else{
     if (question.selectAnsValue == question.Answers[AnsInd].value_id || (question.qtype == 'L' || (question.qtype == 'RT' && question.qsubtype == 0))) {
       question.AnswerID = 0;
       question.selectAnsValue = -1;
       //}
       question.AnswerText = null;
       question.isValid = false;
     }

    if(question.selectedOptionList != null && question.selectedOptionList.length > 0)
    {
      let selItem = question.selectedOptionList.find(e=> e.value_id == question.Answers[AnsInd].value_id)
      if (selItem != null && selItem != undefined) {
        let selInd = question.selectedOptionList.indexOf(selItem);
        question.selectedOptionList.splice(selInd,1)
      }
    }
    if (question.Answers != null) {
        question.Answers[AnsInd].ControlAns = null;
        question.Answers[AnsInd].selectdId = 0;
    }

    if(question.qtype=="RK"){
      question.selectedOptionList = [];
    if (question.Answers != null) {
      for (let i = 0; i < question.Answers.length; i++) {
        question.Answers[i].ControlAns = null;
        question.Answers[i].selectdId = 0;
      }
    }
    }

    // if (question.isMatrixQuestion && !isRecursive) {
    //   this.matrixGroupClearAnswer(question)
    // } else if (!isRecursive && question.group_no > 0) {
    //   this.clearGroupAnswer(question.page_no, question.group_no);
    // }
    if (question.isSQ && !this.isByPassLogic) {
      this.QuestionDisplayLogic(question);
    }

    this.RemoveUpdateQuestionsData(question);
  }

  /**
   * this method use for multi-question data clear on QDL
   * @param page_no
   * @param group_no
   */
   clearGroupAnswer(page_no: number, group_no: number){
    let groupQuestions = this.surveyData.Pages[page_no - 1].Questions.filter(e => e.group_no == group_no );
   let allGrupRule = groupQuestions.filter(e=> e.Rule_id !=0 && e.Rule_id == groupQuestions[0].Rule_id);
      if(allGrupRule.length == groupQuestions.length)
      {
        groupQuestions[0].isGroupRule = true;
      }
      if (groupQuestions != null && groupQuestions.length > 0 && groupQuestions[0].isGroupRule) { 
        for (let index = 0; index < groupQuestions.length; index++) {
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
          if( this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 1 
            && this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 3)
          {
            this.ClearQDLAnswerOnHide(groupQuestions[index], true);
            if (groupQuestions[index].isSQ && !this.isByPassLogic) {
              this.QuestionDisplayLogic(groupQuestions[index]);
            }
          }
          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];
          //Issue No.  122192 : Open : [ANG] Response not rec. when QDL applied to MG for a case
          this.surveyData.Pages[page_no - 1].Questions[ind].isCQHide = true;
        }
      }
      let CheckNoGroupHide = groupQuestions.filter(e=> e.isCQHide == false);
      if( CheckNoGroupHide != null && CheckNoGroupHide.length == 0)
      {
        for (let index = 0; index < groupQuestions.length; index++) {
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
          if( this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 1 
            && this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 3)
          {
            this.ClearQDLAnswerOnHide(groupQuestions[index], true);
            if (groupQuestions[index].isSQ && !this.isByPassLogic) {
              this.QuestionDisplayLogic(groupQuestions[index]);
            }
          }
          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];         
          this.surveyData.Pages[page_no - 1].Questions[ind].isGroupCQHide = true;
        }
      }
      else{
        for (let index = 0; index < groupQuestions.length; index++) {
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
          if( this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 1 
            && this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 3)
          {
            this.ClearQDLAnswerOnHide(groupQuestions[index], true);
            if (groupQuestions[index].isSQ && !this.isByPassLogic) {
              this.QuestionDisplayLogic(groupQuestions[index]);
            }
          }
          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];         
          this.surveyData.Pages[page_no - 1].Questions[ind].isGroupCQHide = false;
        }
      }

  }

  /**
   * this method use for multi-question data clear on QDL
   * @param page_no
   * @param group_no
   */
  clearGroupAnswerShow(page_no: number, group_no: number){
    let groupQuestions = this.surveyData.Pages[page_no - 1].Questions.filter(e => e.group_no == group_no );
   let allGrupRule = groupQuestions.filter(e=> e.Rule_id !=0 && e.Rule_id == groupQuestions[0].Rule_id);
      if(allGrupRule.length == groupQuestions.length)
      {
        groupQuestions[0].isGroupRule = true;
      }
      if (groupQuestions != null && groupQuestions.length > 0 && groupQuestions[0].isGroupRule) { 
        for (let index = 0; index < groupQuestions.length; index++) {
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
          if( this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 1 
            && this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 3)
          {
            this.ClearQDLAnswerOnShow(groupQuestions[index], true);
            if (groupQuestions[index].isSQ && !this.isByPassLogic) {
              this.QuestionDisplayLogic(groupQuestions[index]);
            }
          }
          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];
          //Issue No.  122192 : Open : [ANG] Response not rec. when QDL applied to MG for a case
          this.surveyData.Pages[page_no - 1].Questions[ind].isCQHide = false;
        }
      }
      // let CheckNoGroupHide = groupQuestions.filter(e=> e.isCQHide == false);
      // if( CheckNoGroupHide != null && CheckNoGroupHide.length == 0)
      // {
      //   for (let index = 0; index < groupQuestions.length; index++) {
      //     let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
      //     if( this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 1 
      //       && this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 3)
      //     {
      //       this.ClearQDLAnswerOnShow(groupQuestions[index], true);
      //       if (groupQuestions[index].isSQ && !this.isByPassLogic) {
      //         this.QuestionDisplayLogic(groupQuestions[index]);
      //       }
      //     }
      //     this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];         
      //     this.surveyData.Pages[page_no - 1].Questions[ind].isGroupCQHide = true;
      //   }
      // }
      // else{
      //   for (let index = 0; index < groupQuestions.length; index++) {
      //     let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
      //     if( this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 1 
      //       && this.surveyData.Pages[page_no - 1].Questions[ind].population_type != 3)
      //     {
      //       this.ClearQDLAnswerOnShow(groupQuestions[index], true);
      //       if (groupQuestions[index].isSQ && !this.isByPassLogic) {
      //         this.QuestionDisplayLogic(groupQuestions[index]);
      //       }
      //     }
      //     this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];         
      //     this.surveyData.Pages[page_no - 1].Questions[ind].isGroupCQHide = false;
      //   }
      // }

  }

  /**
   * this method used for SRS group CQ hide.
   * @param page_no
   * @param group_no
   */
  setSRS_GroupCQ_hide(page_no: number, group_no: number){

    let groupQuestions = this.surveyData.Pages[page_no - 1].Questions.filter(e => e.group_no == group_no);
    let allGrupRule = groupQuestions.filter(e=> e.Rule_id !=0 && e.Rule_id == groupQuestions[0].Rule_id);
      if(allGrupRule.length == groupQuestions.length)
      {
        
        groupQuestions[0].isGroupRule = true;
      }
      if (groupQuestions != null && groupQuestions.length > 0 && groupQuestions[0].isGroupRule) {
        for (let index = 0; index < groupQuestions.length; index++) {
          //this.ClearQDLAnswerOnHide(groupQuestions[index], true);

          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);

          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];
          this.surveyData.Pages[page_no - 1].Questions[ind].isCQHide = true;
        }
      }
  }

  matrixGroupClearAnswer(question: Questions) {
    let groupData = this.GetGroupData(question.group_no);

    if (groupData != null && groupData != undefined) {
      let matrixData = this.GetMatrixData(groupData);

      if (matrixData != null && matrixData != undefined) {
        let groupDatas = this.surveyData.Groups.filter(
          e => e.Matrix_id == matrixData.matrix_id);

        if (groupDatas != null && groupDatas.length > 0) {
          for (let i = 0; i < groupDatas.length; i++) {
            this.clearGroupAnswer(question.page_no, groupDatas[i].group_no);
          }
        }
      }
    }
  }

  matrixGroupClearAnswerShow(question: Questions) {
    let groupData = this.GetGroupData(question.group_no);

    if (groupData != null && groupData != undefined) {
      let matrixData = this.GetMatrixData(groupData);

      if (matrixData != null && matrixData != undefined) {
        let groupDatas = this.surveyData.Groups.filter(
          e => e.Matrix_id == matrixData.matrix_id);

        if (groupDatas != null && groupDatas.length > 0) {
          for (let i = 0; i < groupDatas.length; i++) {
            this.clearGroupAnswerShow(question.page_no, groupDatas[i].group_no);
          }
        }
      }
    }
  }

  /**
   * this method used for CQ_hide flag for Question hidden.
   * @param question
   */
  CQHideHanldeFalse(question: Questions) {
    if (question.isMatrixQuestion) {
      this.CQHideHandleForMatrix(question)
    } else if (question.group_no > 0) {
      this.CQHideHandleForGroup(question.page_no, question.group_no);
    }
  }

  /**
   * this method used for CQ_hide flag for Question hidden.
   * @param question
   */
  CQHideHanldeTrue(question: Questions) {
    if (question.isMatrixQuestion) {
      this.CQHideHandleTrueForMatrix(question)
    } else if (question.group_no > 0) {
      this.CQHideHandleTrueForGroup(question.page_no, question.group_no);
    }
  }

  /**
   * this method used for CQ_hide flag for multi-Question hidden.
   * @param page_no
   * @param group_no
   */
  CQHideHandleForGroup(page_no: number, group_no: number) {
    let groupQuestions = this.surveyData.Pages[page_no - 1].Questions.filter(e => e.group_no == group_no);

    if (groupQuestions != null && groupQuestions.length > 0 && groupQuestions[0].isGroupRule) { 
      for (let index = 0; index < groupQuestions.length; index++) {

        let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);

        this.surveyData.Pages[page_no - 1].Questions[ind].isCQHide = false;
      }
    }
    let CheckNoGroupHide = groupQuestions.filter(e=> e.isCQHide == false)
    if(CheckNoGroupHide != null && CheckNoGroupHide.length == 0)
      {
        for (let index = 0; index < groupQuestions.length; index++) {
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];         
          this.surveyData.Pages[page_no - 1].Questions[ind].isGroupCQHide = true;
        }
      }
      else{
        for (let index = 0; index < groupQuestions.length; index++) {
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];         
          this.surveyData.Pages[page_no - 1].Questions[ind].isGroupCQHide = false;
        }
      }


  }

    /**
   * this method used for CQ_hide flag for multi-Question hidden.
   * @param page_no
   * @param group_no
   */
    CQHideHandleTrueForGroup(page_no: number, group_no: number) {
      let groupQuestions = this.surveyData.Pages[page_no - 1].Questions.filter(e => e.group_no == group_no);
  
      if (groupQuestions != null && groupQuestions.length > 0 && groupQuestions[0].isGroupRule) { 
       
        for (let index = 0; index < groupQuestions.length; index++) {
  
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
  
          this.surveyData.Pages[page_no - 1].Questions[ind].isCQHide = true;
        }
      }
      
    let CheckNoGroupHide = groupQuestions.filter(e=> e.isCQHide == false)
    if(CheckNoGroupHide != null && CheckNoGroupHide.length == 0)
      {
        for (let index = 0; index < groupQuestions.length; index++) {
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];         
          this.surveyData.Pages[page_no - 1].Questions[ind].isGroupCQHide = true;
        }
      }
      else{
        for (let index = 0; index < groupQuestions.length; index++) {
          let ind = this.surveyData.Pages[page_no - 1].Questions.indexOf(groupQuestions[index]);
          this.surveyData.Pages[page_no - 1].Questions[ind] = groupQuestions[index];         
          this.surveyData.Pages[page_no - 1].Questions[ind].isGroupCQHide = false;
        }
      }
    }

  /**
   * this method used for CQ_hide flag for matrix-Question hidden.
   * @param question
   */
  CQHideHandleForMatrix(question: Questions) {
    let groupData = this.GetGroupData(question.group_no);

    if (groupData != null && groupData != undefined) {
      let matrixData = this.GetMatrixData(groupData);

      if (matrixData != null && matrixData != undefined) {
        let groupDatas = this.surveyData.Groups.filter(
          e => e.Matrix_id == matrixData.matrix_id);

        if (groupDatas != null && groupDatas.length > 0) { 
          for (let i = 0; i < groupDatas.length; i++) {
            this.CQHideHandleForGroup(question.page_no, groupDatas[i].group_no);
          }
        }
      }
    }
  }

  /**
   * this method used for CQ_hide flag for matrix-Question hidden.
   * @param question
   */
  CQHideHandleTrueForMatrix(question: Questions) {
    let groupData = this.GetGroupData(question.group_no);

    if (groupData != null && groupData != undefined) {
      let matrixData = this.GetMatrixData(groupData);

      if (matrixData != null && matrixData != undefined) {
        let groupDatas = this.surveyData.Groups.filter(
          e => e.Matrix_id == matrixData.matrix_id);

        if (groupDatas != null && groupDatas.length > 0) { 
          for (let i = 0; i < groupDatas.length; i++) {
            this.CQHideHandleTrueForGroup(question.page_no, groupDatas[i].group_no);
          }
        }
      }
    }
  }

  /**
   * this method use for check cookies.
   * @returns
   */
  checkcookie() {

    var self=this;
    //cookie less participation for Embed Survey
    if((self.surveyData.SurveyDetails.intSourceID == 6 || self.surveyData.SurveyDetails.surveytype == 6 || self.surveyData.SurveyDetails.intSourceID == 10 || self.surveyData.SurveyDetails.surveytype == 10))// && self.cookieCorpNO.indexOf(self.surveyData.CorpSettings.corporate_no.toString()) > -1
    {
        return false;
    }

    if(this.SurveyURL.indexOf('https://')> -1)
    {
    document.cookie = 'Enabled=true;SameSite=None; Secure;';
    }
    else
    {
      document.cookie = 'Enabled=true;';
    }
    var cookieValid = document.cookie;
    if (cookieValid.indexOf('Enabled=true') != -1) {
      return true;
    }
     else {
        this.surveySpecificData.Participation_Message_Type = 4;
        this.surveySpecificData.Participation_Messages.Error_Message = this.surveyData.SurveyMessages.strCookieDisable;
        this.isRemoveBackGround = true;
        this.removePageBGClass();
        this.isSaveAndContinue = true;
        this.multiLanguage = false;
        this.selectedLanguage = false;
        this.isPrintDownload = false;
        this.pageNumber = 999;
        this.isAcceptCookies = false;
        return true;
     }
  }

  /**
   * this method use for mobile preview.
   */
  showHamburgerMenu() {
    if ($('.mobile-wrapper').hasClass('hamburgerActive')) {
      $('.mobile-wrapper').removeClass('hamburgerActive');
      // if (this.isMobile) {
      //   $('body').css('overflow', 'auto');
      // } else {
      //   $('body').css('overflow', 'hidden');
      // }
      setTimeout(() => {
        if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
        $("body").getNiceScroll().show();
      }, 0);
      this.overFlow();
    } else {
      $('.mobile-wrapper').addClass('hamburgerActive');
      // if (this.isMobile) {
      //   $('body').css('overflow', 'auto');
      // } else {
      //   $('body').css('overflow', 'hidden');
      // }
      setTimeout(() => {
        if(!(!(this.surveyData.SurveyDetails.GroupType == 'preview') && this.isMobile)||this.commonSetting.isEmbedMobile|| this.commonSetting.isEmbedPopMobile)
        $("body").getNiceScroll().hide();
      }, 0);
      this.overFlow();
    }
  }

  /**
   * this method use for mobile preview menu.
   */
  HideHamburgerMenu() {
    $('.mobile-wrapper').removeClass('hamburgerActive');
    if (this.surveyData.SurveyDetails.GroupType == 'preview') {
      // if (this.isMobile && !(this.surveyData.SurveyDetails.GroupType == 'preview'
      // && $("#ddPreview", parent.document).length != 0
      // && $("#ddPreview", parent.document).val() != 1
      // )) {
      //   $('body').css('overflow', 'auto');
      // } else {
      //   $('body').css('overflow', 'hidden');
      // }

      this.overFlow();
    }
    else {
      $('body').css('overflow', '');
    }
  }

  /**
   * this method use for overflow.
   */
  overFlow() {
    if (this.isMobile && !(this.surveyData.SurveyDetails.GroupType == 'preview'
      && $("#ddPreview", parent.document).length != 0) ) {
        if(this.commonSetting.isEmbedMobile == 1|| this.commonSetting.isEmbedPopMobile == 1)
          {
            $('body').css('overflow-y', 'hidden');
          }
          else
          {
            $('body').css('overflow', 'auto');
          }
    } else {
      $('body').css('overflow', 'hidden');
    }
  }

  /**
   * this method used for show Anonymous Pop-Up
   */
  showAnonymousPopup(){
    $('.anonymous-msg-wrap').show();
  }

  /**
   * this method used for hide Anonymous Pop-Up
   */
  hideAnonymousPopup(){
    $('.anonymous-msg-wrap').hide();
  }

  /**
   * this method used for active survey.
   */
  ActiveSurvey() {
    this.isTimeOutMsg = false;

    if (this.subscription_2) {
      this.subscription_2.unsubscribe();
    }
  }

  /**
   * this method used for auto-Save.
   */
  SetAutoSave() {
    if (this.surveyData != null) {

      if (this.autoSaveSubscription) {
        this.autoSaveSubscription.unsubscribe();
      }

      this.autoSaveTimer = timer(this.surveyData.CorpSettings.AutosaveTimeStamp);
      this.autoSaveSubscription = this.autoSaveTimer.subscribe(() => {
        this.UpdateLocalJson();
        this.SaveOnNext(this.pageNumber, false, true);
      });
    }
  }

  /**
   * this m thod used for mobile device.
   */
  IsMobileDevice() {
    let userAgent = window.navigator.userAgent;
    if (userAgent.match(/Mobi|iPhone|Android|BlackBerry|IEMobile/)) {
      if (userAgent.match(/iPad/)) {
        this.isTablet = true;
        this.isDeviceCSS = "tablet-wrapper";
      }
      else
      {
        this.isMobile = true;
        this.isDeviceCSS = "mobile-wrapper";
      }
    }
  }

  /**
   * this method used for set download cookies.
   * @param name
   * @param value
   * @param expiracy
   */
  public setDownloadCookie(name, value, expiracy) {
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiracy * 1000);
    var c_value = escape(value) + ((expiracy == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = name + "=" + c_value + '; path=/';
  }

  /**
   * this method used for get download cookies.
   * @param name
   * @returns
   */
  public getDownloadCookie(name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
      x = x.replace(/^\s+|\s+$/g, "");
      if (x == name) {
        return y ? decodeURI(unescape(y.replace(/\+/g, ' '))) : y;
      }
    }
  }

  /**
   * this method used for check Download Cookie
   */
  downloadTimeout: any;
  public checkDownloadCookie() {
    if (this.getDownloadCookie("downloadStarted") == 1) {
      this.setDownloadCookie("downloadStarted", "false", 100); //Expiration could be anything... As long as we reset the value
      this.showLoader = false;
      this.changeDetect.detectChanges();
    } else {
      this.downloadTimeout = setTimeout(() => { this.checkDownloadCookie(); }, 1000); //Re-run this function in 1 second.
    }
  }

  /**
   * this method used for start file download.
   */
  startFileDownload() {
    this.showLoader = true;
    //window.location.href = this.surveyData.SurveyDetails.PrintDownLoadLink;
    this.setDownloadCookie('downloadStarted', 0, 100);
    this.checkDownloadCookie();
  }

  /**
   * this method used for set cookies.
   * @param name
   * @param value
   * @param expiracy
   */
  public setCookie(name,value,expiracy)
  {
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiracy * 1000);
    var c_value = escape(value) + ((expiracy == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = name + "=" + c_value + '; path=/';
  }

  /**
   * this method used for get cookies.
   * @param c_name
   * @returns
   */
  public getCookie(c_name)
  {
    if (document.cookie.length>0)
    {
      let c_start =	document.cookie.indexOf(c_name + "=");
      if (c_start!=-1)
      {
        c_start=c_start + c_name.length+1;
      let 	c_end=document.cookie.indexOf(";",c_start);
      if (c_end==-1) c_end=document.cookie.length;
        return unescape(document.cookie.substring(c_start,c_end));
      }
    }
  return "";
  }

  /**
   * this method used for check cookies.
   */
  public checkCookie()
  {
  let corpNo=this.getCookie('PublicCorpNo' + this.surveyData.CorpSettings.corporate_no );
  let surveyNo=this.getCookie('PublicSurveyNo'+ this.surveyData.SurveyDetails.survey_no);
  let recNo=this.getCookie('PublicRecNo' + this.surveyData.ResponseInfo.ResponseUID);
    if (corpNo=="" || surveyNo=="") {
      this.setCookie('PublicCorpNo'+ this.surveyData.CorpSettings.corporate_no ,this.surveyData.CorpSettings.corporate_no,2);
      this.setCookie('PublicSurveyNo'+ this.surveyData.SurveyDetails.survey_no,this.surveyData.SurveyDetails.survey_no,2);
      this.setCookie('PublicRecNo' +this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype, this.surveyData.ResponseInfo.ResponseUID,2);
    }
  }

  public CheckCookieforDelete(name)
  {
    debugger;
    let corpNo=this.getCookie('PublicCorpNo' + this.surveyData.CorpSettings.corporate_no );
    let surveyNo=this.getCookie('PublicSurveyNo'+ this.surveyData.SurveyDetails.survey_no);
    let recNo=this.getCookie('PublicRecNo' + 'PublicRecNo' +this.surveyData.CorpSettings.corporate_no + this.surveyData.SurveyDetails.survey_no + this.surveyData.SurveyDetails.surveytype);
    if (corpNo !="" || surveyNo !="" || recNo !="") {
      let url = "SurveyData/JSErrorMail?data=" + encodeURIComponent(JSON.stringify({ '_Participation_Type': 'Angular Participation', '_ParticipationURL': document.location.href, '_Message': '', '_Filename': name, '_Lineno': EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", recNo) , '_Colno': 0, '_Error': "deleteCookie", '_Surveyno': surveyNo, '_CorpNo': corpNo}));
      this.service.JSErrorMail(url)
        .subscribe(async (data) => {
        },
          error => {
          });
        }
  }


  /**
   * this method used for resolution of screen.
   * @returns
   */
  getResolution(): string {
    return screen.width + "x" + screen.height + " ,color depth=" + screen.colorDepth + " bit";
  }

  /**
   * this method used for delete cookies.
   * @param cookie_name
   */
  public deleteCookie(cookie_name) {
    var cookie_date = new Date();
    cookie_date.setTime(cookie_date.getTime() - 1);
    document.cookie = cookie_name += '=; expires=' + cookie_date.toUTCString() + '; path=/';
  }

  /**
   * this method used for open export file.
   */
  openExport() {
    var Link = this.surveyData.SurveyDetails.PrintDownLoadLink.split("/zprint/PrintSurvey.aspx?", 2)
    if (Link.length == 2) {
      var newlink
      if(document.baseURI){
        newlink = document.baseURI + "zprint/PrintSurvey.aspx?" + Link[1];
      }else{
        newlink = "zprint/PrintSurvey.aspx?" + Link[1];
      }
      window.location.href = newlink;
    } else {
      window.location.href = this.surveyData.SurveyDetails.PrintDownLoadLink;
    }
  }


  DrillDownFirstQHide(question: Questions, index: number): boolean {
    if (question.qtype == "RW" && question.qsubtype == 3 && question.population_type == 2 && question.PrePopText != null ) {
        let findQuestion = this.surveyData.Pages[index].Questions.find(e => e.group_no == question.group_no
          && e.qtype == "RW" && e.qsubtype == 3 && (e.population_type != 2 && e.population_type != 5 && e.isHiddenQ));

        if (findQuestion != null && findQuestion != undefined) {
          return false;
        }
        else {
          return true;
        }
    }
     else {
      return false;
    }
  }

  /**
   * this method used for drill down hide question.
   * @param question
   * @param index
   * @returns
   */
  DrillDownHide(question: Questions, index: number): boolean {
   
    if (question.qtype == "RW" && question.qsubtype == 3) {
      
      if (question.population_type != 2) {
        let findQuestion = this.surveyData.Pages[index].Questions.find(e => e.group_no == question.group_no
          && e.qtype == "RW" && e.qsubtype == 3 && e.PrePopText != null && e.qno > question.qno && (e.population_type == 2 || e.population_type == 5 || e.isHiddenQ));

        if (findQuestion != null && findQuestion != undefined) {
          return false;
        }
        else {
          return true;
        }
      }
      else if (question.population_type == 2 && question.PrePopText != null ) {
        let findQuestion = this.surveyData.Pages[index].Questions.find(e => e.group_no == question.group_no
          && e.qtype == "RW" && e.qsubtype == 3 && (e.population_type != 2 && e.population_type != 5 && e.isHiddenQ));

        if (findQuestion != null && findQuestion != undefined) {
          return false;
        }
        else {
          return true;
        }
    }
      else {
        return false;
      }
    } else {
      return true;
    }
  }


  /**
   * this method used for blank page.
   * @param pageNumber
   * @returns
   */
  isBlankPage(pageNumber: number): boolean {

    let questions = this.surveyData.Pages[pageNumber].Questions;

    let hiddenQuestions = questions.filter(question => {
      return (question.population_type == 2 || question.population_type == 5 || question.isHiddenQ)
    });

    return hiddenQuestions.length == questions.length;
  }

  /**
   * this method use for check all question hide on previous page.
   * @param pageNumber
   * @returns
   */
  public AllQuestionHideONPrevPages(pageNumber: number): boolean {
    if (pageNumber != 999) {
      for (let i = (pageNumber == 0 ? 0 : pageNumber - 1); i >= 0; i--) {
        if (!this.allQuestionHideOnPage(i, false, true, false, false)) {
          return false;
        }
      }
      return true;
    }
    else {
      return false;
    }

  }

  /**
   * this method use for check all question hide on next page.
   * @param pageNumber
   * @returns
   */
  public AllQuestionHideONNextPages(pageNumber: number): boolean {
    if (pageNumber != 999) {
      for (let i = (pageNumber + 1); i < this.maxPageNumber; i++) {
        if (!this.allQuestionHideOnPage(i, false, true, false, true)) {
          return false;
        }
      }
      return true;
    }
    else {
      return false;
    }
  }

  /**
   * this method used for dipslay page count.
   * @param pageNumber
   * @returns
   */
  public getDisplayPageCount(pageNumber: number): number {
    let index = this.surveyDisplayPageList2.indexOf((pageNumber + 1))
    if (index != -1) {
      return this.surveyDisplayPageList1.length;
    }
    else {
      return this.maxPageNumber;
    }
  }

  /**
   * this method used for dipslay page No.
   * @param pageNumber
   * @returns
   */
  public getDisplayPageNo(pageNumber: number): number {
    let index = this.surveyDisplayPageList2.indexOf((pageNumber + 1))
    if (index != -1) {
      return this.surveyDisplayPageList1[index];
    }
    else {
      return (pageNumber + 1)
    }
  }

  /**
   * this method used for All Question Answers Exausts
   * @param question
   * @returns
   */
  isAllQuestionAnswersExausts(question: Questions): boolean {
    if (question.Answers != null) {
      let ExaustAns = question.Answers.filter(e => e.isQuotaDisable || e.isQuotaHide)

      if (ExaustAns.length == question.Answers.length) {
        return true;
      }
      else {
        return false;
      }
    }
    else
    {
      return false;
    }
  }

   // divScroll(questions: Questions): string {
  //   if ((questions.qtype != 'RW' && questions.qsubtype != 3) && questions.qtype != 'RK'
  //   && (questions.qtype != 'T' && (questions.qsubtype != 1 && questions.qsubtype != 2 && questions.qsubtype != 3 && questions.qsubtype != 4)) ||
  //   (questions.qtype == 'T' && (questions.qsubtype == 71 || questions.qsubtype == 0))) {
  //     return "divScroll"
  //   } else {
  //     return ""
  //   }
  // }

  /**
   * this method used for empty list
   * @param question
   * @returns
   */
  isEmptyList(question: Questions){
    let emptyCount = 0;
    if(question.qtype == "CS" && question.selectedOptionList != undefined && question.selectedOptionList != null && question.selectedOptionList.length > 0 ){
      for(let answerOption of question.selectedOptionList){
        if(answerOption.value_text == "" || answerOption.value_text == null){
          emptyCount++;
        }
      }

      if(emptyCount == question.selectedOptionList.length){
        return true;
      }

    }
    return false;
  }

  /**
   * this method used for trap focus.
   * @param event
   */
  trapFocus(event){
    let focusableElements = this.elementref.nativeElement.querySelectorAll('.timeOutMsg, .timeOutMsgWrapper a[href]:not([disabled]),.timeOutMsgWrapper button:not([disabled]),.timeOutMsgWrapper div[role=button]')

    let firstFocusableEl = focusableElements[0];
    let lastFocusableEl = focusableElements[focusableElements.length - 1];

    if(event.keyCode == 9){
      if (event.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          event.preventDefault();
        }
      }
      else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          event.preventDefault();
        }
      }
    }
  }

  /**
   * this method used for remove background class.
   */
  removePageBGClass(){
    var body = document.body;
    body.classList.remove('page-bg-clr');
  }

  /**
   * this method used for add page background class.
   */
  addPageBGClass() {
    if (!(this.surveyData.SurveyDetails.isSystemBGImage
      || this.surveyData.SurveySettings.SurveyBackgroundImage)) {
      var body = document.body;
      body.classList.add("page-bg-clr");
    }
  }

  /**
   * this method used for check inline question
   * @param question
   * @param index
   * @returns
   */
  CheckInlineQuestion(question: Questions, index: number): boolean {
    if (question.rules != null) {
      let rules = question.rules.filter(e => e.InlineQDL);

      if (rules != null && rules.length > 0) {
        for (let i = 0; i < rules.length; i++) {
          let softRequiredObj = this.surveyData.Pages[index].Questions.find(e => e.UniqueNumber == question.rules[i].ConditionQID
            && e.isSoftRequired && !e.isHiddenQ && e.AnswerText == null && (e.InlineQDL && e.isCQHide && e.isLoading) &&
            !this.isAllQuestionAnswersExausts(e));

          if (softRequiredObj != null && softRequiredObj != undefined) {
            return true;
          }
        }
      }
    }
    return false;
  }

  /**
   * this method used for show tool tip
   */
  showTooltip() {
    document.getElementById("saveandcontinue-tooltip").style.display = "block";
  }

  /**
   * this method used for hide tool tip
   */
  hideTooltip(){
    document.getElementById("saveandcontinue-tooltip").style.display = "none";
  }

  /**
   * this method handle active Question
   * @param obj
   * @param objPos
   * @param direction
   */
  activateQuestion(obj, objPos, direction) {
    //objPos is the position + ht of the current active question
    if (this.isactivateQuestionInt) {
      var switchPosition = $(window).height() * 0.5;
      var switchPosition2 = $(window).height() * 0;
      var switchPosition3 = $(window).height() * 0.7;
      if (direction == 'down') {
        var nextElement = obj.nextAll('.inactive-ques').has('.question-data').eq(0);
        if (objPos < switchPosition && objPos && nextElement.length > 0) {
          nextElement.addClass('active-ques');
          nextElement.removeClass('inactive-ques');
          obj.removeClass('active-ques');
          obj.addClass('inactive-ques');
        }
      } else {
        var prevElement = obj.prevAll('.inactive-ques').has('.question-data').eq(0);

        if (prevElement != undefined && prevElement.length > 0) {
          var prevElemPos = (obj.prevAll('.inactive-ques').has('.question-data').eq(0).offset().top - $(window).scrollTop());
          var prevElemPosWithHt = (obj.prevAll('.inactive-ques').has('.question-data').eq(0).offset().top - $(window).scrollTop()) + obj.prevAll('.inactive-ques').has('.question-data').eq(0).outerHeight();
          if ((prevElemPos >= switchPosition2 || prevElemPosWithHt > switchPosition3) && prevElement.length > 0) {
            prevElement.addClass('active-ques');
            prevElement.removeClass('inactive-ques');
            obj.removeClass('active-ques');
            obj.addClass('inactive-ques');
          }
        }
      }
    }
    this.isactivateQuestionInt = true;
  }

  /**
   * this method use for get question in view.
   * @param event
   */
  getQuestionInView(event){
    var minusScroll = 0;
    var elemPosition = $(event).offset().top;

    var elemBtnCount = $(event).closest('.main-ques-cont').find('.ques-response-btn').length;
    var preElemBtnCount = $('.active-ques').find('.ques-response-btn').length;

    if($(event).outerHeight() > $(window).height()){
      if(elemPosition > $('html').scrollTop()){
        if(elemBtnCount > 0 && preElemBtnCount > 0){
          minusScroll = $(event).closest('.main-ques-cont').find('.ques-response-btn').outerHeight();
        } else {
          if(elemBtnCount > 0){
            minusScroll = $(event).closest('.main-ques-cont').find('.ques-response-btn').outerHeight();
          } else if(preElemBtnCount > 0){
            minusScroll = $('.active-ques').find('.ques-response-btn').outerHeight();
          } else {
            minusScroll = 0;
          }
        }
      } else {
        minusScroll = 0;
      }
    } else {
      if(elemBtnCount > 0 && preElemBtnCount > 0){
        if(elemPosition > $('html').scrollTop()) {
          if($(event).closest('.main-ques-cont').nextAll('.active-ques').length > 0){
            minusScroll = elemPosition - $('html').scrollTop() + 20;
          } else {
            minusScroll = ($(window).height() - $(event).outerHeight())/2;
            if((elemPosition - minusScroll) < $('html').scrollTop()){
              minusScroll = elemPosition - $('html').scrollTop() - 10
            }
          }
        } else {
          // minusScroll = ($(window).height() - $(event).outerHeight())/2 - $(event).closest('.main-ques-cont').find('.ques-response-btn').outerHeight();
          minusScroll = 30;
        }
      } else {
        if(elemPosition > $('html').scrollTop()) {
          if($(event).closest('.main-ques-cont').nextAll('.active-ques').length > 0){
            minusScroll = elemPosition - $('html').scrollTop() + 20;
          } else {
            if(elemBtnCount > 0){
              minusScroll = ($(window).height() - $(event).outerHeight())/2 - $(event).closest('.main-ques-cont').find('.ques-response-btn').outerHeight();
            } else if(preElemBtnCount > 0) {
              minusScroll = ($(window).height() - $(event).outerHeight())/2 + $('.active-ques').find('.ques-response-btn').outerHeight();
            } else {
              minusScroll = ($(window).height() - $(event).outerHeight())/2;
            }
          }
        } else {
          // if(elemBtnCount > 0) {
          //   minusScroll = ($(window).height() - $(event).outerHeight())/2 - $(event).closest('.main-ques-cont').find('.ques-response-btn').outerHeight();
          // } else {
          //   minusScroll = ($(window).height() - $(event).outerHeight())/2
          // }
          minusScroll = 30;
        }
      }
    }
    $('html,body').animate({
      scrollTop: (elemPosition - minusScroll)
    }, 400);
  }

  /**
   * this method use for new scroll
   */
  showNewParticipationScroll() {
    let self = this;
    $(window).scroll(function () {
      if($('.active-ques').length > 0){
        var activeElemPos = $('.active-ques').offset().top + $('.active-ques').outerHeight() - $(window).scrollTop();
        if(self.lastScrollTop != 0 && !($(window).scrollTop() < 0 || self.lastScrollTop < 0) && $(window).scrollTop()!=self.lastScrollTop){
          if ($(window).scrollTop() >= self.lastScrollTop) {
            self.activateQuestion($('.active-ques'), activeElemPos, 'down');
          } else {
            self.activateQuestion($('.active-ques'), activeElemPos, 'up');
          }
        }
        self.lastScrollTop = $(window).scrollTop();
      }
    });
  }

  /**
   * this method use for check Matrix Quation Length
   * @param question
   * @returns
   */
  checkMatrixQuationLength(question: Questions){
    let groupData = this.GetGroupData(question.group_no);

    if (groupData != null && groupData != undefined) {
      let matrixData = this.GetMatrixData(groupData);

      if (matrixData != null && matrixData != undefined) {
        let groupDatas = this.surveyData.Groups.filter(
          e => e.Matrix_id == matrixData.matrix_id);



        if (groupDatas != null && groupDatas != undefined) {
          if (groupDatas.length == 1) {
            let questionDatas = this.surveyData.Pages[question.page_no-1].Questions.filter(
              e => e.group_no == groupDatas[0].group_no);
              if(questionDatas.length==1){
                return true;
              }else{
                return false;
              }
          }
          else{
            return false;
          }
        }
      }
    }
  }

  /**
   * this method use for new participation button.
   * @param question
   * @param i
   * @param j
   * @returns
   */
  isNewParticipationButton(question: Questions, i: number, j: number): boolean {
    let questions = this.surveyData.Pages[i].Questions.filter(e => e.population_type != 2 && e.population_type != 5 && !e.isHiddenQ);
    let hideQuestion = this.surveyData.Pages[i].Questions.filter(e => (e.population_type == 2 || e.population_type == 5 || e.isHiddenQ) && question.qno>e.qno).length;
    if (questions.length == (j + this.questionLength-hideQuestion)) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * this method used for show next Question
   */
  // Survey Format 2 Functions
  showNextQues() {
    var currElem = $('.active-ques');
    var nextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(0);
    var afterNextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(1);
    if (nextElem.length > 0) {
      $('.back-arrow').removeClass('disabled');
      this.service.hideQuestion(currElem[0]);
      let isHidden = $(nextElem).find(".question-data").attr("hidden");

      if (isHidden) {
        this.service.showQuestion(afterNextElem[0]);
      } else {
        this.service.showQuestion(nextElem[0]);
      }

      if (afterNextElem.length == 0 && $('.next-button').length == 0) {
        $('.next-arrow').addClass('disabled');
      }
    } else {
      if ($('.next-button').length != 0) {
        this.GetNextPage(this.pageNumber,false);
      }
    }
  }

  /**
   * this method used for show previou Question
   */
  showPrevQues() {
    var currElem = $('.active-ques');
    var prevElem = currElem.prevAll('.inactive-ques').has('.question-data').eq(0);
    var beforePrevElem = currElem.prevAll('.inactive-ques').has('.question-data').eq(1);
    if (prevElem.length > 0) {
      $('.next-arrow').removeClass('disabled');
      this.service.hideQuestion(currElem[0]);

      let isHidden = $(prevElem).find(".question-data").attr("hidden")
      if (isHidden) {
        this.service.showQuestion(beforePrevElem[0]);
      } else {
        this.service.showQuestion(prevElem[0]);
      }

      if (beforePrevElem.length == 0 && $('.showBackBtn').length == 0) {
        $('.back-arrow').addClass('disabled');
      }
    } else {
      if ($('.showBackBtn').length != 0) {
        this.GetBackPage();
      }
    }
  }

  /**
   * this method used for set Back Page Active Question
   */
  setBackPageActiveQues() {
    if (this.isNewParticipation && this.surveyFormat == 3) {
      var elementsLength = $('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
      var currActiveElem = $('.active-ques');
      currActiveElem.removeClass('active-ques');
      currActiveElem.addClass('inactive-ques');
      currActiveElem.nextAll('.inactive-ques').has('.question-data').eq(elementsLength - 1).addClass('active-ques');
      currActiveElem.nextAll('.inactive-ques').has('.question-data').eq(elementsLength - 1).removeClass('inactive-ques');
    }
  }

  /**
   * this method used for set Lang Based On Browser
   */
  setLangBasedOnBrowser() {
    let browserLanguage = navigator.language;
    if(browserLanguage == 'pt'){browserLanguage= 'pt-PT';}
    let foundLanguage = this.surveyData.LanguageDatas.find( e => e.browser_culture.split(',').length > 0 && e.browser_culture.split(',').indexOf(browserLanguage)>-1);
    if (!foundLanguage) {
      if (browserLanguage.indexOf('-') > -1) {
        let brwCulture = browserLanguage.split('-')[0];
        foundLanguage = this.surveyData.LanguageDatas.find(e => e.culture == brwCulture);
      } else {
        foundLanguage = this.surveyData.LanguageDatas.find(e => e.culture == browserLanguage);
      }
    }
    if(this.embedlangOpt == 1)
    {
        this.isHideHambugforEmbedMob = true;
        this.isHideEmbedWebHeader = true; 
    }
    if (foundLanguage && !this.surveyData.SurveyDetails.isSurveyReopened && this.surveySpecificData.Participation_Message_Type == 0 ) {
      this.selectedLang = foundLanguage.lang_id;
       if(this.surveyData.SurveyDetails.intSourceID  == 6 || this.surveyData.SurveyDetails.surveytype == 6  ||
         this.surveyData.SurveyDetails.intSourceID == 10 || this.surveyData.SurveyDetails.surveytype == 10 )
      //if(this.commonSetting.isEmbed == 1)
      { 
        this.isHideHamburgerMenu = true;
        if (this.surveySpecificData.Participation_Message_Type == 0) {
          this.multiLanguage = false;
          if(this.embedlangOpt == 3)
          {
            this.multiLanguage = true;
          }
          else
          {
            this.isLangSetonLoading = true;
            this.GetLanguageId(this.surveyData.LanguageDatas.find(
              e => e.lang_id == foundLanguage.lang_id
            ))
          }
          if(this.embedlangOpt == 1)
          {
              this.isHideHambugforEmbedMob = true;
              this.isHideEmbedWebHeader = true; 
          }

        }
      }
    }
  } 

  /**
   * this method used for get browser cultural language
   * @param langID
   * @returns
   */
  getLanguageCulture(langID: number) {
    let foundLanguage = this.surveyData.LanguageDatas.find( e => e.lang_id == langID)
    if (foundLanguage) {
      return foundLanguage.culture;
    }
  }

  /**
   * this method used for reset captcha
   * @param page
   */
  resetCaptcha(page : number) {
    let captchaControl = this.surveyData.Pages[page].Questions.find(e => e.qtype === "CM" && e.qsubtype === 1);
    if (captchaControl) {
      captchaControl.AnswerText = null;
    }
  }

  /**
   * this method return header footer spacer.
   * @returns
   */
  headerFooterSpacer(){
    if (this.isTablet && !(this.surveyData.SurveyDetails.GroupType == 'preview'
      && $("#ddPreview", parent.document).length != 0)) {
        return true;
      }
  }

  /**
   * this method used for focus on question
   * @param target
   */
  focusOnQuestion(target) {
    if ($(target).closest(".main-ques-cont").hasClass("inactive-ques") && this.surveyFormat == 1) {
      this.getQuestionInView($(target).closest(".inactive-ques").find(".ques-overlay"));
    }
  }

  /**
   * this method used for activate Question OnHover
   * @param element
   */
	activateQuestionOnHover(element) {
		if(this.surveyFormat == 1 && this.isactivateQuestionOnHoverInt)
		{
		  $('.active-ques').addClass('inactive-ques');
		  $('.active-ques').removeClass('active-ques');
		  $(element).closest('.inactive-ques').addClass('active-ques');
		  $(element).closest('.inactive-ques').removeClass('inactive-ques');
		}
    this.isactivateQuestionOnHoverInt = true;
	}

  /**
   * this method used for set Is First ShowQuestion
   */
  setIsFirstShowQuestion() {
    for (let i = 0; i < this.maxPageNumber; i++) {
      for (let j = 0; j < this.surveyData.Pages[i].Questions.length; j++) {
        if(this.surveyData.Pages[i].Questions[j].population_type !== 2
          && this.surveyData.Pages[i].Questions[j].population_type !== 5
          && !this.surveyData.Pages[i].Questions[j].isHiddenQ
          && (this.DrillDownHide(this.surveyData.Pages[i].Questions[j], i))){
          this.surveyData.Pages[i].Questions[j].isFirstShowQuestion = true;
          break;
        }
      }
    }
  }

  /**
   * this method used for remove Question Spacer For Piping
   * @param question
   * @returns
   */
  removeQuestionSpacerForPiping(question: Questions): boolean {

    if (question.group_no == 0) {
        return true;
    } else if(question.AnsPipeQID > 0 && question.group_no > 0){
      let grouQuestions = this.surveyData.Pages[this.pageNumber].Questions.filter(e => e.group_no == question.group_no);

      if (grouQuestions.length > 0) {
        if (grouQuestions.length == grouQuestions.filter(e => e.isMultiQuestionPiping).length) {
          return false;
        } else {
          return true;
        }
      }
    }

    return true;
  }

  /**
   * this method used for close test modal
   */
  closeTestModal() {
    $('.test-modal-overlay').hide();
    this.selectedLanguage = false;
    this.service.emitFormSubmitEvent.next(false);
    this.SubmitData();

    //if (isLoading) {
      this.pageNumber = 999;
    //}
  }

  /**
   * this method used for show preferences
   */
  showPreferences() {
    $('.cookie-strip').slideUp(150, function() {
      $('.manage-cont').slideDown(300);
    });
  }

  /**
   * this method used for cancel preferences
   */
  cancelPreference() {
    $('.manage-cont').slideUp(300, function() {
      $('.cookie-strip').slideDown(150);
    });
  }

  /**
   * this method used for hide preferences
   */
  hidePreference() {
    var self = this;
    $('.manage-cont').slideUp(function () {
      $('.cookie-container').hide(100);
    });

    self.manageCookiesAccept($('#analytics').prop('checked'));
  }

  /**
   * this method used for Functional Tooltip
   */
  showFunctionalTooltip() {
    $('.cd-tooltip').fadeIn(100);
    this.cookieTooltip = setTimeout(function() {
      $('.cd-tooltip').fadeOut(100);
    }, 5000);
  }

  /**
   * this method used for get First Question In Focus
   */
  getFirstQuestionInFocus() {
    var firstInactive = $('.inactive-ques').has('.question-data:visible').eq(0);
    var firstActive = $('.active-ques').has('.question-data:visible').eq(0);

    if(firstInactive.length > 0 && firstActive.length > 0) {
      if(firstInactive.offset().top < firstActive.offset().top) {
        firstInactive.removeClass('inactive-ques');
        firstInactive.addClass('active-ques');
        firstActive.removeClass('active-ques');
        firstActive.addClass('inactive-ques');
      }
    } else if(firstInactive.length > 0 && firstActive.length == 0) {
      firstInactive.removeClass('inactive-ques');
      firstInactive.addClass('active-ques');
    }
    this.isactivateQuestionInt = false;
    this.isactivateQuestionOnHoverInt = false;
  }

  /**
   * this method used for start survey
   */
  Startsurvey() {
    // let path = 'Survey1.aspx?' + this.GetUrlData(false);
    // this.router.navigateByUrl(path);
    //this.isOfflinePage = false;
  }

  /**
   * this method used for Offline Dashboard.
   */
  OfflineDashboard() {
    if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
      this.timer = timer((1 * 1000) * this.offlineSurvey.Surveytimeout);

      if(this.subscription_3){
        this.subscription_3.unsubscribe();
      }
      this.subscription_3 = this.timer.subscribe(() => {

        setTimeout(() =>{
          this.isOfflineTimeout=true;
          this.SaveAndContinue(this.pageNumber);
          //this.SaveOnNext(this.pageNumber, false, false);
          document.title = "Offline Home -" + this.offlineSurvey.surveyno;
          let k = '';
          this.activatedRoute.queryParams.subscribe(async params => {
            k = params['k'];
          });
          let path = 'offline.aspx?' + 'k=' + k + '&lang='+ this.offlineSurvey.primaryLang;
          this.router.navigateByUrl(path);
        },100);
      });
    }
  }

  /**
   * this method used for launch Sample Survey.
   */
  launchSampleSurvey() {
    var win = window.open(this.SignUp.strHostPath + 'static/welcome.aspx?ActMsg=1&participation=1&istrial=PYayMpe1Tuk%3d&zid=' + this.surveyData.SurveySettings.EncZarcaID + '&', '_blank');
    win.focus();
  }

  /**
   * this method used for get EST Time String.
   * @returns
   */
  getESTTimeString(){
      //EST
      var offset = -5.0;

      var clientDate = new Date();
      var utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000);

       var serverDate = new Date(utc + (3600000*offset));

       return formatDate(serverDate, 'M/d/y h:mm:ss a', 'en');

  }

  /**
   * this method used for prevent event.
   * @param event
   * @returns
   */
  preventEvent(event){
    if (event.keyCode == 13 && event.target.type != "" &&
        event.target.type != "submit" && event.target.type != "button" && event.target.type != "textarea" ) {
      return event.preventDefault();
    }
  }

  bottomfooterPos() {

    if($('.main-footer-div') && ((this.surveyData.SurveyDetails.intSourceID != 6 && this.surveyData.SurveyDetails.surveytype != 6 &&
      (this.surveyData.SurveyDetails.intSourceID != 10 && this.surveyData.SurveyDetails.surveytype != 10 && window.location == window.parent.location)) || this.isPreview )){
    var docHeight = $(window).height();
    var footerHeight = $('.main-footer-div').height();
    var footerTop = footerHeight;
    if($('.main-footer-div').position())
    {
        footerTop = $('.main-footer-div').position().top + footerHeight;
    }
    if (footerTop < docHeight) {
      $('.main-footer-div').css('margin-top', (docHeight - footerTop) - 21.5 + 'px');
    } else {
      $('.main-footer-div').css('margin-top', '0px');
    }
    }
  }

  //Changes for Unique Array
  UniqueArray(pagelist: number[]):number[]{
    let  uniqSort : number[];
     const map = {};
     const res = [];
     for (let i = 0; i < pagelist.length; i++) {
        if (!map[pagelist[i]]) {
           map[pagelist[i]] = true;
           res.push(pagelist[i]);
        };
     };
     if(res.length > 1)
     {
       res.sort((a, b) => a - b);
     }
     uniqSort = res;
     return uniqSort;
   }


   QDLForSkippedQuestions(pagelist: number[]){
    for (let i = 0; i < pagelist.length; i++) {
       if(this.surveyData.Pages[(pagelist[i]-1)].Questions.filter(e=> e.isSQ).length > 0)
       {
         let QDLSQ = this.surveyData.Pages[(pagelist[i]-1)].Questions.filter(e=> e.isSQ);
         for(let k = 0; k < QDLSQ.length; k++)
         {
             this.ClearQDLAnswerOnShow(QDLSQ[k],false);
             this.QuestionDisplayLogic(QDLSQ[k]);
         }
       }
    };
  }

  bodyNiceScrollResize() {  
    try {
      $('body').getNiceScroll().resize();
    } catch (error) {
    }
    }
  
    fnPostMessage(postMessageSource :string,isLoading:boolean = false)
    {
      clearInterval(myPostMessage);
      this.currHeight = 0;
      var iInterval = 0;
      var self = this;
      var myPostMessage = setInterval(function(){
      let docHeight = document.documentElement.scrollHeight;
      if ($('form').height() != undefined && $('form').height() != 0) {
        docHeight = $('form').height();
      }
      $('.langModal').css('max-height','unset');
      $('.langModal').css('overflow','auto'); 

      if(self.multiLanguage && docHeight < ($('.langModal').height() + 70) )
      {
        docHeight = ($('.langModal').height() + 250); 
      }
      $('.langModal').css('max-height','calc(100vh - 20vh)');
      $('.langModal').css('overflow','hidden'); 
      self.postMessgesData = new PostMessgesData()
      self.postMessgesData.action= isLoading?'Project Load':postMessageSource;
      self.postMessgesData.data='';
      self.postMessgesData.height= docHeight + (self.commonSetting.embedDefaultPx? self.commonSetting.embedDefaultPx : 0 );
      self.postMessgesData.width = document.documentElement.scrollWidth;
      self.postMessgesData.embedid = self.commonSetting.embedID;
        parent.postMessage(JSON.stringify(self.postMessgesData),"*");
       
       
        if(this.currheight != docHeight + (self.commonSetting.embedDefaultPx? self.commonSetting.embedDefaultPx : 0 ))
        {
          this.currheight = docHeight + (self.commonSetting.embedDefaultPx? self.commonSetting.embedDefaultPx : 0 )
          iInterval = 0;
        }
        else
        {
          iInterval++;
        }
        if(iInterval == 10)
        {
          clearInterval(myPostMessage);
        }
      },1000);

    }

}
